/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: string; output: string; }
  /** Json custom scalar type */
  Json: { input: unknown; output: unknown; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: { input: string; output: string; }
  _Any: { input: unknown; output: unknown; }
  _FieldSet: { input: unknown; output: unknown; }
};

export type Action = {
  __typename?: 'Action';
  _meta?: Maybe<ActionMeta>;
  activities: Array<Activity>;
  createdAt: Scalars['DateTime']['output'];
  deadline?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  links?: Maybe<Scalars['Json']['output']>;
  name: Scalars['String']['output'];
  opportunities: Array<Opportunity>;
  owner?: Maybe<Member>;
  paginateActivities: ActivityConnection;
  paginateOpportunities: OpportunityConnection;
  paginateTags: TagConnection;
  priority: ActionPriority;
  solvedAt?: Maybe<Scalars['DateTime']['output']>;
  status: ActionStatus;
  tags: Array<Tag>;
};


export type ActionActivitiesArgs = {
  filter?: InputMaybe<ActivityWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityOrderBy>>;
};


export type ActionOpportunitiesArgs = {
  filter?: InputMaybe<OpportunityWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpportunityOrderBy>>;
};


export type ActionOwnerArgs = {
  filter?: InputMaybe<MemberWhere>;
};


export type ActionPaginateActivitiesArgs = {
  filter?: InputMaybe<ActivityWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ActionPaginateOpportunitiesArgs = {
  filter?: InputMaybe<OpportunityWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpportunityOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ActionPaginateTagsArgs = {
  filter?: InputMaybe<TagWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ActionTagsArgs = {
  filter?: InputMaybe<TagWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderBy>>;
};

export type ActionConnectOrCreateActivitiesRelationInput = {
  connect: ActivityUniqueWhere;
  create: ActivityWithoutActionsCreateInput;
};

export type ActionConnectOrCreateOpportunitiesRelationInput = {
  connect: OpportunityUniqueWhere;
  create: OpportunityWithoutActionsCreateInput;
};

export type ActionConnectOrCreateOwnerRelationInput = {
  connect: MemberUniqueWhere;
  create: MemberWithoutActionsCreateInput;
};

export type ActionConnectOrCreateTagsRelationInput = {
  connect: TagUniqueWhere;
  create: TagWithoutActionsCreateInput;
};

export type ActionConnection = {
  __typename?: 'ActionConnection';
  edges: Array<ActionEdge>;
  pageInfo: PageInfo;
};

export type ActionCreateActivitiesEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ActivityUniqueWhere>;
  connectOrCreate?: InputMaybe<ActionConnectOrCreateActivitiesRelationInput>;
  create?: InputMaybe<ActivityWithoutActionsCreateInput>;
};

export type ActionCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activities?: InputMaybe<Array<ActionCreateActivitiesEntityRelationInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadline?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActionCreateOpportunitiesEntityRelationInput>>;
  owner?: InputMaybe<ActionCreateOwnerEntityRelationInput>;
  priority?: InputMaybe<ActionPriority>;
  solvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ActionStatus>;
  tags?: InputMaybe<Array<ActionCreateTagsEntityRelationInput>>;
};

export type ActionCreateOpportunitiesEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<OpportunityUniqueWhere>;
  connectOrCreate?: InputMaybe<ActionConnectOrCreateOpportunitiesRelationInput>;
  create?: InputMaybe<OpportunityWithoutActionsCreateInput>;
};

export type ActionCreateOwnerEntityRelationInput = {
  connect?: InputMaybe<MemberUniqueWhere>;
  connectOrCreate?: InputMaybe<ActionConnectOrCreateOwnerRelationInput>;
  create?: InputMaybe<MemberWithoutActionsCreateInput>;
};

export type ActionCreateResult = MutationResult & {
  __typename?: 'ActionCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Action>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ActionCreateTagsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<TagUniqueWhere>;
  connectOrCreate?: InputMaybe<ActionConnectOrCreateTagsRelationInput>;
  create?: InputMaybe<TagWithoutActionsCreateInput>;
};

export type ActionDeleteResult = MutationResult & {
  __typename?: 'ActionDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Action>;
  ok: Scalars['Boolean']['output'];
};

export type ActionEdge = {
  __typename?: 'ActionEdge';
  node: Action;
};

export type ActionMeta = {
  __typename?: 'ActionMeta';
  activities?: Maybe<FieldMeta>;
  createdAt?: Maybe<FieldMeta>;
  deadline?: Maybe<FieldMeta>;
  description?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  links?: Maybe<FieldMeta>;
  name?: Maybe<FieldMeta>;
  opportunities?: Maybe<FieldMeta>;
  owner?: Maybe<FieldMeta>;
  priority?: Maybe<FieldMeta>;
  solvedAt?: Maybe<FieldMeta>;
  status?: Maybe<FieldMeta>;
  tags?: Maybe<FieldMeta>;
};

export type ActionOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<OrderDirection>;
  deadline?: InputMaybe<OrderDirection>;
  description?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  links?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  owner?: InputMaybe<MemberOrderBy>;
  priority?: InputMaybe<OrderDirection>;
  solvedAt?: InputMaybe<OrderDirection>;
  status?: InputMaybe<OrderDirection>;
};

export type ActionPriority =
  | 'high'
  | 'low'
  | 'medium';

export type ActionPriorityCondition = {
  and?: InputMaybe<Array<ActionPriorityCondition>>;
  eq?: InputMaybe<ActionPriority>;
  gt?: InputMaybe<ActionPriority>;
  gte?: InputMaybe<ActionPriority>;
  in?: InputMaybe<Array<ActionPriority>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<ActionPriority>;
  lte?: InputMaybe<ActionPriority>;
  not?: InputMaybe<ActionPriorityCondition>;
  notEq?: InputMaybe<ActionPriority>;
  notIn?: InputMaybe<Array<ActionPriority>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<ActionPriorityCondition>>;
};

export type ActionStatus =
  | 'approved'
  | 'open'
  | 'rejected'
  | 'resolved';

export type ActionStatusCondition = {
  and?: InputMaybe<Array<ActionStatusCondition>>;
  eq?: InputMaybe<ActionStatus>;
  gt?: InputMaybe<ActionStatus>;
  gte?: InputMaybe<ActionStatus>;
  in?: InputMaybe<Array<ActionStatus>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<ActionStatus>;
  lte?: InputMaybe<ActionStatus>;
  not?: InputMaybe<ActionStatusCondition>;
  notEq?: InputMaybe<ActionStatus>;
  notIn?: InputMaybe<Array<ActionStatus>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<ActionStatusCondition>>;
};

export type ActionUniqueWhere = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type ActionUpdateActivitiesEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ActivityUniqueWhere>;
  create?: InputMaybe<ActivityWithoutActionsCreateInput>;
  delete?: InputMaybe<ActivityUniqueWhere>;
  disconnect?: InputMaybe<ActivityUniqueWhere>;
  update?: InputMaybe<ActionUpdateActivitiesRelationInput>;
  upsert?: InputMaybe<ActionUpsertActivitiesRelationInput>;
};

export type ActionUpdateActivitiesRelationInput = {
  by: ActivityUniqueWhere;
  data: ActivityWithoutActionsUpdateInput;
};

export type ActionUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activities?: InputMaybe<Array<ActionUpdateActivitiesEntityRelationInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadline?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActionUpdateOpportunitiesEntityRelationInput>>;
  owner?: InputMaybe<ActionUpdateOwnerEntityRelationInput>;
  priority?: InputMaybe<ActionPriority>;
  solvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ActionStatus>;
  tags?: InputMaybe<Array<ActionUpdateTagsEntityRelationInput>>;
};

export type ActionUpdateOpportunitiesEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<OpportunityUniqueWhere>;
  create?: InputMaybe<OpportunityWithoutActionsCreateInput>;
  delete?: InputMaybe<OpportunityUniqueWhere>;
  disconnect?: InputMaybe<OpportunityUniqueWhere>;
  update?: InputMaybe<ActionUpdateOpportunitiesRelationInput>;
  upsert?: InputMaybe<ActionUpsertOpportunitiesRelationInput>;
};

export type ActionUpdateOpportunitiesRelationInput = {
  by: OpportunityUniqueWhere;
  data: OpportunityWithoutActionsUpdateInput;
};

export type ActionUpdateOwnerEntityRelationInput = {
  connect?: InputMaybe<MemberUniqueWhere>;
  connectOrCreate?: InputMaybe<ActionConnectOrCreateOwnerRelationInput>;
  create?: InputMaybe<MemberWithoutActionsCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<MemberWithoutActionsUpdateInput>;
  upsert?: InputMaybe<ActionUpsertOwnerRelationInput>;
};

export type ActionUpdateResult = MutationResult & {
  __typename?: 'ActionUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Action>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ActionUpdateTagsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<TagUniqueWhere>;
  create?: InputMaybe<TagWithoutActionsCreateInput>;
  delete?: InputMaybe<TagUniqueWhere>;
  disconnect?: InputMaybe<TagUniqueWhere>;
  update?: InputMaybe<ActionUpdateTagsRelationInput>;
  upsert?: InputMaybe<ActionUpsertTagsRelationInput>;
};

export type ActionUpdateTagsRelationInput = {
  by: TagUniqueWhere;
  data: TagWithoutActionsUpdateInput;
};

export type ActionUpsertActivitiesRelationInput = {
  by: ActivityUniqueWhere;
  create: ActivityWithoutActionsCreateInput;
  update: ActivityWithoutActionsUpdateInput;
};

export type ActionUpsertOpportunitiesRelationInput = {
  by: OpportunityUniqueWhere;
  create: OpportunityWithoutActionsCreateInput;
  update: OpportunityWithoutActionsUpdateInput;
};

export type ActionUpsertOwnerRelationInput = {
  create: MemberWithoutActionsCreateInput;
  update: MemberWithoutActionsUpdateInput;
};

export type ActionUpsertResult = MutationResult & {
  __typename?: 'ActionUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Action>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ActionUpsertTagsRelationInput = {
  by: TagUniqueWhere;
  create: TagWithoutActionsCreateInput;
  update: TagWithoutActionsUpdateInput;
};

export type ActionWhere = {
  activities?: InputMaybe<ActivityWhere>;
  and?: InputMaybe<Array<InputMaybe<ActionWhere>>>;
  createdAt?: InputMaybe<DateTimeCondition>;
  deadline?: InputMaybe<DateCondition>;
  description?: InputMaybe<StringCondition>;
  id?: InputMaybe<UuidCondition>;
  links?: InputMaybe<JsonCondition>;
  name?: InputMaybe<StringCondition>;
  not?: InputMaybe<ActionWhere>;
  opportunities?: InputMaybe<OpportunityWhere>;
  or?: InputMaybe<Array<InputMaybe<ActionWhere>>>;
  owner?: InputMaybe<MemberWhere>;
  priority?: InputMaybe<ActionPriorityCondition>;
  solvedAt?: InputMaybe<DateTimeCondition>;
  status?: InputMaybe<ActionStatusCondition>;
  tags?: InputMaybe<TagWhere>;
};

export type ActionWithoutActivitiesCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadline?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActionCreateOpportunitiesEntityRelationInput>>;
  owner?: InputMaybe<ActionCreateOwnerEntityRelationInput>;
  priority?: InputMaybe<ActionPriority>;
  solvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ActionStatus>;
  tags?: InputMaybe<Array<ActionCreateTagsEntityRelationInput>>;
};

export type ActionWithoutActivitiesUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadline?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActionUpdateOpportunitiesEntityRelationInput>>;
  owner?: InputMaybe<ActionUpdateOwnerEntityRelationInput>;
  priority?: InputMaybe<ActionPriority>;
  solvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ActionStatus>;
  tags?: InputMaybe<Array<ActionUpdateTagsEntityRelationInput>>;
};

export type ActionWithoutOpportunitiesCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activities?: InputMaybe<Array<ActionCreateActivitiesEntityRelationInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadline?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<ActionCreateOwnerEntityRelationInput>;
  priority?: InputMaybe<ActionPriority>;
  solvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ActionStatus>;
  tags?: InputMaybe<Array<ActionCreateTagsEntityRelationInput>>;
};

export type ActionWithoutOpportunitiesUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activities?: InputMaybe<Array<ActionUpdateActivitiesEntityRelationInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadline?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<ActionUpdateOwnerEntityRelationInput>;
  priority?: InputMaybe<ActionPriority>;
  solvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ActionStatus>;
  tags?: InputMaybe<Array<ActionUpdateTagsEntityRelationInput>>;
};

export type ActionWithoutOwnerCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activities?: InputMaybe<Array<ActionCreateActivitiesEntityRelationInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadline?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActionCreateOpportunitiesEntityRelationInput>>;
  priority?: InputMaybe<ActionPriority>;
  solvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ActionStatus>;
  tags?: InputMaybe<Array<ActionCreateTagsEntityRelationInput>>;
};

export type ActionWithoutOwnerUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activities?: InputMaybe<Array<ActionUpdateActivitiesEntityRelationInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadline?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActionUpdateOpportunitiesEntityRelationInput>>;
  priority?: InputMaybe<ActionPriority>;
  solvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ActionStatus>;
  tags?: InputMaybe<Array<ActionUpdateTagsEntityRelationInput>>;
};

export type ActionWithoutTagsCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activities?: InputMaybe<Array<ActionCreateActivitiesEntityRelationInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadline?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActionCreateOpportunitiesEntityRelationInput>>;
  owner?: InputMaybe<ActionCreateOwnerEntityRelationInput>;
  priority?: InputMaybe<ActionPriority>;
  solvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ActionStatus>;
};

export type ActionWithoutTagsUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activities?: InputMaybe<Array<ActionUpdateActivitiesEntityRelationInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadline?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActionUpdateOpportunitiesEntityRelationInput>>;
  owner?: InputMaybe<ActionUpdateOwnerEntityRelationInput>;
  priority?: InputMaybe<ActionPriority>;
  solvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ActionStatus>;
};

export type Activity = {
  __typename?: 'Activity';
  _meta?: Maybe<ActivityMeta>;
  actions: Array<Action>;
  connectedJourneys: Array<Journey>;
  contentMetrics: Array<ContentMetric>;
  controlCycle?: Maybe<ControlCycle>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<ActivityDuration>;
  goalsAndObjectives?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  links?: Maybe<Scalars['Json']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  opportunities: Array<Opportunity>;
  owner?: Maybe<Member>;
  paginateActions: ActionConnection;
  paginateConnectedJourneys: JourneyConnection;
  paginateContentMetrics: ContentMetricConnection;
  paginateOpportunities: OpportunityConnection;
  paginatePersonas: PersonaConnection;
  paginatePictures: PictureConnection;
  paginateSubTouchpoints: TouchpointConnection;
  paginateTags: TagConnection;
  paginateWarnings: ActivityWarningConnection;
  personas: Array<Persona>;
  pictures: Array<Picture>;
  picturesByImage?: Maybe<Picture>;
  satisfaction: Scalars['Int']['output'];
  subTouchpoints: Array<Touchpoint>;
  subTouchpointsByActivity?: Maybe<Touchpoint>;
  tags: Array<Tag>;
  touchpoint?: Maybe<Touchpoint>;
  warnings: Array<ActivityWarning>;
  warningsByContentMetrics?: Maybe<ActivityWarning>;
};


export type ActivityActionsArgs = {
  filter?: InputMaybe<ActionWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionOrderBy>>;
};


export type ActivityConnectedJourneysArgs = {
  filter?: InputMaybe<JourneyWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<JourneyOrderBy>>;
};


export type ActivityContentMetricsArgs = {
  filter?: InputMaybe<ContentMetricWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentMetricOrderBy>>;
};


export type ActivityControlCycleArgs = {
  filter?: InputMaybe<ControlCycleWhere>;
};


export type ActivityDurationArgs = {
  filter?: InputMaybe<ActivityDurationWhere>;
};


export type ActivityOpportunitiesArgs = {
  filter?: InputMaybe<OpportunityWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpportunityOrderBy>>;
};


export type ActivityOwnerArgs = {
  filter?: InputMaybe<MemberWhere>;
};


export type ActivityPaginateActionsArgs = {
  filter?: InputMaybe<ActionWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ActivityPaginateConnectedJourneysArgs = {
  filter?: InputMaybe<JourneyWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<JourneyOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ActivityPaginateContentMetricsArgs = {
  filter?: InputMaybe<ContentMetricWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentMetricOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ActivityPaginateOpportunitiesArgs = {
  filter?: InputMaybe<OpportunityWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpportunityOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ActivityPaginatePersonasArgs = {
  filter?: InputMaybe<PersonaWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PersonaOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ActivityPaginatePicturesArgs = {
  filter?: InputMaybe<PictureWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PictureOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ActivityPaginateSubTouchpointsArgs = {
  filter?: InputMaybe<TouchpointWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TouchpointOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ActivityPaginateTagsArgs = {
  filter?: InputMaybe<TagWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ActivityPaginateWarningsArgs = {
  filter?: InputMaybe<ActivityWarningWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityWarningOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ActivityPersonasArgs = {
  filter?: InputMaybe<PersonaWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PersonaOrderBy>>;
};


export type ActivityPicturesArgs = {
  filter?: InputMaybe<PictureWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PictureOrderBy>>;
};


export type ActivityPicturesByImageArgs = {
  by: ActivityPicturesByImageUniqueWhere;
  filter?: InputMaybe<PictureWhere>;
};


export type ActivitySubTouchpointsArgs = {
  filter?: InputMaybe<TouchpointWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TouchpointOrderBy>>;
};


export type ActivitySubTouchpointsByActivityArgs = {
  by: ActivitySubTouchpointsByActivityUniqueWhere;
  filter?: InputMaybe<TouchpointWhere>;
};


export type ActivityTagsArgs = {
  filter?: InputMaybe<TagWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderBy>>;
};


export type ActivityTouchpointArgs = {
  filter?: InputMaybe<TouchpointWhere>;
};


export type ActivityWarningsArgs = {
  filter?: InputMaybe<ActivityWarningWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityWarningOrderBy>>;
};


export type ActivityWarningsByContentMetricsArgs = {
  by: ActivityWarningsByContentMetricsUniqueWhere;
  filter?: InputMaybe<ActivityWarningWhere>;
};

export type ActivityConnectOrCreateActionsRelationInput = {
  connect: ActionUniqueWhere;
  create: ActionWithoutActivitiesCreateInput;
};

export type ActivityConnectOrCreateConnectedJourneysRelationInput = {
  connect: JourneyUniqueWhere;
  create: JourneyWithoutConnectedActivitiesCreateInput;
};

export type ActivityConnectOrCreateContentMetricsRelationInput = {
  connect: ContentMetricUniqueWhere;
  create: ContentMetricWithoutActivitiesCreateInput;
};

export type ActivityConnectOrCreateControlCycleRelationInput = {
  connect: ControlCycleUniqueWhere;
  create: ControlCycleCreateInput;
};

export type ActivityConnectOrCreateDurationRelationInput = {
  connect: ActivityDurationUniqueWhere;
  create: ActivityDurationCreateInput;
};

export type ActivityConnectOrCreateOpportunitiesRelationInput = {
  connect: OpportunityUniqueWhere;
  create: OpportunityWithoutActivitiesCreateInput;
};

export type ActivityConnectOrCreateOwnerRelationInput = {
  connect: MemberUniqueWhere;
  create: MemberWithoutActivitiesCreateInput;
};

export type ActivityConnectOrCreatePersonasRelationInput = {
  connect: PersonaUniqueWhere;
  create: PersonaWithoutActivitiesCreateInput;
};

export type ActivityConnectOrCreatePicturesRelationInput = {
  connect: PictureUniqueWhere;
  create: PictureWithoutActivityCreateInput;
};

export type ActivityConnectOrCreateSubTouchpointsRelationInput = {
  connect: TouchpointUniqueWhere;
  create: TouchpointWithoutParentActivityCreateInput;
};

export type ActivityConnectOrCreateTagsRelationInput = {
  connect: TagUniqueWhere;
  create: TagWithoutActivitiesCreateInput;
};

export type ActivityConnectOrCreateTouchpointRelationInput = {
  connect: TouchpointUniqueWhere;
  create: TouchpointWithoutActivityCreateInput;
};

export type ActivityConnectOrCreateWarningsRelationInput = {
  connect: ActivityWarningUniqueWhere;
  create: ActivityWarningWithoutActivityCreateInput;
};

export type ActivityConnection = {
  __typename?: 'ActivityConnection';
  edges: Array<ActivityEdge>;
  pageInfo: PageInfo;
};

export type ActivityCreateActionsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ActionUniqueWhere>;
  connectOrCreate?: InputMaybe<ActivityConnectOrCreateActionsRelationInput>;
  create?: InputMaybe<ActionWithoutActivitiesCreateInput>;
};

export type ActivityCreateConnectedJourneysEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<JourneyUniqueWhere>;
  connectOrCreate?: InputMaybe<ActivityConnectOrCreateConnectedJourneysRelationInput>;
  create?: InputMaybe<JourneyWithoutConnectedActivitiesCreateInput>;
};

export type ActivityCreateContentMetricsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ContentMetricUniqueWhere>;
  connectOrCreate?: InputMaybe<ActivityConnectOrCreateContentMetricsRelationInput>;
  create?: InputMaybe<ContentMetricWithoutActivitiesCreateInput>;
};

export type ActivityCreateControlCycleEntityRelationInput = {
  connect?: InputMaybe<ControlCycleUniqueWhere>;
  connectOrCreate?: InputMaybe<ActivityConnectOrCreateControlCycleRelationInput>;
  create?: InputMaybe<ControlCycleCreateInput>;
};

export type ActivityCreateDurationEntityRelationInput = {
  connect?: InputMaybe<ActivityDurationUniqueWhere>;
  connectOrCreate?: InputMaybe<ActivityConnectOrCreateDurationRelationInput>;
  create?: InputMaybe<ActivityDurationCreateInput>;
};

export type ActivityCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<ActivityCreateActionsEntityRelationInput>>;
  connectedJourneys?: InputMaybe<Array<ActivityCreateConnectedJourneysEntityRelationInput>>;
  contentMetrics?: InputMaybe<Array<ActivityCreateContentMetricsEntityRelationInput>>;
  controlCycle?: InputMaybe<ActivityCreateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ActivityCreateDurationEntityRelationInput>;
  goalsAndObjectives?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActivityCreateOpportunitiesEntityRelationInput>>;
  owner?: InputMaybe<ActivityCreateOwnerEntityRelationInput>;
  personas?: InputMaybe<Array<ActivityCreatePersonasEntityRelationInput>>;
  pictures?: InputMaybe<Array<ActivityCreatePicturesEntityRelationInput>>;
  satisfaction?: InputMaybe<Scalars['Int']['input']>;
  subTouchpoints?: InputMaybe<Array<ActivityCreateSubTouchpointsEntityRelationInput>>;
  tags?: InputMaybe<Array<ActivityCreateTagsEntityRelationInput>>;
  touchpoint?: InputMaybe<ActivityCreateTouchpointEntityRelationInput>;
  warnings?: InputMaybe<Array<ActivityCreateWarningsEntityRelationInput>>;
};

export type ActivityCreateOpportunitiesEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<OpportunityUniqueWhere>;
  connectOrCreate?: InputMaybe<ActivityConnectOrCreateOpportunitiesRelationInput>;
  create?: InputMaybe<OpportunityWithoutActivitiesCreateInput>;
};

export type ActivityCreateOwnerEntityRelationInput = {
  connect?: InputMaybe<MemberUniqueWhere>;
  connectOrCreate?: InputMaybe<ActivityConnectOrCreateOwnerRelationInput>;
  create?: InputMaybe<MemberWithoutActivitiesCreateInput>;
};

export type ActivityCreatePersonasEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<PersonaUniqueWhere>;
  connectOrCreate?: InputMaybe<ActivityConnectOrCreatePersonasRelationInput>;
  create?: InputMaybe<PersonaWithoutActivitiesCreateInput>;
};

export type ActivityCreatePicturesEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<PictureUniqueWhere>;
  connectOrCreate?: InputMaybe<ActivityConnectOrCreatePicturesRelationInput>;
  create?: InputMaybe<PictureWithoutActivityCreateInput>;
};

export type ActivityCreateResult = MutationResult & {
  __typename?: 'ActivityCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Activity>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ActivityCreateSubTouchpointsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<TouchpointUniqueWhere>;
  connectOrCreate?: InputMaybe<ActivityConnectOrCreateSubTouchpointsRelationInput>;
  create?: InputMaybe<TouchpointWithoutParentActivityCreateInput>;
};

export type ActivityCreateTagsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<TagUniqueWhere>;
  connectOrCreate?: InputMaybe<ActivityConnectOrCreateTagsRelationInput>;
  create?: InputMaybe<TagWithoutActivitiesCreateInput>;
};

export type ActivityCreateTouchpointEntityRelationInput = {
  connect?: InputMaybe<TouchpointUniqueWhere>;
  connectOrCreate?: InputMaybe<ActivityConnectOrCreateTouchpointRelationInput>;
  create?: InputMaybe<TouchpointWithoutActivityCreateInput>;
};

export type ActivityCreateWarningsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ActivityWarningUniqueWhere>;
  connectOrCreate?: InputMaybe<ActivityConnectOrCreateWarningsRelationInput>;
  create?: InputMaybe<ActivityWarningWithoutActivityCreateInput>;
};

export type ActivityDeleteResult = MutationResult & {
  __typename?: 'ActivityDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Activity>;
  ok: Scalars['Boolean']['output'];
};

export type ActivityDuration = {
  __typename?: 'ActivityDuration';
  _meta?: Maybe<ActivityDurationMeta>;
  end?: Maybe<Scalars['Date']['output']>;
  id: Scalars['UUID']['output'];
  occurence?: Maybe<Scalars['Int']['output']>;
  showOnActivityMap: Scalars['Boolean']['output'];
  start?: Maybe<Scalars['Date']['output']>;
  type: ActivityDurationType;
  unit?: Maybe<ActivityDurationOccurenceUnitType>;
};

export type ActivityDurationConnection = {
  __typename?: 'ActivityDurationConnection';
  edges: Array<ActivityDurationEdge>;
  pageInfo: PageInfo;
};

export type ActivityDurationCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  occurence?: InputMaybe<Scalars['Int']['input']>;
  showOnActivityMap?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<ActivityDurationType>;
  unit?: InputMaybe<ActivityDurationOccurenceUnitType>;
};

export type ActivityDurationCreateResult = MutationResult & {
  __typename?: 'ActivityDurationCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<ActivityDuration>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ActivityDurationDeleteResult = MutationResult & {
  __typename?: 'ActivityDurationDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<ActivityDuration>;
  ok: Scalars['Boolean']['output'];
};

export type ActivityDurationEdge = {
  __typename?: 'ActivityDurationEdge';
  node: ActivityDuration;
};

export type ActivityDurationMeta = {
  __typename?: 'ActivityDurationMeta';
  end?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  occurence?: Maybe<FieldMeta>;
  showOnActivityMap?: Maybe<FieldMeta>;
  start?: Maybe<FieldMeta>;
  type?: Maybe<FieldMeta>;
  unit?: Maybe<FieldMeta>;
};

export type ActivityDurationOccurenceUnitType =
  | 'day'
  | 'hour'
  | 'month'
  | 'year';

export type ActivityDurationOccurenceUnitTypeCondition = {
  and?: InputMaybe<Array<ActivityDurationOccurenceUnitTypeCondition>>;
  eq?: InputMaybe<ActivityDurationOccurenceUnitType>;
  gt?: InputMaybe<ActivityDurationOccurenceUnitType>;
  gte?: InputMaybe<ActivityDurationOccurenceUnitType>;
  in?: InputMaybe<Array<ActivityDurationOccurenceUnitType>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<ActivityDurationOccurenceUnitType>;
  lte?: InputMaybe<ActivityDurationOccurenceUnitType>;
  not?: InputMaybe<ActivityDurationOccurenceUnitTypeCondition>;
  notEq?: InputMaybe<ActivityDurationOccurenceUnitType>;
  notIn?: InputMaybe<Array<ActivityDurationOccurenceUnitType>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<ActivityDurationOccurenceUnitTypeCondition>>;
};

export type ActivityDurationOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  end?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  occurence?: InputMaybe<OrderDirection>;
  showOnActivityMap?: InputMaybe<OrderDirection>;
  start?: InputMaybe<OrderDirection>;
  type?: InputMaybe<OrderDirection>;
  unit?: InputMaybe<OrderDirection>;
};

export type ActivityDurationType =
  | 'continuous'
  | 'occurence'
  | 'one_time'
  | 'time_limited';

export type ActivityDurationTypeCondition = {
  and?: InputMaybe<Array<ActivityDurationTypeCondition>>;
  eq?: InputMaybe<ActivityDurationType>;
  gt?: InputMaybe<ActivityDurationType>;
  gte?: InputMaybe<ActivityDurationType>;
  in?: InputMaybe<Array<ActivityDurationType>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<ActivityDurationType>;
  lte?: InputMaybe<ActivityDurationType>;
  not?: InputMaybe<ActivityDurationTypeCondition>;
  notEq?: InputMaybe<ActivityDurationType>;
  notIn?: InputMaybe<Array<ActivityDurationType>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<ActivityDurationTypeCondition>>;
};

export type ActivityDurationUniqueWhere = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type ActivityDurationUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  occurence?: InputMaybe<Scalars['Int']['input']>;
  showOnActivityMap?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<ActivityDurationType>;
  unit?: InputMaybe<ActivityDurationOccurenceUnitType>;
};

export type ActivityDurationUpdateResult = MutationResult & {
  __typename?: 'ActivityDurationUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<ActivityDuration>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ActivityDurationUpsertResult = MutationResult & {
  __typename?: 'ActivityDurationUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<ActivityDuration>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ActivityDurationWhere = {
  and?: InputMaybe<Array<InputMaybe<ActivityDurationWhere>>>;
  end?: InputMaybe<DateCondition>;
  id?: InputMaybe<UuidCondition>;
  not?: InputMaybe<ActivityDurationWhere>;
  occurence?: InputMaybe<IntCondition>;
  or?: InputMaybe<Array<InputMaybe<ActivityDurationWhere>>>;
  showOnActivityMap?: InputMaybe<BooleanCondition>;
  start?: InputMaybe<DateCondition>;
  type?: InputMaybe<ActivityDurationTypeCondition>;
  unit?: InputMaybe<ActivityDurationOccurenceUnitTypeCondition>;
};

export type ActivityEdge = {
  __typename?: 'ActivityEdge';
  node: Activity;
};

export type ActivityMeta = {
  __typename?: 'ActivityMeta';
  actions?: Maybe<FieldMeta>;
  connectedJourneys?: Maybe<FieldMeta>;
  contentMetrics?: Maybe<FieldMeta>;
  controlCycle?: Maybe<FieldMeta>;
  createdAt?: Maybe<FieldMeta>;
  description?: Maybe<FieldMeta>;
  duration?: Maybe<FieldMeta>;
  goalsAndObjectives?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  links?: Maybe<FieldMeta>;
  name?: Maybe<FieldMeta>;
  notes?: Maybe<FieldMeta>;
  opportunities?: Maybe<FieldMeta>;
  owner?: Maybe<FieldMeta>;
  personas?: Maybe<FieldMeta>;
  pictures?: Maybe<FieldMeta>;
  satisfaction?: Maybe<FieldMeta>;
  subTouchpoints?: Maybe<FieldMeta>;
  tags?: Maybe<FieldMeta>;
  touchpoint?: Maybe<FieldMeta>;
  warnings?: Maybe<FieldMeta>;
};

export type ActivityOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  controlCycle?: InputMaybe<ControlCycleOrderBy>;
  createdAt?: InputMaybe<OrderDirection>;
  description?: InputMaybe<OrderDirection>;
  duration?: InputMaybe<ActivityDurationOrderBy>;
  goalsAndObjectives?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  links?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  notes?: InputMaybe<OrderDirection>;
  owner?: InputMaybe<MemberOrderBy>;
  satisfaction?: InputMaybe<OrderDirection>;
  touchpoint?: InputMaybe<TouchpointOrderBy>;
};

export type ActivityPicturesByImageUniqueWhere = {
  image?: InputMaybe<ImageUniqueWhere>;
};

export type ActivitySubTouchpointsByActivityUniqueWhere = {
  activity?: InputMaybe<ActivityUniqueWhere>;
};

export type ActivityUniqueWhere = {
  controlCycle?: InputMaybe<ControlCycleUniqueWhere>;
  duration?: InputMaybe<ActivityDurationUniqueWhere>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  pictures?: InputMaybe<PictureUniqueWhere>;
  subTouchpoints?: InputMaybe<TouchpointUniqueWhere>;
  touchpoint?: InputMaybe<TouchpointUniqueWhere>;
  warnings?: InputMaybe<ActivityWarningUniqueWhere>;
};

export type ActivityUpdateActionsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ActionUniqueWhere>;
  create?: InputMaybe<ActionWithoutActivitiesCreateInput>;
  delete?: InputMaybe<ActionUniqueWhere>;
  disconnect?: InputMaybe<ActionUniqueWhere>;
  update?: InputMaybe<ActivityUpdateActionsRelationInput>;
  upsert?: InputMaybe<ActivityUpsertActionsRelationInput>;
};

export type ActivityUpdateActionsRelationInput = {
  by: ActionUniqueWhere;
  data: ActionWithoutActivitiesUpdateInput;
};

export type ActivityUpdateConnectedJourneysEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<JourneyUniqueWhere>;
  create?: InputMaybe<JourneyWithoutConnectedActivitiesCreateInput>;
  delete?: InputMaybe<JourneyUniqueWhere>;
  disconnect?: InputMaybe<JourneyUniqueWhere>;
  update?: InputMaybe<ActivityUpdateConnectedJourneysRelationInput>;
  upsert?: InputMaybe<ActivityUpsertConnectedJourneysRelationInput>;
};

export type ActivityUpdateConnectedJourneysRelationInput = {
  by: JourneyUniqueWhere;
  data: JourneyWithoutConnectedActivitiesUpdateInput;
};

export type ActivityUpdateContentMetricsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ContentMetricUniqueWhere>;
  create?: InputMaybe<ContentMetricWithoutActivitiesCreateInput>;
  delete?: InputMaybe<ContentMetricUniqueWhere>;
  disconnect?: InputMaybe<ContentMetricUniqueWhere>;
  update?: InputMaybe<ActivityUpdateContentMetricsRelationInput>;
  upsert?: InputMaybe<ActivityUpsertContentMetricsRelationInput>;
};

export type ActivityUpdateContentMetricsRelationInput = {
  by: ContentMetricUniqueWhere;
  data: ContentMetricWithoutActivitiesUpdateInput;
};

export type ActivityUpdateControlCycleEntityRelationInput = {
  connect?: InputMaybe<ControlCycleUniqueWhere>;
  connectOrCreate?: InputMaybe<ActivityConnectOrCreateControlCycleRelationInput>;
  create?: InputMaybe<ControlCycleCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<ControlCycleUpdateInput>;
  upsert?: InputMaybe<ActivityUpsertControlCycleRelationInput>;
};

export type ActivityUpdateDurationEntityRelationInput = {
  connect?: InputMaybe<ActivityDurationUniqueWhere>;
  connectOrCreate?: InputMaybe<ActivityConnectOrCreateDurationRelationInput>;
  create?: InputMaybe<ActivityDurationCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<ActivityDurationUpdateInput>;
  upsert?: InputMaybe<ActivityUpsertDurationRelationInput>;
};

export type ActivityUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<ActivityUpdateActionsEntityRelationInput>>;
  connectedJourneys?: InputMaybe<Array<ActivityUpdateConnectedJourneysEntityRelationInput>>;
  contentMetrics?: InputMaybe<Array<ActivityUpdateContentMetricsEntityRelationInput>>;
  controlCycle?: InputMaybe<ActivityUpdateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ActivityUpdateDurationEntityRelationInput>;
  goalsAndObjectives?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActivityUpdateOpportunitiesEntityRelationInput>>;
  owner?: InputMaybe<ActivityUpdateOwnerEntityRelationInput>;
  personas?: InputMaybe<Array<ActivityUpdatePersonasEntityRelationInput>>;
  pictures?: InputMaybe<Array<ActivityUpdatePicturesEntityRelationInput>>;
  satisfaction?: InputMaybe<Scalars['Int']['input']>;
  subTouchpoints?: InputMaybe<Array<ActivityUpdateSubTouchpointsEntityRelationInput>>;
  tags?: InputMaybe<Array<ActivityUpdateTagsEntityRelationInput>>;
  touchpoint?: InputMaybe<ActivityUpdateTouchpointEntityRelationInput>;
  warnings?: InputMaybe<Array<ActivityUpdateWarningsEntityRelationInput>>;
};

export type ActivityUpdateOpportunitiesEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<OpportunityUniqueWhere>;
  create?: InputMaybe<OpportunityWithoutActivitiesCreateInput>;
  delete?: InputMaybe<OpportunityUniqueWhere>;
  disconnect?: InputMaybe<OpportunityUniqueWhere>;
  update?: InputMaybe<ActivityUpdateOpportunitiesRelationInput>;
  upsert?: InputMaybe<ActivityUpsertOpportunitiesRelationInput>;
};

export type ActivityUpdateOpportunitiesRelationInput = {
  by: OpportunityUniqueWhere;
  data: OpportunityWithoutActivitiesUpdateInput;
};

export type ActivityUpdateOwnerEntityRelationInput = {
  connect?: InputMaybe<MemberUniqueWhere>;
  connectOrCreate?: InputMaybe<ActivityConnectOrCreateOwnerRelationInput>;
  create?: InputMaybe<MemberWithoutActivitiesCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<MemberWithoutActivitiesUpdateInput>;
  upsert?: InputMaybe<ActivityUpsertOwnerRelationInput>;
};

export type ActivityUpdatePersonasEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<PersonaUniqueWhere>;
  create?: InputMaybe<PersonaWithoutActivitiesCreateInput>;
  delete?: InputMaybe<PersonaUniqueWhere>;
  disconnect?: InputMaybe<PersonaUniqueWhere>;
  update?: InputMaybe<ActivityUpdatePersonasRelationInput>;
  upsert?: InputMaybe<ActivityUpsertPersonasRelationInput>;
};

export type ActivityUpdatePersonasRelationInput = {
  by: PersonaUniqueWhere;
  data: PersonaWithoutActivitiesUpdateInput;
};

export type ActivityUpdatePicturesEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<PictureUniqueWhere>;
  create?: InputMaybe<PictureWithoutActivityCreateInput>;
  delete?: InputMaybe<PictureUniqueWhere>;
  disconnect?: InputMaybe<PictureUniqueWhere>;
  update?: InputMaybe<ActivityUpdatePicturesRelationInput>;
  upsert?: InputMaybe<ActivityUpsertPicturesRelationInput>;
};

export type ActivityUpdatePicturesRelationInput = {
  by: PictureUniqueWhere;
  data: PictureWithoutActivityUpdateInput;
};

export type ActivityUpdateResult = MutationResult & {
  __typename?: 'ActivityUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Activity>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ActivityUpdateSubTouchpointsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<TouchpointUniqueWhere>;
  create?: InputMaybe<TouchpointWithoutParentActivityCreateInput>;
  delete?: InputMaybe<TouchpointUniqueWhere>;
  disconnect?: InputMaybe<TouchpointUniqueWhere>;
  update?: InputMaybe<ActivityUpdateSubTouchpointsRelationInput>;
  upsert?: InputMaybe<ActivityUpsertSubTouchpointsRelationInput>;
};

export type ActivityUpdateSubTouchpointsRelationInput = {
  by: TouchpointUniqueWhere;
  data: TouchpointWithoutParentActivityUpdateInput;
};

export type ActivityUpdateTagsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<TagUniqueWhere>;
  create?: InputMaybe<TagWithoutActivitiesCreateInput>;
  delete?: InputMaybe<TagUniqueWhere>;
  disconnect?: InputMaybe<TagUniqueWhere>;
  update?: InputMaybe<ActivityUpdateTagsRelationInput>;
  upsert?: InputMaybe<ActivityUpsertTagsRelationInput>;
};

export type ActivityUpdateTagsRelationInput = {
  by: TagUniqueWhere;
  data: TagWithoutActivitiesUpdateInput;
};

export type ActivityUpdateTouchpointEntityRelationInput = {
  connect?: InputMaybe<TouchpointUniqueWhere>;
  connectOrCreate?: InputMaybe<ActivityConnectOrCreateTouchpointRelationInput>;
  create?: InputMaybe<TouchpointWithoutActivityCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<TouchpointWithoutActivityUpdateInput>;
  upsert?: InputMaybe<ActivityUpsertTouchpointRelationInput>;
};

export type ActivityUpdateWarningsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ActivityWarningUniqueWhere>;
  create?: InputMaybe<ActivityWarningWithoutActivityCreateInput>;
  delete?: InputMaybe<ActivityWarningUniqueWhere>;
  disconnect?: InputMaybe<ActivityWarningUniqueWhere>;
  update?: InputMaybe<ActivityUpdateWarningsRelationInput>;
  upsert?: InputMaybe<ActivityUpsertWarningsRelationInput>;
};

export type ActivityUpdateWarningsRelationInput = {
  by: ActivityWarningUniqueWhere;
  data: ActivityWarningWithoutActivityUpdateInput;
};

export type ActivityUpsertActionsRelationInput = {
  by: ActionUniqueWhere;
  create: ActionWithoutActivitiesCreateInput;
  update: ActionWithoutActivitiesUpdateInput;
};

export type ActivityUpsertConnectedJourneysRelationInput = {
  by: JourneyUniqueWhere;
  create: JourneyWithoutConnectedActivitiesCreateInput;
  update: JourneyWithoutConnectedActivitiesUpdateInput;
};

export type ActivityUpsertContentMetricsRelationInput = {
  by: ContentMetricUniqueWhere;
  create: ContentMetricWithoutActivitiesCreateInput;
  update: ContentMetricWithoutActivitiesUpdateInput;
};

export type ActivityUpsertControlCycleRelationInput = {
  create: ControlCycleCreateInput;
  update: ControlCycleUpdateInput;
};

export type ActivityUpsertDurationRelationInput = {
  create: ActivityDurationCreateInput;
  update: ActivityDurationUpdateInput;
};

export type ActivityUpsertOpportunitiesRelationInput = {
  by: OpportunityUniqueWhere;
  create: OpportunityWithoutActivitiesCreateInput;
  update: OpportunityWithoutActivitiesUpdateInput;
};

export type ActivityUpsertOwnerRelationInput = {
  create: MemberWithoutActivitiesCreateInput;
  update: MemberWithoutActivitiesUpdateInput;
};

export type ActivityUpsertPersonasRelationInput = {
  by: PersonaUniqueWhere;
  create: PersonaWithoutActivitiesCreateInput;
  update: PersonaWithoutActivitiesUpdateInput;
};

export type ActivityUpsertPicturesRelationInput = {
  by: PictureUniqueWhere;
  create: PictureWithoutActivityCreateInput;
  update: PictureWithoutActivityUpdateInput;
};

export type ActivityUpsertResult = MutationResult & {
  __typename?: 'ActivityUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Activity>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ActivityUpsertSubTouchpointsRelationInput = {
  by: TouchpointUniqueWhere;
  create: TouchpointWithoutParentActivityCreateInput;
  update: TouchpointWithoutParentActivityUpdateInput;
};

export type ActivityUpsertTagsRelationInput = {
  by: TagUniqueWhere;
  create: TagWithoutActivitiesCreateInput;
  update: TagWithoutActivitiesUpdateInput;
};

export type ActivityUpsertTouchpointRelationInput = {
  create: TouchpointWithoutActivityCreateInput;
  update: TouchpointWithoutActivityUpdateInput;
};

export type ActivityUpsertWarningsRelationInput = {
  by: ActivityWarningUniqueWhere;
  create: ActivityWarningWithoutActivityCreateInput;
  update: ActivityWarningWithoutActivityUpdateInput;
};

export type ActivityWarning = {
  __typename?: 'ActivityWarning';
  _meta?: Maybe<ActivityWarningMeta>;
  activity?: Maybe<Activity>;
  contentMetrics?: Maybe<ContentMetric>;
  id: Scalars['UUID']['output'];
};


export type ActivityWarningActivityArgs = {
  filter?: InputMaybe<ActivityWhere>;
};


export type ActivityWarningContentMetricsArgs = {
  filter?: InputMaybe<ContentMetricWhere>;
};

export type ActivityWarningConnectOrCreateActivityRelationInput = {
  connect: ActivityUniqueWhere;
  create: ActivityWithoutWarningsCreateInput;
};

export type ActivityWarningConnectOrCreateContentMetricsRelationInput = {
  connect: ContentMetricUniqueWhere;
  create: ContentMetricWithoutActivityWarningCreateInput;
};

export type ActivityWarningConnection = {
  __typename?: 'ActivityWarningConnection';
  edges: Array<ActivityWarningEdge>;
  pageInfo: PageInfo;
};

export type ActivityWarningCreateActivityEntityRelationInput = {
  connect?: InputMaybe<ActivityUniqueWhere>;
  connectOrCreate?: InputMaybe<ActivityWarningConnectOrCreateActivityRelationInput>;
  create?: InputMaybe<ActivityWithoutWarningsCreateInput>;
};

export type ActivityWarningCreateContentMetricsEntityRelationInput = {
  connect?: InputMaybe<ContentMetricUniqueWhere>;
  connectOrCreate?: InputMaybe<ActivityWarningConnectOrCreateContentMetricsRelationInput>;
  create?: InputMaybe<ContentMetricWithoutActivityWarningCreateInput>;
};

export type ActivityWarningCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activity?: InputMaybe<ActivityWarningCreateActivityEntityRelationInput>;
  contentMetrics?: InputMaybe<ActivityWarningCreateContentMetricsEntityRelationInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type ActivityWarningCreateResult = MutationResult & {
  __typename?: 'ActivityWarningCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<ActivityWarning>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ActivityWarningDeleteResult = MutationResult & {
  __typename?: 'ActivityWarningDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<ActivityWarning>;
  ok: Scalars['Boolean']['output'];
};

export type ActivityWarningEdge = {
  __typename?: 'ActivityWarningEdge';
  node: ActivityWarning;
};

export type ActivityWarningMeta = {
  __typename?: 'ActivityWarningMeta';
  activity?: Maybe<FieldMeta>;
  contentMetrics?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
};

export type ActivityWarningOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  activity?: InputMaybe<ActivityOrderBy>;
  contentMetrics?: InputMaybe<ContentMetricOrderBy>;
  id?: InputMaybe<OrderDirection>;
};

export type ActivityWarningUniqueWhere = {
  activity?: InputMaybe<ActivityUniqueWhere>;
  contentMetrics?: InputMaybe<ContentMetricUniqueWhere>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type ActivityWarningUpdateActivityEntityRelationInput = {
  connect?: InputMaybe<ActivityUniqueWhere>;
  connectOrCreate?: InputMaybe<ActivityWarningConnectOrCreateActivityRelationInput>;
  create?: InputMaybe<ActivityWithoutWarningsCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<ActivityWithoutWarningsUpdateInput>;
  upsert?: InputMaybe<ActivityWarningUpsertActivityRelationInput>;
};

export type ActivityWarningUpdateContentMetricsEntityRelationInput = {
  connect?: InputMaybe<ContentMetricUniqueWhere>;
  connectOrCreate?: InputMaybe<ActivityWarningConnectOrCreateContentMetricsRelationInput>;
  create?: InputMaybe<ContentMetricWithoutActivityWarningCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<ContentMetricWithoutActivityWarningUpdateInput>;
  upsert?: InputMaybe<ActivityWarningUpsertContentMetricsRelationInput>;
};

export type ActivityWarningUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activity?: InputMaybe<ActivityWarningUpdateActivityEntityRelationInput>;
  contentMetrics?: InputMaybe<ActivityWarningUpdateContentMetricsEntityRelationInput>;
};

export type ActivityWarningUpdateResult = MutationResult & {
  __typename?: 'ActivityWarningUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<ActivityWarning>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ActivityWarningUpsertActivityRelationInput = {
  create: ActivityWithoutWarningsCreateInput;
  update: ActivityWithoutWarningsUpdateInput;
};

export type ActivityWarningUpsertContentMetricsRelationInput = {
  create: ContentMetricWithoutActivityWarningCreateInput;
  update: ContentMetricWithoutActivityWarningUpdateInput;
};

export type ActivityWarningUpsertResult = MutationResult & {
  __typename?: 'ActivityWarningUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<ActivityWarning>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ActivityWarningWhere = {
  activity?: InputMaybe<ActivityWhere>;
  and?: InputMaybe<Array<InputMaybe<ActivityWarningWhere>>>;
  contentMetrics?: InputMaybe<ContentMetricWhere>;
  id?: InputMaybe<UuidCondition>;
  not?: InputMaybe<ActivityWarningWhere>;
  or?: InputMaybe<Array<InputMaybe<ActivityWarningWhere>>>;
};

export type ActivityWarningWithoutActivityCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  contentMetrics?: InputMaybe<ActivityWarningCreateContentMetricsEntityRelationInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type ActivityWarningWithoutActivityUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  contentMetrics?: InputMaybe<ActivityWarningUpdateContentMetricsEntityRelationInput>;
};

export type ActivityWarningWithoutContentMetricsCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activity?: InputMaybe<ActivityWarningCreateActivityEntityRelationInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type ActivityWarningWithoutContentMetricsUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activity?: InputMaybe<ActivityWarningUpdateActivityEntityRelationInput>;
};

export type ActivityWarningsByContentMetricsUniqueWhere = {
  contentMetrics?: InputMaybe<ContentMetricUniqueWhere>;
};

export type ActivityWhere = {
  actions?: InputMaybe<ActionWhere>;
  and?: InputMaybe<Array<InputMaybe<ActivityWhere>>>;
  connectedJourneys?: InputMaybe<JourneyWhere>;
  contentMetrics?: InputMaybe<ContentMetricWhere>;
  controlCycle?: InputMaybe<ControlCycleWhere>;
  createdAt?: InputMaybe<DateTimeCondition>;
  description?: InputMaybe<StringCondition>;
  duration?: InputMaybe<ActivityDurationWhere>;
  goalsAndObjectives?: InputMaybe<StringCondition>;
  id?: InputMaybe<UuidCondition>;
  links?: InputMaybe<JsonCondition>;
  name?: InputMaybe<StringCondition>;
  not?: InputMaybe<ActivityWhere>;
  notes?: InputMaybe<StringCondition>;
  opportunities?: InputMaybe<OpportunityWhere>;
  or?: InputMaybe<Array<InputMaybe<ActivityWhere>>>;
  owner?: InputMaybe<MemberWhere>;
  personas?: InputMaybe<PersonaWhere>;
  pictures?: InputMaybe<PictureWhere>;
  satisfaction?: InputMaybe<IntCondition>;
  subTouchpoints?: InputMaybe<TouchpointWhere>;
  tags?: InputMaybe<TagWhere>;
  touchpoint?: InputMaybe<TouchpointWhere>;
  warnings?: InputMaybe<ActivityWarningWhere>;
};

export type ActivityWithoutActionsCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  connectedJourneys?: InputMaybe<Array<ActivityCreateConnectedJourneysEntityRelationInput>>;
  contentMetrics?: InputMaybe<Array<ActivityCreateContentMetricsEntityRelationInput>>;
  controlCycle?: InputMaybe<ActivityCreateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ActivityCreateDurationEntityRelationInput>;
  goalsAndObjectives?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActivityCreateOpportunitiesEntityRelationInput>>;
  owner?: InputMaybe<ActivityCreateOwnerEntityRelationInput>;
  personas?: InputMaybe<Array<ActivityCreatePersonasEntityRelationInput>>;
  pictures?: InputMaybe<Array<ActivityCreatePicturesEntityRelationInput>>;
  satisfaction?: InputMaybe<Scalars['Int']['input']>;
  subTouchpoints?: InputMaybe<Array<ActivityCreateSubTouchpointsEntityRelationInput>>;
  tags?: InputMaybe<Array<ActivityCreateTagsEntityRelationInput>>;
  touchpoint?: InputMaybe<ActivityCreateTouchpointEntityRelationInput>;
  warnings?: InputMaybe<Array<ActivityCreateWarningsEntityRelationInput>>;
};

export type ActivityWithoutActionsUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  connectedJourneys?: InputMaybe<Array<ActivityUpdateConnectedJourneysEntityRelationInput>>;
  contentMetrics?: InputMaybe<Array<ActivityUpdateContentMetricsEntityRelationInput>>;
  controlCycle?: InputMaybe<ActivityUpdateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ActivityUpdateDurationEntityRelationInput>;
  goalsAndObjectives?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActivityUpdateOpportunitiesEntityRelationInput>>;
  owner?: InputMaybe<ActivityUpdateOwnerEntityRelationInput>;
  personas?: InputMaybe<Array<ActivityUpdatePersonasEntityRelationInput>>;
  pictures?: InputMaybe<Array<ActivityUpdatePicturesEntityRelationInput>>;
  satisfaction?: InputMaybe<Scalars['Int']['input']>;
  subTouchpoints?: InputMaybe<Array<ActivityUpdateSubTouchpointsEntityRelationInput>>;
  tags?: InputMaybe<Array<ActivityUpdateTagsEntityRelationInput>>;
  touchpoint?: InputMaybe<ActivityUpdateTouchpointEntityRelationInput>;
  warnings?: InputMaybe<Array<ActivityUpdateWarningsEntityRelationInput>>;
};

export type ActivityWithoutConnectedJourneysCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<ActivityCreateActionsEntityRelationInput>>;
  contentMetrics?: InputMaybe<Array<ActivityCreateContentMetricsEntityRelationInput>>;
  controlCycle?: InputMaybe<ActivityCreateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ActivityCreateDurationEntityRelationInput>;
  goalsAndObjectives?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActivityCreateOpportunitiesEntityRelationInput>>;
  owner?: InputMaybe<ActivityCreateOwnerEntityRelationInput>;
  personas?: InputMaybe<Array<ActivityCreatePersonasEntityRelationInput>>;
  pictures?: InputMaybe<Array<ActivityCreatePicturesEntityRelationInput>>;
  satisfaction?: InputMaybe<Scalars['Int']['input']>;
  subTouchpoints?: InputMaybe<Array<ActivityCreateSubTouchpointsEntityRelationInput>>;
  tags?: InputMaybe<Array<ActivityCreateTagsEntityRelationInput>>;
  touchpoint?: InputMaybe<ActivityCreateTouchpointEntityRelationInput>;
  warnings?: InputMaybe<Array<ActivityCreateWarningsEntityRelationInput>>;
};

export type ActivityWithoutConnectedJourneysUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<ActivityUpdateActionsEntityRelationInput>>;
  contentMetrics?: InputMaybe<Array<ActivityUpdateContentMetricsEntityRelationInput>>;
  controlCycle?: InputMaybe<ActivityUpdateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ActivityUpdateDurationEntityRelationInput>;
  goalsAndObjectives?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActivityUpdateOpportunitiesEntityRelationInput>>;
  owner?: InputMaybe<ActivityUpdateOwnerEntityRelationInput>;
  personas?: InputMaybe<Array<ActivityUpdatePersonasEntityRelationInput>>;
  pictures?: InputMaybe<Array<ActivityUpdatePicturesEntityRelationInput>>;
  satisfaction?: InputMaybe<Scalars['Int']['input']>;
  subTouchpoints?: InputMaybe<Array<ActivityUpdateSubTouchpointsEntityRelationInput>>;
  tags?: InputMaybe<Array<ActivityUpdateTagsEntityRelationInput>>;
  touchpoint?: InputMaybe<ActivityUpdateTouchpointEntityRelationInput>;
  warnings?: InputMaybe<Array<ActivityUpdateWarningsEntityRelationInput>>;
};

export type ActivityWithoutContentMetricsCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<ActivityCreateActionsEntityRelationInput>>;
  connectedJourneys?: InputMaybe<Array<ActivityCreateConnectedJourneysEntityRelationInput>>;
  controlCycle?: InputMaybe<ActivityCreateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ActivityCreateDurationEntityRelationInput>;
  goalsAndObjectives?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActivityCreateOpportunitiesEntityRelationInput>>;
  owner?: InputMaybe<ActivityCreateOwnerEntityRelationInput>;
  personas?: InputMaybe<Array<ActivityCreatePersonasEntityRelationInput>>;
  pictures?: InputMaybe<Array<ActivityCreatePicturesEntityRelationInput>>;
  satisfaction?: InputMaybe<Scalars['Int']['input']>;
  subTouchpoints?: InputMaybe<Array<ActivityCreateSubTouchpointsEntityRelationInput>>;
  tags?: InputMaybe<Array<ActivityCreateTagsEntityRelationInput>>;
  touchpoint?: InputMaybe<ActivityCreateTouchpointEntityRelationInput>;
  warnings?: InputMaybe<Array<ActivityCreateWarningsEntityRelationInput>>;
};

export type ActivityWithoutContentMetricsUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<ActivityUpdateActionsEntityRelationInput>>;
  connectedJourneys?: InputMaybe<Array<ActivityUpdateConnectedJourneysEntityRelationInput>>;
  controlCycle?: InputMaybe<ActivityUpdateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ActivityUpdateDurationEntityRelationInput>;
  goalsAndObjectives?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActivityUpdateOpportunitiesEntityRelationInput>>;
  owner?: InputMaybe<ActivityUpdateOwnerEntityRelationInput>;
  personas?: InputMaybe<Array<ActivityUpdatePersonasEntityRelationInput>>;
  pictures?: InputMaybe<Array<ActivityUpdatePicturesEntityRelationInput>>;
  satisfaction?: InputMaybe<Scalars['Int']['input']>;
  subTouchpoints?: InputMaybe<Array<ActivityUpdateSubTouchpointsEntityRelationInput>>;
  tags?: InputMaybe<Array<ActivityUpdateTagsEntityRelationInput>>;
  touchpoint?: InputMaybe<ActivityUpdateTouchpointEntityRelationInput>;
  warnings?: InputMaybe<Array<ActivityUpdateWarningsEntityRelationInput>>;
};

export type ActivityWithoutOpportunitiesCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<ActivityCreateActionsEntityRelationInput>>;
  connectedJourneys?: InputMaybe<Array<ActivityCreateConnectedJourneysEntityRelationInput>>;
  contentMetrics?: InputMaybe<Array<ActivityCreateContentMetricsEntityRelationInput>>;
  controlCycle?: InputMaybe<ActivityCreateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ActivityCreateDurationEntityRelationInput>;
  goalsAndObjectives?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<ActivityCreateOwnerEntityRelationInput>;
  personas?: InputMaybe<Array<ActivityCreatePersonasEntityRelationInput>>;
  pictures?: InputMaybe<Array<ActivityCreatePicturesEntityRelationInput>>;
  satisfaction?: InputMaybe<Scalars['Int']['input']>;
  subTouchpoints?: InputMaybe<Array<ActivityCreateSubTouchpointsEntityRelationInput>>;
  tags?: InputMaybe<Array<ActivityCreateTagsEntityRelationInput>>;
  touchpoint?: InputMaybe<ActivityCreateTouchpointEntityRelationInput>;
  warnings?: InputMaybe<Array<ActivityCreateWarningsEntityRelationInput>>;
};

export type ActivityWithoutOpportunitiesUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<ActivityUpdateActionsEntityRelationInput>>;
  connectedJourneys?: InputMaybe<Array<ActivityUpdateConnectedJourneysEntityRelationInput>>;
  contentMetrics?: InputMaybe<Array<ActivityUpdateContentMetricsEntityRelationInput>>;
  controlCycle?: InputMaybe<ActivityUpdateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ActivityUpdateDurationEntityRelationInput>;
  goalsAndObjectives?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<ActivityUpdateOwnerEntityRelationInput>;
  personas?: InputMaybe<Array<ActivityUpdatePersonasEntityRelationInput>>;
  pictures?: InputMaybe<Array<ActivityUpdatePicturesEntityRelationInput>>;
  satisfaction?: InputMaybe<Scalars['Int']['input']>;
  subTouchpoints?: InputMaybe<Array<ActivityUpdateSubTouchpointsEntityRelationInput>>;
  tags?: InputMaybe<Array<ActivityUpdateTagsEntityRelationInput>>;
  touchpoint?: InputMaybe<ActivityUpdateTouchpointEntityRelationInput>;
  warnings?: InputMaybe<Array<ActivityUpdateWarningsEntityRelationInput>>;
};

export type ActivityWithoutOwnerCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<ActivityCreateActionsEntityRelationInput>>;
  connectedJourneys?: InputMaybe<Array<ActivityCreateConnectedJourneysEntityRelationInput>>;
  contentMetrics?: InputMaybe<Array<ActivityCreateContentMetricsEntityRelationInput>>;
  controlCycle?: InputMaybe<ActivityCreateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ActivityCreateDurationEntityRelationInput>;
  goalsAndObjectives?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActivityCreateOpportunitiesEntityRelationInput>>;
  personas?: InputMaybe<Array<ActivityCreatePersonasEntityRelationInput>>;
  pictures?: InputMaybe<Array<ActivityCreatePicturesEntityRelationInput>>;
  satisfaction?: InputMaybe<Scalars['Int']['input']>;
  subTouchpoints?: InputMaybe<Array<ActivityCreateSubTouchpointsEntityRelationInput>>;
  tags?: InputMaybe<Array<ActivityCreateTagsEntityRelationInput>>;
  touchpoint?: InputMaybe<ActivityCreateTouchpointEntityRelationInput>;
  warnings?: InputMaybe<Array<ActivityCreateWarningsEntityRelationInput>>;
};

export type ActivityWithoutOwnerUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<ActivityUpdateActionsEntityRelationInput>>;
  connectedJourneys?: InputMaybe<Array<ActivityUpdateConnectedJourneysEntityRelationInput>>;
  contentMetrics?: InputMaybe<Array<ActivityUpdateContentMetricsEntityRelationInput>>;
  controlCycle?: InputMaybe<ActivityUpdateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ActivityUpdateDurationEntityRelationInput>;
  goalsAndObjectives?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActivityUpdateOpportunitiesEntityRelationInput>>;
  personas?: InputMaybe<Array<ActivityUpdatePersonasEntityRelationInput>>;
  pictures?: InputMaybe<Array<ActivityUpdatePicturesEntityRelationInput>>;
  satisfaction?: InputMaybe<Scalars['Int']['input']>;
  subTouchpoints?: InputMaybe<Array<ActivityUpdateSubTouchpointsEntityRelationInput>>;
  tags?: InputMaybe<Array<ActivityUpdateTagsEntityRelationInput>>;
  touchpoint?: InputMaybe<ActivityUpdateTouchpointEntityRelationInput>;
  warnings?: InputMaybe<Array<ActivityUpdateWarningsEntityRelationInput>>;
};

export type ActivityWithoutPersonasCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<ActivityCreateActionsEntityRelationInput>>;
  connectedJourneys?: InputMaybe<Array<ActivityCreateConnectedJourneysEntityRelationInput>>;
  contentMetrics?: InputMaybe<Array<ActivityCreateContentMetricsEntityRelationInput>>;
  controlCycle?: InputMaybe<ActivityCreateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ActivityCreateDurationEntityRelationInput>;
  goalsAndObjectives?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActivityCreateOpportunitiesEntityRelationInput>>;
  owner?: InputMaybe<ActivityCreateOwnerEntityRelationInput>;
  pictures?: InputMaybe<Array<ActivityCreatePicturesEntityRelationInput>>;
  satisfaction?: InputMaybe<Scalars['Int']['input']>;
  subTouchpoints?: InputMaybe<Array<ActivityCreateSubTouchpointsEntityRelationInput>>;
  tags?: InputMaybe<Array<ActivityCreateTagsEntityRelationInput>>;
  touchpoint?: InputMaybe<ActivityCreateTouchpointEntityRelationInput>;
  warnings?: InputMaybe<Array<ActivityCreateWarningsEntityRelationInput>>;
};

export type ActivityWithoutPersonasUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<ActivityUpdateActionsEntityRelationInput>>;
  connectedJourneys?: InputMaybe<Array<ActivityUpdateConnectedJourneysEntityRelationInput>>;
  contentMetrics?: InputMaybe<Array<ActivityUpdateContentMetricsEntityRelationInput>>;
  controlCycle?: InputMaybe<ActivityUpdateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ActivityUpdateDurationEntityRelationInput>;
  goalsAndObjectives?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActivityUpdateOpportunitiesEntityRelationInput>>;
  owner?: InputMaybe<ActivityUpdateOwnerEntityRelationInput>;
  pictures?: InputMaybe<Array<ActivityUpdatePicturesEntityRelationInput>>;
  satisfaction?: InputMaybe<Scalars['Int']['input']>;
  subTouchpoints?: InputMaybe<Array<ActivityUpdateSubTouchpointsEntityRelationInput>>;
  tags?: InputMaybe<Array<ActivityUpdateTagsEntityRelationInput>>;
  touchpoint?: InputMaybe<ActivityUpdateTouchpointEntityRelationInput>;
  warnings?: InputMaybe<Array<ActivityUpdateWarningsEntityRelationInput>>;
};

export type ActivityWithoutPicturesCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<ActivityCreateActionsEntityRelationInput>>;
  connectedJourneys?: InputMaybe<Array<ActivityCreateConnectedJourneysEntityRelationInput>>;
  contentMetrics?: InputMaybe<Array<ActivityCreateContentMetricsEntityRelationInput>>;
  controlCycle?: InputMaybe<ActivityCreateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ActivityCreateDurationEntityRelationInput>;
  goalsAndObjectives?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActivityCreateOpportunitiesEntityRelationInput>>;
  owner?: InputMaybe<ActivityCreateOwnerEntityRelationInput>;
  personas?: InputMaybe<Array<ActivityCreatePersonasEntityRelationInput>>;
  satisfaction?: InputMaybe<Scalars['Int']['input']>;
  subTouchpoints?: InputMaybe<Array<ActivityCreateSubTouchpointsEntityRelationInput>>;
  tags?: InputMaybe<Array<ActivityCreateTagsEntityRelationInput>>;
  touchpoint?: InputMaybe<ActivityCreateTouchpointEntityRelationInput>;
  warnings?: InputMaybe<Array<ActivityCreateWarningsEntityRelationInput>>;
};

export type ActivityWithoutPicturesUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<ActivityUpdateActionsEntityRelationInput>>;
  connectedJourneys?: InputMaybe<Array<ActivityUpdateConnectedJourneysEntityRelationInput>>;
  contentMetrics?: InputMaybe<Array<ActivityUpdateContentMetricsEntityRelationInput>>;
  controlCycle?: InputMaybe<ActivityUpdateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ActivityUpdateDurationEntityRelationInput>;
  goalsAndObjectives?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActivityUpdateOpportunitiesEntityRelationInput>>;
  owner?: InputMaybe<ActivityUpdateOwnerEntityRelationInput>;
  personas?: InputMaybe<Array<ActivityUpdatePersonasEntityRelationInput>>;
  satisfaction?: InputMaybe<Scalars['Int']['input']>;
  subTouchpoints?: InputMaybe<Array<ActivityUpdateSubTouchpointsEntityRelationInput>>;
  tags?: InputMaybe<Array<ActivityUpdateTagsEntityRelationInput>>;
  touchpoint?: InputMaybe<ActivityUpdateTouchpointEntityRelationInput>;
  warnings?: InputMaybe<Array<ActivityUpdateWarningsEntityRelationInput>>;
};

export type ActivityWithoutSubTouchpointsCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<ActivityCreateActionsEntityRelationInput>>;
  connectedJourneys?: InputMaybe<Array<ActivityCreateConnectedJourneysEntityRelationInput>>;
  contentMetrics?: InputMaybe<Array<ActivityCreateContentMetricsEntityRelationInput>>;
  controlCycle?: InputMaybe<ActivityCreateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ActivityCreateDurationEntityRelationInput>;
  goalsAndObjectives?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActivityCreateOpportunitiesEntityRelationInput>>;
  owner?: InputMaybe<ActivityCreateOwnerEntityRelationInput>;
  personas?: InputMaybe<Array<ActivityCreatePersonasEntityRelationInput>>;
  pictures?: InputMaybe<Array<ActivityCreatePicturesEntityRelationInput>>;
  satisfaction?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<ActivityCreateTagsEntityRelationInput>>;
  touchpoint?: InputMaybe<ActivityCreateTouchpointEntityRelationInput>;
  warnings?: InputMaybe<Array<ActivityCreateWarningsEntityRelationInput>>;
};

export type ActivityWithoutSubTouchpointsUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<ActivityUpdateActionsEntityRelationInput>>;
  connectedJourneys?: InputMaybe<Array<ActivityUpdateConnectedJourneysEntityRelationInput>>;
  contentMetrics?: InputMaybe<Array<ActivityUpdateContentMetricsEntityRelationInput>>;
  controlCycle?: InputMaybe<ActivityUpdateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ActivityUpdateDurationEntityRelationInput>;
  goalsAndObjectives?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActivityUpdateOpportunitiesEntityRelationInput>>;
  owner?: InputMaybe<ActivityUpdateOwnerEntityRelationInput>;
  personas?: InputMaybe<Array<ActivityUpdatePersonasEntityRelationInput>>;
  pictures?: InputMaybe<Array<ActivityUpdatePicturesEntityRelationInput>>;
  satisfaction?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<ActivityUpdateTagsEntityRelationInput>>;
  touchpoint?: InputMaybe<ActivityUpdateTouchpointEntityRelationInput>;
  warnings?: InputMaybe<Array<ActivityUpdateWarningsEntityRelationInput>>;
};

export type ActivityWithoutTagsCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<ActivityCreateActionsEntityRelationInput>>;
  connectedJourneys?: InputMaybe<Array<ActivityCreateConnectedJourneysEntityRelationInput>>;
  contentMetrics?: InputMaybe<Array<ActivityCreateContentMetricsEntityRelationInput>>;
  controlCycle?: InputMaybe<ActivityCreateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ActivityCreateDurationEntityRelationInput>;
  goalsAndObjectives?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActivityCreateOpportunitiesEntityRelationInput>>;
  owner?: InputMaybe<ActivityCreateOwnerEntityRelationInput>;
  personas?: InputMaybe<Array<ActivityCreatePersonasEntityRelationInput>>;
  pictures?: InputMaybe<Array<ActivityCreatePicturesEntityRelationInput>>;
  satisfaction?: InputMaybe<Scalars['Int']['input']>;
  subTouchpoints?: InputMaybe<Array<ActivityCreateSubTouchpointsEntityRelationInput>>;
  touchpoint?: InputMaybe<ActivityCreateTouchpointEntityRelationInput>;
  warnings?: InputMaybe<Array<ActivityCreateWarningsEntityRelationInput>>;
};

export type ActivityWithoutTagsUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<ActivityUpdateActionsEntityRelationInput>>;
  connectedJourneys?: InputMaybe<Array<ActivityUpdateConnectedJourneysEntityRelationInput>>;
  contentMetrics?: InputMaybe<Array<ActivityUpdateContentMetricsEntityRelationInput>>;
  controlCycle?: InputMaybe<ActivityUpdateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ActivityUpdateDurationEntityRelationInput>;
  goalsAndObjectives?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActivityUpdateOpportunitiesEntityRelationInput>>;
  owner?: InputMaybe<ActivityUpdateOwnerEntityRelationInput>;
  personas?: InputMaybe<Array<ActivityUpdatePersonasEntityRelationInput>>;
  pictures?: InputMaybe<Array<ActivityUpdatePicturesEntityRelationInput>>;
  satisfaction?: InputMaybe<Scalars['Int']['input']>;
  subTouchpoints?: InputMaybe<Array<ActivityUpdateSubTouchpointsEntityRelationInput>>;
  touchpoint?: InputMaybe<ActivityUpdateTouchpointEntityRelationInput>;
  warnings?: InputMaybe<Array<ActivityUpdateWarningsEntityRelationInput>>;
};

export type ActivityWithoutTouchpointCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<ActivityCreateActionsEntityRelationInput>>;
  connectedJourneys?: InputMaybe<Array<ActivityCreateConnectedJourneysEntityRelationInput>>;
  contentMetrics?: InputMaybe<Array<ActivityCreateContentMetricsEntityRelationInput>>;
  controlCycle?: InputMaybe<ActivityCreateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ActivityCreateDurationEntityRelationInput>;
  goalsAndObjectives?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActivityCreateOpportunitiesEntityRelationInput>>;
  owner?: InputMaybe<ActivityCreateOwnerEntityRelationInput>;
  personas?: InputMaybe<Array<ActivityCreatePersonasEntityRelationInput>>;
  pictures?: InputMaybe<Array<ActivityCreatePicturesEntityRelationInput>>;
  satisfaction?: InputMaybe<Scalars['Int']['input']>;
  subTouchpoints?: InputMaybe<Array<ActivityCreateSubTouchpointsEntityRelationInput>>;
  tags?: InputMaybe<Array<ActivityCreateTagsEntityRelationInput>>;
  warnings?: InputMaybe<Array<ActivityCreateWarningsEntityRelationInput>>;
};

export type ActivityWithoutTouchpointUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<ActivityUpdateActionsEntityRelationInput>>;
  connectedJourneys?: InputMaybe<Array<ActivityUpdateConnectedJourneysEntityRelationInput>>;
  contentMetrics?: InputMaybe<Array<ActivityUpdateContentMetricsEntityRelationInput>>;
  controlCycle?: InputMaybe<ActivityUpdateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ActivityUpdateDurationEntityRelationInput>;
  goalsAndObjectives?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActivityUpdateOpportunitiesEntityRelationInput>>;
  owner?: InputMaybe<ActivityUpdateOwnerEntityRelationInput>;
  personas?: InputMaybe<Array<ActivityUpdatePersonasEntityRelationInput>>;
  pictures?: InputMaybe<Array<ActivityUpdatePicturesEntityRelationInput>>;
  satisfaction?: InputMaybe<Scalars['Int']['input']>;
  subTouchpoints?: InputMaybe<Array<ActivityUpdateSubTouchpointsEntityRelationInput>>;
  tags?: InputMaybe<Array<ActivityUpdateTagsEntityRelationInput>>;
  warnings?: InputMaybe<Array<ActivityUpdateWarningsEntityRelationInput>>;
};

export type ActivityWithoutWarningsCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<ActivityCreateActionsEntityRelationInput>>;
  connectedJourneys?: InputMaybe<Array<ActivityCreateConnectedJourneysEntityRelationInput>>;
  contentMetrics?: InputMaybe<Array<ActivityCreateContentMetricsEntityRelationInput>>;
  controlCycle?: InputMaybe<ActivityCreateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ActivityCreateDurationEntityRelationInput>;
  goalsAndObjectives?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActivityCreateOpportunitiesEntityRelationInput>>;
  owner?: InputMaybe<ActivityCreateOwnerEntityRelationInput>;
  personas?: InputMaybe<Array<ActivityCreatePersonasEntityRelationInput>>;
  pictures?: InputMaybe<Array<ActivityCreatePicturesEntityRelationInput>>;
  satisfaction?: InputMaybe<Scalars['Int']['input']>;
  subTouchpoints?: InputMaybe<Array<ActivityCreateSubTouchpointsEntityRelationInput>>;
  tags?: InputMaybe<Array<ActivityCreateTagsEntityRelationInput>>;
  touchpoint?: InputMaybe<ActivityCreateTouchpointEntityRelationInput>;
};

export type ActivityWithoutWarningsUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<ActivityUpdateActionsEntityRelationInput>>;
  connectedJourneys?: InputMaybe<Array<ActivityUpdateConnectedJourneysEntityRelationInput>>;
  contentMetrics?: InputMaybe<Array<ActivityUpdateContentMetricsEntityRelationInput>>;
  controlCycle?: InputMaybe<ActivityUpdateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ActivityUpdateDurationEntityRelationInput>;
  goalsAndObjectives?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<ActivityUpdateOpportunitiesEntityRelationInput>>;
  owner?: InputMaybe<ActivityUpdateOwnerEntityRelationInput>;
  personas?: InputMaybe<Array<ActivityUpdatePersonasEntityRelationInput>>;
  pictures?: InputMaybe<Array<ActivityUpdatePicturesEntityRelationInput>>;
  satisfaction?: InputMaybe<Scalars['Int']['input']>;
  subTouchpoints?: InputMaybe<Array<ActivityUpdateSubTouchpointsEntityRelationInput>>;
  tags?: InputMaybe<Array<ActivityUpdateTagsEntityRelationInput>>;
  touchpoint?: InputMaybe<ActivityUpdateTouchpointEntityRelationInput>;
};

export type AddGlobalIdentityRolesError = {
  __typename?: 'AddGlobalIdentityRolesError';
  code: AddGlobalIdentityRolesErrorCode;
  developerMessage: Scalars['String']['output'];
};

export type AddGlobalIdentityRolesErrorCode =
  | 'IDENTITY_NOT_FOUND'
  | 'INVALID_ROLE';

export type AddGlobalIdentityRolesResponse = {
  __typename?: 'AddGlobalIdentityRolesResponse';
  error?: Maybe<AddGlobalIdentityRolesError>;
  ok: Scalars['Boolean']['output'];
  result?: Maybe<AddGlobalIdentityRolesResult>;
};

export type AddGlobalIdentityRolesResult = {
  __typename?: 'AddGlobalIdentityRolesResult';
  identity: Identity;
};

export type AddIdpError = {
  __typename?: 'AddIDPError';
  code: AddIdpErrorCode;
  developerMessage: Scalars['String']['output'];
};

export type AddIdpErrorCode =
  | 'ALREADY_EXISTS'
  | 'INVALID_CONFIGURATION'
  | 'UNKNOWN_TYPE';

export type AddIdpResponse = {
  __typename?: 'AddIDPResponse';
  error?: Maybe<AddIdpError>;
  ok: Scalars['Boolean']['output'];
};

export type AddMailTemplateError = {
  __typename?: 'AddMailTemplateError';
  code: AddMailTemplateErrorCode;
  developerMessage: Scalars['String']['output'];
  /** @deprecated Field no longer supported */
  endUserMessage?: Maybe<Scalars['String']['output']>;
};

export type AddMailTemplateErrorCode =
  | 'INVALID_REPLY_EMAIL_FORMAT'
  | 'MISSING_VARIABLE'
  | 'PROJECT_NOT_FOUND';

export type AddMailTemplateResponse = {
  __typename?: 'AddMailTemplateResponse';
  error?: Maybe<AddMailTemplateError>;
  /** @deprecated Field no longer supported */
  errors: Array<AddMailTemplateError>;
  ok: Scalars['Boolean']['output'];
};

export type AddProjectMemberError = {
  __typename?: 'AddProjectMemberError';
  code: AddProjectMemberErrorCode;
  developerMessage: Scalars['String']['output'];
  /** @deprecated Field no longer supported */
  endUserMessage?: Maybe<Scalars['String']['output']>;
  membershipValidation?: Maybe<Array<MembershipValidationError>>;
};

export type AddProjectMemberErrorCode =
  | 'ALREADY_MEMBER'
  | 'IDENTITY_NOT_FOUND'
  | 'INVALID_MEMBERSHIP'
  | 'PROJECT_NOT_FOUND'
  | 'ROLE_NOT_FOUND'
  | 'VARIABLE_EMPTY'
  | 'VARIABLE_NOT_FOUND';

export type AddProjectMemberResponse = {
  __typename?: 'AddProjectMemberResponse';
  error?: Maybe<AddProjectMemberError>;
  errors: Array<AddProjectMemberError>;
  ok: Scalars['Boolean']['output'];
};

export type Announcement = {
  __typename?: 'Announcement';
  id: Scalars['UUID']['output'];
  message: Scalars['String']['output'];
  type: AnnouncementType;
};

export type AnnouncementType =
  | 'ERROR'
  | 'INFO'
  | 'WARNING';

export type ApiKey = {
  __typename?: 'ApiKey';
  id: Scalars['String']['output'];
  identity: Identity;
};

export type ApiKeyWithToken = {
  __typename?: 'ApiKeyWithToken';
  id: Scalars['String']['output'];
  identity: Identity;
  token?: Maybe<Scalars['String']['output']>;
};

export type BooleanCondition = {
  and?: InputMaybe<Array<BooleanCondition>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanCondition>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<BooleanCondition>>;
};

export type BreakdownInterval =
  | 'MONTH'
  | 'WEEK';

export type ChangeMyPasswordError = {
  __typename?: 'ChangeMyPasswordError';
  code: ChangeMyPasswordErrorCode;
  developerMessage: Scalars['String']['output'];
};

export type ChangeMyPasswordErrorCode =
  | 'INVALID_PASSWORD'
  | 'NOT_A_PERSON'
  | 'NO_PASSWORD_SET'
  | 'TOO_WEAK';

export type ChangeMyPasswordResponse = {
  __typename?: 'ChangeMyPasswordResponse';
  error?: Maybe<ChangeMyPasswordError>;
  ok: Scalars['Boolean']['output'];
};

export type ChangeMyProfileError = {
  __typename?: 'ChangeMyProfileError';
  code: ChangeMyProfileErrorCode;
  developerMessage: Scalars['String']['output'];
};

export type ChangeMyProfileErrorCode =
  | 'EMAIL_ALREADY_EXISTS'
  | 'INVALID_EMAIL_FORMAT'
  | 'NOT_A_PERSON';

export type ChangeMyProfileResponse = {
  __typename?: 'ChangeMyProfileResponse';
  error?: Maybe<ChangeMyProfileError>;
  ok: Scalars['Boolean']['output'];
};

export type ChangePasswordError = {
  __typename?: 'ChangePasswordError';
  code: ChangePasswordErrorCode;
  developerMessage: Scalars['String']['output'];
  /** @deprecated Field no longer supported */
  endUserMessage?: Maybe<Scalars['String']['output']>;
};

export type ChangePasswordErrorCode =
  | 'PERSON_NOT_FOUND'
  | 'TOO_WEAK';

export type ChangePasswordResponse = {
  __typename?: 'ChangePasswordResponse';
  error?: Maybe<ChangePasswordError>;
  /** @deprecated Field no longer supported */
  errors: Array<ChangePasswordError>;
  ok: Scalars['Boolean']['output'];
};

export type ChangeProfileError = {
  __typename?: 'ChangeProfileError';
  code: ChangeProfileErrorCode;
  developerMessage: Scalars['String']['output'];
};

export type ChangeProfileErrorCode =
  | 'EMAIL_ALREADY_EXISTS'
  | 'INVALID_EMAIL_FORMAT'
  | 'PERSON_NOT_FOUND';

export type ChangeProfileResponse = {
  __typename?: 'ChangeProfileResponse';
  error?: Maybe<ChangeProfileError>;
  ok: Scalars['Boolean']['output'];
};

export type ChartDataPoint = {
  __typename?: 'ChartDataPoint';
  time: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type CheckResetPasswordTokenCode =
  | 'REQUEST_NOT_FOUND'
  | 'TOKEN_EXPIRED'
  | 'TOKEN_NOT_FOUND'
  | 'TOKEN_USED';

export type CheckResetPasswordTokenResult = {
  __typename?: 'CheckResetPasswordTokenResult';
  code: CheckResetPasswordTokenCode;
};

export type CommonSignInResult = {
  person: Person;
  token: Scalars['String']['output'];
};

export type ConfirmOtpError = {
  __typename?: 'ConfirmOtpError';
  code: ConfirmOtpErrorCode;
  developerMessage: Scalars['String']['output'];
  /** @deprecated Field no longer supported */
  endUserMessage?: Maybe<Scalars['String']['output']>;
};

export type ConfirmOtpErrorCode =
  | 'INVALID_OTP_TOKEN'
  | 'NOT_PREPARED';

export type ConfirmOtpResponse = {
  __typename?: 'ConfirmOtpResponse';
  error?: Maybe<ConfirmOtpError>;
  /** @deprecated Field no longer supported */
  errors: Array<ConfirmOtpError>;
  ok: Scalars['Boolean']['output'];
};

export type ContentMetric = {
  __typename?: 'ContentMetric';
  _meta?: Maybe<ContentMetricMeta>;
  activities: Array<Activity>;
  activityWarning: Array<ActivityWarning>;
  activityWarningByActivity?: Maybe<ActivityWarning>;
  hideFromPlanning: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  journeys: Array<Journey>;
  journeysByControlCycle?: Maybe<Journey>;
  journeysByPhases?: Maybe<Journey>;
  journeysByWidgets?: Maybe<Journey>;
  metric?: Maybe<Metric>;
  paginateActivities: ActivityConnection;
  paginateActivityWarning: ActivityWarningConnection;
  paginateJourneys: JourneyConnection;
};


export type ContentMetricActivitiesArgs = {
  filter?: InputMaybe<ActivityWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityOrderBy>>;
};


export type ContentMetricActivityWarningArgs = {
  filter?: InputMaybe<ActivityWarningWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityWarningOrderBy>>;
};


export type ContentMetricActivityWarningByActivityArgs = {
  by: ContentMetricActivityWarningByActivityUniqueWhere;
  filter?: InputMaybe<ActivityWarningWhere>;
};


export type ContentMetricJourneysArgs = {
  filter?: InputMaybe<JourneyWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<JourneyOrderBy>>;
};


export type ContentMetricJourneysByControlCycleArgs = {
  by: ContentMetricJourneysByControlCycleUniqueWhere;
  filter?: InputMaybe<JourneyWhere>;
};


export type ContentMetricJourneysByPhasesArgs = {
  by: ContentMetricJourneysByPhasesUniqueWhere;
  filter?: InputMaybe<JourneyWhere>;
};


export type ContentMetricJourneysByWidgetsArgs = {
  by: ContentMetricJourneysByWidgetsUniqueWhere;
  filter?: InputMaybe<JourneyWhere>;
};


export type ContentMetricMetricArgs = {
  filter?: InputMaybe<MetricWhere>;
};


export type ContentMetricPaginateActivitiesArgs = {
  filter?: InputMaybe<ActivityWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentMetricPaginateActivityWarningArgs = {
  filter?: InputMaybe<ActivityWarningWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityWarningOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentMetricPaginateJourneysArgs = {
  filter?: InputMaybe<JourneyWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<JourneyOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentMetricActivityWarningByActivityUniqueWhere = {
  activity?: InputMaybe<ActivityUniqueWhere>;
};

export type ContentMetricConnectOrCreateActivitiesRelationInput = {
  connect: ActivityUniqueWhere;
  create: ActivityWithoutContentMetricsCreateInput;
};

export type ContentMetricConnectOrCreateActivityWarningRelationInput = {
  connect: ActivityWarningUniqueWhere;
  create: ActivityWarningWithoutContentMetricsCreateInput;
};

export type ContentMetricConnectOrCreateJourneysRelationInput = {
  connect: JourneyUniqueWhere;
  create: JourneyWithoutMainMetricCreateInput;
};

export type ContentMetricConnectOrCreateMetricRelationInput = {
  connect: MetricUniqueWhere;
  create: MetricCreateInput;
};

export type ContentMetricConnection = {
  __typename?: 'ContentMetricConnection';
  edges: Array<ContentMetricEdge>;
  pageInfo: PageInfo;
};

export type ContentMetricCreateActivitiesEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ActivityUniqueWhere>;
  connectOrCreate?: InputMaybe<ContentMetricConnectOrCreateActivitiesRelationInput>;
  create?: InputMaybe<ActivityWithoutContentMetricsCreateInput>;
};

export type ContentMetricCreateActivityWarningEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ActivityWarningUniqueWhere>;
  connectOrCreate?: InputMaybe<ContentMetricConnectOrCreateActivityWarningRelationInput>;
  create?: InputMaybe<ActivityWarningWithoutContentMetricsCreateInput>;
};

export type ContentMetricCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activities?: InputMaybe<Array<ContentMetricCreateActivitiesEntityRelationInput>>;
  activityWarning?: InputMaybe<Array<ContentMetricCreateActivityWarningEntityRelationInput>>;
  hideFromPlanning?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  journeys?: InputMaybe<Array<ContentMetricCreateJourneysEntityRelationInput>>;
  metric?: InputMaybe<ContentMetricCreateMetricEntityRelationInput>;
};

export type ContentMetricCreateJourneysEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<JourneyUniqueWhere>;
  connectOrCreate?: InputMaybe<ContentMetricConnectOrCreateJourneysRelationInput>;
  create?: InputMaybe<JourneyWithoutMainMetricCreateInput>;
};

export type ContentMetricCreateMetricEntityRelationInput = {
  connect?: InputMaybe<MetricUniqueWhere>;
  connectOrCreate?: InputMaybe<ContentMetricConnectOrCreateMetricRelationInput>;
  create?: InputMaybe<MetricCreateInput>;
};

export type ContentMetricCreateResult = MutationResult & {
  __typename?: 'ContentMetricCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<ContentMetric>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ContentMetricDataPoint = {
  __typename?: 'ContentMetricDataPoint';
  _meta?: Maybe<ContentMetricDataPointMeta>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<Member>;
  id: Scalars['UUID']['output'];
  metricDataPoint?: Maybe<MetricDataPoint>;
};


export type ContentMetricDataPointCreatorArgs = {
  filter?: InputMaybe<MemberWhere>;
};


export type ContentMetricDataPointMetricDataPointArgs = {
  filter?: InputMaybe<MetricDataPointWhere>;
};

export type ContentMetricDataPointConnectOrCreateCreatorRelationInput = {
  connect: MemberUniqueWhere;
  create: MemberCreateInput;
};

export type ContentMetricDataPointConnectOrCreateMetricDataPointRelationInput = {
  connect: MetricDataPointUniqueWhere;
  create: MetricDataPointWithoutContentMetricDataPointCreateInput;
};

export type ContentMetricDataPointConnection = {
  __typename?: 'ContentMetricDataPointConnection';
  edges: Array<ContentMetricDataPointEdge>;
  pageInfo: PageInfo;
};

export type ContentMetricDataPointCreateCreatorEntityRelationInput = {
  connect?: InputMaybe<MemberUniqueWhere>;
  connectOrCreate?: InputMaybe<ContentMetricDataPointConnectOrCreateCreatorRelationInput>;
  create?: InputMaybe<MemberCreateInput>;
};

export type ContentMetricDataPointCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<ContentMetricDataPointCreateCreatorEntityRelationInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  metricDataPoint?: InputMaybe<ContentMetricDataPointCreateMetricDataPointEntityRelationInput>;
};

export type ContentMetricDataPointCreateMetricDataPointEntityRelationInput = {
  connect?: InputMaybe<MetricDataPointUniqueWhere>;
  connectOrCreate?: InputMaybe<ContentMetricDataPointConnectOrCreateMetricDataPointRelationInput>;
  create?: InputMaybe<MetricDataPointWithoutContentMetricDataPointCreateInput>;
};

export type ContentMetricDataPointCreateResult = MutationResult & {
  __typename?: 'ContentMetricDataPointCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<ContentMetricDataPoint>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ContentMetricDataPointDeleteResult = MutationResult & {
  __typename?: 'ContentMetricDataPointDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<ContentMetricDataPoint>;
  ok: Scalars['Boolean']['output'];
};

export type ContentMetricDataPointEdge = {
  __typename?: 'ContentMetricDataPointEdge';
  node: ContentMetricDataPoint;
};

export type ContentMetricDataPointMeta = {
  __typename?: 'ContentMetricDataPointMeta';
  createdAt?: Maybe<FieldMeta>;
  creator?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  metricDataPoint?: Maybe<FieldMeta>;
};

export type ContentMetricDataPointOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<OrderDirection>;
  creator?: InputMaybe<MemberOrderBy>;
  id?: InputMaybe<OrderDirection>;
  metricDataPoint?: InputMaybe<MetricDataPointOrderBy>;
};

export type ContentMetricDataPointUniqueWhere = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  metricDataPoint?: InputMaybe<MetricDataPointUniqueWhere>;
};

export type ContentMetricDataPointUpdateCreatorEntityRelationInput = {
  connect?: InputMaybe<MemberUniqueWhere>;
  connectOrCreate?: InputMaybe<ContentMetricDataPointConnectOrCreateCreatorRelationInput>;
  create?: InputMaybe<MemberCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<MemberUpdateInput>;
  upsert?: InputMaybe<ContentMetricDataPointUpsertCreatorRelationInput>;
};

export type ContentMetricDataPointUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<ContentMetricDataPointUpdateCreatorEntityRelationInput>;
  metricDataPoint?: InputMaybe<ContentMetricDataPointUpdateMetricDataPointEntityRelationInput>;
};

export type ContentMetricDataPointUpdateMetricDataPointEntityRelationInput = {
  connect?: InputMaybe<MetricDataPointUniqueWhere>;
  connectOrCreate?: InputMaybe<ContentMetricDataPointConnectOrCreateMetricDataPointRelationInput>;
  create?: InputMaybe<MetricDataPointWithoutContentMetricDataPointCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<MetricDataPointWithoutContentMetricDataPointUpdateInput>;
  upsert?: InputMaybe<ContentMetricDataPointUpsertMetricDataPointRelationInput>;
};

export type ContentMetricDataPointUpdateResult = MutationResult & {
  __typename?: 'ContentMetricDataPointUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<ContentMetricDataPoint>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ContentMetricDataPointUpsertCreatorRelationInput = {
  create: MemberCreateInput;
  update: MemberUpdateInput;
};

export type ContentMetricDataPointUpsertMetricDataPointRelationInput = {
  create: MetricDataPointWithoutContentMetricDataPointCreateInput;
  update: MetricDataPointWithoutContentMetricDataPointUpdateInput;
};

export type ContentMetricDataPointUpsertResult = MutationResult & {
  __typename?: 'ContentMetricDataPointUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<ContentMetricDataPoint>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ContentMetricDataPointWhere = {
  and?: InputMaybe<Array<InputMaybe<ContentMetricDataPointWhere>>>;
  createdAt?: InputMaybe<DateTimeCondition>;
  creator?: InputMaybe<MemberWhere>;
  id?: InputMaybe<UuidCondition>;
  metricDataPoint?: InputMaybe<MetricDataPointWhere>;
  not?: InputMaybe<ContentMetricDataPointWhere>;
  or?: InputMaybe<Array<InputMaybe<ContentMetricDataPointWhere>>>;
};

export type ContentMetricDataPointWithoutMetricDataPointCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<ContentMetricDataPointCreateCreatorEntityRelationInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type ContentMetricDataPointWithoutMetricDataPointUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<ContentMetricDataPointUpdateCreatorEntityRelationInput>;
};

export type ContentMetricDeleteResult = MutationResult & {
  __typename?: 'ContentMetricDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<ContentMetric>;
  ok: Scalars['Boolean']['output'];
};

export type ContentMetricEdge = {
  __typename?: 'ContentMetricEdge';
  node: ContentMetric;
};

export type ContentMetricJourneysByControlCycleUniqueWhere = {
  controlCycle?: InputMaybe<ControlCycleUniqueWhere>;
};

export type ContentMetricJourneysByPhasesUniqueWhere = {
  phases?: InputMaybe<PhaseUniqueWhere>;
};

export type ContentMetricJourneysByWidgetsUniqueWhere = {
  widgets?: InputMaybe<WidgetUniqueWhere>;
};

export type ContentMetricMeta = {
  __typename?: 'ContentMetricMeta';
  activities?: Maybe<FieldMeta>;
  activityWarning?: Maybe<FieldMeta>;
  hideFromPlanning?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  journeys?: Maybe<FieldMeta>;
  metric?: Maybe<FieldMeta>;
};

export type ContentMetricOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  hideFromPlanning?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  metric?: InputMaybe<MetricOrderBy>;
};

export type ContentMetricUniqueWhere = {
  activityWarning?: InputMaybe<ActivityWarningUniqueWhere>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  journeys?: InputMaybe<JourneyUniqueWhere>;
  metric?: InputMaybe<MetricUniqueWhere>;
};

export type ContentMetricUpdateActivitiesEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ActivityUniqueWhere>;
  create?: InputMaybe<ActivityWithoutContentMetricsCreateInput>;
  delete?: InputMaybe<ActivityUniqueWhere>;
  disconnect?: InputMaybe<ActivityUniqueWhere>;
  update?: InputMaybe<ContentMetricUpdateActivitiesRelationInput>;
  upsert?: InputMaybe<ContentMetricUpsertActivitiesRelationInput>;
};

export type ContentMetricUpdateActivitiesRelationInput = {
  by: ActivityUniqueWhere;
  data: ActivityWithoutContentMetricsUpdateInput;
};

export type ContentMetricUpdateActivityWarningEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ActivityWarningUniqueWhere>;
  create?: InputMaybe<ActivityWarningWithoutContentMetricsCreateInput>;
  delete?: InputMaybe<ActivityWarningUniqueWhere>;
  disconnect?: InputMaybe<ActivityWarningUniqueWhere>;
  update?: InputMaybe<ContentMetricUpdateActivityWarningRelationInput>;
  upsert?: InputMaybe<ContentMetricUpsertActivityWarningRelationInput>;
};

export type ContentMetricUpdateActivityWarningRelationInput = {
  by: ActivityWarningUniqueWhere;
  data: ActivityWarningWithoutContentMetricsUpdateInput;
};

export type ContentMetricUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activities?: InputMaybe<Array<ContentMetricUpdateActivitiesEntityRelationInput>>;
  activityWarning?: InputMaybe<Array<ContentMetricUpdateActivityWarningEntityRelationInput>>;
  hideFromPlanning?: InputMaybe<Scalars['Boolean']['input']>;
  journeys?: InputMaybe<Array<ContentMetricUpdateJourneysEntityRelationInput>>;
  metric?: InputMaybe<ContentMetricUpdateMetricEntityRelationInput>;
};

export type ContentMetricUpdateJourneysEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<JourneyUniqueWhere>;
  create?: InputMaybe<JourneyWithoutMainMetricCreateInput>;
  delete?: InputMaybe<JourneyUniqueWhere>;
  disconnect?: InputMaybe<JourneyUniqueWhere>;
  update?: InputMaybe<ContentMetricUpdateJourneysRelationInput>;
  upsert?: InputMaybe<ContentMetricUpsertJourneysRelationInput>;
};

export type ContentMetricUpdateJourneysRelationInput = {
  by: JourneyUniqueWhere;
  data: JourneyWithoutMainMetricUpdateInput;
};

export type ContentMetricUpdateMetricEntityRelationInput = {
  connect?: InputMaybe<MetricUniqueWhere>;
  connectOrCreate?: InputMaybe<ContentMetricConnectOrCreateMetricRelationInput>;
  create?: InputMaybe<MetricCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<MetricUpdateInput>;
  upsert?: InputMaybe<ContentMetricUpsertMetricRelationInput>;
};

export type ContentMetricUpdateResult = MutationResult & {
  __typename?: 'ContentMetricUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<ContentMetric>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ContentMetricUpsertActivitiesRelationInput = {
  by: ActivityUniqueWhere;
  create: ActivityWithoutContentMetricsCreateInput;
  update: ActivityWithoutContentMetricsUpdateInput;
};

export type ContentMetricUpsertActivityWarningRelationInput = {
  by: ActivityWarningUniqueWhere;
  create: ActivityWarningWithoutContentMetricsCreateInput;
  update: ActivityWarningWithoutContentMetricsUpdateInput;
};

export type ContentMetricUpsertJourneysRelationInput = {
  by: JourneyUniqueWhere;
  create: JourneyWithoutMainMetricCreateInput;
  update: JourneyWithoutMainMetricUpdateInput;
};

export type ContentMetricUpsertMetricRelationInput = {
  create: MetricCreateInput;
  update: MetricUpdateInput;
};

export type ContentMetricUpsertResult = MutationResult & {
  __typename?: 'ContentMetricUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<ContentMetric>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ContentMetricWhere = {
  activities?: InputMaybe<ActivityWhere>;
  activityWarning?: InputMaybe<ActivityWarningWhere>;
  and?: InputMaybe<Array<InputMaybe<ContentMetricWhere>>>;
  hideFromPlanning?: InputMaybe<BooleanCondition>;
  id?: InputMaybe<UuidCondition>;
  journeys?: InputMaybe<JourneyWhere>;
  metric?: InputMaybe<MetricWhere>;
  not?: InputMaybe<ContentMetricWhere>;
  or?: InputMaybe<Array<InputMaybe<ContentMetricWhere>>>;
};

export type ContentMetricWithoutActivitiesCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activityWarning?: InputMaybe<Array<ContentMetricCreateActivityWarningEntityRelationInput>>;
  hideFromPlanning?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  journeys?: InputMaybe<Array<ContentMetricCreateJourneysEntityRelationInput>>;
  metric?: InputMaybe<ContentMetricCreateMetricEntityRelationInput>;
};

export type ContentMetricWithoutActivitiesUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activityWarning?: InputMaybe<Array<ContentMetricUpdateActivityWarningEntityRelationInput>>;
  hideFromPlanning?: InputMaybe<Scalars['Boolean']['input']>;
  journeys?: InputMaybe<Array<ContentMetricUpdateJourneysEntityRelationInput>>;
  metric?: InputMaybe<ContentMetricUpdateMetricEntityRelationInput>;
};

export type ContentMetricWithoutActivityWarningCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activities?: InputMaybe<Array<ContentMetricCreateActivitiesEntityRelationInput>>;
  hideFromPlanning?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  journeys?: InputMaybe<Array<ContentMetricCreateJourneysEntityRelationInput>>;
  metric?: InputMaybe<ContentMetricCreateMetricEntityRelationInput>;
};

export type ContentMetricWithoutActivityWarningUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activities?: InputMaybe<Array<ContentMetricUpdateActivitiesEntityRelationInput>>;
  hideFromPlanning?: InputMaybe<Scalars['Boolean']['input']>;
  journeys?: InputMaybe<Array<ContentMetricUpdateJourneysEntityRelationInput>>;
  metric?: InputMaybe<ContentMetricUpdateMetricEntityRelationInput>;
};

export type ContentMetricWithoutJourneysCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activities?: InputMaybe<Array<ContentMetricCreateActivitiesEntityRelationInput>>;
  activityWarning?: InputMaybe<Array<ContentMetricCreateActivityWarningEntityRelationInput>>;
  hideFromPlanning?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  metric?: InputMaybe<ContentMetricCreateMetricEntityRelationInput>;
};

export type ContentMetricWithoutJourneysUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activities?: InputMaybe<Array<ContentMetricUpdateActivitiesEntityRelationInput>>;
  activityWarning?: InputMaybe<Array<ContentMetricUpdateActivityWarningEntityRelationInput>>;
  hideFromPlanning?: InputMaybe<Scalars['Boolean']['input']>;
  metric?: InputMaybe<ContentMetricUpdateMetricEntityRelationInput>;
};

export type ControlCycle = {
  __typename?: 'ControlCycle';
  _meta?: Maybe<ControlCycleMeta>;
  days?: Maybe<Scalars['Int']['output']>;
  history: Array<ControlCycleCheck>;
  id: Scalars['UUID']['output'];
  paginateHistory: ControlCycleCheckConnection;
};


export type ControlCycleHistoryArgs = {
  filter?: InputMaybe<ControlCycleCheckWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ControlCycleCheckOrderBy>>;
};


export type ControlCyclePaginateHistoryArgs = {
  filter?: InputMaybe<ControlCycleCheckWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ControlCycleCheckOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ControlCycleCheck = {
  __typename?: 'ControlCycleCheck';
  _meta?: Maybe<ControlCycleCheckMeta>;
  at: Scalars['DateTime']['output'];
  cycle?: Maybe<ControlCycle>;
  id: Scalars['UUID']['output'];
  who?: Maybe<Member>;
};


export type ControlCycleCheckCycleArgs = {
  filter?: InputMaybe<ControlCycleWhere>;
};


export type ControlCycleCheckWhoArgs = {
  filter?: InputMaybe<MemberWhere>;
};

export type ControlCycleCheckConnectOrCreateCycleRelationInput = {
  connect: ControlCycleUniqueWhere;
  create: ControlCycleWithoutHistoryCreateInput;
};

export type ControlCycleCheckConnectOrCreateWhoRelationInput = {
  connect: MemberUniqueWhere;
  create: MemberCreateInput;
};

export type ControlCycleCheckConnection = {
  __typename?: 'ControlCycleCheckConnection';
  edges: Array<ControlCycleCheckEdge>;
  pageInfo: PageInfo;
};

export type ControlCycleCheckCreateCycleEntityRelationInput = {
  connect?: InputMaybe<ControlCycleUniqueWhere>;
  connectOrCreate?: InputMaybe<ControlCycleCheckConnectOrCreateCycleRelationInput>;
  create?: InputMaybe<ControlCycleWithoutHistoryCreateInput>;
};

export type ControlCycleCheckCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  at?: InputMaybe<Scalars['DateTime']['input']>;
  cycle?: InputMaybe<ControlCycleCheckCreateCycleEntityRelationInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  who?: InputMaybe<ControlCycleCheckCreateWhoEntityRelationInput>;
};

export type ControlCycleCheckCreateResult = MutationResult & {
  __typename?: 'ControlCycleCheckCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<ControlCycleCheck>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ControlCycleCheckCreateWhoEntityRelationInput = {
  connect?: InputMaybe<MemberUniqueWhere>;
  connectOrCreate?: InputMaybe<ControlCycleCheckConnectOrCreateWhoRelationInput>;
  create?: InputMaybe<MemberCreateInput>;
};

export type ControlCycleCheckDeleteResult = MutationResult & {
  __typename?: 'ControlCycleCheckDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<ControlCycleCheck>;
  ok: Scalars['Boolean']['output'];
};

export type ControlCycleCheckEdge = {
  __typename?: 'ControlCycleCheckEdge';
  node: ControlCycleCheck;
};

export type ControlCycleCheckMeta = {
  __typename?: 'ControlCycleCheckMeta';
  at?: Maybe<FieldMeta>;
  cycle?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  who?: Maybe<FieldMeta>;
};

export type ControlCycleCheckOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  at?: InputMaybe<OrderDirection>;
  cycle?: InputMaybe<ControlCycleOrderBy>;
  id?: InputMaybe<OrderDirection>;
  who?: InputMaybe<MemberOrderBy>;
};

export type ControlCycleCheckUniqueWhere = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type ControlCycleCheckUpdateCycleEntityRelationInput = {
  connect?: InputMaybe<ControlCycleUniqueWhere>;
  connectOrCreate?: InputMaybe<ControlCycleCheckConnectOrCreateCycleRelationInput>;
  create?: InputMaybe<ControlCycleWithoutHistoryCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<ControlCycleWithoutHistoryUpdateInput>;
  upsert?: InputMaybe<ControlCycleCheckUpsertCycleRelationInput>;
};

export type ControlCycleCheckUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  at?: InputMaybe<Scalars['DateTime']['input']>;
  cycle?: InputMaybe<ControlCycleCheckUpdateCycleEntityRelationInput>;
  who?: InputMaybe<ControlCycleCheckUpdateWhoEntityRelationInput>;
};

export type ControlCycleCheckUpdateResult = MutationResult & {
  __typename?: 'ControlCycleCheckUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<ControlCycleCheck>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ControlCycleCheckUpdateWhoEntityRelationInput = {
  connect?: InputMaybe<MemberUniqueWhere>;
  connectOrCreate?: InputMaybe<ControlCycleCheckConnectOrCreateWhoRelationInput>;
  create?: InputMaybe<MemberCreateInput>;
  update?: InputMaybe<MemberUpdateInput>;
  upsert?: InputMaybe<ControlCycleCheckUpsertWhoRelationInput>;
};

export type ControlCycleCheckUpsertCycleRelationInput = {
  create: ControlCycleWithoutHistoryCreateInput;
  update: ControlCycleWithoutHistoryUpdateInput;
};

export type ControlCycleCheckUpsertResult = MutationResult & {
  __typename?: 'ControlCycleCheckUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<ControlCycleCheck>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ControlCycleCheckUpsertWhoRelationInput = {
  create: MemberCreateInput;
  update: MemberUpdateInput;
};

export type ControlCycleCheckWhere = {
  and?: InputMaybe<Array<InputMaybe<ControlCycleCheckWhere>>>;
  at?: InputMaybe<DateTimeCondition>;
  cycle?: InputMaybe<ControlCycleWhere>;
  id?: InputMaybe<UuidCondition>;
  not?: InputMaybe<ControlCycleCheckWhere>;
  or?: InputMaybe<Array<InputMaybe<ControlCycleCheckWhere>>>;
  who?: InputMaybe<MemberWhere>;
};

export type ControlCycleCheckWithoutCycleCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  who?: InputMaybe<ControlCycleCheckCreateWhoEntityRelationInput>;
};

export type ControlCycleCheckWithoutCycleUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  at?: InputMaybe<Scalars['DateTime']['input']>;
  who?: InputMaybe<ControlCycleCheckUpdateWhoEntityRelationInput>;
};

export type ControlCycleConnectOrCreateHistoryRelationInput = {
  connect: ControlCycleCheckUniqueWhere;
  create: ControlCycleCheckWithoutCycleCreateInput;
};

export type ControlCycleConnection = {
  __typename?: 'ControlCycleConnection';
  edges: Array<ControlCycleEdge>;
  pageInfo: PageInfo;
};

export type ControlCycleCreateHistoryEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ControlCycleCheckUniqueWhere>;
  connectOrCreate?: InputMaybe<ControlCycleConnectOrCreateHistoryRelationInput>;
  create?: InputMaybe<ControlCycleCheckWithoutCycleCreateInput>;
};

export type ControlCycleCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  days?: InputMaybe<Scalars['Int']['input']>;
  history?: InputMaybe<Array<ControlCycleCreateHistoryEntityRelationInput>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type ControlCycleCreateResult = MutationResult & {
  __typename?: 'ControlCycleCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<ControlCycle>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ControlCycleDeleteResult = MutationResult & {
  __typename?: 'ControlCycleDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<ControlCycle>;
  ok: Scalars['Boolean']['output'];
};

export type ControlCycleEdge = {
  __typename?: 'ControlCycleEdge';
  node: ControlCycle;
};

export type ControlCycleMeta = {
  __typename?: 'ControlCycleMeta';
  days?: Maybe<FieldMeta>;
  history?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
};

export type ControlCycleOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  days?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
};

export type ControlCycleUniqueWhere = {
  history?: InputMaybe<ControlCycleCheckUniqueWhere>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type ControlCycleUpdateHistoryEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ControlCycleCheckUniqueWhere>;
  create?: InputMaybe<ControlCycleCheckWithoutCycleCreateInput>;
  delete?: InputMaybe<ControlCycleCheckUniqueWhere>;
  disconnect?: InputMaybe<ControlCycleCheckUniqueWhere>;
  update?: InputMaybe<ControlCycleUpdateHistoryRelationInput>;
  upsert?: InputMaybe<ControlCycleUpsertHistoryRelationInput>;
};

export type ControlCycleUpdateHistoryRelationInput = {
  by: ControlCycleCheckUniqueWhere;
  data: ControlCycleCheckWithoutCycleUpdateInput;
};

export type ControlCycleUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  days?: InputMaybe<Scalars['Int']['input']>;
  history?: InputMaybe<Array<ControlCycleUpdateHistoryEntityRelationInput>>;
};

export type ControlCycleUpdateResult = MutationResult & {
  __typename?: 'ControlCycleUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<ControlCycle>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ControlCycleUpsertHistoryRelationInput = {
  by: ControlCycleCheckUniqueWhere;
  create: ControlCycleCheckWithoutCycleCreateInput;
  update: ControlCycleCheckWithoutCycleUpdateInput;
};

export type ControlCycleUpsertResult = MutationResult & {
  __typename?: 'ControlCycleUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<ControlCycle>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ControlCycleWhere = {
  and?: InputMaybe<Array<InputMaybe<ControlCycleWhere>>>;
  days?: InputMaybe<IntCondition>;
  history?: InputMaybe<ControlCycleCheckWhere>;
  id?: InputMaybe<UuidCondition>;
  not?: InputMaybe<ControlCycleWhere>;
  or?: InputMaybe<Array<InputMaybe<ControlCycleWhere>>>;
};

export type ControlCycleWithoutHistoryCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  days?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type ControlCycleWithoutHistoryUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  days?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateApiKeyError = {
  __typename?: 'CreateApiKeyError';
  code: CreateApiKeyErrorCode;
  developerMessage: Scalars['String']['output'];
  /** @deprecated Field no longer supported */
  endUserMessage?: Maybe<Scalars['String']['output']>;
  membershipValidation?: Maybe<Array<MembershipValidationError>>;
};

export type CreateApiKeyErrorCode =
  | 'INVALID_MEMBERSHIP'
  | 'PROJECT_NOT_FOUND'
  | 'ROLE_NOT_FOUND'
  | 'VARIABLE_EMPTY'
  | 'VARIABLE_NOT_FOUND';

export type CreateApiKeyResponse = {
  __typename?: 'CreateApiKeyResponse';
  error?: Maybe<CreateApiKeyError>;
  /** @deprecated Field no longer supported */
  errors: Array<CreateApiKeyError>;
  ok: Scalars['Boolean']['output'];
  result?: Maybe<CreateApiKeyResult>;
};

export type CreateApiKeyResult = {
  __typename?: 'CreateApiKeyResult';
  apiKey: ApiKeyWithToken;
};

export type CreatePasswordResetRequestError = {
  __typename?: 'CreatePasswordResetRequestError';
  code: CreatePasswordResetRequestErrorCode;
  developerMessage: Scalars['String']['output'];
  /** @deprecated Field no longer supported */
  endUserMessage?: Maybe<Scalars['String']['output']>;
};

export type CreatePasswordResetRequestErrorCode =
  | 'PERSON_NOT_FOUND';

export type CreatePasswordResetRequestResponse = {
  __typename?: 'CreatePasswordResetRequestResponse';
  error?: Maybe<CreatePasswordResetRequestError>;
  /** @deprecated Field no longer supported */
  errors: Array<CreatePasswordResetRequestError>;
  ok: Scalars['Boolean']['output'];
};

export type CreateProjectOptions = {
  deployTokenHash?: InputMaybe<Scalars['String']['input']>;
  noDeployToken?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateProjectResponse = {
  __typename?: 'CreateProjectResponse';
  error?: Maybe<CreateProjectResponseError>;
  ok: Scalars['Boolean']['output'];
  result?: Maybe<CreateProjectResult>;
};

export type CreateProjectResponseError = {
  __typename?: 'CreateProjectResponseError';
  code: CreateProjectResponseErrorCode;
  developerMessage: Scalars['String']['output'];
};

export type CreateProjectResponseErrorCode =
  | 'ALREADY_EXISTS'
  | 'INIT_ERROR';

export type CreateProjectResult = {
  __typename?: 'CreateProjectResult';
  deployerApiKey?: Maybe<ApiKeyWithToken>;
};

export type CreateResetPasswordRequestOptions = {
  mailProject?: InputMaybe<Scalars['String']['input']>;
  mailVariant?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSessionTokenError = {
  __typename?: 'CreateSessionTokenError';
  code: CreateSessionTokenErrorCode;
  developerMessage: Scalars['String']['output'];
};

export type CreateSessionTokenErrorCode =
  | 'PERSON_DISABLED'
  | 'UNKNOWN_EMAIL'
  | 'UNKNOWN_PERSON_ID';

export type CreateSessionTokenResponse = {
  __typename?: 'CreateSessionTokenResponse';
  error?: Maybe<CreateSessionTokenError>;
  ok: Scalars['Boolean']['output'];
  result?: Maybe<CreateSessionTokenResult>;
};

export type CreateSessionTokenResult = CommonSignInResult & {
  __typename?: 'CreateSessionTokenResult';
  person: Person;
  token: Scalars['String']['output'];
};

export type Dashboard = {
  __typename?: 'Dashboard';
  _meta?: Maybe<DashboardMeta>;
  dashboardJourneys: Array<DashboardJourney>;
  dashboardJourneysByJourney?: Maybe<DashboardJourney>;
  dashboardMetrics: Array<DashboardMetric>;
  dashboardMetricsByContentMetric?: Maybe<DashboardMetric>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  paginateDashboardJourneys: DashboardJourneyConnection;
  paginateDashboardMetrics: DashboardMetricConnection;
};


export type DashboardDashboardJourneysArgs = {
  filter?: InputMaybe<DashboardJourneyWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DashboardJourneyOrderBy>>;
};


export type DashboardDashboardJourneysByJourneyArgs = {
  by: DashboardDashboardJourneysByJourneyUniqueWhere;
  filter?: InputMaybe<DashboardJourneyWhere>;
};


export type DashboardDashboardMetricsArgs = {
  filter?: InputMaybe<DashboardMetricWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DashboardMetricOrderBy>>;
};


export type DashboardDashboardMetricsByContentMetricArgs = {
  by: DashboardDashboardMetricsByContentMetricUniqueWhere;
  filter?: InputMaybe<DashboardMetricWhere>;
};


export type DashboardPaginateDashboardJourneysArgs = {
  filter?: InputMaybe<DashboardJourneyWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DashboardJourneyOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardPaginateDashboardMetricsArgs = {
  filter?: InputMaybe<DashboardMetricWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DashboardMetricOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type DashboardConnectOrCreateDashboardJourneysRelationInput = {
  connect: DashboardJourneyUniqueWhere;
  create: DashboardJourneyWithoutDashboardCreateInput;
};

export type DashboardConnectOrCreateDashboardMetricsRelationInput = {
  connect: DashboardMetricUniqueWhere;
  create: DashboardMetricWithoutDashboardCreateInput;
};

export type DashboardConnection = {
  __typename?: 'DashboardConnection';
  edges: Array<DashboardEdge>;
  pageInfo: PageInfo;
};

export type DashboardCreateDashboardJourneysEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<DashboardJourneyUniqueWhere>;
  connectOrCreate?: InputMaybe<DashboardConnectOrCreateDashboardJourneysRelationInput>;
  create?: InputMaybe<DashboardJourneyWithoutDashboardCreateInput>;
};

export type DashboardCreateDashboardMetricsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<DashboardMetricUniqueWhere>;
  connectOrCreate?: InputMaybe<DashboardConnectOrCreateDashboardMetricsRelationInput>;
  create?: InputMaybe<DashboardMetricWithoutDashboardCreateInput>;
};

export type DashboardCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  dashboardJourneys?: InputMaybe<Array<DashboardCreateDashboardJourneysEntityRelationInput>>;
  dashboardMetrics?: InputMaybe<Array<DashboardCreateDashboardMetricsEntityRelationInput>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DashboardCreateResult = MutationResult & {
  __typename?: 'DashboardCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Dashboard>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type DashboardDashboardJourneysByJourneyUniqueWhere = {
  journey?: InputMaybe<JourneyUniqueWhere>;
};

export type DashboardDashboardMetricsByContentMetricUniqueWhere = {
  contentMetric?: InputMaybe<ContentMetricUniqueWhere>;
};

export type DashboardDeleteResult = MutationResult & {
  __typename?: 'DashboardDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Dashboard>;
  ok: Scalars['Boolean']['output'];
};

export type DashboardEdge = {
  __typename?: 'DashboardEdge';
  node: Dashboard;
};

export type DashboardJourney = {
  __typename?: 'DashboardJourney';
  _meta?: Maybe<DashboardJourneyMeta>;
  dashboard?: Maybe<Dashboard>;
  id: Scalars['UUID']['output'];
  journey?: Maybe<Journey>;
  order: Scalars['Int']['output'];
};


export type DashboardJourneyDashboardArgs = {
  filter?: InputMaybe<DashboardWhere>;
};


export type DashboardJourneyJourneyArgs = {
  filter?: InputMaybe<JourneyWhere>;
};

export type DashboardJourneyConnectOrCreateDashboardRelationInput = {
  connect: DashboardUniqueWhere;
  create: DashboardWithoutDashboardJourneysCreateInput;
};

export type DashboardJourneyConnectOrCreateJourneyRelationInput = {
  connect: JourneyUniqueWhere;
  create: JourneyCreateInput;
};

export type DashboardJourneyConnection = {
  __typename?: 'DashboardJourneyConnection';
  edges: Array<DashboardJourneyEdge>;
  pageInfo: PageInfo;
};

export type DashboardJourneyCreateDashboardEntityRelationInput = {
  connect?: InputMaybe<DashboardUniqueWhere>;
  connectOrCreate?: InputMaybe<DashboardJourneyConnectOrCreateDashboardRelationInput>;
  create?: InputMaybe<DashboardWithoutDashboardJourneysCreateInput>;
};

export type DashboardJourneyCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  dashboard?: InputMaybe<DashboardJourneyCreateDashboardEntityRelationInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  journey?: InputMaybe<DashboardJourneyCreateJourneyEntityRelationInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type DashboardJourneyCreateJourneyEntityRelationInput = {
  connect?: InputMaybe<JourneyUniqueWhere>;
  connectOrCreate?: InputMaybe<DashboardJourneyConnectOrCreateJourneyRelationInput>;
  create?: InputMaybe<JourneyCreateInput>;
};

export type DashboardJourneyCreateResult = MutationResult & {
  __typename?: 'DashboardJourneyCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<DashboardJourney>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type DashboardJourneyDeleteResult = MutationResult & {
  __typename?: 'DashboardJourneyDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<DashboardJourney>;
  ok: Scalars['Boolean']['output'];
};

export type DashboardJourneyEdge = {
  __typename?: 'DashboardJourneyEdge';
  node: DashboardJourney;
};

export type DashboardJourneyMeta = {
  __typename?: 'DashboardJourneyMeta';
  dashboard?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  journey?: Maybe<FieldMeta>;
  order?: Maybe<FieldMeta>;
};

export type DashboardJourneyOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  dashboard?: InputMaybe<DashboardOrderBy>;
  id?: InputMaybe<OrderDirection>;
  journey?: InputMaybe<JourneyOrderBy>;
  order?: InputMaybe<OrderDirection>;
};

export type DashboardJourneyUniqueWhere = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  journey?: InputMaybe<JourneyUniqueWhere>;
};

export type DashboardJourneyUpdateDashboardEntityRelationInput = {
  connect?: InputMaybe<DashboardUniqueWhere>;
  connectOrCreate?: InputMaybe<DashboardJourneyConnectOrCreateDashboardRelationInput>;
  create?: InputMaybe<DashboardWithoutDashboardJourneysCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<DashboardWithoutDashboardJourneysUpdateInput>;
  upsert?: InputMaybe<DashboardJourneyUpsertDashboardRelationInput>;
};

export type DashboardJourneyUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  dashboard?: InputMaybe<DashboardJourneyUpdateDashboardEntityRelationInput>;
  journey?: InputMaybe<DashboardJourneyUpdateJourneyEntityRelationInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type DashboardJourneyUpdateJourneyEntityRelationInput = {
  connect?: InputMaybe<JourneyUniqueWhere>;
  connectOrCreate?: InputMaybe<DashboardJourneyConnectOrCreateJourneyRelationInput>;
  create?: InputMaybe<JourneyCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<JourneyUpdateInput>;
  upsert?: InputMaybe<DashboardJourneyUpsertJourneyRelationInput>;
};

export type DashboardJourneyUpdateResult = MutationResult & {
  __typename?: 'DashboardJourneyUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<DashboardJourney>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type DashboardJourneyUpsertDashboardRelationInput = {
  create: DashboardWithoutDashboardJourneysCreateInput;
  update: DashboardWithoutDashboardJourneysUpdateInput;
};

export type DashboardJourneyUpsertJourneyRelationInput = {
  create: JourneyCreateInput;
  update: JourneyUpdateInput;
};

export type DashboardJourneyUpsertResult = MutationResult & {
  __typename?: 'DashboardJourneyUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<DashboardJourney>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type DashboardJourneyWhere = {
  and?: InputMaybe<Array<InputMaybe<DashboardJourneyWhere>>>;
  dashboard?: InputMaybe<DashboardWhere>;
  id?: InputMaybe<UuidCondition>;
  journey?: InputMaybe<JourneyWhere>;
  not?: InputMaybe<DashboardJourneyWhere>;
  or?: InputMaybe<Array<InputMaybe<DashboardJourneyWhere>>>;
  order?: InputMaybe<IntCondition>;
};

export type DashboardJourneyWithoutDashboardCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  journey?: InputMaybe<DashboardJourneyCreateJourneyEntityRelationInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type DashboardJourneyWithoutDashboardUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  journey?: InputMaybe<DashboardJourneyUpdateJourneyEntityRelationInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type DashboardMeta = {
  __typename?: 'DashboardMeta';
  dashboardJourneys?: Maybe<FieldMeta>;
  dashboardMetrics?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  name?: Maybe<FieldMeta>;
};

export type DashboardMetric = {
  __typename?: 'DashboardMetric';
  _meta?: Maybe<DashboardMetricMeta>;
  color?: Maybe<Scalars['String']['output']>;
  contentMetric?: Maybe<ContentMetric>;
  dashboard?: Maybe<Dashboard>;
  displayType: DashboardMetricDisplayType;
  id: Scalars['UUID']['output'];
  order: Scalars['Int']['output'];
};


export type DashboardMetricContentMetricArgs = {
  filter?: InputMaybe<ContentMetricWhere>;
};


export type DashboardMetricDashboardArgs = {
  filter?: InputMaybe<DashboardWhere>;
};

export type DashboardMetricConnectOrCreateContentMetricRelationInput = {
  connect: ContentMetricUniqueWhere;
  create: ContentMetricCreateInput;
};

export type DashboardMetricConnectOrCreateDashboardRelationInput = {
  connect: DashboardUniqueWhere;
  create: DashboardWithoutDashboardMetricsCreateInput;
};

export type DashboardMetricConnection = {
  __typename?: 'DashboardMetricConnection';
  edges: Array<DashboardMetricEdge>;
  pageInfo: PageInfo;
};

export type DashboardMetricCreateContentMetricEntityRelationInput = {
  connect?: InputMaybe<ContentMetricUniqueWhere>;
  connectOrCreate?: InputMaybe<DashboardMetricConnectOrCreateContentMetricRelationInput>;
  create?: InputMaybe<ContentMetricCreateInput>;
};

export type DashboardMetricCreateDashboardEntityRelationInput = {
  connect?: InputMaybe<DashboardUniqueWhere>;
  connectOrCreate?: InputMaybe<DashboardMetricConnectOrCreateDashboardRelationInput>;
  create?: InputMaybe<DashboardWithoutDashboardMetricsCreateInput>;
};

export type DashboardMetricCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  contentMetric?: InputMaybe<DashboardMetricCreateContentMetricEntityRelationInput>;
  dashboard?: InputMaybe<DashboardMetricCreateDashboardEntityRelationInput>;
  displayType?: InputMaybe<DashboardMetricDisplayType>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type DashboardMetricCreateResult = MutationResult & {
  __typename?: 'DashboardMetricCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<DashboardMetric>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type DashboardMetricDeleteResult = MutationResult & {
  __typename?: 'DashboardMetricDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<DashboardMetric>;
  ok: Scalars['Boolean']['output'];
};

export type DashboardMetricDisplayType =
  | 'currentValue'
  | 'history';

export type DashboardMetricDisplayTypeCondition = {
  and?: InputMaybe<Array<DashboardMetricDisplayTypeCondition>>;
  eq?: InputMaybe<DashboardMetricDisplayType>;
  gt?: InputMaybe<DashboardMetricDisplayType>;
  gte?: InputMaybe<DashboardMetricDisplayType>;
  in?: InputMaybe<Array<DashboardMetricDisplayType>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<DashboardMetricDisplayType>;
  lte?: InputMaybe<DashboardMetricDisplayType>;
  not?: InputMaybe<DashboardMetricDisplayTypeCondition>;
  notEq?: InputMaybe<DashboardMetricDisplayType>;
  notIn?: InputMaybe<Array<DashboardMetricDisplayType>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<DashboardMetricDisplayTypeCondition>>;
};

export type DashboardMetricEdge = {
  __typename?: 'DashboardMetricEdge';
  node: DashboardMetric;
};

export type DashboardMetricMeta = {
  __typename?: 'DashboardMetricMeta';
  color?: Maybe<FieldMeta>;
  contentMetric?: Maybe<FieldMeta>;
  dashboard?: Maybe<FieldMeta>;
  displayType?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  order?: Maybe<FieldMeta>;
};

export type DashboardMetricOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<OrderDirection>;
  contentMetric?: InputMaybe<ContentMetricOrderBy>;
  dashboard?: InputMaybe<DashboardOrderBy>;
  displayType?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  order?: InputMaybe<OrderDirection>;
};

export type DashboardMetricUniqueWhere = {
  contentMetric?: InputMaybe<ContentMetricUniqueWhere>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type DashboardMetricUpdateContentMetricEntityRelationInput = {
  connect?: InputMaybe<ContentMetricUniqueWhere>;
  connectOrCreate?: InputMaybe<DashboardMetricConnectOrCreateContentMetricRelationInput>;
  create?: InputMaybe<ContentMetricCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<ContentMetricUpdateInput>;
  upsert?: InputMaybe<DashboardMetricUpsertContentMetricRelationInput>;
};

export type DashboardMetricUpdateDashboardEntityRelationInput = {
  connect?: InputMaybe<DashboardUniqueWhere>;
  connectOrCreate?: InputMaybe<DashboardMetricConnectOrCreateDashboardRelationInput>;
  create?: InputMaybe<DashboardWithoutDashboardMetricsCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<DashboardWithoutDashboardMetricsUpdateInput>;
  upsert?: InputMaybe<DashboardMetricUpsertDashboardRelationInput>;
};

export type DashboardMetricUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  contentMetric?: InputMaybe<DashboardMetricUpdateContentMetricEntityRelationInput>;
  dashboard?: InputMaybe<DashboardMetricUpdateDashboardEntityRelationInput>;
  displayType?: InputMaybe<DashboardMetricDisplayType>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type DashboardMetricUpdateResult = MutationResult & {
  __typename?: 'DashboardMetricUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<DashboardMetric>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type DashboardMetricUpsertContentMetricRelationInput = {
  create: ContentMetricCreateInput;
  update: ContentMetricUpdateInput;
};

export type DashboardMetricUpsertDashboardRelationInput = {
  create: DashboardWithoutDashboardMetricsCreateInput;
  update: DashboardWithoutDashboardMetricsUpdateInput;
};

export type DashboardMetricUpsertResult = MutationResult & {
  __typename?: 'DashboardMetricUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<DashboardMetric>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type DashboardMetricWhere = {
  and?: InputMaybe<Array<InputMaybe<DashboardMetricWhere>>>;
  color?: InputMaybe<StringCondition>;
  contentMetric?: InputMaybe<ContentMetricWhere>;
  dashboard?: InputMaybe<DashboardWhere>;
  displayType?: InputMaybe<DashboardMetricDisplayTypeCondition>;
  id?: InputMaybe<UuidCondition>;
  not?: InputMaybe<DashboardMetricWhere>;
  or?: InputMaybe<Array<InputMaybe<DashboardMetricWhere>>>;
  order?: InputMaybe<IntCondition>;
};

export type DashboardMetricWithoutDashboardCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  contentMetric?: InputMaybe<DashboardMetricCreateContentMetricEntityRelationInput>;
  displayType?: InputMaybe<DashboardMetricDisplayType>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type DashboardMetricWithoutDashboardUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  contentMetric?: InputMaybe<DashboardMetricUpdateContentMetricEntityRelationInput>;
  displayType?: InputMaybe<DashboardMetricDisplayType>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type DashboardOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type DashboardUniqueWhere = {
  dashboardJourneys?: InputMaybe<DashboardJourneyUniqueWhere>;
  dashboardMetrics?: InputMaybe<DashboardMetricUniqueWhere>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type DashboardUpdateDashboardJourneysEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<DashboardJourneyUniqueWhere>;
  create?: InputMaybe<DashboardJourneyWithoutDashboardCreateInput>;
  delete?: InputMaybe<DashboardJourneyUniqueWhere>;
  disconnect?: InputMaybe<DashboardJourneyUniqueWhere>;
  update?: InputMaybe<DashboardUpdateDashboardJourneysRelationInput>;
  upsert?: InputMaybe<DashboardUpsertDashboardJourneysRelationInput>;
};

export type DashboardUpdateDashboardJourneysRelationInput = {
  by: DashboardJourneyUniqueWhere;
  data: DashboardJourneyWithoutDashboardUpdateInput;
};

export type DashboardUpdateDashboardMetricsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<DashboardMetricUniqueWhere>;
  create?: InputMaybe<DashboardMetricWithoutDashboardCreateInput>;
  delete?: InputMaybe<DashboardMetricUniqueWhere>;
  disconnect?: InputMaybe<DashboardMetricUniqueWhere>;
  update?: InputMaybe<DashboardUpdateDashboardMetricsRelationInput>;
  upsert?: InputMaybe<DashboardUpsertDashboardMetricsRelationInput>;
};

export type DashboardUpdateDashboardMetricsRelationInput = {
  by: DashboardMetricUniqueWhere;
  data: DashboardMetricWithoutDashboardUpdateInput;
};

export type DashboardUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  dashboardJourneys?: InputMaybe<Array<DashboardUpdateDashboardJourneysEntityRelationInput>>;
  dashboardMetrics?: InputMaybe<Array<DashboardUpdateDashboardMetricsEntityRelationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DashboardUpdateResult = MutationResult & {
  __typename?: 'DashboardUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Dashboard>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type DashboardUpsertDashboardJourneysRelationInput = {
  by: DashboardJourneyUniqueWhere;
  create: DashboardJourneyWithoutDashboardCreateInput;
  update: DashboardJourneyWithoutDashboardUpdateInput;
};

export type DashboardUpsertDashboardMetricsRelationInput = {
  by: DashboardMetricUniqueWhere;
  create: DashboardMetricWithoutDashboardCreateInput;
  update: DashboardMetricWithoutDashboardUpdateInput;
};

export type DashboardUpsertResult = MutationResult & {
  __typename?: 'DashboardUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Dashboard>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type DashboardWhere = {
  and?: InputMaybe<Array<InputMaybe<DashboardWhere>>>;
  dashboardJourneys?: InputMaybe<DashboardJourneyWhere>;
  dashboardMetrics?: InputMaybe<DashboardMetricWhere>;
  id?: InputMaybe<UuidCondition>;
  name?: InputMaybe<StringCondition>;
  not?: InputMaybe<DashboardWhere>;
  or?: InputMaybe<Array<InputMaybe<DashboardWhere>>>;
};

export type DashboardWithoutDashboardJourneysCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  dashboardMetrics?: InputMaybe<Array<DashboardCreateDashboardMetricsEntityRelationInput>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DashboardWithoutDashboardJourneysUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  dashboardMetrics?: InputMaybe<Array<DashboardUpdateDashboardMetricsEntityRelationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DashboardWithoutDashboardMetricsCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  dashboardJourneys?: InputMaybe<Array<DashboardCreateDashboardJourneysEntityRelationInput>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DashboardWithoutDashboardMetricsUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  dashboardJourneys?: InputMaybe<Array<DashboardUpdateDashboardJourneysEntityRelationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DateCondition = {
  and?: InputMaybe<Array<DateCondition>>;
  eq?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<Scalars['Date']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  not?: InputMaybe<DateCondition>;
  notEq?: InputMaybe<Scalars['Date']['input']>;
  notIn?: InputMaybe<Array<Scalars['Date']['input']>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<DateCondition>>;
};

export type DateTimeCondition = {
  and?: InputMaybe<Array<DateTimeCondition>>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeCondition>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<DateTimeCondition>>;
};

export type DateTimeRange = {
  __typename?: 'DateTimeRange';
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type DateTimeRangeInput = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export type DisableApiKeyError = {
  __typename?: 'DisableApiKeyError';
  code: DisableApiKeyErrorCode;
  developerMessage: Scalars['String']['output'];
  /** @deprecated Field no longer supported */
  endUserMessage?: Maybe<Scalars['String']['output']>;
};

export type DisableApiKeyErrorCode =
  | 'KEY_NOT_FOUND';

export type DisableApiKeyResponse = {
  __typename?: 'DisableApiKeyResponse';
  error?: Maybe<DisableApiKeyError>;
  /** @deprecated Field no longer supported */
  errors: Array<DisableApiKeyError>;
  ok: Scalars['Boolean']['output'];
};

export type DisableIdpError = {
  __typename?: 'DisableIDPError';
  code: DisableIdpErrorCode;
  developerMessage: Scalars['String']['output'];
};

export type DisableIdpErrorCode =
  | 'NOT_FOUND';

export type DisableIdpResponse = {
  __typename?: 'DisableIDPResponse';
  error?: Maybe<DisableIdpError>;
  ok: Scalars['Boolean']['output'];
};

export type DisableOtpError = {
  __typename?: 'DisableOtpError';
  code: DisableOtpErrorCode;
  developerMessage: Scalars['String']['output'];
  /** @deprecated Field no longer supported */
  endUserMessage?: Maybe<Scalars['String']['output']>;
};

export type DisableOtpErrorCode =
  | 'OTP_NOT_ACTIVE';

export type DisableOtpResponse = {
  __typename?: 'DisableOtpResponse';
  error?: Maybe<DisableOtpError>;
  /** @deprecated Field no longer supported */
  errors: Array<DisableOtpError>;
  ok: Scalars['Boolean']['output'];
};

export type DisablePersonError = {
  __typename?: 'DisablePersonError';
  code: DisablePersonErrorCode;
  developerMessage: Scalars['String']['output'];
};

export type DisablePersonErrorCode =
  | 'PERSON_ALREADY_DISABLED'
  | 'PERSON_NOT_FOUND';

export type DisablePersonResponse = {
  __typename?: 'DisablePersonResponse';
  error?: Maybe<DisablePersonError>;
  ok: Scalars['Boolean']['output'];
};

export type DisplayMetric = {
  __typename?: 'DisplayMetric';
  breakdown: Array<DisplayMetricBreakdown>;
  chartDataPoints: Array<ChartDataPoint>;
  expectations?: Maybe<Expectations>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  precision?: Maybe<Scalars['Int']['output']>;
  trendComparison?: Maybe<TrendComparison>;
  unit: Units;
  unitSign?: Maybe<Scalars['String']['output']>;
  values: DisplayMetricValues;
};


export type DisplayMetricBreakdownArgs = {
  breakdownInterval: BreakdownInterval;
  range: DateTimeRangeInput;
};


export type DisplayMetricChartDataPointsArgs = {
  range: DateTimeRangeInput;
};


export type DisplayMetricValuesArgs = {
  compareRange: DateTimeRangeInput;
  targetRange: DateTimeRangeInput;
};

export type DisplayMetricBreakdown = {
  __typename?: 'DisplayMetricBreakdown';
  chartDataPoints: Array<ChartDataPoint>;
  range: DateTimeRange;
  values?: Maybe<DisplayMetricValues>;
};

export type DisplayMetricValues = {
  __typename?: 'DisplayMetricValues';
  comparedValue?: Maybe<Scalars['Float']['output']>;
  comparison?: Maybe<Scalars['Float']['output']>;
  lastUpdateAt?: Maybe<Scalars['String']['output']>;
  targetValue?: Maybe<Scalars['Float']['output']>;
};

export type EnableIdpError = {
  __typename?: 'EnableIDPError';
  code: EnableIdpErrorCode;
  developerMessage: Scalars['String']['output'];
};

export type EnableIdpErrorCode =
  | 'NOT_FOUND';

export type EnableIdpResponse = {
  __typename?: 'EnableIDPResponse';
  error?: Maybe<EnableIdpError>;
  ok: Scalars['Boolean']['output'];
};

export type ExceptionResult = {
  __typename?: 'ExceptionResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type Expectations =
  | 'decrease'
  | 'increase';

export type FieldMeta = {
  __typename?: 'FieldMeta';
  readable?: Maybe<Scalars['Boolean']['output']>;
  updatable?: Maybe<Scalars['Boolean']['output']>;
};

export type FloatCondition = {
  and?: InputMaybe<Array<FloatCondition>>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<FloatCondition>;
  notEq?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<FloatCondition>>;
};

export type GoogleSheetsConfiguration = {
  __typename?: 'GoogleSheetsConfiguration';
  spreadsheetId?: Maybe<Scalars['String']['output']>;
};

export type GoogleSpreadsheetSheet = {
  __typename?: 'GoogleSpreadsheetSheet';
  sheetTitle?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
};

export type GoogleSpreadsheetSheets = {
  __typename?: 'GoogleSpreadsheetSheets';
  sheets: Array<Maybe<GoogleSpreadsheetSheet>>;
};

export type IdpOptions = {
  autoSignUp?: InputMaybe<Scalars['Boolean']['input']>;
  exclusive?: InputMaybe<Scalars['Boolean']['input']>;
  initReturnsConfig?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IdpOptionsOutput = {
  __typename?: 'IDPOptionsOutput';
  autoSignUp: Scalars['Boolean']['output'];
  exclusive: Scalars['Boolean']['output'];
  initReturnsConfig: Scalars['Boolean']['output'];
};

export type IdpResponseInput = {
  url: Scalars['String']['input'];
};

export type Identity = {
  __typename?: 'Identity';
  apiKey?: Maybe<ApiKey>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  permissions?: Maybe<IdentityGlobalPermissions>;
  person?: Maybe<Person>;
  projects: Array<IdentityProjectRelation>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
};

export type IdentityGlobalPermissions = {
  __typename?: 'IdentityGlobalPermissions';
  canCreateProject: Scalars['Boolean']['output'];
  canDeployEntrypoint: Scalars['Boolean']['output'];
};

export type IdentityProjectRelation = {
  __typename?: 'IdentityProjectRelation';
  memberships: Array<Membership>;
  project: Project;
};

export type IdentityProvider = {
  __typename?: 'IdentityProvider';
  configuration: Scalars['Json']['output'];
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  options: IdpOptionsOutput;
  slug: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Image = {
  __typename?: 'Image';
  _meta?: Maybe<ImageMeta>;
  externalId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  namespace: Scalars['String']['output'];
  status?: Maybe<ImageStatus>;
  /** In order to get URL, at least one of the height and the width must be specified. */
  url?: Maybe<Scalars['String']['output']>;
};


export type ImageUrlArgs = {
  fit?: InputMaybe<ImageUrlFit>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageConnection = {
  __typename?: 'ImageConnection';
  edges: Array<ImageEdge>;
  pageInfo: PageInfo;
};

export type ImageCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ImageStatus>;
};

export type ImageCreateResult = MutationResult & {
  __typename?: 'ImageCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Image>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ImageDeleteResult = MutationResult & {
  __typename?: 'ImageDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Image>;
  ok: Scalars['Boolean']['output'];
};

export type ImageEdge = {
  __typename?: 'ImageEdge';
  node: Image;
};

export type ImageMeta = {
  __typename?: 'ImageMeta';
  externalId?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  namespace?: Maybe<FieldMeta>;
  status?: Maybe<FieldMeta>;
};

export type ImageOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  externalId?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  namespace?: InputMaybe<OrderDirection>;
  status?: InputMaybe<OrderDirection>;
};

export type ImageProcessingStatus =
  | 'deleted'
  | 'error'
  | 'uploaded';

export type ImageStatus =
  | 'created'
  | 'deleted'
  | 'error'
  | 'uploaded';

export type ImageStatusCondition = {
  and?: InputMaybe<Array<ImageStatusCondition>>;
  eq?: InputMaybe<ImageStatus>;
  gt?: InputMaybe<ImageStatus>;
  gte?: InputMaybe<ImageStatus>;
  in?: InputMaybe<Array<ImageStatus>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<ImageStatus>;
  lte?: InputMaybe<ImageStatus>;
  not?: InputMaybe<ImageStatusCondition>;
  notEq?: InputMaybe<ImageStatus>;
  notIn?: InputMaybe<Array<ImageStatus>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<ImageStatusCondition>>;
};

export type ImageUniqueWhere = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type ImageUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['UUID']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ImageStatus>;
};

export type ImageUpdateResult = MutationResult & {
  __typename?: 'ImageUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Image>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ImageUploadFormDataField = {
  __typename?: 'ImageUploadFormDataField';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ImageUploadRequestResult = {
  __typename?: 'ImageUploadRequestResult';
  formDataFields: Array<ImageUploadFormDataField>;
  id: Scalars['UUID']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type ImageUpsertResult = MutationResult & {
  __typename?: 'ImageUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Image>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type ImageUrlFit =
  | 'cover'
  | 'fill'
  | 'inside'
  | 'outside';

export type ImageWhere = {
  and?: InputMaybe<Array<InputMaybe<ImageWhere>>>;
  externalId?: InputMaybe<UuidCondition>;
  id?: InputMaybe<UuidCondition>;
  namespace?: InputMaybe<StringCondition>;
  not?: InputMaybe<ImageWhere>;
  or?: InputMaybe<Array<InputMaybe<ImageWhere>>>;
  status?: InputMaybe<ImageStatusCondition>;
};

export type Info = {
  __typename?: 'Info';
  description?: Maybe<Scalars['String']['output']>;
};

export type InitSignInIdpError = {
  __typename?: 'InitSignInIDPError';
  code: InitSignInIdpErrorCode;
  developerMessage: Scalars['String']['output'];
  /** @deprecated Field no longer supported */
  endUserMessage?: Maybe<Scalars['String']['output']>;
};

export type InitSignInIdpErrorCode =
  | 'IDP_VALIDATION_FAILED'
  | 'PROVIDER_NOT_FOUND';

export type InitSignInIdpResponse = {
  __typename?: 'InitSignInIDPResponse';
  error?: Maybe<InitSignInIdpError>;
  /** @deprecated Field no longer supported */
  errors: Array<InitSignInIdpError>;
  ok: Scalars['Boolean']['output'];
  result?: Maybe<InitSignInIdpResult>;
};

export type InitSignInIdpResult = {
  __typename?: 'InitSignInIDPResult';
  authUrl: Scalars['String']['output'];
  idpConfiguration?: Maybe<Scalars['Json']['output']>;
  sessionData: Scalars['Json']['output'];
};

export type IntCondition = {
  and?: InputMaybe<Array<IntCondition>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntCondition>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<IntCondition>>;
};

export type InviteError = {
  __typename?: 'InviteError';
  code: InviteErrorCode;
  developerMessage: Scalars['String']['output'];
  /** @deprecated Field no longer supported */
  endUserMessage?: Maybe<Scalars['String']['output']>;
  membershipValidation?: Maybe<Array<MembershipValidationError>>;
};

export type InviteErrorCode =
  | 'ALREADY_MEMBER'
  | 'INVALID_EMAIL_FORMAT'
  | 'INVALID_MEMBERSHIP'
  | 'PROJECT_NOT_FOUND'
  | 'ROLE_NOT_FOUND'
  | 'VARIABLE_EMPTY'
  | 'VARIABLE_NOT_FOUND';

export type InviteMethod =
  | 'CREATE_PASSWORD'
  | 'RESET_PASSWORD';

export type InviteOptions = {
  mailVariant?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<InviteMethod>;
};

export type InviteResponse = {
  __typename?: 'InviteResponse';
  error?: Maybe<InviteError>;
  /** @deprecated Field no longer supported */
  errors: Array<InviteError>;
  ok: Scalars['Boolean']['output'];
  result?: Maybe<InviteResult>;
};

export type InviteResult = {
  __typename?: 'InviteResult';
  isNew: Scalars['Boolean']['output'];
  person: Person;
};

export type Journey = {
  __typename?: 'Journey';
  _meta?: Maybe<JourneyMeta>;
  activityWarnings?: Maybe<Array<ActivityWarning>>;
  color?: Maybe<Scalars['String']['output']>;
  connectedActivities: Array<Activity>;
  contentMetrics?: Maybe<Array<ContentMetric>>;
  controlCycle?: Maybe<ControlCycle>;
  createdAt: Scalars['DateTime']['output'];
  createdOpportunitiesCount?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isTemplate: Scalars['Boolean']['output'];
  mainMetric?: Maybe<ContentMetric>;
  name: Scalars['String']['output'];
  owners?: Maybe<Array<Member>>;
  paginateConnectedActivities: ActivityConnection;
  paginatePhases: PhaseConnection;
  paginateTeams: TeamConnection;
  paginateWidgets: WidgetConnection;
  personas?: Maybe<Array<Persona>>;
  phases: Array<Phase>;
  phasesByTouchpoints?: Maybe<Phase>;
  /** satisfaction can be null if journey does not contain "satisfaction" widget */
  satisfaction?: Maybe<Scalars['Int']['output']>;
  solvedActionsCount?: Maybe<Scalars['Int']['output']>;
  teams: Array<Team>;
  widgets: Array<Widget>;
};


export type JourneyConnectedActivitiesArgs = {
  filter?: InputMaybe<ActivityWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityOrderBy>>;
};


export type JourneyControlCycleArgs = {
  filter?: InputMaybe<ControlCycleWhere>;
};


export type JourneyCreatedOpportunitiesCountArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type JourneyMainMetricArgs = {
  filter?: InputMaybe<ContentMetricWhere>;
};


export type JourneyPaginateConnectedActivitiesArgs = {
  filter?: InputMaybe<ActivityWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type JourneyPaginatePhasesArgs = {
  filter?: InputMaybe<PhaseWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PhaseOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type JourneyPaginateTeamsArgs = {
  filter?: InputMaybe<TeamWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TeamOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type JourneyPaginateWidgetsArgs = {
  filter?: InputMaybe<WidgetWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WidgetOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type JourneyPhasesArgs = {
  filter?: InputMaybe<PhaseWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PhaseOrderBy>>;
};


export type JourneyPhasesByTouchpointsArgs = {
  by: JourneyPhasesByTouchpointsUniqueWhere;
  filter?: InputMaybe<PhaseWhere>;
};


export type JourneySolvedActionsCountArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type JourneyTeamsArgs = {
  filter?: InputMaybe<TeamWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TeamOrderBy>>;
};


export type JourneyWidgetsArgs = {
  filter?: InputMaybe<WidgetWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WidgetOrderBy>>;
};

export type JourneyConnectOrCreateConnectedActivitiesRelationInput = {
  connect: ActivityUniqueWhere;
  create: ActivityWithoutConnectedJourneysCreateInput;
};

export type JourneyConnectOrCreateControlCycleRelationInput = {
  connect: ControlCycleUniqueWhere;
  create: ControlCycleCreateInput;
};

export type JourneyConnectOrCreateMainMetricRelationInput = {
  connect: ContentMetricUniqueWhere;
  create: ContentMetricWithoutJourneysCreateInput;
};

export type JourneyConnectOrCreatePhasesRelationInput = {
  connect: PhaseUniqueWhere;
  create: PhaseWithoutJourneyCreateInput;
};

export type JourneyConnectOrCreateTeamsRelationInput = {
  connect: TeamUniqueWhere;
  create: TeamWithoutJourneysCreateInput;
};

export type JourneyConnectOrCreateWidgetsRelationInput = {
  connect: WidgetUniqueWhere;
  create: WidgetWithoutJourneyCreateInput;
};

export type JourneyConnection = {
  __typename?: 'JourneyConnection';
  edges: Array<JourneyEdge>;
  pageInfo: PageInfo;
};

export type JourneyCreateConnectedActivitiesEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ActivityUniqueWhere>;
  connectOrCreate?: InputMaybe<JourneyConnectOrCreateConnectedActivitiesRelationInput>;
  create?: InputMaybe<ActivityWithoutConnectedJourneysCreateInput>;
};

export type JourneyCreateControlCycleEntityRelationInput = {
  connect?: InputMaybe<ControlCycleUniqueWhere>;
  connectOrCreate?: InputMaybe<JourneyConnectOrCreateControlCycleRelationInput>;
  create?: InputMaybe<ControlCycleCreateInput>;
};

export type JourneyCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  connectedActivities?: InputMaybe<Array<JourneyCreateConnectedActivitiesEntityRelationInput>>;
  controlCycle?: InputMaybe<JourneyCreateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  mainMetric?: InputMaybe<JourneyCreateMainMetricEntityRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  phases?: InputMaybe<Array<JourneyCreatePhasesEntityRelationInput>>;
  teams?: InputMaybe<Array<JourneyCreateTeamsEntityRelationInput>>;
  widgets?: InputMaybe<Array<JourneyCreateWidgetsEntityRelationInput>>;
};

export type JourneyCreateMainMetricEntityRelationInput = {
  connect?: InputMaybe<ContentMetricUniqueWhere>;
  connectOrCreate?: InputMaybe<JourneyConnectOrCreateMainMetricRelationInput>;
  create?: InputMaybe<ContentMetricWithoutJourneysCreateInput>;
};

export type JourneyCreatePhasesEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<PhaseUniqueWhere>;
  connectOrCreate?: InputMaybe<JourneyConnectOrCreatePhasesRelationInput>;
  create?: InputMaybe<PhaseWithoutJourneyCreateInput>;
};

export type JourneyCreateResult = MutationResult & {
  __typename?: 'JourneyCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Journey>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type JourneyCreateTeamsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<TeamUniqueWhere>;
  connectOrCreate?: InputMaybe<JourneyConnectOrCreateTeamsRelationInput>;
  create?: InputMaybe<TeamWithoutJourneysCreateInput>;
};

export type JourneyCreateWidgetsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<WidgetUniqueWhere>;
  connectOrCreate?: InputMaybe<JourneyConnectOrCreateWidgetsRelationInput>;
  create?: InputMaybe<WidgetWithoutJourneyCreateInput>;
};

export type JourneyDeleteResult = MutationResult & {
  __typename?: 'JourneyDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Journey>;
  ok: Scalars['Boolean']['output'];
};

export type JourneyEdge = {
  __typename?: 'JourneyEdge';
  node: Journey;
};

export type JourneyMeta = {
  __typename?: 'JourneyMeta';
  color?: Maybe<FieldMeta>;
  connectedActivities?: Maybe<FieldMeta>;
  controlCycle?: Maybe<FieldMeta>;
  createdAt?: Maybe<FieldMeta>;
  description?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  isTemplate?: Maybe<FieldMeta>;
  mainMetric?: Maybe<FieldMeta>;
  name?: Maybe<FieldMeta>;
  phases?: Maybe<FieldMeta>;
  teams?: Maybe<FieldMeta>;
  widgets?: Maybe<FieldMeta>;
};

export type JourneyOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<OrderDirection>;
  controlCycle?: InputMaybe<ControlCycleOrderBy>;
  createdAt?: InputMaybe<OrderDirection>;
  description?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  isTemplate?: InputMaybe<OrderDirection>;
  mainMetric?: InputMaybe<ContentMetricOrderBy>;
  name?: InputMaybe<OrderDirection>;
};

export type JourneyPhasesByTouchpointsUniqueWhere = {
  touchpoints?: InputMaybe<TouchpointUniqueWhere>;
};

export type JourneyUniqueWhere = {
  controlCycle?: InputMaybe<ControlCycleUniqueWhere>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  phases?: InputMaybe<PhaseUniqueWhere>;
  widgets?: InputMaybe<WidgetUniqueWhere>;
};

export type JourneyUpdateConnectedActivitiesEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ActivityUniqueWhere>;
  create?: InputMaybe<ActivityWithoutConnectedJourneysCreateInput>;
  delete?: InputMaybe<ActivityUniqueWhere>;
  disconnect?: InputMaybe<ActivityUniqueWhere>;
  update?: InputMaybe<JourneyUpdateConnectedActivitiesRelationInput>;
  upsert?: InputMaybe<JourneyUpsertConnectedActivitiesRelationInput>;
};

export type JourneyUpdateConnectedActivitiesRelationInput = {
  by: ActivityUniqueWhere;
  data: ActivityWithoutConnectedJourneysUpdateInput;
};

export type JourneyUpdateControlCycleEntityRelationInput = {
  connect?: InputMaybe<ControlCycleUniqueWhere>;
  connectOrCreate?: InputMaybe<JourneyConnectOrCreateControlCycleRelationInput>;
  create?: InputMaybe<ControlCycleCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<ControlCycleUpdateInput>;
  upsert?: InputMaybe<JourneyUpsertControlCycleRelationInput>;
};

export type JourneyUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  connectedActivities?: InputMaybe<Array<JourneyUpdateConnectedActivitiesEntityRelationInput>>;
  controlCycle?: InputMaybe<JourneyUpdateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  mainMetric?: InputMaybe<JourneyUpdateMainMetricEntityRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  phases?: InputMaybe<Array<JourneyUpdatePhasesEntityRelationInput>>;
  teams?: InputMaybe<Array<JourneyUpdateTeamsEntityRelationInput>>;
  widgets?: InputMaybe<Array<JourneyUpdateWidgetsEntityRelationInput>>;
};

export type JourneyUpdateMainMetricEntityRelationInput = {
  connect?: InputMaybe<ContentMetricUniqueWhere>;
  connectOrCreate?: InputMaybe<JourneyConnectOrCreateMainMetricRelationInput>;
  create?: InputMaybe<ContentMetricWithoutJourneysCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<ContentMetricWithoutJourneysUpdateInput>;
  upsert?: InputMaybe<JourneyUpsertMainMetricRelationInput>;
};

export type JourneyUpdatePhasesEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<PhaseUniqueWhere>;
  create?: InputMaybe<PhaseWithoutJourneyCreateInput>;
  delete?: InputMaybe<PhaseUniqueWhere>;
  disconnect?: InputMaybe<PhaseUniqueWhere>;
  update?: InputMaybe<JourneyUpdatePhasesRelationInput>;
  upsert?: InputMaybe<JourneyUpsertPhasesRelationInput>;
};

export type JourneyUpdatePhasesRelationInput = {
  by: PhaseUniqueWhere;
  data: PhaseWithoutJourneyUpdateInput;
};

export type JourneyUpdateResult = MutationResult & {
  __typename?: 'JourneyUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Journey>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type JourneyUpdateTeamsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<TeamUniqueWhere>;
  create?: InputMaybe<TeamWithoutJourneysCreateInput>;
  delete?: InputMaybe<TeamUniqueWhere>;
  disconnect?: InputMaybe<TeamUniqueWhere>;
  update?: InputMaybe<JourneyUpdateTeamsRelationInput>;
  upsert?: InputMaybe<JourneyUpsertTeamsRelationInput>;
};

export type JourneyUpdateTeamsRelationInput = {
  by: TeamUniqueWhere;
  data: TeamWithoutJourneysUpdateInput;
};

export type JourneyUpdateWidgetsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<WidgetUniqueWhere>;
  create?: InputMaybe<WidgetWithoutJourneyCreateInput>;
  delete?: InputMaybe<WidgetUniqueWhere>;
  disconnect?: InputMaybe<WidgetUniqueWhere>;
  update?: InputMaybe<JourneyUpdateWidgetsRelationInput>;
  upsert?: InputMaybe<JourneyUpsertWidgetsRelationInput>;
};

export type JourneyUpdateWidgetsRelationInput = {
  by: WidgetUniqueWhere;
  data: WidgetWithoutJourneyUpdateInput;
};

export type JourneyUpsertConnectedActivitiesRelationInput = {
  by: ActivityUniqueWhere;
  create: ActivityWithoutConnectedJourneysCreateInput;
  update: ActivityWithoutConnectedJourneysUpdateInput;
};

export type JourneyUpsertControlCycleRelationInput = {
  create: ControlCycleCreateInput;
  update: ControlCycleUpdateInput;
};

export type JourneyUpsertMainMetricRelationInput = {
  create: ContentMetricWithoutJourneysCreateInput;
  update: ContentMetricWithoutJourneysUpdateInput;
};

export type JourneyUpsertPhasesRelationInput = {
  by: PhaseUniqueWhere;
  create: PhaseWithoutJourneyCreateInput;
  update: PhaseWithoutJourneyUpdateInput;
};

export type JourneyUpsertResult = MutationResult & {
  __typename?: 'JourneyUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Journey>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type JourneyUpsertTeamsRelationInput = {
  by: TeamUniqueWhere;
  create: TeamWithoutJourneysCreateInput;
  update: TeamWithoutJourneysUpdateInput;
};

export type JourneyUpsertWidgetsRelationInput = {
  by: WidgetUniqueWhere;
  create: WidgetWithoutJourneyCreateInput;
  update: WidgetWithoutJourneyUpdateInput;
};

export type JourneyWhere = {
  and?: InputMaybe<Array<InputMaybe<JourneyWhere>>>;
  color?: InputMaybe<StringCondition>;
  connectedActivities?: InputMaybe<ActivityWhere>;
  controlCycle?: InputMaybe<ControlCycleWhere>;
  createdAt?: InputMaybe<DateTimeCondition>;
  description?: InputMaybe<StringCondition>;
  id?: InputMaybe<UuidCondition>;
  isTemplate?: InputMaybe<BooleanCondition>;
  mainMetric?: InputMaybe<ContentMetricWhere>;
  name?: InputMaybe<StringCondition>;
  not?: InputMaybe<JourneyWhere>;
  or?: InputMaybe<Array<InputMaybe<JourneyWhere>>>;
  phases?: InputMaybe<PhaseWhere>;
  teams?: InputMaybe<TeamWhere>;
  widgets?: InputMaybe<WidgetWhere>;
};

export type JourneyWithoutConnectedActivitiesCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  controlCycle?: InputMaybe<JourneyCreateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  mainMetric?: InputMaybe<JourneyCreateMainMetricEntityRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  phases?: InputMaybe<Array<JourneyCreatePhasesEntityRelationInput>>;
  teams?: InputMaybe<Array<JourneyCreateTeamsEntityRelationInput>>;
  widgets?: InputMaybe<Array<JourneyCreateWidgetsEntityRelationInput>>;
};

export type JourneyWithoutConnectedActivitiesUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  controlCycle?: InputMaybe<JourneyUpdateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  mainMetric?: InputMaybe<JourneyUpdateMainMetricEntityRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  phases?: InputMaybe<Array<JourneyUpdatePhasesEntityRelationInput>>;
  teams?: InputMaybe<Array<JourneyUpdateTeamsEntityRelationInput>>;
  widgets?: InputMaybe<Array<JourneyUpdateWidgetsEntityRelationInput>>;
};

export type JourneyWithoutMainMetricCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  connectedActivities?: InputMaybe<Array<JourneyCreateConnectedActivitiesEntityRelationInput>>;
  controlCycle?: InputMaybe<JourneyCreateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phases?: InputMaybe<Array<JourneyCreatePhasesEntityRelationInput>>;
  teams?: InputMaybe<Array<JourneyCreateTeamsEntityRelationInput>>;
  widgets?: InputMaybe<Array<JourneyCreateWidgetsEntityRelationInput>>;
};

export type JourneyWithoutMainMetricUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  connectedActivities?: InputMaybe<Array<JourneyUpdateConnectedActivitiesEntityRelationInput>>;
  controlCycle?: InputMaybe<JourneyUpdateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phases?: InputMaybe<Array<JourneyUpdatePhasesEntityRelationInput>>;
  teams?: InputMaybe<Array<JourneyUpdateTeamsEntityRelationInput>>;
  widgets?: InputMaybe<Array<JourneyUpdateWidgetsEntityRelationInput>>;
};

export type JourneyWithoutPhasesCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  connectedActivities?: InputMaybe<Array<JourneyCreateConnectedActivitiesEntityRelationInput>>;
  controlCycle?: InputMaybe<JourneyCreateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  mainMetric?: InputMaybe<JourneyCreateMainMetricEntityRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<Array<JourneyCreateTeamsEntityRelationInput>>;
  widgets?: InputMaybe<Array<JourneyCreateWidgetsEntityRelationInput>>;
};

export type JourneyWithoutPhasesUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  connectedActivities?: InputMaybe<Array<JourneyUpdateConnectedActivitiesEntityRelationInput>>;
  controlCycle?: InputMaybe<JourneyUpdateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  mainMetric?: InputMaybe<JourneyUpdateMainMetricEntityRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<Array<JourneyUpdateTeamsEntityRelationInput>>;
  widgets?: InputMaybe<Array<JourneyUpdateWidgetsEntityRelationInput>>;
};

export type JourneyWithoutTeamsCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  connectedActivities?: InputMaybe<Array<JourneyCreateConnectedActivitiesEntityRelationInput>>;
  controlCycle?: InputMaybe<JourneyCreateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  mainMetric?: InputMaybe<JourneyCreateMainMetricEntityRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  phases?: InputMaybe<Array<JourneyCreatePhasesEntityRelationInput>>;
  widgets?: InputMaybe<Array<JourneyCreateWidgetsEntityRelationInput>>;
};

export type JourneyWithoutTeamsUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  connectedActivities?: InputMaybe<Array<JourneyUpdateConnectedActivitiesEntityRelationInput>>;
  controlCycle?: InputMaybe<JourneyUpdateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  mainMetric?: InputMaybe<JourneyUpdateMainMetricEntityRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  phases?: InputMaybe<Array<JourneyUpdatePhasesEntityRelationInput>>;
  widgets?: InputMaybe<Array<JourneyUpdateWidgetsEntityRelationInput>>;
};

export type JourneyWithoutWidgetsCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  connectedActivities?: InputMaybe<Array<JourneyCreateConnectedActivitiesEntityRelationInput>>;
  controlCycle?: InputMaybe<JourneyCreateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  mainMetric?: InputMaybe<JourneyCreateMainMetricEntityRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  phases?: InputMaybe<Array<JourneyCreatePhasesEntityRelationInput>>;
  teams?: InputMaybe<Array<JourneyCreateTeamsEntityRelationInput>>;
};

export type JourneyWithoutWidgetsUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  connectedActivities?: InputMaybe<Array<JourneyUpdateConnectedActivitiesEntityRelationInput>>;
  controlCycle?: InputMaybe<JourneyUpdateControlCycleEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  mainMetric?: InputMaybe<JourneyUpdateMainMetricEntityRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  phases?: InputMaybe<Array<JourneyUpdatePhasesEntityRelationInput>>;
  teams?: InputMaybe<Array<JourneyUpdateTeamsEntityRelationInput>>;
};

export type JsonCondition = {
  and?: InputMaybe<Array<JsonCondition>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<JsonCondition>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<JsonCondition>>;
};

export type KeboolaSyncEvent = {
  __typename?: 'KeboolaSyncEvent';
  _meta?: Maybe<KeboolaSyncEventMeta>;
  end?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  externalOrchestrationId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  metricGoogleSheetsSource?: Maybe<MetricGoogleSheetsSource>;
  start: Scalars['DateTime']['output'];
  status: KeboolaSyncLogStatus;
};


export type KeboolaSyncEventMetricGoogleSheetsSourceArgs = {
  filter?: InputMaybe<MetricGoogleSheetsSourceWhere>;
};

export type KeboolaSyncEventConnectOrCreateMetricGoogleSheetsSourceRelationInput = {
  connect: MetricGoogleSheetsSourceUniqueWhere;
  create: MetricGoogleSheetsSourceWithoutKeboolaSyncEventsCreateInput;
};

export type KeboolaSyncEventConnection = {
  __typename?: 'KeboolaSyncEventConnection';
  edges: Array<KeboolaSyncEventEdge>;
  pageInfo: PageInfo;
};

export type KeboolaSyncEventCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  externalOrchestrationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  metricGoogleSheetsSource?: InputMaybe<KeboolaSyncEventCreateMetricGoogleSheetsSourceEntityRelationInput>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<KeboolaSyncLogStatus>;
};

export type KeboolaSyncEventCreateMetricGoogleSheetsSourceEntityRelationInput = {
  connect?: InputMaybe<MetricGoogleSheetsSourceUniqueWhere>;
  connectOrCreate?: InputMaybe<KeboolaSyncEventConnectOrCreateMetricGoogleSheetsSourceRelationInput>;
  create?: InputMaybe<MetricGoogleSheetsSourceWithoutKeboolaSyncEventsCreateInput>;
};

export type KeboolaSyncEventCreateResult = MutationResult & {
  __typename?: 'KeboolaSyncEventCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<KeboolaSyncEvent>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type KeboolaSyncEventDeleteResult = MutationResult & {
  __typename?: 'KeboolaSyncEventDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<KeboolaSyncEvent>;
  ok: Scalars['Boolean']['output'];
};

export type KeboolaSyncEventEdge = {
  __typename?: 'KeboolaSyncEventEdge';
  node: KeboolaSyncEvent;
};

export type KeboolaSyncEventMeta = {
  __typename?: 'KeboolaSyncEventMeta';
  end?: Maybe<FieldMeta>;
  errorMessage?: Maybe<FieldMeta>;
  externalOrchestrationId?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  metricGoogleSheetsSource?: Maybe<FieldMeta>;
  start?: Maybe<FieldMeta>;
  status?: Maybe<FieldMeta>;
};

export type KeboolaSyncEventOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  end?: InputMaybe<OrderDirection>;
  errorMessage?: InputMaybe<OrderDirection>;
  externalOrchestrationId?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  metricGoogleSheetsSource?: InputMaybe<MetricGoogleSheetsSourceOrderBy>;
  start?: InputMaybe<OrderDirection>;
  status?: InputMaybe<OrderDirection>;
};

export type KeboolaSyncEventUniqueWhere = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type KeboolaSyncEventUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  externalOrchestrationId?: InputMaybe<Scalars['String']['input']>;
  metricGoogleSheetsSource?: InputMaybe<KeboolaSyncEventUpdateMetricGoogleSheetsSourceEntityRelationInput>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<KeboolaSyncLogStatus>;
};

export type KeboolaSyncEventUpdateMetricGoogleSheetsSourceEntityRelationInput = {
  connect?: InputMaybe<MetricGoogleSheetsSourceUniqueWhere>;
  connectOrCreate?: InputMaybe<KeboolaSyncEventConnectOrCreateMetricGoogleSheetsSourceRelationInput>;
  create?: InputMaybe<MetricGoogleSheetsSourceWithoutKeboolaSyncEventsCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<MetricGoogleSheetsSourceWithoutKeboolaSyncEventsUpdateInput>;
  upsert?: InputMaybe<KeboolaSyncEventUpsertMetricGoogleSheetsSourceRelationInput>;
};

export type KeboolaSyncEventUpdateResult = MutationResult & {
  __typename?: 'KeboolaSyncEventUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<KeboolaSyncEvent>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type KeboolaSyncEventUpsertMetricGoogleSheetsSourceRelationInput = {
  create: MetricGoogleSheetsSourceWithoutKeboolaSyncEventsCreateInput;
  update: MetricGoogleSheetsSourceWithoutKeboolaSyncEventsUpdateInput;
};

export type KeboolaSyncEventUpsertResult = MutationResult & {
  __typename?: 'KeboolaSyncEventUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<KeboolaSyncEvent>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type KeboolaSyncEventWhere = {
  and?: InputMaybe<Array<InputMaybe<KeboolaSyncEventWhere>>>;
  end?: InputMaybe<DateTimeCondition>;
  errorMessage?: InputMaybe<StringCondition>;
  externalOrchestrationId?: InputMaybe<StringCondition>;
  id?: InputMaybe<UuidCondition>;
  metricGoogleSheetsSource?: InputMaybe<MetricGoogleSheetsSourceWhere>;
  not?: InputMaybe<KeboolaSyncEventWhere>;
  or?: InputMaybe<Array<InputMaybe<KeboolaSyncEventWhere>>>;
  start?: InputMaybe<DateTimeCondition>;
  status?: InputMaybe<KeboolaSyncLogStatusCondition>;
};

export type KeboolaSyncEventWithoutMetricGoogleSheetsSourceCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  externalOrchestrationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<KeboolaSyncLogStatus>;
};

export type KeboolaSyncEventWithoutMetricGoogleSheetsSourceUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  externalOrchestrationId?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<KeboolaSyncLogStatus>;
};

export type KeboolaSyncLogStatus =
  | 'cancelled'
  | 'created'
  | 'error'
  | 'processing'
  | 'success'
  | 'terminated'
  | 'terminating'
  | 'waiting'
  | 'warning';

export type KeboolaSyncLogStatusCondition = {
  and?: InputMaybe<Array<KeboolaSyncLogStatusCondition>>;
  eq?: InputMaybe<KeboolaSyncLogStatus>;
  gt?: InputMaybe<KeboolaSyncLogStatus>;
  gte?: InputMaybe<KeboolaSyncLogStatus>;
  in?: InputMaybe<Array<KeboolaSyncLogStatus>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<KeboolaSyncLogStatus>;
  lte?: InputMaybe<KeboolaSyncLogStatus>;
  not?: InputMaybe<KeboolaSyncLogStatusCondition>;
  notEq?: InputMaybe<KeboolaSyncLogStatus>;
  notIn?: InputMaybe<Array<KeboolaSyncLogStatus>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<KeboolaSyncLogStatusCondition>>;
};

export type MailTemplate = {
  content: Scalars['String']['input'];
  projectSlug?: InputMaybe<Scalars['String']['input']>;
  replyTo?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  type: MailType;
  useLayout?: InputMaybe<Scalars['Boolean']['input']>;
  /** Custom mail variant identifier, e.g. a locale. */
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type MailTemplateData = {
  __typename?: 'MailTemplateData';
  content: Scalars['String']['output'];
  projectSlug?: Maybe<Scalars['String']['output']>;
  replyTo?: Maybe<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
  type: MailType;
  useLayout: Scalars['Boolean']['output'];
  variant?: Maybe<Scalars['String']['output']>;
};

export type MailTemplateIdentifier = {
  projectSlug?: InputMaybe<Scalars['String']['input']>;
  type: MailType;
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type MailType =
  | 'EXISTING_USER_INVITED'
  | 'NEW_USER_INVITED'
  | 'RESET_PASSWORD_REQUEST';

export type Member = {
  __typename?: 'Member';
  _meta?: Maybe<MemberMeta>;
  actions: Array<Action>;
  activities: Array<Activity>;
  activitiesByControlCycle?: Maybe<Activity>;
  activitiesByDuration?: Maybe<Activity>;
  activitiesByPictures?: Maybe<Activity>;
  activitiesBySubTouchpoints?: Maybe<Activity>;
  activitiesByTouchpoint?: Maybe<Activity>;
  activitiesByWarnings?: Maybe<Activity>;
  avatar?: Maybe<Image>;
  createdAt: Scalars['DateTime']['output'];
  googleSheetsConsent?: Maybe<MetricGoogleSheetsSource>;
  id: Scalars['UUID']['output'];
  isBlocked: Scalars['Boolean']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  opportunities: Array<Opportunity>;
  paginateActions: ActionConnection;
  paginateActivities: ActivityConnection;
  paginateOpportunities: OpportunityConnection;
  person?: Maybe<MemberPerson>;
  settings?: Maybe<MemberSettings>;
  team?: Maybe<Team>;
};


export type MemberActionsArgs = {
  filter?: InputMaybe<ActionWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionOrderBy>>;
};


export type MemberActivitiesArgs = {
  filter?: InputMaybe<ActivityWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityOrderBy>>;
};


export type MemberActivitiesByControlCycleArgs = {
  by: MemberActivitiesByControlCycleUniqueWhere;
  filter?: InputMaybe<ActivityWhere>;
};


export type MemberActivitiesByDurationArgs = {
  by: MemberActivitiesByDurationUniqueWhere;
  filter?: InputMaybe<ActivityWhere>;
};


export type MemberActivitiesByPicturesArgs = {
  by: MemberActivitiesByPicturesUniqueWhere;
  filter?: InputMaybe<ActivityWhere>;
};


export type MemberActivitiesBySubTouchpointsArgs = {
  by: MemberActivitiesBySubTouchpointsUniqueWhere;
  filter?: InputMaybe<ActivityWhere>;
};


export type MemberActivitiesByTouchpointArgs = {
  by: MemberActivitiesByTouchpointUniqueWhere;
  filter?: InputMaybe<ActivityWhere>;
};


export type MemberActivitiesByWarningsArgs = {
  by: MemberActivitiesByWarningsUniqueWhere;
  filter?: InputMaybe<ActivityWhere>;
};


export type MemberAvatarArgs = {
  filter?: InputMaybe<ImageWhere>;
};


export type MemberGoogleSheetsConsentArgs = {
  filter?: InputMaybe<MetricGoogleSheetsSourceWhere>;
};


export type MemberOpportunitiesArgs = {
  filter?: InputMaybe<OpportunityWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpportunityOrderBy>>;
};


export type MemberPaginateActionsArgs = {
  filter?: InputMaybe<ActionWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type MemberPaginateActivitiesArgs = {
  filter?: InputMaybe<ActivityWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type MemberPaginateOpportunitiesArgs = {
  filter?: InputMaybe<OpportunityWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpportunityOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type MemberSettingsArgs = {
  filter?: InputMaybe<MemberSettingsWhere>;
};


export type MemberTeamArgs = {
  filter?: InputMaybe<TeamWhere>;
};

export type MemberActivitiesByControlCycleUniqueWhere = {
  controlCycle?: InputMaybe<ControlCycleUniqueWhere>;
};

export type MemberActivitiesByDurationUniqueWhere = {
  duration?: InputMaybe<ActivityDurationUniqueWhere>;
};

export type MemberActivitiesByPicturesUniqueWhere = {
  pictures?: InputMaybe<PictureUniqueWhere>;
};

export type MemberActivitiesBySubTouchpointsUniqueWhere = {
  subTouchpoints?: InputMaybe<TouchpointUniqueWhere>;
};

export type MemberActivitiesByTouchpointUniqueWhere = {
  touchpoint?: InputMaybe<TouchpointUniqueWhere>;
};

export type MemberActivitiesByWarningsUniqueWhere = {
  warnings?: InputMaybe<ActivityWarningUniqueWhere>;
};

export type MemberConnectOrCreateActionsRelationInput = {
  connect: ActionUniqueWhere;
  create: ActionWithoutOwnerCreateInput;
};

export type MemberConnectOrCreateActivitiesRelationInput = {
  connect: ActivityUniqueWhere;
  create: ActivityWithoutOwnerCreateInput;
};

export type MemberConnectOrCreateAvatarRelationInput = {
  connect: ImageUniqueWhere;
  create: ImageCreateInput;
};

export type MemberConnectOrCreateGoogleSheetsConsentRelationInput = {
  connect: MetricGoogleSheetsSourceUniqueWhere;
  create: MetricGoogleSheetsSourceWithoutConsentCreateInput;
};

export type MemberConnectOrCreateOpportunitiesRelationInput = {
  connect: OpportunityUniqueWhere;
  create: OpportunityWithoutOwnerCreateInput;
};

export type MemberConnectOrCreateSettingsRelationInput = {
  connect: MemberSettingsUniqueWhere;
  create: MemberSettingsWithoutMemberCreateInput;
};

export type MemberConnectOrCreateTeamRelationInput = {
  connect: TeamUniqueWhere;
  create: TeamWithoutMembersCreateInput;
};

export type MemberConnection = {
  __typename?: 'MemberConnection';
  edges: Array<MemberEdge>;
  pageInfo: PageInfo;
};

export type MemberCreateActionsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ActionUniqueWhere>;
  connectOrCreate?: InputMaybe<MemberConnectOrCreateActionsRelationInput>;
  create?: InputMaybe<ActionWithoutOwnerCreateInput>;
};

export type MemberCreateActivitiesEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ActivityUniqueWhere>;
  connectOrCreate?: InputMaybe<MemberConnectOrCreateActivitiesRelationInput>;
  create?: InputMaybe<ActivityWithoutOwnerCreateInput>;
};

export type MemberCreateAvatarEntityRelationInput = {
  connect?: InputMaybe<ImageUniqueWhere>;
  connectOrCreate?: InputMaybe<MemberConnectOrCreateAvatarRelationInput>;
  create?: InputMaybe<ImageCreateInput>;
};

export type MemberCreateGoogleSheetsConsentEntityRelationInput = {
  connect?: InputMaybe<MetricGoogleSheetsSourceUniqueWhere>;
  connectOrCreate?: InputMaybe<MemberConnectOrCreateGoogleSheetsConsentRelationInput>;
  create?: InputMaybe<MetricGoogleSheetsSourceWithoutConsentCreateInput>;
};

export type MemberCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<MemberCreateActionsEntityRelationInput>>;
  activities?: InputMaybe<Array<MemberCreateActivitiesEntityRelationInput>>;
  avatar?: InputMaybe<MemberCreateAvatarEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  googleSheetsConsent?: InputMaybe<MemberCreateGoogleSheetsConsentEntityRelationInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<MemberCreateOpportunitiesEntityRelationInput>>;
  settings?: InputMaybe<MemberCreateSettingsEntityRelationInput>;
  team?: InputMaybe<MemberCreateTeamEntityRelationInput>;
};

export type MemberCreateOpportunitiesEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<OpportunityUniqueWhere>;
  connectOrCreate?: InputMaybe<MemberConnectOrCreateOpportunitiesRelationInput>;
  create?: InputMaybe<OpportunityWithoutOwnerCreateInput>;
};

export type MemberCreateResult = MutationResult & {
  __typename?: 'MemberCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Member>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MemberCreateSettingsEntityRelationInput = {
  connect?: InputMaybe<MemberSettingsUniqueWhere>;
  connectOrCreate?: InputMaybe<MemberConnectOrCreateSettingsRelationInput>;
  create?: InputMaybe<MemberSettingsWithoutMemberCreateInput>;
};

export type MemberCreateTeamEntityRelationInput = {
  connect?: InputMaybe<TeamUniqueWhere>;
  connectOrCreate?: InputMaybe<MemberConnectOrCreateTeamRelationInput>;
  create?: InputMaybe<TeamWithoutMembersCreateInput>;
};

export type MemberDeleteResult = MutationResult & {
  __typename?: 'MemberDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Member>;
  ok: Scalars['Boolean']['output'];
};

export type MemberEdge = {
  __typename?: 'MemberEdge';
  node: Member;
};

export type MemberMeta = {
  __typename?: 'MemberMeta';
  actions?: Maybe<FieldMeta>;
  activities?: Maybe<FieldMeta>;
  avatar?: Maybe<FieldMeta>;
  createdAt?: Maybe<FieldMeta>;
  googleSheetsConsent?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  isBlocked?: Maybe<FieldMeta>;
  jobTitle?: Maybe<FieldMeta>;
  name?: Maybe<FieldMeta>;
  opportunities?: Maybe<FieldMeta>;
  settings?: Maybe<FieldMeta>;
  team?: Maybe<FieldMeta>;
};

export type MemberMyProfileData = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MemberOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  avatar?: InputMaybe<ImageOrderBy>;
  createdAt?: InputMaybe<OrderDirection>;
  googleSheetsConsent?: InputMaybe<MetricGoogleSheetsSourceOrderBy>;
  id?: InputMaybe<OrderDirection>;
  isBlocked?: InputMaybe<OrderDirection>;
  jobTitle?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  settings?: InputMaybe<MemberSettingsOrderBy>;
  team?: InputMaybe<TeamOrderBy>;
};

/** graphql */
export type MemberOrganization = {
  __typename?: 'MemberOrganization';
  id: Scalars['UUID']['output'];
  isCurrent: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  slugAlias?: Maybe<Scalars['String']['output']>;
  slugPreferred: Scalars['String']['output'];
};

export type MemberPerson = {
  __typename?: 'MemberPerson';
  currentOrganization?: Maybe<MemberOrganization>;
  email: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organizations: Array<MemberOrganization>;
  roles: Array<Scalars['String']['output']>;
};

export type MemberSettings = {
  __typename?: 'MemberSettings';
  _meta?: Maybe<MemberSettingsMeta>;
  currency?: Maybe<Scalars['String']['output']>;
  dateFormat?: Maybe<Scalars['String']['output']>;
  firstDayOfWeek?: Maybe<MemberSettingsFirstDayOfWeek>;
  id: Scalars['UUID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  member?: Maybe<Member>;
  timezone?: Maybe<Scalars['String']['output']>;
};


export type MemberSettingsMemberArgs = {
  filter?: InputMaybe<MemberWhere>;
};

export type MemberSettingsConnectOrCreateMemberRelationInput = {
  connect: MemberUniqueWhere;
  create: MemberWithoutSettingsCreateInput;
};

export type MemberSettingsConnection = {
  __typename?: 'MemberSettingsConnection';
  edges: Array<MemberSettingsEdge>;
  pageInfo: PageInfo;
};

export type MemberSettingsCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dateFormat?: InputMaybe<Scalars['String']['input']>;
  firstDayOfWeek?: InputMaybe<MemberSettingsFirstDayOfWeek>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  member?: InputMaybe<MemberSettingsCreateMemberEntityRelationInput>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type MemberSettingsCreateMemberEntityRelationInput = {
  connect?: InputMaybe<MemberUniqueWhere>;
  connectOrCreate?: InputMaybe<MemberSettingsConnectOrCreateMemberRelationInput>;
  create?: InputMaybe<MemberWithoutSettingsCreateInput>;
};

export type MemberSettingsCreateResult = MutationResult & {
  __typename?: 'MemberSettingsCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MemberSettings>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MemberSettingsDeleteResult = MutationResult & {
  __typename?: 'MemberSettingsDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MemberSettings>;
  ok: Scalars['Boolean']['output'];
};

export type MemberSettingsEdge = {
  __typename?: 'MemberSettingsEdge';
  node: MemberSettings;
};

export type MemberSettingsFirstDayOfWeek =
  | 'monday'
  | 'saturday'
  | 'sunday';

export type MemberSettingsFirstDayOfWeekCondition = {
  and?: InputMaybe<Array<MemberSettingsFirstDayOfWeekCondition>>;
  eq?: InputMaybe<MemberSettingsFirstDayOfWeek>;
  gt?: InputMaybe<MemberSettingsFirstDayOfWeek>;
  gte?: InputMaybe<MemberSettingsFirstDayOfWeek>;
  in?: InputMaybe<Array<MemberSettingsFirstDayOfWeek>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<MemberSettingsFirstDayOfWeek>;
  lte?: InputMaybe<MemberSettingsFirstDayOfWeek>;
  not?: InputMaybe<MemberSettingsFirstDayOfWeekCondition>;
  notEq?: InputMaybe<MemberSettingsFirstDayOfWeek>;
  notIn?: InputMaybe<Array<MemberSettingsFirstDayOfWeek>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<MemberSettingsFirstDayOfWeekCondition>>;
};

export type MemberSettingsMeta = {
  __typename?: 'MemberSettingsMeta';
  currency?: Maybe<FieldMeta>;
  dateFormat?: Maybe<FieldMeta>;
  firstDayOfWeek?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  language?: Maybe<FieldMeta>;
  member?: Maybe<FieldMeta>;
  timezone?: Maybe<FieldMeta>;
};

export type MemberSettingsOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<OrderDirection>;
  dateFormat?: InputMaybe<OrderDirection>;
  firstDayOfWeek?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  language?: InputMaybe<OrderDirection>;
  member?: InputMaybe<MemberOrderBy>;
  timezone?: InputMaybe<OrderDirection>;
};

export type MemberSettingsUniqueWhere = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  member?: InputMaybe<MemberUniqueWhere>;
};

export type MemberSettingsUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dateFormat?: InputMaybe<Scalars['String']['input']>;
  firstDayOfWeek?: InputMaybe<MemberSettingsFirstDayOfWeek>;
  language?: InputMaybe<Scalars['String']['input']>;
  member?: InputMaybe<MemberSettingsUpdateMemberEntityRelationInput>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type MemberSettingsUpdateMemberEntityRelationInput = {
  connect?: InputMaybe<MemberUniqueWhere>;
  connectOrCreate?: InputMaybe<MemberSettingsConnectOrCreateMemberRelationInput>;
  create?: InputMaybe<MemberWithoutSettingsCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<MemberWithoutSettingsUpdateInput>;
  upsert?: InputMaybe<MemberSettingsUpsertMemberRelationInput>;
};

export type MemberSettingsUpdateResult = MutationResult & {
  __typename?: 'MemberSettingsUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MemberSettings>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MemberSettingsUpsertMemberRelationInput = {
  create: MemberWithoutSettingsCreateInput;
  update: MemberWithoutSettingsUpdateInput;
};

export type MemberSettingsUpsertResult = MutationResult & {
  __typename?: 'MemberSettingsUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MemberSettings>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MemberSettingsWhere = {
  and?: InputMaybe<Array<InputMaybe<MemberSettingsWhere>>>;
  currency?: InputMaybe<StringCondition>;
  dateFormat?: InputMaybe<StringCondition>;
  firstDayOfWeek?: InputMaybe<MemberSettingsFirstDayOfWeekCondition>;
  id?: InputMaybe<UuidCondition>;
  language?: InputMaybe<StringCondition>;
  member?: InputMaybe<MemberWhere>;
  not?: InputMaybe<MemberSettingsWhere>;
  or?: InputMaybe<Array<InputMaybe<MemberSettingsWhere>>>;
  timezone?: InputMaybe<StringCondition>;
};

export type MemberSettingsWithoutMemberCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dateFormat?: InputMaybe<Scalars['String']['input']>;
  firstDayOfWeek?: InputMaybe<MemberSettingsFirstDayOfWeek>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type MemberSettingsWithoutMemberUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dateFormat?: InputMaybe<Scalars['String']['input']>;
  firstDayOfWeek?: InputMaybe<MemberSettingsFirstDayOfWeek>;
  language?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type MemberType =
  | 'API_KEY'
  | 'PERSON';

export type MemberUniqueWhere = {
  actions?: InputMaybe<ActionUniqueWhere>;
  activities?: InputMaybe<ActivityUniqueWhere>;
  googleSheetsConsent?: InputMaybe<MetricGoogleSheetsSourceUniqueWhere>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  opportunities?: InputMaybe<OpportunityUniqueWhere>;
  settings?: InputMaybe<MemberSettingsUniqueWhere>;
};

export type MemberUpdateActionsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ActionUniqueWhere>;
  create?: InputMaybe<ActionWithoutOwnerCreateInput>;
  delete?: InputMaybe<ActionUniqueWhere>;
  disconnect?: InputMaybe<ActionUniqueWhere>;
  update?: InputMaybe<MemberUpdateActionsRelationInput>;
  upsert?: InputMaybe<MemberUpsertActionsRelationInput>;
};

export type MemberUpdateActionsRelationInput = {
  by: ActionUniqueWhere;
  data: ActionWithoutOwnerUpdateInput;
};

export type MemberUpdateActivitiesEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ActivityUniqueWhere>;
  create?: InputMaybe<ActivityWithoutOwnerCreateInput>;
  delete?: InputMaybe<ActivityUniqueWhere>;
  disconnect?: InputMaybe<ActivityUniqueWhere>;
  update?: InputMaybe<MemberUpdateActivitiesRelationInput>;
  upsert?: InputMaybe<MemberUpsertActivitiesRelationInput>;
};

export type MemberUpdateActivitiesRelationInput = {
  by: ActivityUniqueWhere;
  data: ActivityWithoutOwnerUpdateInput;
};

export type MemberUpdateAvatarEntityRelationInput = {
  connect?: InputMaybe<ImageUniqueWhere>;
  connectOrCreate?: InputMaybe<MemberConnectOrCreateAvatarRelationInput>;
  create?: InputMaybe<ImageCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<ImageUpdateInput>;
  upsert?: InputMaybe<MemberUpsertAvatarRelationInput>;
};

export type MemberUpdateGoogleSheetsConsentEntityRelationInput = {
  connect?: InputMaybe<MetricGoogleSheetsSourceUniqueWhere>;
  connectOrCreate?: InputMaybe<MemberConnectOrCreateGoogleSheetsConsentRelationInput>;
  create?: InputMaybe<MetricGoogleSheetsSourceWithoutConsentCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<MetricGoogleSheetsSourceWithoutConsentUpdateInput>;
  upsert?: InputMaybe<MemberUpsertGoogleSheetsConsentRelationInput>;
};

export type MemberUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<MemberUpdateActionsEntityRelationInput>>;
  activities?: InputMaybe<Array<MemberUpdateActivitiesEntityRelationInput>>;
  avatar?: InputMaybe<MemberUpdateAvatarEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  googleSheetsConsent?: InputMaybe<MemberUpdateGoogleSheetsConsentEntityRelationInput>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<MemberUpdateOpportunitiesEntityRelationInput>>;
  settings?: InputMaybe<MemberUpdateSettingsEntityRelationInput>;
  team?: InputMaybe<MemberUpdateTeamEntityRelationInput>;
};

export type MemberUpdateInputFiltered = {
  avatar?: InputMaybe<MemberUpdateAvatarEntityRelationInput>;
  team?: InputMaybe<MemberUpdateTeamEntityRelationInput>;
};

export type MemberUpdateOpportunitiesEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<OpportunityUniqueWhere>;
  create?: InputMaybe<OpportunityWithoutOwnerCreateInput>;
  delete?: InputMaybe<OpportunityUniqueWhere>;
  disconnect?: InputMaybe<OpportunityUniqueWhere>;
  update?: InputMaybe<MemberUpdateOpportunitiesRelationInput>;
  upsert?: InputMaybe<MemberUpsertOpportunitiesRelationInput>;
};

export type MemberUpdateOpportunitiesRelationInput = {
  by: OpportunityUniqueWhere;
  data: OpportunityWithoutOwnerUpdateInput;
};

export type MemberUpdateResult = MutationResult & {
  __typename?: 'MemberUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Member>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MemberUpdateSettingsEntityRelationInput = {
  connect?: InputMaybe<MemberSettingsUniqueWhere>;
  connectOrCreate?: InputMaybe<MemberConnectOrCreateSettingsRelationInput>;
  create?: InputMaybe<MemberSettingsWithoutMemberCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<MemberSettingsWithoutMemberUpdateInput>;
  upsert?: InputMaybe<MemberUpsertSettingsRelationInput>;
};

export type MemberUpdateTeamEntityRelationInput = {
  connect?: InputMaybe<TeamUniqueWhere>;
  connectOrCreate?: InputMaybe<MemberConnectOrCreateTeamRelationInput>;
  create?: InputMaybe<TeamWithoutMembersCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<TeamWithoutMembersUpdateInput>;
  upsert?: InputMaybe<MemberUpsertTeamRelationInput>;
};

export type MemberUpsertActionsRelationInput = {
  by: ActionUniqueWhere;
  create: ActionWithoutOwnerCreateInput;
  update: ActionWithoutOwnerUpdateInput;
};

export type MemberUpsertActivitiesRelationInput = {
  by: ActivityUniqueWhere;
  create: ActivityWithoutOwnerCreateInput;
  update: ActivityWithoutOwnerUpdateInput;
};

export type MemberUpsertAvatarRelationInput = {
  create: ImageCreateInput;
  update: ImageUpdateInput;
};

export type MemberUpsertGoogleSheetsConsentRelationInput = {
  create: MetricGoogleSheetsSourceWithoutConsentCreateInput;
  update: MetricGoogleSheetsSourceWithoutConsentUpdateInput;
};

export type MemberUpsertOpportunitiesRelationInput = {
  by: OpportunityUniqueWhere;
  create: OpportunityWithoutOwnerCreateInput;
  update: OpportunityWithoutOwnerUpdateInput;
};

export type MemberUpsertResult = MutationResult & {
  __typename?: 'MemberUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Member>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MemberUpsertSettingsRelationInput = {
  create: MemberSettingsWithoutMemberCreateInput;
  update: MemberSettingsWithoutMemberUpdateInput;
};

export type MemberUpsertTeamRelationInput = {
  create: TeamWithoutMembersCreateInput;
  update: TeamWithoutMembersUpdateInput;
};

export type MemberWhere = {
  actions?: InputMaybe<ActionWhere>;
  activities?: InputMaybe<ActivityWhere>;
  and?: InputMaybe<Array<InputMaybe<MemberWhere>>>;
  avatar?: InputMaybe<ImageWhere>;
  createdAt?: InputMaybe<DateTimeCondition>;
  googleSheetsConsent?: InputMaybe<MetricGoogleSheetsSourceWhere>;
  id?: InputMaybe<UuidCondition>;
  isBlocked?: InputMaybe<BooleanCondition>;
  jobTitle?: InputMaybe<StringCondition>;
  name?: InputMaybe<StringCondition>;
  not?: InputMaybe<MemberWhere>;
  opportunities?: InputMaybe<OpportunityWhere>;
  or?: InputMaybe<Array<InputMaybe<MemberWhere>>>;
  settings?: InputMaybe<MemberSettingsWhere>;
  team?: InputMaybe<TeamWhere>;
};

export type MemberWithoutActionsCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activities?: InputMaybe<Array<MemberCreateActivitiesEntityRelationInput>>;
  avatar?: InputMaybe<MemberCreateAvatarEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  googleSheetsConsent?: InputMaybe<MemberCreateGoogleSheetsConsentEntityRelationInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<MemberCreateOpportunitiesEntityRelationInput>>;
  settings?: InputMaybe<MemberCreateSettingsEntityRelationInput>;
  team?: InputMaybe<MemberCreateTeamEntityRelationInput>;
};

export type MemberWithoutActionsUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activities?: InputMaybe<Array<MemberUpdateActivitiesEntityRelationInput>>;
  avatar?: InputMaybe<MemberUpdateAvatarEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  googleSheetsConsent?: InputMaybe<MemberUpdateGoogleSheetsConsentEntityRelationInput>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<MemberUpdateOpportunitiesEntityRelationInput>>;
  settings?: InputMaybe<MemberUpdateSettingsEntityRelationInput>;
  team?: InputMaybe<MemberUpdateTeamEntityRelationInput>;
};

export type MemberWithoutActivitiesCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<MemberCreateActionsEntityRelationInput>>;
  avatar?: InputMaybe<MemberCreateAvatarEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  googleSheetsConsent?: InputMaybe<MemberCreateGoogleSheetsConsentEntityRelationInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<MemberCreateOpportunitiesEntityRelationInput>>;
  settings?: InputMaybe<MemberCreateSettingsEntityRelationInput>;
  team?: InputMaybe<MemberCreateTeamEntityRelationInput>;
};

export type MemberWithoutActivitiesUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<MemberUpdateActionsEntityRelationInput>>;
  avatar?: InputMaybe<MemberUpdateAvatarEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  googleSheetsConsent?: InputMaybe<MemberUpdateGoogleSheetsConsentEntityRelationInput>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<MemberUpdateOpportunitiesEntityRelationInput>>;
  settings?: InputMaybe<MemberUpdateSettingsEntityRelationInput>;
  team?: InputMaybe<MemberUpdateTeamEntityRelationInput>;
};

export type MemberWithoutGoogleSheetsConsentCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<MemberCreateActionsEntityRelationInput>>;
  activities?: InputMaybe<Array<MemberCreateActivitiesEntityRelationInput>>;
  avatar?: InputMaybe<MemberCreateAvatarEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<MemberCreateOpportunitiesEntityRelationInput>>;
  settings?: InputMaybe<MemberCreateSettingsEntityRelationInput>;
  team?: InputMaybe<MemberCreateTeamEntityRelationInput>;
};

export type MemberWithoutGoogleSheetsConsentUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<MemberUpdateActionsEntityRelationInput>>;
  activities?: InputMaybe<Array<MemberUpdateActivitiesEntityRelationInput>>;
  avatar?: InputMaybe<MemberUpdateAvatarEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<MemberUpdateOpportunitiesEntityRelationInput>>;
  settings?: InputMaybe<MemberUpdateSettingsEntityRelationInput>;
  team?: InputMaybe<MemberUpdateTeamEntityRelationInput>;
};

export type MemberWithoutOpportunitiesCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<MemberCreateActionsEntityRelationInput>>;
  activities?: InputMaybe<Array<MemberCreateActivitiesEntityRelationInput>>;
  avatar?: InputMaybe<MemberCreateAvatarEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  googleSheetsConsent?: InputMaybe<MemberCreateGoogleSheetsConsentEntityRelationInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<MemberCreateSettingsEntityRelationInput>;
  team?: InputMaybe<MemberCreateTeamEntityRelationInput>;
};

export type MemberWithoutOpportunitiesUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<MemberUpdateActionsEntityRelationInput>>;
  activities?: InputMaybe<Array<MemberUpdateActivitiesEntityRelationInput>>;
  avatar?: InputMaybe<MemberUpdateAvatarEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  googleSheetsConsent?: InputMaybe<MemberUpdateGoogleSheetsConsentEntityRelationInput>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<MemberUpdateSettingsEntityRelationInput>;
  team?: InputMaybe<MemberUpdateTeamEntityRelationInput>;
};

export type MemberWithoutSettingsCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<MemberCreateActionsEntityRelationInput>>;
  activities?: InputMaybe<Array<MemberCreateActivitiesEntityRelationInput>>;
  avatar?: InputMaybe<MemberCreateAvatarEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  googleSheetsConsent?: InputMaybe<MemberCreateGoogleSheetsConsentEntityRelationInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<MemberCreateOpportunitiesEntityRelationInput>>;
  team?: InputMaybe<MemberCreateTeamEntityRelationInput>;
};

export type MemberWithoutSettingsUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<MemberUpdateActionsEntityRelationInput>>;
  activities?: InputMaybe<Array<MemberUpdateActivitiesEntityRelationInput>>;
  avatar?: InputMaybe<MemberUpdateAvatarEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  googleSheetsConsent?: InputMaybe<MemberUpdateGoogleSheetsConsentEntityRelationInput>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<MemberUpdateOpportunitiesEntityRelationInput>>;
  team?: InputMaybe<MemberUpdateTeamEntityRelationInput>;
};

export type MemberWithoutTeamCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<MemberCreateActionsEntityRelationInput>>;
  activities?: InputMaybe<Array<MemberCreateActivitiesEntityRelationInput>>;
  avatar?: InputMaybe<MemberCreateAvatarEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  googleSheetsConsent?: InputMaybe<MemberCreateGoogleSheetsConsentEntityRelationInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<MemberCreateOpportunitiesEntityRelationInput>>;
  settings?: InputMaybe<MemberCreateSettingsEntityRelationInput>;
};

export type MemberWithoutTeamUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<MemberUpdateActionsEntityRelationInput>>;
  activities?: InputMaybe<Array<MemberUpdateActivitiesEntityRelationInput>>;
  avatar?: InputMaybe<MemberUpdateAvatarEntityRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  googleSheetsConsent?: InputMaybe<MemberUpdateGoogleSheetsConsentEntityRelationInput>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<MemberUpdateOpportunitiesEntityRelationInput>>;
  settings?: InputMaybe<MemberUpdateSettingsEntityRelationInput>;
};

export type Membership = {
  __typename?: 'Membership';
  role: Scalars['String']['output'];
  variables: Array<VariableEntry>;
};

export type MembershipInput = {
  role: Scalars['String']['input'];
  variables: Array<VariableEntryInput>;
};

export type MembershipValidationError = {
  __typename?: 'MembershipValidationError';
  code: MembershipValidationErrorCode;
  role: Scalars['String']['output'];
  variable?: Maybe<Scalars['String']['output']>;
};

export type MembershipValidationErrorCode =
  | 'ROLE_NOT_FOUND'
  | 'VARIABLE_EMPTY'
  | 'VARIABLE_INVALID'
  | 'VARIABLE_NOT_FOUND';

export type Metric = {
  __typename?: 'Metric';
  _meta?: Maybe<MetricMeta>;
  behavior: MetricBehavior;
  dataLabels: Array<MetricDataLabel>;
  dataSet?: Maybe<MetricDataSet>;
  id: Scalars['UUID']['output'];
  lowerWarningBound?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  paginateDataLabels: MetricDataLabelConnection;
  unit?: Maybe<MetricUnit>;
  unitSign?: Maybe<Scalars['String']['output']>;
  upperWarningBound?: Maybe<Scalars['Float']['output']>;
};


export type MetricDataLabelsArgs = {
  filter?: InputMaybe<MetricDataLabelWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricDataLabelOrderBy>>;
};


export type MetricDataSetArgs = {
  filter?: InputMaybe<MetricDataSetWhere>;
};


export type MetricPaginateDataLabelsArgs = {
  filter?: InputMaybe<MetricDataLabelWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricDataLabelOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type MetricBehavior =
  | 'average'
  | 'latest'
  | 'proportion'
  | 'sum';

export type MetricBehaviorCondition = {
  and?: InputMaybe<Array<MetricBehaviorCondition>>;
  eq?: InputMaybe<MetricBehavior>;
  gt?: InputMaybe<MetricBehavior>;
  gte?: InputMaybe<MetricBehavior>;
  in?: InputMaybe<Array<MetricBehavior>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<MetricBehavior>;
  lte?: InputMaybe<MetricBehavior>;
  not?: InputMaybe<MetricBehaviorCondition>;
  notEq?: InputMaybe<MetricBehavior>;
  notIn?: InputMaybe<Array<MetricBehavior>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<MetricBehaviorCondition>>;
};

export type MetricConnectOrCreateDataLabelsRelationInput = {
  connect: MetricDataLabelUniqueWhere;
  create: MetricDataLabelCreateInput;
};

export type MetricConnectOrCreateDataSetRelationInput = {
  connect: MetricDataSetUniqueWhere;
  create: MetricDataSetCreateInput;
};

export type MetricConnection = {
  __typename?: 'MetricConnection';
  edges: Array<MetricEdge>;
  pageInfo: PageInfo;
};

export type MetricCreateDataLabelsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<MetricDataLabelUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricConnectOrCreateDataLabelsRelationInput>;
  create?: InputMaybe<MetricDataLabelCreateInput>;
};

export type MetricCreateDataSetEntityRelationInput = {
  connect?: InputMaybe<MetricDataSetUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricConnectOrCreateDataSetRelationInput>;
  create?: InputMaybe<MetricDataSetCreateInput>;
};

export type MetricCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  behavior?: InputMaybe<MetricBehavior>;
  dataLabels?: InputMaybe<Array<MetricCreateDataLabelsEntityRelationInput>>;
  dataSet?: InputMaybe<MetricCreateDataSetEntityRelationInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  lowerWarningBound?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<MetricUnit>;
  unitSign?: InputMaybe<Scalars['String']['input']>;
  upperWarningBound?: InputMaybe<Scalars['Float']['input']>;
};

export type MetricCreateResult = MutationResult & {
  __typename?: 'MetricCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Metric>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricDataLabel = {
  __typename?: 'MetricDataLabel';
  _meta?: Maybe<MetricDataLabelMeta>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type MetricDataLabelConnection = {
  __typename?: 'MetricDataLabelConnection';
  edges: Array<MetricDataLabelEdge>;
  pageInfo: PageInfo;
};

export type MetricDataLabelCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricDataLabelCreateResult = MutationResult & {
  __typename?: 'MetricDataLabelCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricDataLabel>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricDataLabelDeleteResult = MutationResult & {
  __typename?: 'MetricDataLabelDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricDataLabel>;
  ok: Scalars['Boolean']['output'];
};

export type MetricDataLabelEdge = {
  __typename?: 'MetricDataLabelEdge';
  node: MetricDataLabel;
};

export type MetricDataLabelMeta = {
  __typename?: 'MetricDataLabelMeta';
  id?: Maybe<FieldMeta>;
  name?: Maybe<FieldMeta>;
  value?: Maybe<FieldMeta>;
};

export type MetricDataLabelOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  value?: InputMaybe<OrderDirection>;
};

export type MetricDataLabelUniqueWhere = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type MetricDataLabelUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricDataLabelUpdateResult = MutationResult & {
  __typename?: 'MetricDataLabelUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricDataLabel>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricDataLabelUpsertResult = MutationResult & {
  __typename?: 'MetricDataLabelUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricDataLabel>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricDataLabelWhere = {
  and?: InputMaybe<Array<InputMaybe<MetricDataLabelWhere>>>;
  id?: InputMaybe<UuidCondition>;
  name?: InputMaybe<StringCondition>;
  not?: InputMaybe<MetricDataLabelWhere>;
  or?: InputMaybe<Array<InputMaybe<MetricDataLabelWhere>>>;
  value?: InputMaybe<StringCondition>;
};

export type MetricDataPoint = {
  __typename?: 'MetricDataPoint';
  _meta?: Maybe<MetricDataPointMeta>;
  contentMetricDataPoint?: Maybe<ContentMetricDataPoint>;
  dataLabels: Array<MetricDataLabel>;
  dataSet?: Maybe<MetricDataSet>;
  end?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  input: MetricDataPointInput;
  paginateDataLabels: MetricDataLabelConnection;
  start: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};


export type MetricDataPointContentMetricDataPointArgs = {
  filter?: InputMaybe<ContentMetricDataPointWhere>;
};


export type MetricDataPointDataLabelsArgs = {
  filter?: InputMaybe<MetricDataLabelWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricDataLabelOrderBy>>;
};


export type MetricDataPointDataSetArgs = {
  filter?: InputMaybe<MetricDataSetWhere>;
};


export type MetricDataPointPaginateDataLabelsArgs = {
  filter?: InputMaybe<MetricDataLabelWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricDataLabelOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type MetricDataPointConnectOrCreateContentMetricDataPointRelationInput = {
  connect: ContentMetricDataPointUniqueWhere;
  create: ContentMetricDataPointWithoutMetricDataPointCreateInput;
};

export type MetricDataPointConnectOrCreateDataLabelsRelationInput = {
  connect: MetricDataLabelUniqueWhere;
  create: MetricDataLabelCreateInput;
};

export type MetricDataPointConnectOrCreateDataSetRelationInput = {
  connect: MetricDataSetUniqueWhere;
  create: MetricDataSetCreateInput;
};

export type MetricDataPointConnection = {
  __typename?: 'MetricDataPointConnection';
  edges: Array<MetricDataPointEdge>;
  pageInfo: PageInfo;
};

export type MetricDataPointCreateContentMetricDataPointEntityRelationInput = {
  connect?: InputMaybe<ContentMetricDataPointUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricDataPointConnectOrCreateContentMetricDataPointRelationInput>;
  create?: InputMaybe<ContentMetricDataPointWithoutMetricDataPointCreateInput>;
};

export type MetricDataPointCreateDataLabelsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<MetricDataLabelUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricDataPointConnectOrCreateDataLabelsRelationInput>;
  create?: InputMaybe<MetricDataLabelCreateInput>;
};

export type MetricDataPointCreateDataSetEntityRelationInput = {
  connect?: InputMaybe<MetricDataSetUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricDataPointConnectOrCreateDataSetRelationInput>;
  create?: InputMaybe<MetricDataSetCreateInput>;
};

export type MetricDataPointCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  contentMetricDataPoint?: InputMaybe<MetricDataPointCreateContentMetricDataPointEntityRelationInput>;
  dataLabels?: InputMaybe<Array<MetricDataPointCreateDataLabelsEntityRelationInput>>;
  dataSet?: InputMaybe<MetricDataPointCreateDataSetEntityRelationInput>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  input?: InputMaybe<MetricDataPointInput>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type MetricDataPointCreateResult = MutationResult & {
  __typename?: 'MetricDataPointCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricDataPoint>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricDataPointDeleteResult = MutationResult & {
  __typename?: 'MetricDataPointDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricDataPoint>;
  ok: Scalars['Boolean']['output'];
};

export type MetricDataPointEdge = {
  __typename?: 'MetricDataPointEdge';
  node: MetricDataPoint;
};

export type MetricDataPointInput =
  | 'automatic'
  | 'manual';

export type MetricDataPointInputCondition = {
  and?: InputMaybe<Array<MetricDataPointInputCondition>>;
  eq?: InputMaybe<MetricDataPointInput>;
  gt?: InputMaybe<MetricDataPointInput>;
  gte?: InputMaybe<MetricDataPointInput>;
  in?: InputMaybe<Array<MetricDataPointInput>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<MetricDataPointInput>;
  lte?: InputMaybe<MetricDataPointInput>;
  not?: InputMaybe<MetricDataPointInputCondition>;
  notEq?: InputMaybe<MetricDataPointInput>;
  notIn?: InputMaybe<Array<MetricDataPointInput>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<MetricDataPointInputCondition>>;
};

export type MetricDataPointMeta = {
  __typename?: 'MetricDataPointMeta';
  contentMetricDataPoint?: Maybe<FieldMeta>;
  dataLabels?: Maybe<FieldMeta>;
  dataSet?: Maybe<FieldMeta>;
  end?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  input?: Maybe<FieldMeta>;
  start?: Maybe<FieldMeta>;
  value?: Maybe<FieldMeta>;
};

export type MetricDataPointOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  contentMetricDataPoint?: InputMaybe<ContentMetricDataPointOrderBy>;
  dataSet?: InputMaybe<MetricDataSetOrderBy>;
  end?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  input?: InputMaybe<OrderDirection>;
  start?: InputMaybe<OrderDirection>;
  value?: InputMaybe<OrderDirection>;
};

export type MetricDataPointUniqueWhere = {
  contentMetricDataPoint?: InputMaybe<ContentMetricDataPointUniqueWhere>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type MetricDataPointUpdateContentMetricDataPointEntityRelationInput = {
  connect?: InputMaybe<ContentMetricDataPointUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricDataPointConnectOrCreateContentMetricDataPointRelationInput>;
  create?: InputMaybe<ContentMetricDataPointWithoutMetricDataPointCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<ContentMetricDataPointWithoutMetricDataPointUpdateInput>;
  upsert?: InputMaybe<MetricDataPointUpsertContentMetricDataPointRelationInput>;
};

export type MetricDataPointUpdateDataLabelsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<MetricDataLabelUniqueWhere>;
  create?: InputMaybe<MetricDataLabelCreateInput>;
  delete?: InputMaybe<MetricDataLabelUniqueWhere>;
  disconnect?: InputMaybe<MetricDataLabelUniqueWhere>;
  update?: InputMaybe<MetricDataPointUpdateDataLabelsRelationInput>;
  upsert?: InputMaybe<MetricDataPointUpsertDataLabelsRelationInput>;
};

export type MetricDataPointUpdateDataLabelsRelationInput = {
  by: MetricDataLabelUniqueWhere;
  data: MetricDataLabelUpdateInput;
};

export type MetricDataPointUpdateDataSetEntityRelationInput = {
  connect?: InputMaybe<MetricDataSetUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricDataPointConnectOrCreateDataSetRelationInput>;
  create?: InputMaybe<MetricDataSetCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<MetricDataSetUpdateInput>;
  upsert?: InputMaybe<MetricDataPointUpsertDataSetRelationInput>;
};

export type MetricDataPointUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  contentMetricDataPoint?: InputMaybe<MetricDataPointUpdateContentMetricDataPointEntityRelationInput>;
  dataLabels?: InputMaybe<Array<MetricDataPointUpdateDataLabelsEntityRelationInput>>;
  dataSet?: InputMaybe<MetricDataPointUpdateDataSetEntityRelationInput>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  input?: InputMaybe<MetricDataPointInput>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type MetricDataPointUpdateResult = MutationResult & {
  __typename?: 'MetricDataPointUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricDataPoint>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricDataPointUpsertContentMetricDataPointRelationInput = {
  create: ContentMetricDataPointWithoutMetricDataPointCreateInput;
  update: ContentMetricDataPointWithoutMetricDataPointUpdateInput;
};

export type MetricDataPointUpsertDataLabelsRelationInput = {
  by: MetricDataLabelUniqueWhere;
  create: MetricDataLabelCreateInput;
  update: MetricDataLabelUpdateInput;
};

export type MetricDataPointUpsertDataSetRelationInput = {
  create: MetricDataSetCreateInput;
  update: MetricDataSetUpdateInput;
};

export type MetricDataPointUpsertResult = MutationResult & {
  __typename?: 'MetricDataPointUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricDataPoint>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricDataPointWhere = {
  and?: InputMaybe<Array<InputMaybe<MetricDataPointWhere>>>;
  contentMetricDataPoint?: InputMaybe<ContentMetricDataPointWhere>;
  dataLabels?: InputMaybe<MetricDataLabelWhere>;
  dataSet?: InputMaybe<MetricDataSetWhere>;
  end?: InputMaybe<DateTimeCondition>;
  id?: InputMaybe<UuidCondition>;
  input?: InputMaybe<MetricDataPointInputCondition>;
  not?: InputMaybe<MetricDataPointWhere>;
  or?: InputMaybe<Array<InputMaybe<MetricDataPointWhere>>>;
  start?: InputMaybe<DateTimeCondition>;
  value?: InputMaybe<FloatCondition>;
};

export type MetricDataPointWithoutContentMetricDataPointCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  dataLabels?: InputMaybe<Array<MetricDataPointCreateDataLabelsEntityRelationInput>>;
  dataSet?: InputMaybe<MetricDataPointCreateDataSetEntityRelationInput>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  input?: InputMaybe<MetricDataPointInput>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type MetricDataPointWithoutContentMetricDataPointUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  dataLabels?: InputMaybe<Array<MetricDataPointUpdateDataLabelsEntityRelationInput>>;
  dataSet?: InputMaybe<MetricDataPointUpdateDataSetEntityRelationInput>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  input?: InputMaybe<MetricDataPointInput>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type MetricDataSet = {
  __typename?: 'MetricDataSet';
  _meta?: Maybe<MetricDataSetMeta>;
  currency?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  metricTemplate?: Maybe<MetricTemplate>;
  name: Scalars['String']['output'];
  source?: Maybe<MetricSource>;
};


export type MetricDataSetMetricTemplateArgs = {
  filter?: InputMaybe<MetricTemplateWhere>;
};


export type MetricDataSetSourceArgs = {
  filter?: InputMaybe<MetricSourceWhere>;
};

export type MetricDataSetConnectOrCreateMetricTemplateRelationInput = {
  connect: MetricTemplateUniqueWhere;
  create: MetricTemplateWithoutDataSetsCreateInput;
};

export type MetricDataSetConnectOrCreateSourceRelationInput = {
  connect: MetricSourceUniqueWhere;
  create: MetricSourceCreateInput;
};

export type MetricDataSetConnection = {
  __typename?: 'MetricDataSetConnection';
  edges: Array<MetricDataSetEdge>;
  pageInfo: PageInfo;
};

export type MetricDataSetCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  metricTemplate?: InputMaybe<MetricDataSetCreateMetricTemplateEntityRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<MetricDataSetCreateSourceEntityRelationInput>;
};

export type MetricDataSetCreateMetricTemplateEntityRelationInput = {
  connect?: InputMaybe<MetricTemplateUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricDataSetConnectOrCreateMetricTemplateRelationInput>;
  create?: InputMaybe<MetricTemplateWithoutDataSetsCreateInput>;
};

export type MetricDataSetCreateResult = MutationResult & {
  __typename?: 'MetricDataSetCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricDataSet>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricDataSetCreateSourceEntityRelationInput = {
  connect?: InputMaybe<MetricSourceUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricDataSetConnectOrCreateSourceRelationInput>;
  create?: InputMaybe<MetricSourceCreateInput>;
};

export type MetricDataSetDeleteResult = MutationResult & {
  __typename?: 'MetricDataSetDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricDataSet>;
  ok: Scalars['Boolean']['output'];
};

export type MetricDataSetEdge = {
  __typename?: 'MetricDataSetEdge';
  node: MetricDataSet;
};

export type MetricDataSetMeta = {
  __typename?: 'MetricDataSetMeta';
  currency?: Maybe<FieldMeta>;
  externalId?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  metricTemplate?: Maybe<FieldMeta>;
  name?: Maybe<FieldMeta>;
  source?: Maybe<FieldMeta>;
};

export type MetricDataSetOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<OrderDirection>;
  externalId?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  metricTemplate?: InputMaybe<MetricTemplateOrderBy>;
  name?: InputMaybe<OrderDirection>;
  source?: InputMaybe<MetricSourceOrderBy>;
};

export type MetricDataSetUniqueWhere = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type MetricDataSetUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  metricTemplate?: InputMaybe<MetricDataSetUpdateMetricTemplateEntityRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<MetricDataSetUpdateSourceEntityRelationInput>;
};

export type MetricDataSetUpdateMetricTemplateEntityRelationInput = {
  connect?: InputMaybe<MetricTemplateUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricDataSetConnectOrCreateMetricTemplateRelationInput>;
  create?: InputMaybe<MetricTemplateWithoutDataSetsCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<MetricTemplateWithoutDataSetsUpdateInput>;
  upsert?: InputMaybe<MetricDataSetUpsertMetricTemplateRelationInput>;
};

export type MetricDataSetUpdateResult = MutationResult & {
  __typename?: 'MetricDataSetUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricDataSet>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricDataSetUpdateSourceEntityRelationInput = {
  connect?: InputMaybe<MetricSourceUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricDataSetConnectOrCreateSourceRelationInput>;
  create?: InputMaybe<MetricSourceCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<MetricSourceUpdateInput>;
  upsert?: InputMaybe<MetricDataSetUpsertSourceRelationInput>;
};

export type MetricDataSetUpsertMetricTemplateRelationInput = {
  create: MetricTemplateWithoutDataSetsCreateInput;
  update: MetricTemplateWithoutDataSetsUpdateInput;
};

export type MetricDataSetUpsertResult = MutationResult & {
  __typename?: 'MetricDataSetUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricDataSet>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricDataSetUpsertSourceRelationInput = {
  create: MetricSourceCreateInput;
  update: MetricSourceUpdateInput;
};

export type MetricDataSetWhere = {
  and?: InputMaybe<Array<InputMaybe<MetricDataSetWhere>>>;
  currency?: InputMaybe<StringCondition>;
  externalId?: InputMaybe<StringCondition>;
  id?: InputMaybe<UuidCondition>;
  metricTemplate?: InputMaybe<MetricTemplateWhere>;
  name?: InputMaybe<StringCondition>;
  not?: InputMaybe<MetricDataSetWhere>;
  or?: InputMaybe<Array<InputMaybe<MetricDataSetWhere>>>;
  source?: InputMaybe<MetricSourceWhere>;
};

export type MetricDataSetWithoutMetricTemplateCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<MetricDataSetCreateSourceEntityRelationInput>;
};

export type MetricDataSetWithoutMetricTemplateUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<MetricDataSetUpdateSourceEntityRelationInput>;
};

export type MetricDeleteResult = MutationResult & {
  __typename?: 'MetricDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Metric>;
  ok: Scalars['Boolean']['output'];
};

export type MetricEdge = {
  __typename?: 'MetricEdge';
  node: Metric;
};

export type MetricGoogleSheetsMapping = {
  __typename?: 'MetricGoogleSheetsMapping';
  _meta?: Maybe<MetricGoogleSheetsMappingMeta>;
  id: Scalars['UUID']['output'];
  metricDataSet?: Maybe<MetricDataSet>;
  metricGoogleSheetsSheet?: Maybe<MetricGoogleSheetsSheet>;
};


export type MetricGoogleSheetsMappingMetricDataSetArgs = {
  filter?: InputMaybe<MetricDataSetWhere>;
};


export type MetricGoogleSheetsMappingMetricGoogleSheetsSheetArgs = {
  filter?: InputMaybe<MetricGoogleSheetsSheetWhere>;
};

export type MetricGoogleSheetsMappingConnectOrCreateMetricDataSetRelationInput = {
  connect: MetricDataSetUniqueWhere;
  create: MetricDataSetCreateInput;
};

export type MetricGoogleSheetsMappingConnectOrCreateMetricGoogleSheetsSheetRelationInput = {
  connect: MetricGoogleSheetsSheetUniqueWhere;
  create: MetricGoogleSheetsSheetWithoutMetricGoogleSheetsMappingsCreateInput;
};

export type MetricGoogleSheetsMappingConnection = {
  __typename?: 'MetricGoogleSheetsMappingConnection';
  edges: Array<MetricGoogleSheetsMappingEdge>;
  pageInfo: PageInfo;
};

export type MetricGoogleSheetsMappingCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  metricDataSet?: InputMaybe<MetricGoogleSheetsMappingCreateMetricDataSetEntityRelationInput>;
  metricGoogleSheetsSheet?: InputMaybe<MetricGoogleSheetsMappingCreateMetricGoogleSheetsSheetEntityRelationInput>;
};

export type MetricGoogleSheetsMappingCreateMetricDataSetEntityRelationInput = {
  connect?: InputMaybe<MetricDataSetUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricGoogleSheetsMappingConnectOrCreateMetricDataSetRelationInput>;
  create?: InputMaybe<MetricDataSetCreateInput>;
};

export type MetricGoogleSheetsMappingCreateMetricGoogleSheetsSheetEntityRelationInput = {
  connect?: InputMaybe<MetricGoogleSheetsSheetUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricGoogleSheetsMappingConnectOrCreateMetricGoogleSheetsSheetRelationInput>;
  create?: InputMaybe<MetricGoogleSheetsSheetWithoutMetricGoogleSheetsMappingsCreateInput>;
};

export type MetricGoogleSheetsMappingCreateResult = MutationResult & {
  __typename?: 'MetricGoogleSheetsMappingCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricGoogleSheetsMapping>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricGoogleSheetsMappingDeleteResult = MutationResult & {
  __typename?: 'MetricGoogleSheetsMappingDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricGoogleSheetsMapping>;
  ok: Scalars['Boolean']['output'];
};

export type MetricGoogleSheetsMappingEdge = {
  __typename?: 'MetricGoogleSheetsMappingEdge';
  node: MetricGoogleSheetsMapping;
};

export type MetricGoogleSheetsMappingMeta = {
  __typename?: 'MetricGoogleSheetsMappingMeta';
  id?: Maybe<FieldMeta>;
  metricDataSet?: Maybe<FieldMeta>;
  metricGoogleSheetsSheet?: Maybe<FieldMeta>;
};

export type MetricGoogleSheetsMappingOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<OrderDirection>;
  metricDataSet?: InputMaybe<MetricDataSetOrderBy>;
  metricGoogleSheetsSheet?: InputMaybe<MetricGoogleSheetsSheetOrderBy>;
};

export type MetricGoogleSheetsMappingUniqueWhere = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  metricDataSet?: InputMaybe<MetricDataSetUniqueWhere>;
};

export type MetricGoogleSheetsMappingUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  metricDataSet?: InputMaybe<MetricGoogleSheetsMappingUpdateMetricDataSetEntityRelationInput>;
  metricGoogleSheetsSheet?: InputMaybe<MetricGoogleSheetsMappingUpdateMetricGoogleSheetsSheetEntityRelationInput>;
};

export type MetricGoogleSheetsMappingUpdateMetricDataSetEntityRelationInput = {
  connect?: InputMaybe<MetricDataSetUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricGoogleSheetsMappingConnectOrCreateMetricDataSetRelationInput>;
  create?: InputMaybe<MetricDataSetCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<MetricDataSetUpdateInput>;
  upsert?: InputMaybe<MetricGoogleSheetsMappingUpsertMetricDataSetRelationInput>;
};

export type MetricGoogleSheetsMappingUpdateMetricGoogleSheetsSheetEntityRelationInput = {
  connect?: InputMaybe<MetricGoogleSheetsSheetUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricGoogleSheetsMappingConnectOrCreateMetricGoogleSheetsSheetRelationInput>;
  create?: InputMaybe<MetricGoogleSheetsSheetWithoutMetricGoogleSheetsMappingsCreateInput>;
  update?: InputMaybe<MetricGoogleSheetsSheetWithoutMetricGoogleSheetsMappingsUpdateInput>;
  upsert?: InputMaybe<MetricGoogleSheetsMappingUpsertMetricGoogleSheetsSheetRelationInput>;
};

export type MetricGoogleSheetsMappingUpdateResult = MutationResult & {
  __typename?: 'MetricGoogleSheetsMappingUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricGoogleSheetsMapping>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricGoogleSheetsMappingUpsertMetricDataSetRelationInput = {
  create: MetricDataSetCreateInput;
  update: MetricDataSetUpdateInput;
};

export type MetricGoogleSheetsMappingUpsertMetricGoogleSheetsSheetRelationInput = {
  create: MetricGoogleSheetsSheetWithoutMetricGoogleSheetsMappingsCreateInput;
  update: MetricGoogleSheetsSheetWithoutMetricGoogleSheetsMappingsUpdateInput;
};

export type MetricGoogleSheetsMappingUpsertResult = MutationResult & {
  __typename?: 'MetricGoogleSheetsMappingUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricGoogleSheetsMapping>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricGoogleSheetsMappingWhere = {
  and?: InputMaybe<Array<InputMaybe<MetricGoogleSheetsMappingWhere>>>;
  id?: InputMaybe<UuidCondition>;
  metricDataSet?: InputMaybe<MetricDataSetWhere>;
  metricGoogleSheetsSheet?: InputMaybe<MetricGoogleSheetsSheetWhere>;
  not?: InputMaybe<MetricGoogleSheetsMappingWhere>;
  or?: InputMaybe<Array<InputMaybe<MetricGoogleSheetsMappingWhere>>>;
};

export type MetricGoogleSheetsMappingWithoutMetricGoogleSheetsSheetCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  metricDataSet?: InputMaybe<MetricGoogleSheetsMappingCreateMetricDataSetEntityRelationInput>;
};

export type MetricGoogleSheetsMappingWithoutMetricGoogleSheetsSheetUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  metricDataSet?: InputMaybe<MetricGoogleSheetsMappingUpdateMetricDataSetEntityRelationInput>;
};

export type MetricGoogleSheetsSheet = {
  __typename?: 'MetricGoogleSheetsSheet';
  _meta?: Maybe<MetricGoogleSheetsSheetMeta>;
  externalId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  keboolaDataDestinationConfigId?: Maybe<Scalars['String']['output']>;
  metricGoogleSheetsMappings: Array<MetricGoogleSheetsMapping>;
  metricGoogleSheetsMappingsByMetricDataSet?: Maybe<MetricGoogleSheetsMapping>;
  metricGoogleSheetsSpreadsheet?: Maybe<MetricGoogleSheetsSpreadsheet>;
  paginateMetricGoogleSheetsMappings: MetricGoogleSheetsMappingConnection;
};


export type MetricGoogleSheetsSheetMetricGoogleSheetsMappingsArgs = {
  filter?: InputMaybe<MetricGoogleSheetsMappingWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricGoogleSheetsMappingOrderBy>>;
};


export type MetricGoogleSheetsSheetMetricGoogleSheetsMappingsByMetricDataSetArgs = {
  by: MetricGoogleSheetsSheetMetricGoogleSheetsMappingsByMetricDataSetUniqueWhere;
  filter?: InputMaybe<MetricGoogleSheetsMappingWhere>;
};


export type MetricGoogleSheetsSheetMetricGoogleSheetsSpreadsheetArgs = {
  filter?: InputMaybe<MetricGoogleSheetsSpreadsheetWhere>;
};


export type MetricGoogleSheetsSheetPaginateMetricGoogleSheetsMappingsArgs = {
  filter?: InputMaybe<MetricGoogleSheetsMappingWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricGoogleSheetsMappingOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type MetricGoogleSheetsSheetConnectOrCreateMetricGoogleSheetsMappingsRelationInput = {
  connect: MetricGoogleSheetsMappingUniqueWhere;
  create: MetricGoogleSheetsMappingWithoutMetricGoogleSheetsSheetCreateInput;
};

export type MetricGoogleSheetsSheetConnectOrCreateMetricGoogleSheetsSpreadsheetRelationInput = {
  connect: MetricGoogleSheetsSpreadsheetUniqueWhere;
  create: MetricGoogleSheetsSpreadsheetWithoutMetricGoogleSheetsSheetsCreateInput;
};

export type MetricGoogleSheetsSheetConnection = {
  __typename?: 'MetricGoogleSheetsSheetConnection';
  edges: Array<MetricGoogleSheetsSheetEdge>;
  pageInfo: PageInfo;
};

export type MetricGoogleSheetsSheetCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  keboolaDataDestinationConfigId?: InputMaybe<Scalars['String']['input']>;
  metricGoogleSheetsMappings?: InputMaybe<Array<MetricGoogleSheetsSheetCreateMetricGoogleSheetsMappingsEntityRelationInput>>;
  metricGoogleSheetsSpreadsheet?: InputMaybe<MetricGoogleSheetsSheetCreateMetricGoogleSheetsSpreadsheetEntityRelationInput>;
};

export type MetricGoogleSheetsSheetCreateMetricGoogleSheetsMappingsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<MetricGoogleSheetsMappingUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricGoogleSheetsSheetConnectOrCreateMetricGoogleSheetsMappingsRelationInput>;
  create?: InputMaybe<MetricGoogleSheetsMappingWithoutMetricGoogleSheetsSheetCreateInput>;
};

export type MetricGoogleSheetsSheetCreateMetricGoogleSheetsSpreadsheetEntityRelationInput = {
  connect?: InputMaybe<MetricGoogleSheetsSpreadsheetUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricGoogleSheetsSheetConnectOrCreateMetricGoogleSheetsSpreadsheetRelationInput>;
  create?: InputMaybe<MetricGoogleSheetsSpreadsheetWithoutMetricGoogleSheetsSheetsCreateInput>;
};

export type MetricGoogleSheetsSheetCreateResult = MutationResult & {
  __typename?: 'MetricGoogleSheetsSheetCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricGoogleSheetsSheet>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricGoogleSheetsSheetDeleteResult = MutationResult & {
  __typename?: 'MetricGoogleSheetsSheetDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricGoogleSheetsSheet>;
  ok: Scalars['Boolean']['output'];
};

export type MetricGoogleSheetsSheetEdge = {
  __typename?: 'MetricGoogleSheetsSheetEdge';
  node: MetricGoogleSheetsSheet;
};

export type MetricGoogleSheetsSheetMeta = {
  __typename?: 'MetricGoogleSheetsSheetMeta';
  externalId?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  keboolaDataDestinationConfigId?: Maybe<FieldMeta>;
  metricGoogleSheetsMappings?: Maybe<FieldMeta>;
  metricGoogleSheetsSpreadsheet?: Maybe<FieldMeta>;
};

export type MetricGoogleSheetsSheetMetricGoogleSheetsMappingsByMetricDataSetUniqueWhere = {
  metricDataSet?: InputMaybe<MetricDataSetUniqueWhere>;
};

export type MetricGoogleSheetsSheetOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  externalId?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  keboolaDataDestinationConfigId?: InputMaybe<OrderDirection>;
  metricGoogleSheetsSpreadsheet?: InputMaybe<MetricGoogleSheetsSpreadsheetOrderBy>;
};

export type MetricGoogleSheetsSheetUniqueWhere = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  keboolaDataDestinationConfigId?: InputMaybe<Scalars['String']['input']>;
  metricGoogleSheetsMappings?: InputMaybe<MetricGoogleSheetsMappingUniqueWhere>;
};

export type MetricGoogleSheetsSheetUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  keboolaDataDestinationConfigId?: InputMaybe<Scalars['String']['input']>;
  metricGoogleSheetsMappings?: InputMaybe<Array<MetricGoogleSheetsSheetUpdateMetricGoogleSheetsMappingsEntityRelationInput>>;
  metricGoogleSheetsSpreadsheet?: InputMaybe<MetricGoogleSheetsSheetUpdateMetricGoogleSheetsSpreadsheetEntityRelationInput>;
};

export type MetricGoogleSheetsSheetUpdateMetricGoogleSheetsMappingsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<MetricGoogleSheetsMappingUniqueWhere>;
  create?: InputMaybe<MetricGoogleSheetsMappingWithoutMetricGoogleSheetsSheetCreateInput>;
  delete?: InputMaybe<MetricGoogleSheetsMappingUniqueWhere>;
  disconnect?: InputMaybe<MetricGoogleSheetsMappingUniqueWhere>;
  update?: InputMaybe<MetricGoogleSheetsSheetUpdateMetricGoogleSheetsMappingsRelationInput>;
  upsert?: InputMaybe<MetricGoogleSheetsSheetUpsertMetricGoogleSheetsMappingsRelationInput>;
};

export type MetricGoogleSheetsSheetUpdateMetricGoogleSheetsMappingsRelationInput = {
  by: MetricGoogleSheetsMappingUniqueWhere;
  data: MetricGoogleSheetsMappingWithoutMetricGoogleSheetsSheetUpdateInput;
};

export type MetricGoogleSheetsSheetUpdateMetricGoogleSheetsSpreadsheetEntityRelationInput = {
  connect?: InputMaybe<MetricGoogleSheetsSpreadsheetUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricGoogleSheetsSheetConnectOrCreateMetricGoogleSheetsSpreadsheetRelationInput>;
  create?: InputMaybe<MetricGoogleSheetsSpreadsheetWithoutMetricGoogleSheetsSheetsCreateInput>;
  update?: InputMaybe<MetricGoogleSheetsSpreadsheetWithoutMetricGoogleSheetsSheetsUpdateInput>;
  upsert?: InputMaybe<MetricGoogleSheetsSheetUpsertMetricGoogleSheetsSpreadsheetRelationInput>;
};

export type MetricGoogleSheetsSheetUpdateResult = MutationResult & {
  __typename?: 'MetricGoogleSheetsSheetUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricGoogleSheetsSheet>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricGoogleSheetsSheetUpsertMetricGoogleSheetsMappingsRelationInput = {
  by: MetricGoogleSheetsMappingUniqueWhere;
  create: MetricGoogleSheetsMappingWithoutMetricGoogleSheetsSheetCreateInput;
  update: MetricGoogleSheetsMappingWithoutMetricGoogleSheetsSheetUpdateInput;
};

export type MetricGoogleSheetsSheetUpsertMetricGoogleSheetsSpreadsheetRelationInput = {
  create: MetricGoogleSheetsSpreadsheetWithoutMetricGoogleSheetsSheetsCreateInput;
  update: MetricGoogleSheetsSpreadsheetWithoutMetricGoogleSheetsSheetsUpdateInput;
};

export type MetricGoogleSheetsSheetUpsertResult = MutationResult & {
  __typename?: 'MetricGoogleSheetsSheetUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricGoogleSheetsSheet>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricGoogleSheetsSheetWhere = {
  and?: InputMaybe<Array<InputMaybe<MetricGoogleSheetsSheetWhere>>>;
  externalId?: InputMaybe<StringCondition>;
  id?: InputMaybe<UuidCondition>;
  keboolaDataDestinationConfigId?: InputMaybe<StringCondition>;
  metricGoogleSheetsMappings?: InputMaybe<MetricGoogleSheetsMappingWhere>;
  metricGoogleSheetsSpreadsheet?: InputMaybe<MetricGoogleSheetsSpreadsheetWhere>;
  not?: InputMaybe<MetricGoogleSheetsSheetWhere>;
  or?: InputMaybe<Array<InputMaybe<MetricGoogleSheetsSheetWhere>>>;
};

export type MetricGoogleSheetsSheetWithoutMetricGoogleSheetsMappingsCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  keboolaDataDestinationConfigId?: InputMaybe<Scalars['String']['input']>;
  metricGoogleSheetsSpreadsheet?: InputMaybe<MetricGoogleSheetsSheetCreateMetricGoogleSheetsSpreadsheetEntityRelationInput>;
};

export type MetricGoogleSheetsSheetWithoutMetricGoogleSheetsMappingsUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  keboolaDataDestinationConfigId?: InputMaybe<Scalars['String']['input']>;
  metricGoogleSheetsSpreadsheet?: InputMaybe<MetricGoogleSheetsSheetUpdateMetricGoogleSheetsSpreadsheetEntityRelationInput>;
};

export type MetricGoogleSheetsSheetWithoutMetricGoogleSheetsSpreadsheetCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  keboolaDataDestinationConfigId?: InputMaybe<Scalars['String']['input']>;
  metricGoogleSheetsMappings?: InputMaybe<Array<MetricGoogleSheetsSheetCreateMetricGoogleSheetsMappingsEntityRelationInput>>;
};

export type MetricGoogleSheetsSheetWithoutMetricGoogleSheetsSpreadsheetUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  keboolaDataDestinationConfigId?: InputMaybe<Scalars['String']['input']>;
  metricGoogleSheetsMappings?: InputMaybe<Array<MetricGoogleSheetsSheetUpdateMetricGoogleSheetsMappingsEntityRelationInput>>;
};

export type MetricGoogleSheetsSource = {
  __typename?: 'MetricGoogleSheetsSource';
  _meta?: Maybe<MetricGoogleSheetsSourceMeta>;
  consent?: Maybe<Member>;
  id: Scalars['UUID']['output'];
  keboolaDataSourceConfigId?: Maybe<Scalars['String']['output']>;
  keboolaOrchestrationId?: Maybe<Scalars['String']['output']>;
  keboolaSyncEvents: Array<KeboolaSyncEvent>;
  lastSyncAt?: Maybe<Scalars['DateTime']['output']>;
  metricGoogleSheetsSpreadsheets: Array<MetricGoogleSheetsSpreadsheet>;
  metricGoogleSheetsSpreadsheetsByExternalId?: Maybe<MetricGoogleSheetsSpreadsheet>;
  metricGoogleSheetsSpreadsheetsByMetricGoogleSheetsSheets?: Maybe<MetricGoogleSheetsSpreadsheet>;
  metricSource?: Maybe<MetricSource>;
  paginateKeboolaSyncEvents: KeboolaSyncEventConnection;
  paginateMetricGoogleSheetsSpreadsheets: MetricGoogleSheetsSpreadsheetConnection;
  refreshToken?: Maybe<Scalars['String']['output']>;
};


export type MetricGoogleSheetsSourceConsentArgs = {
  filter?: InputMaybe<MemberWhere>;
};


export type MetricGoogleSheetsSourceKeboolaSyncEventsArgs = {
  filter?: InputMaybe<KeboolaSyncEventWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<KeboolaSyncEventOrderBy>>;
};


export type MetricGoogleSheetsSourceMetricGoogleSheetsSpreadsheetsArgs = {
  filter?: InputMaybe<MetricGoogleSheetsSpreadsheetWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricGoogleSheetsSpreadsheetOrderBy>>;
};


export type MetricGoogleSheetsSourceMetricGoogleSheetsSpreadsheetsByExternalIdArgs = {
  by: MetricGoogleSheetsSourceMetricGoogleSheetsSpreadsheetsByExternalIdUniqueWhere;
  filter?: InputMaybe<MetricGoogleSheetsSpreadsheetWhere>;
};


export type MetricGoogleSheetsSourceMetricGoogleSheetsSpreadsheetsByMetricGoogleSheetsSheetsArgs = {
  by: MetricGoogleSheetsSourceMetricGoogleSheetsSpreadsheetsByMetricGoogleSheetsSheetsUniqueWhere;
  filter?: InputMaybe<MetricGoogleSheetsSpreadsheetWhere>;
};


export type MetricGoogleSheetsSourceMetricSourceArgs = {
  filter?: InputMaybe<MetricSourceWhere>;
};


export type MetricGoogleSheetsSourcePaginateKeboolaSyncEventsArgs = {
  filter?: InputMaybe<KeboolaSyncEventWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<KeboolaSyncEventOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type MetricGoogleSheetsSourcePaginateMetricGoogleSheetsSpreadsheetsArgs = {
  filter?: InputMaybe<MetricGoogleSheetsSpreadsheetWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricGoogleSheetsSpreadsheetOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type MetricGoogleSheetsSourceConnectOrCreateConsentRelationInput = {
  connect: MemberUniqueWhere;
  create: MemberWithoutGoogleSheetsConsentCreateInput;
};

export type MetricGoogleSheetsSourceConnectOrCreateKeboolaSyncEventsRelationInput = {
  connect: KeboolaSyncEventUniqueWhere;
  create: KeboolaSyncEventWithoutMetricGoogleSheetsSourceCreateInput;
};

export type MetricGoogleSheetsSourceConnectOrCreateMetricGoogleSheetsSpreadsheetsRelationInput = {
  connect: MetricGoogleSheetsSpreadsheetUniqueWhere;
  create: MetricGoogleSheetsSpreadsheetWithoutMetricGoogleSheetsSourceCreateInput;
};

export type MetricGoogleSheetsSourceConnectOrCreateMetricSourceRelationInput = {
  connect: MetricSourceUniqueWhere;
  create: MetricSourceCreateInput;
};

export type MetricGoogleSheetsSourceConnection = {
  __typename?: 'MetricGoogleSheetsSourceConnection';
  edges: Array<MetricGoogleSheetsSourceEdge>;
  pageInfo: PageInfo;
};

export type MetricGoogleSheetsSourceCreateConsentEntityRelationInput = {
  connect?: InputMaybe<MemberUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricGoogleSheetsSourceConnectOrCreateConsentRelationInput>;
  create?: InputMaybe<MemberWithoutGoogleSheetsConsentCreateInput>;
};

export type MetricGoogleSheetsSourceCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  consent?: InputMaybe<MetricGoogleSheetsSourceCreateConsentEntityRelationInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  keboolaDataSourceConfigId?: InputMaybe<Scalars['String']['input']>;
  keboolaOrchestrationId?: InputMaybe<Scalars['String']['input']>;
  keboolaSyncEvents?: InputMaybe<Array<MetricGoogleSheetsSourceCreateKeboolaSyncEventsEntityRelationInput>>;
  lastSyncAt?: InputMaybe<Scalars['DateTime']['input']>;
  metricGoogleSheetsSpreadsheets?: InputMaybe<Array<MetricGoogleSheetsSourceCreateMetricGoogleSheetsSpreadsheetsEntityRelationInput>>;
  metricSource?: InputMaybe<MetricGoogleSheetsSourceCreateMetricSourceEntityRelationInput>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricGoogleSheetsSourceCreateKeboolaSyncEventsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<KeboolaSyncEventUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricGoogleSheetsSourceConnectOrCreateKeboolaSyncEventsRelationInput>;
  create?: InputMaybe<KeboolaSyncEventWithoutMetricGoogleSheetsSourceCreateInput>;
};

export type MetricGoogleSheetsSourceCreateMetricGoogleSheetsSpreadsheetsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<MetricGoogleSheetsSpreadsheetUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricGoogleSheetsSourceConnectOrCreateMetricGoogleSheetsSpreadsheetsRelationInput>;
  create?: InputMaybe<MetricGoogleSheetsSpreadsheetWithoutMetricGoogleSheetsSourceCreateInput>;
};

export type MetricGoogleSheetsSourceCreateMetricSourceEntityRelationInput = {
  connect?: InputMaybe<MetricSourceUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricGoogleSheetsSourceConnectOrCreateMetricSourceRelationInput>;
  create?: InputMaybe<MetricSourceCreateInput>;
};

export type MetricGoogleSheetsSourceCreateResult = MutationResult & {
  __typename?: 'MetricGoogleSheetsSourceCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricGoogleSheetsSource>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricGoogleSheetsSourceDeleteResult = MutationResult & {
  __typename?: 'MetricGoogleSheetsSourceDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricGoogleSheetsSource>;
  ok: Scalars['Boolean']['output'];
};

export type MetricGoogleSheetsSourceEdge = {
  __typename?: 'MetricGoogleSheetsSourceEdge';
  node: MetricGoogleSheetsSource;
};

export type MetricGoogleSheetsSourceMeta = {
  __typename?: 'MetricGoogleSheetsSourceMeta';
  consent?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  keboolaDataSourceConfigId?: Maybe<FieldMeta>;
  keboolaOrchestrationId?: Maybe<FieldMeta>;
  keboolaSyncEvents?: Maybe<FieldMeta>;
  lastSyncAt?: Maybe<FieldMeta>;
  metricGoogleSheetsSpreadsheets?: Maybe<FieldMeta>;
  metricSource?: Maybe<FieldMeta>;
  refreshToken?: Maybe<FieldMeta>;
};

export type MetricGoogleSheetsSourceMetricGoogleSheetsSpreadsheetsByExternalIdUniqueWhere = {
  externalId?: InputMaybe<Scalars['String']['input']>;
};

export type MetricGoogleSheetsSourceMetricGoogleSheetsSpreadsheetsByMetricGoogleSheetsSheetsUniqueWhere = {
  metricGoogleSheetsSheets?: InputMaybe<MetricGoogleSheetsSheetUniqueWhere>;
};

export type MetricGoogleSheetsSourceOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  consent?: InputMaybe<MemberOrderBy>;
  id?: InputMaybe<OrderDirection>;
  keboolaDataSourceConfigId?: InputMaybe<OrderDirection>;
  keboolaOrchestrationId?: InputMaybe<OrderDirection>;
  lastSyncAt?: InputMaybe<OrderDirection>;
  metricSource?: InputMaybe<MetricSourceOrderBy>;
  refreshToken?: InputMaybe<OrderDirection>;
};

export type MetricGoogleSheetsSourceUniqueWhere = {
  consent?: InputMaybe<MemberUniqueWhere>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  keboolaSyncEvents?: InputMaybe<KeboolaSyncEventUniqueWhere>;
  metricGoogleSheetsSpreadsheets?: InputMaybe<MetricGoogleSheetsSpreadsheetUniqueWhere>;
  metricSource?: InputMaybe<MetricSourceUniqueWhere>;
};

export type MetricGoogleSheetsSourceUpdateConsentEntityRelationInput = {
  connect?: InputMaybe<MemberUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricGoogleSheetsSourceConnectOrCreateConsentRelationInput>;
  create?: InputMaybe<MemberWithoutGoogleSheetsConsentCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<MemberWithoutGoogleSheetsConsentUpdateInput>;
  upsert?: InputMaybe<MetricGoogleSheetsSourceUpsertConsentRelationInput>;
};

export type MetricGoogleSheetsSourceUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  consent?: InputMaybe<MetricGoogleSheetsSourceUpdateConsentEntityRelationInput>;
  keboolaDataSourceConfigId?: InputMaybe<Scalars['String']['input']>;
  keboolaOrchestrationId?: InputMaybe<Scalars['String']['input']>;
  keboolaSyncEvents?: InputMaybe<Array<MetricGoogleSheetsSourceUpdateKeboolaSyncEventsEntityRelationInput>>;
  lastSyncAt?: InputMaybe<Scalars['DateTime']['input']>;
  metricGoogleSheetsSpreadsheets?: InputMaybe<Array<MetricGoogleSheetsSourceUpdateMetricGoogleSheetsSpreadsheetsEntityRelationInput>>;
  metricSource?: InputMaybe<MetricGoogleSheetsSourceUpdateMetricSourceEntityRelationInput>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricGoogleSheetsSourceUpdateKeboolaSyncEventsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<KeboolaSyncEventUniqueWhere>;
  create?: InputMaybe<KeboolaSyncEventWithoutMetricGoogleSheetsSourceCreateInput>;
  delete?: InputMaybe<KeboolaSyncEventUniqueWhere>;
  disconnect?: InputMaybe<KeboolaSyncEventUniqueWhere>;
  update?: InputMaybe<MetricGoogleSheetsSourceUpdateKeboolaSyncEventsRelationInput>;
  upsert?: InputMaybe<MetricGoogleSheetsSourceUpsertKeboolaSyncEventsRelationInput>;
};

export type MetricGoogleSheetsSourceUpdateKeboolaSyncEventsRelationInput = {
  by: KeboolaSyncEventUniqueWhere;
  data: KeboolaSyncEventWithoutMetricGoogleSheetsSourceUpdateInput;
};

export type MetricGoogleSheetsSourceUpdateMetricGoogleSheetsSpreadsheetsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<MetricGoogleSheetsSpreadsheetUniqueWhere>;
  create?: InputMaybe<MetricGoogleSheetsSpreadsheetWithoutMetricGoogleSheetsSourceCreateInput>;
  delete?: InputMaybe<MetricGoogleSheetsSpreadsheetUniqueWhere>;
  disconnect?: InputMaybe<MetricGoogleSheetsSpreadsheetUniqueWhere>;
  update?: InputMaybe<MetricGoogleSheetsSourceUpdateMetricGoogleSheetsSpreadsheetsRelationInput>;
  upsert?: InputMaybe<MetricGoogleSheetsSourceUpsertMetricGoogleSheetsSpreadsheetsRelationInput>;
};

export type MetricGoogleSheetsSourceUpdateMetricGoogleSheetsSpreadsheetsRelationInput = {
  by: MetricGoogleSheetsSpreadsheetUniqueWhere;
  data: MetricGoogleSheetsSpreadsheetWithoutMetricGoogleSheetsSourceUpdateInput;
};

export type MetricGoogleSheetsSourceUpdateMetricSourceEntityRelationInput = {
  connect?: InputMaybe<MetricSourceUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricGoogleSheetsSourceConnectOrCreateMetricSourceRelationInput>;
  create?: InputMaybe<MetricSourceCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<MetricSourceUpdateInput>;
  upsert?: InputMaybe<MetricGoogleSheetsSourceUpsertMetricSourceRelationInput>;
};

export type MetricGoogleSheetsSourceUpdateResult = MutationResult & {
  __typename?: 'MetricGoogleSheetsSourceUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricGoogleSheetsSource>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricGoogleSheetsSourceUpsertConsentRelationInput = {
  create: MemberWithoutGoogleSheetsConsentCreateInput;
  update: MemberWithoutGoogleSheetsConsentUpdateInput;
};

export type MetricGoogleSheetsSourceUpsertKeboolaSyncEventsRelationInput = {
  by: KeboolaSyncEventUniqueWhere;
  create: KeboolaSyncEventWithoutMetricGoogleSheetsSourceCreateInput;
  update: KeboolaSyncEventWithoutMetricGoogleSheetsSourceUpdateInput;
};

export type MetricGoogleSheetsSourceUpsertMetricGoogleSheetsSpreadsheetsRelationInput = {
  by: MetricGoogleSheetsSpreadsheetUniqueWhere;
  create: MetricGoogleSheetsSpreadsheetWithoutMetricGoogleSheetsSourceCreateInput;
  update: MetricGoogleSheetsSpreadsheetWithoutMetricGoogleSheetsSourceUpdateInput;
};

export type MetricGoogleSheetsSourceUpsertMetricSourceRelationInput = {
  create: MetricSourceCreateInput;
  update: MetricSourceUpdateInput;
};

export type MetricGoogleSheetsSourceUpsertResult = MutationResult & {
  __typename?: 'MetricGoogleSheetsSourceUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricGoogleSheetsSource>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricGoogleSheetsSourceWhere = {
  and?: InputMaybe<Array<InputMaybe<MetricGoogleSheetsSourceWhere>>>;
  consent?: InputMaybe<MemberWhere>;
  id?: InputMaybe<UuidCondition>;
  keboolaDataSourceConfigId?: InputMaybe<StringCondition>;
  keboolaOrchestrationId?: InputMaybe<StringCondition>;
  keboolaSyncEvents?: InputMaybe<KeboolaSyncEventWhere>;
  lastSyncAt?: InputMaybe<DateTimeCondition>;
  metricGoogleSheetsSpreadsheets?: InputMaybe<MetricGoogleSheetsSpreadsheetWhere>;
  metricSource?: InputMaybe<MetricSourceWhere>;
  not?: InputMaybe<MetricGoogleSheetsSourceWhere>;
  or?: InputMaybe<Array<InputMaybe<MetricGoogleSheetsSourceWhere>>>;
  refreshToken?: InputMaybe<StringCondition>;
};

export type MetricGoogleSheetsSourceWithoutConsentCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  keboolaDataSourceConfigId?: InputMaybe<Scalars['String']['input']>;
  keboolaOrchestrationId?: InputMaybe<Scalars['String']['input']>;
  keboolaSyncEvents?: InputMaybe<Array<MetricGoogleSheetsSourceCreateKeboolaSyncEventsEntityRelationInput>>;
  lastSyncAt?: InputMaybe<Scalars['DateTime']['input']>;
  metricGoogleSheetsSpreadsheets?: InputMaybe<Array<MetricGoogleSheetsSourceCreateMetricGoogleSheetsSpreadsheetsEntityRelationInput>>;
  metricSource?: InputMaybe<MetricGoogleSheetsSourceCreateMetricSourceEntityRelationInput>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricGoogleSheetsSourceWithoutConsentUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  keboolaDataSourceConfigId?: InputMaybe<Scalars['String']['input']>;
  keboolaOrchestrationId?: InputMaybe<Scalars['String']['input']>;
  keboolaSyncEvents?: InputMaybe<Array<MetricGoogleSheetsSourceUpdateKeboolaSyncEventsEntityRelationInput>>;
  lastSyncAt?: InputMaybe<Scalars['DateTime']['input']>;
  metricGoogleSheetsSpreadsheets?: InputMaybe<Array<MetricGoogleSheetsSourceUpdateMetricGoogleSheetsSpreadsheetsEntityRelationInput>>;
  metricSource?: InputMaybe<MetricGoogleSheetsSourceUpdateMetricSourceEntityRelationInput>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricGoogleSheetsSourceWithoutKeboolaSyncEventsCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  consent?: InputMaybe<MetricGoogleSheetsSourceCreateConsentEntityRelationInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  keboolaDataSourceConfigId?: InputMaybe<Scalars['String']['input']>;
  keboolaOrchestrationId?: InputMaybe<Scalars['String']['input']>;
  lastSyncAt?: InputMaybe<Scalars['DateTime']['input']>;
  metricGoogleSheetsSpreadsheets?: InputMaybe<Array<MetricGoogleSheetsSourceCreateMetricGoogleSheetsSpreadsheetsEntityRelationInput>>;
  metricSource?: InputMaybe<MetricGoogleSheetsSourceCreateMetricSourceEntityRelationInput>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricGoogleSheetsSourceWithoutKeboolaSyncEventsUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  consent?: InputMaybe<MetricGoogleSheetsSourceUpdateConsentEntityRelationInput>;
  keboolaDataSourceConfigId?: InputMaybe<Scalars['String']['input']>;
  keboolaOrchestrationId?: InputMaybe<Scalars['String']['input']>;
  lastSyncAt?: InputMaybe<Scalars['DateTime']['input']>;
  metricGoogleSheetsSpreadsheets?: InputMaybe<Array<MetricGoogleSheetsSourceUpdateMetricGoogleSheetsSpreadsheetsEntityRelationInput>>;
  metricSource?: InputMaybe<MetricGoogleSheetsSourceUpdateMetricSourceEntityRelationInput>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricGoogleSheetsSourceWithoutMetricGoogleSheetsSpreadsheetsCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  consent?: InputMaybe<MetricGoogleSheetsSourceCreateConsentEntityRelationInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  keboolaDataSourceConfigId?: InputMaybe<Scalars['String']['input']>;
  keboolaOrchestrationId?: InputMaybe<Scalars['String']['input']>;
  keboolaSyncEvents?: InputMaybe<Array<MetricGoogleSheetsSourceCreateKeboolaSyncEventsEntityRelationInput>>;
  lastSyncAt?: InputMaybe<Scalars['DateTime']['input']>;
  metricSource?: InputMaybe<MetricGoogleSheetsSourceCreateMetricSourceEntityRelationInput>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricGoogleSheetsSourceWithoutMetricGoogleSheetsSpreadsheetsUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  consent?: InputMaybe<MetricGoogleSheetsSourceUpdateConsentEntityRelationInput>;
  keboolaDataSourceConfigId?: InputMaybe<Scalars['String']['input']>;
  keboolaOrchestrationId?: InputMaybe<Scalars['String']['input']>;
  keboolaSyncEvents?: InputMaybe<Array<MetricGoogleSheetsSourceUpdateKeboolaSyncEventsEntityRelationInput>>;
  lastSyncAt?: InputMaybe<Scalars['DateTime']['input']>;
  metricSource?: InputMaybe<MetricGoogleSheetsSourceUpdateMetricSourceEntityRelationInput>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricGoogleSheetsSpreadsheet = {
  __typename?: 'MetricGoogleSheetsSpreadsheet';
  _meta?: Maybe<MetricGoogleSheetsSpreadsheetMeta>;
  externalId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  metricGoogleSheetsSheets: Array<MetricGoogleSheetsSheet>;
  metricGoogleSheetsSheetsByExternalId?: Maybe<MetricGoogleSheetsSheet>;
  metricGoogleSheetsSheetsByKeboolaDataDestinationConfigId?: Maybe<MetricGoogleSheetsSheet>;
  metricGoogleSheetsSheetsByMetricGoogleSheetsMappings?: Maybe<MetricGoogleSheetsSheet>;
  metricGoogleSheetsSource?: Maybe<MetricGoogleSheetsSource>;
  paginateMetricGoogleSheetsSheets: MetricGoogleSheetsSheetConnection;
};


export type MetricGoogleSheetsSpreadsheetMetricGoogleSheetsSheetsArgs = {
  filter?: InputMaybe<MetricGoogleSheetsSheetWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricGoogleSheetsSheetOrderBy>>;
};


export type MetricGoogleSheetsSpreadsheetMetricGoogleSheetsSheetsByExternalIdArgs = {
  by: MetricGoogleSheetsSpreadsheetMetricGoogleSheetsSheetsByExternalIdUniqueWhere;
  filter?: InputMaybe<MetricGoogleSheetsSheetWhere>;
};


export type MetricGoogleSheetsSpreadsheetMetricGoogleSheetsSheetsByKeboolaDataDestinationConfigIdArgs = {
  by: MetricGoogleSheetsSpreadsheetMetricGoogleSheetsSheetsByKeboolaDataDestinationConfigIdUniqueWhere;
  filter?: InputMaybe<MetricGoogleSheetsSheetWhere>;
};


export type MetricGoogleSheetsSpreadsheetMetricGoogleSheetsSheetsByMetricGoogleSheetsMappingsArgs = {
  by: MetricGoogleSheetsSpreadsheetMetricGoogleSheetsSheetsByMetricGoogleSheetsMappingsUniqueWhere;
  filter?: InputMaybe<MetricGoogleSheetsSheetWhere>;
};


export type MetricGoogleSheetsSpreadsheetMetricGoogleSheetsSourceArgs = {
  filter?: InputMaybe<MetricGoogleSheetsSourceWhere>;
};


export type MetricGoogleSheetsSpreadsheetPaginateMetricGoogleSheetsSheetsArgs = {
  filter?: InputMaybe<MetricGoogleSheetsSheetWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricGoogleSheetsSheetOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type MetricGoogleSheetsSpreadsheetConnectOrCreateMetricGoogleSheetsSheetsRelationInput = {
  connect: MetricGoogleSheetsSheetUniqueWhere;
  create: MetricGoogleSheetsSheetWithoutMetricGoogleSheetsSpreadsheetCreateInput;
};

export type MetricGoogleSheetsSpreadsheetConnectOrCreateMetricGoogleSheetsSourceRelationInput = {
  connect: MetricGoogleSheetsSourceUniqueWhere;
  create: MetricGoogleSheetsSourceWithoutMetricGoogleSheetsSpreadsheetsCreateInput;
};

export type MetricGoogleSheetsSpreadsheetConnection = {
  __typename?: 'MetricGoogleSheetsSpreadsheetConnection';
  edges: Array<MetricGoogleSheetsSpreadsheetEdge>;
  pageInfo: PageInfo;
};

export type MetricGoogleSheetsSpreadsheetCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  metricGoogleSheetsSheets?: InputMaybe<Array<MetricGoogleSheetsSpreadsheetCreateMetricGoogleSheetsSheetsEntityRelationInput>>;
  metricGoogleSheetsSource?: InputMaybe<MetricGoogleSheetsSpreadsheetCreateMetricGoogleSheetsSourceEntityRelationInput>;
};

export type MetricGoogleSheetsSpreadsheetCreateMetricGoogleSheetsSheetsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<MetricGoogleSheetsSheetUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricGoogleSheetsSpreadsheetConnectOrCreateMetricGoogleSheetsSheetsRelationInput>;
  create?: InputMaybe<MetricGoogleSheetsSheetWithoutMetricGoogleSheetsSpreadsheetCreateInput>;
};

export type MetricGoogleSheetsSpreadsheetCreateMetricGoogleSheetsSourceEntityRelationInput = {
  connect?: InputMaybe<MetricGoogleSheetsSourceUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricGoogleSheetsSpreadsheetConnectOrCreateMetricGoogleSheetsSourceRelationInput>;
  create?: InputMaybe<MetricGoogleSheetsSourceWithoutMetricGoogleSheetsSpreadsheetsCreateInput>;
};

export type MetricGoogleSheetsSpreadsheetCreateResult = MutationResult & {
  __typename?: 'MetricGoogleSheetsSpreadsheetCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricGoogleSheetsSpreadsheet>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricGoogleSheetsSpreadsheetDeleteResult = MutationResult & {
  __typename?: 'MetricGoogleSheetsSpreadsheetDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricGoogleSheetsSpreadsheet>;
  ok: Scalars['Boolean']['output'];
};

export type MetricGoogleSheetsSpreadsheetEdge = {
  __typename?: 'MetricGoogleSheetsSpreadsheetEdge';
  node: MetricGoogleSheetsSpreadsheet;
};

export type MetricGoogleSheetsSpreadsheetMeta = {
  __typename?: 'MetricGoogleSheetsSpreadsheetMeta';
  externalId?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  metricGoogleSheetsSheets?: Maybe<FieldMeta>;
  metricGoogleSheetsSource?: Maybe<FieldMeta>;
};

export type MetricGoogleSheetsSpreadsheetMetricGoogleSheetsSheetsByExternalIdUniqueWhere = {
  externalId?: InputMaybe<Scalars['String']['input']>;
};

export type MetricGoogleSheetsSpreadsheetMetricGoogleSheetsSheetsByKeboolaDataDestinationConfigIdUniqueWhere = {
  keboolaDataDestinationConfigId?: InputMaybe<Scalars['String']['input']>;
};

export type MetricGoogleSheetsSpreadsheetMetricGoogleSheetsSheetsByMetricGoogleSheetsMappingsUniqueWhere = {
  metricGoogleSheetsMappings?: InputMaybe<MetricGoogleSheetsMappingUniqueWhere>;
};

export type MetricGoogleSheetsSpreadsheetOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  externalId?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  metricGoogleSheetsSource?: InputMaybe<MetricGoogleSheetsSourceOrderBy>;
};

export type MetricGoogleSheetsSpreadsheetUniqueWhere = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  metricGoogleSheetsSheets?: InputMaybe<MetricGoogleSheetsSheetUniqueWhere>;
};

export type MetricGoogleSheetsSpreadsheetUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  metricGoogleSheetsSheets?: InputMaybe<Array<MetricGoogleSheetsSpreadsheetUpdateMetricGoogleSheetsSheetsEntityRelationInput>>;
  metricGoogleSheetsSource?: InputMaybe<MetricGoogleSheetsSpreadsheetUpdateMetricGoogleSheetsSourceEntityRelationInput>;
};

export type MetricGoogleSheetsSpreadsheetUpdateMetricGoogleSheetsSheetsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<MetricGoogleSheetsSheetUniqueWhere>;
  create?: InputMaybe<MetricGoogleSheetsSheetWithoutMetricGoogleSheetsSpreadsheetCreateInput>;
  delete?: InputMaybe<MetricGoogleSheetsSheetUniqueWhere>;
  disconnect?: InputMaybe<MetricGoogleSheetsSheetUniqueWhere>;
  update?: InputMaybe<MetricGoogleSheetsSpreadsheetUpdateMetricGoogleSheetsSheetsRelationInput>;
  upsert?: InputMaybe<MetricGoogleSheetsSpreadsheetUpsertMetricGoogleSheetsSheetsRelationInput>;
};

export type MetricGoogleSheetsSpreadsheetUpdateMetricGoogleSheetsSheetsRelationInput = {
  by: MetricGoogleSheetsSheetUniqueWhere;
  data: MetricGoogleSheetsSheetWithoutMetricGoogleSheetsSpreadsheetUpdateInput;
};

export type MetricGoogleSheetsSpreadsheetUpdateMetricGoogleSheetsSourceEntityRelationInput = {
  connect?: InputMaybe<MetricGoogleSheetsSourceUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricGoogleSheetsSpreadsheetConnectOrCreateMetricGoogleSheetsSourceRelationInput>;
  create?: InputMaybe<MetricGoogleSheetsSourceWithoutMetricGoogleSheetsSpreadsheetsCreateInput>;
  update?: InputMaybe<MetricGoogleSheetsSourceWithoutMetricGoogleSheetsSpreadsheetsUpdateInput>;
  upsert?: InputMaybe<MetricGoogleSheetsSpreadsheetUpsertMetricGoogleSheetsSourceRelationInput>;
};

export type MetricGoogleSheetsSpreadsheetUpdateResult = MutationResult & {
  __typename?: 'MetricGoogleSheetsSpreadsheetUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricGoogleSheetsSpreadsheet>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricGoogleSheetsSpreadsheetUpsertMetricGoogleSheetsSheetsRelationInput = {
  by: MetricGoogleSheetsSheetUniqueWhere;
  create: MetricGoogleSheetsSheetWithoutMetricGoogleSheetsSpreadsheetCreateInput;
  update: MetricGoogleSheetsSheetWithoutMetricGoogleSheetsSpreadsheetUpdateInput;
};

export type MetricGoogleSheetsSpreadsheetUpsertMetricGoogleSheetsSourceRelationInput = {
  create: MetricGoogleSheetsSourceWithoutMetricGoogleSheetsSpreadsheetsCreateInput;
  update: MetricGoogleSheetsSourceWithoutMetricGoogleSheetsSpreadsheetsUpdateInput;
};

export type MetricGoogleSheetsSpreadsheetUpsertResult = MutationResult & {
  __typename?: 'MetricGoogleSheetsSpreadsheetUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricGoogleSheetsSpreadsheet>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricGoogleSheetsSpreadsheetWhere = {
  and?: InputMaybe<Array<InputMaybe<MetricGoogleSheetsSpreadsheetWhere>>>;
  externalId?: InputMaybe<StringCondition>;
  id?: InputMaybe<UuidCondition>;
  metricGoogleSheetsSheets?: InputMaybe<MetricGoogleSheetsSheetWhere>;
  metricGoogleSheetsSource?: InputMaybe<MetricGoogleSheetsSourceWhere>;
  not?: InputMaybe<MetricGoogleSheetsSpreadsheetWhere>;
  or?: InputMaybe<Array<InputMaybe<MetricGoogleSheetsSpreadsheetWhere>>>;
};

export type MetricGoogleSheetsSpreadsheetWithoutMetricGoogleSheetsSheetsCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  metricGoogleSheetsSource?: InputMaybe<MetricGoogleSheetsSpreadsheetCreateMetricGoogleSheetsSourceEntityRelationInput>;
};

export type MetricGoogleSheetsSpreadsheetWithoutMetricGoogleSheetsSheetsUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  metricGoogleSheetsSource?: InputMaybe<MetricGoogleSheetsSpreadsheetUpdateMetricGoogleSheetsSourceEntityRelationInput>;
};

export type MetricGoogleSheetsSpreadsheetWithoutMetricGoogleSheetsSourceCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  metricGoogleSheetsSheets?: InputMaybe<Array<MetricGoogleSheetsSpreadsheetCreateMetricGoogleSheetsSheetsEntityRelationInput>>;
};

export type MetricGoogleSheetsSpreadsheetWithoutMetricGoogleSheetsSourceUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  metricGoogleSheetsSheets?: InputMaybe<Array<MetricGoogleSheetsSpreadsheetUpdateMetricGoogleSheetsSheetsEntityRelationInput>>;
};

export type MetricMeta = {
  __typename?: 'MetricMeta';
  behavior?: Maybe<FieldMeta>;
  dataLabels?: Maybe<FieldMeta>;
  dataSet?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  lowerWarningBound?: Maybe<FieldMeta>;
  name?: Maybe<FieldMeta>;
  unit?: Maybe<FieldMeta>;
  unitSign?: Maybe<FieldMeta>;
  upperWarningBound?: Maybe<FieldMeta>;
};

export type MetricOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  behavior?: InputMaybe<OrderDirection>;
  dataSet?: InputMaybe<MetricDataSetOrderBy>;
  id?: InputMaybe<OrderDirection>;
  lowerWarningBound?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  unit?: InputMaybe<OrderDirection>;
  unitSign?: InputMaybe<OrderDirection>;
  upperWarningBound?: InputMaybe<OrderDirection>;
};

export type MetricSource = {
  __typename?: 'MetricSource';
  _meta?: Maybe<MetricSourceMeta>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  type: SourceType;
};

export type MetricSourceConnection = {
  __typename?: 'MetricSourceConnection';
  edges: Array<MetricSourceEdge>;
  pageInfo: PageInfo;
};

export type MetricSourceCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SourceType>;
};

export type MetricSourceCreateResult = MutationResult & {
  __typename?: 'MetricSourceCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricSource>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricSourceDeleteResult = MutationResult & {
  __typename?: 'MetricSourceDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricSource>;
  ok: Scalars['Boolean']['output'];
};

export type MetricSourceEdge = {
  __typename?: 'MetricSourceEdge';
  node: MetricSource;
};

export type MetricSourceMeta = {
  __typename?: 'MetricSourceMeta';
  id?: Maybe<FieldMeta>;
  name?: Maybe<FieldMeta>;
  type?: Maybe<FieldMeta>;
};

export type MetricSourceOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  type?: InputMaybe<OrderDirection>;
};

export type MetricSourceUniqueWhere = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  type?: InputMaybe<SourceType>;
};

export type MetricSourceUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SourceType>;
};

export type MetricSourceUpdateResult = MutationResult & {
  __typename?: 'MetricSourceUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricSource>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricSourceUpsertResult = MutationResult & {
  __typename?: 'MetricSourceUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricSource>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricSourceWhere = {
  and?: InputMaybe<Array<InputMaybe<MetricSourceWhere>>>;
  id?: InputMaybe<UuidCondition>;
  name?: InputMaybe<StringCondition>;
  not?: InputMaybe<MetricSourceWhere>;
  or?: InputMaybe<Array<InputMaybe<MetricSourceWhere>>>;
  type?: InputMaybe<SourceTypeCondition>;
};

export type MetricTemplate = {
  __typename?: 'MetricTemplate';
  _meta?: Maybe<MetricTemplateMeta>;
  behavior: MetricBehavior;
  dataSets: Array<MetricDataSet>;
  defaultTrendComparison: MetricTemplateDefaultTrendComparison;
  description?: Maybe<Scalars['String']['output']>;
  expectations: MetricTemplateExpectations;
  id: Scalars['UUID']['output'];
  isSystem: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  paginateDataSets: MetricDataSetConnection;
  precision: Scalars['Int']['output'];
  unit: MetricUnit;
  unitSign?: Maybe<Scalars['String']['output']>;
};


export type MetricTemplateDataSetsArgs = {
  filter?: InputMaybe<MetricDataSetWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricDataSetOrderBy>>;
};


export type MetricTemplatePaginateDataSetsArgs = {
  filter?: InputMaybe<MetricDataSetWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricDataSetOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type MetricTemplateConnectOrCreateDataSetsRelationInput = {
  connect: MetricDataSetUniqueWhere;
  create: MetricDataSetWithoutMetricTemplateCreateInput;
};

export type MetricTemplateConnection = {
  __typename?: 'MetricTemplateConnection';
  edges: Array<MetricTemplateEdge>;
  pageInfo: PageInfo;
};

export type MetricTemplateCreateDataSetsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<MetricDataSetUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricTemplateConnectOrCreateDataSetsRelationInput>;
  create?: InputMaybe<MetricDataSetWithoutMetricTemplateCreateInput>;
};

export type MetricTemplateCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  behavior?: InputMaybe<MetricBehavior>;
  dataSets?: InputMaybe<Array<MetricTemplateCreateDataSetsEntityRelationInput>>;
  defaultTrendComparison?: InputMaybe<MetricTemplateDefaultTrendComparison>;
  description?: InputMaybe<Scalars['String']['input']>;
  expectations?: InputMaybe<MetricTemplateExpectations>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  precision?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<MetricUnit>;
  unitSign?: InputMaybe<Scalars['String']['input']>;
};

export type MetricTemplateCreateResult = MutationResult & {
  __typename?: 'MetricTemplateCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricTemplate>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricTemplateDefaultTrendComparison =
  | 'absolute'
  | 'relative';

export type MetricTemplateDefaultTrendComparisonCondition = {
  and?: InputMaybe<Array<MetricTemplateDefaultTrendComparisonCondition>>;
  eq?: InputMaybe<MetricTemplateDefaultTrendComparison>;
  gt?: InputMaybe<MetricTemplateDefaultTrendComparison>;
  gte?: InputMaybe<MetricTemplateDefaultTrendComparison>;
  in?: InputMaybe<Array<MetricTemplateDefaultTrendComparison>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<MetricTemplateDefaultTrendComparison>;
  lte?: InputMaybe<MetricTemplateDefaultTrendComparison>;
  not?: InputMaybe<MetricTemplateDefaultTrendComparisonCondition>;
  notEq?: InputMaybe<MetricTemplateDefaultTrendComparison>;
  notIn?: InputMaybe<Array<MetricTemplateDefaultTrendComparison>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<MetricTemplateDefaultTrendComparisonCondition>>;
};

export type MetricTemplateDeleteResult = MutationResult & {
  __typename?: 'MetricTemplateDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricTemplate>;
  ok: Scalars['Boolean']['output'];
};

export type MetricTemplateEdge = {
  __typename?: 'MetricTemplateEdge';
  node: MetricTemplate;
};

export type MetricTemplateExpectations =
  | 'decrease'
  | 'increase';

export type MetricTemplateExpectationsCondition = {
  and?: InputMaybe<Array<MetricTemplateExpectationsCondition>>;
  eq?: InputMaybe<MetricTemplateExpectations>;
  gt?: InputMaybe<MetricTemplateExpectations>;
  gte?: InputMaybe<MetricTemplateExpectations>;
  in?: InputMaybe<Array<MetricTemplateExpectations>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<MetricTemplateExpectations>;
  lte?: InputMaybe<MetricTemplateExpectations>;
  not?: InputMaybe<MetricTemplateExpectationsCondition>;
  notEq?: InputMaybe<MetricTemplateExpectations>;
  notIn?: InputMaybe<Array<MetricTemplateExpectations>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<MetricTemplateExpectationsCondition>>;
};

export type MetricTemplateMeta = {
  __typename?: 'MetricTemplateMeta';
  behavior?: Maybe<FieldMeta>;
  dataSets?: Maybe<FieldMeta>;
  defaultTrendComparison?: Maybe<FieldMeta>;
  description?: Maybe<FieldMeta>;
  expectations?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  isSystem?: Maybe<FieldMeta>;
  name?: Maybe<FieldMeta>;
  precision?: Maybe<FieldMeta>;
  unit?: Maybe<FieldMeta>;
  unitSign?: Maybe<FieldMeta>;
};

export type MetricTemplateOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  behavior?: InputMaybe<OrderDirection>;
  defaultTrendComparison?: InputMaybe<OrderDirection>;
  description?: InputMaybe<OrderDirection>;
  expectations?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  isSystem?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  precision?: InputMaybe<OrderDirection>;
  unit?: InputMaybe<OrderDirection>;
  unitSign?: InputMaybe<OrderDirection>;
};

export type MetricTemplateUniqueWhere = {
  dataSets?: InputMaybe<MetricDataSetUniqueWhere>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type MetricTemplateUpdateDataSetsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<MetricDataSetUniqueWhere>;
  create?: InputMaybe<MetricDataSetWithoutMetricTemplateCreateInput>;
  delete?: InputMaybe<MetricDataSetUniqueWhere>;
  disconnect?: InputMaybe<MetricDataSetUniqueWhere>;
  update?: InputMaybe<MetricTemplateUpdateDataSetsRelationInput>;
  upsert?: InputMaybe<MetricTemplateUpsertDataSetsRelationInput>;
};

export type MetricTemplateUpdateDataSetsRelationInput = {
  by: MetricDataSetUniqueWhere;
  data: MetricDataSetWithoutMetricTemplateUpdateInput;
};

export type MetricTemplateUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  behavior?: InputMaybe<MetricBehavior>;
  dataSets?: InputMaybe<Array<MetricTemplateUpdateDataSetsEntityRelationInput>>;
  defaultTrendComparison?: InputMaybe<MetricTemplateDefaultTrendComparison>;
  description?: InputMaybe<Scalars['String']['input']>;
  expectations?: InputMaybe<MetricTemplateExpectations>;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  precision?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<MetricUnit>;
  unitSign?: InputMaybe<Scalars['String']['input']>;
};

export type MetricTemplateUpdateResult = MutationResult & {
  __typename?: 'MetricTemplateUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricTemplate>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricTemplateUpsertDataSetsRelationInput = {
  by: MetricDataSetUniqueWhere;
  create: MetricDataSetWithoutMetricTemplateCreateInput;
  update: MetricDataSetWithoutMetricTemplateUpdateInput;
};

export type MetricTemplateUpsertResult = MutationResult & {
  __typename?: 'MetricTemplateUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<MetricTemplate>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricTemplateWhere = {
  and?: InputMaybe<Array<InputMaybe<MetricTemplateWhere>>>;
  behavior?: InputMaybe<MetricBehaviorCondition>;
  dataSets?: InputMaybe<MetricDataSetWhere>;
  defaultTrendComparison?: InputMaybe<MetricTemplateDefaultTrendComparisonCondition>;
  description?: InputMaybe<StringCondition>;
  expectations?: InputMaybe<MetricTemplateExpectationsCondition>;
  id?: InputMaybe<UuidCondition>;
  isSystem?: InputMaybe<BooleanCondition>;
  name?: InputMaybe<StringCondition>;
  not?: InputMaybe<MetricTemplateWhere>;
  or?: InputMaybe<Array<InputMaybe<MetricTemplateWhere>>>;
  precision?: InputMaybe<IntCondition>;
  unit?: InputMaybe<MetricUnitCondition>;
  unitSign?: InputMaybe<StringCondition>;
};

export type MetricTemplateWithoutDataSetsCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  behavior?: InputMaybe<MetricBehavior>;
  defaultTrendComparison?: InputMaybe<MetricTemplateDefaultTrendComparison>;
  description?: InputMaybe<Scalars['String']['input']>;
  expectations?: InputMaybe<MetricTemplateExpectations>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  precision?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<MetricUnit>;
  unitSign?: InputMaybe<Scalars['String']['input']>;
};

export type MetricTemplateWithoutDataSetsUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  behavior?: InputMaybe<MetricBehavior>;
  defaultTrendComparison?: InputMaybe<MetricTemplateDefaultTrendComparison>;
  description?: InputMaybe<Scalars['String']['input']>;
  expectations?: InputMaybe<MetricTemplateExpectations>;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  precision?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<MetricUnit>;
  unitSign?: InputMaybe<Scalars['String']['input']>;
};

export type MetricUniqueWhere = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type MetricUnit =
  | 'currency'
  | 'number'
  | 'percentage';

export type MetricUnitCondition = {
  and?: InputMaybe<Array<MetricUnitCondition>>;
  eq?: InputMaybe<MetricUnit>;
  gt?: InputMaybe<MetricUnit>;
  gte?: InputMaybe<MetricUnit>;
  in?: InputMaybe<Array<MetricUnit>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<MetricUnit>;
  lte?: InputMaybe<MetricUnit>;
  not?: InputMaybe<MetricUnitCondition>;
  notEq?: InputMaybe<MetricUnit>;
  notIn?: InputMaybe<Array<MetricUnit>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<MetricUnitCondition>>;
};

export type MetricUpdateDataLabelsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<MetricDataLabelUniqueWhere>;
  create?: InputMaybe<MetricDataLabelCreateInput>;
  delete?: InputMaybe<MetricDataLabelUniqueWhere>;
  disconnect?: InputMaybe<MetricDataLabelUniqueWhere>;
  update?: InputMaybe<MetricUpdateDataLabelsRelationInput>;
  upsert?: InputMaybe<MetricUpsertDataLabelsRelationInput>;
};

export type MetricUpdateDataLabelsRelationInput = {
  by: MetricDataLabelUniqueWhere;
  data: MetricDataLabelUpdateInput;
};

export type MetricUpdateDataSetEntityRelationInput = {
  connect?: InputMaybe<MetricDataSetUniqueWhere>;
  connectOrCreate?: InputMaybe<MetricConnectOrCreateDataSetRelationInput>;
  create?: InputMaybe<MetricDataSetCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<MetricDataSetUpdateInput>;
  upsert?: InputMaybe<MetricUpsertDataSetRelationInput>;
};

export type MetricUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  behavior?: InputMaybe<MetricBehavior>;
  dataLabels?: InputMaybe<Array<MetricUpdateDataLabelsEntityRelationInput>>;
  dataSet?: InputMaybe<MetricUpdateDataSetEntityRelationInput>;
  lowerWarningBound?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<MetricUnit>;
  unitSign?: InputMaybe<Scalars['String']['input']>;
  upperWarningBound?: InputMaybe<Scalars['Float']['input']>;
};

export type MetricUpdateResult = MutationResult & {
  __typename?: 'MetricUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Metric>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricUpsertDataLabelsRelationInput = {
  by: MetricDataLabelUniqueWhere;
  create: MetricDataLabelCreateInput;
  update: MetricDataLabelUpdateInput;
};

export type MetricUpsertDataSetRelationInput = {
  create: MetricDataSetCreateInput;
  update: MetricDataSetUpdateInput;
};

export type MetricUpsertResult = MutationResult & {
  __typename?: 'MetricUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Metric>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type MetricWhere = {
  and?: InputMaybe<Array<InputMaybe<MetricWhere>>>;
  behavior?: InputMaybe<MetricBehaviorCondition>;
  dataLabels?: InputMaybe<MetricDataLabelWhere>;
  dataSet?: InputMaybe<MetricDataSetWhere>;
  id?: InputMaybe<UuidCondition>;
  lowerWarningBound?: InputMaybe<FloatCondition>;
  name?: InputMaybe<StringCondition>;
  not?: InputMaybe<MetricWhere>;
  or?: InputMaybe<Array<InputMaybe<MetricWhere>>>;
  unit?: InputMaybe<MetricUnitCondition>;
  unitSign?: InputMaybe<StringCondition>;
  upperWarningBound?: InputMaybe<FloatCondition>;
};

export type Mutation = {
  __typename?: 'Mutation';
  changeMyPassword?: Maybe<ChangeMyPasswordResponse>;
  changeMyProfile?: Maybe<ChangeMyProfileResponse>;
  createAction: ActionCreateResult;
  createActivity: ActivityCreateResult;
  createActivityDeepClone: ActivityCreateResult;
  createActivityDuration: ActivityDurationCreateResult;
  createActivityWarning: ActivityWarningCreateResult;
  createContentMetric: ContentMetricCreateResult;
  createContentMetricDataPoint: ContentMetricDataPointCreateResult;
  createControlCycle: ControlCycleCreateResult;
  createControlCycleCheck: ControlCycleCheckCreateResult;
  createDashboard: DashboardCreateResult;
  createDashboardJourney: DashboardJourneyCreateResult;
  createDashboardMetric: DashboardMetricCreateResult;
  createJourney: JourneyCreateResult;
  createJourneyDeepClone: JourneyCreateResult;
  createKeboolaSyncEvent: KeboolaSyncEventCreateResult;
  createMemberSettings: MemberSettingsCreateResult;
  createMetric: MetricCreateResult;
  createMetricDataLabel: MetricDataLabelCreateResult;
  createMetricDataPoint: MetricDataPointCreateResult;
  createMetricDataSet: MetricDataSetCreateResult;
  createMetricGoogleSheetsMapping: MetricGoogleSheetsMappingCreateResult;
  createMetricGoogleSheetsSheet: MetricGoogleSheetsSheetCreateResult;
  createMetricGoogleSheetsSource: MetricGoogleSheetsSourceCreateResult;
  createMetricGoogleSheetsSpreadsheet: MetricGoogleSheetsSpreadsheetCreateResult;
  createMetricSource: MetricSourceCreateResult;
  createMetricTemplate: MetricTemplateCreateResult;
  createOpportunity: OpportunityCreateResult;
  createPersona: PersonaCreateResult;
  createPersonaBlock: PersonaBlockCreateResult;
  createPersonaBlockItem: PersonaBlockItemCreateResult;
  createPhase: PhaseCreateResult;
  createPicture: PictureCreateResult;
  createResetPassword: CreatePasswordResetRequestResponse;
  createResetPasswordRequest?: Maybe<CreatePasswordResetRequestResponse>;
  createTag: TagCreateResult;
  createTeam: TeamCreateResult;
  createTouchpoint: TouchpointCreateResult;
  createWidget: WidgetCreateResult;
  deactivateMember?: Maybe<MemberUpdateResult>;
  deleteAction: ActionDeleteResult;
  deleteActivity: ActivityDeleteResult;
  deleteActivityDuration: ActivityDurationDeleteResult;
  deleteActivityWarning: ActivityWarningDeleteResult;
  deleteContentMetric: ContentMetricDeleteResult;
  deleteContentMetricDataPoint: ContentMetricDataPointDeleteResult;
  deleteControlCycle: ControlCycleDeleteResult;
  deleteControlCycleCheck: ControlCycleCheckDeleteResult;
  deleteDashboard: DashboardDeleteResult;
  deleteDashboardJourney: DashboardJourneyDeleteResult;
  deleteDashboardMetric: DashboardMetricDeleteResult;
  deleteJourney: JourneyDeleteResult;
  deleteKeboolaSyncEvent: KeboolaSyncEventDeleteResult;
  deleteMember: MemberDeleteResult;
  deleteMemberSettings: MemberSettingsDeleteResult;
  deleteMetric: MetricDeleteResult;
  deleteMetricDataLabel: MetricDataLabelDeleteResult;
  deleteMetricDataPoint: MetricDataPointDeleteResult;
  deleteMetricDataSet: MetricDataSetDeleteResult;
  deleteMetricGoogleSheetsMapping: MetricGoogleSheetsMappingDeleteResult;
  deleteMetricGoogleSheetsSheet: MetricGoogleSheetsSheetDeleteResult;
  deleteMetricGoogleSheetsSource: MetricGoogleSheetsSourceDeleteResult;
  deleteMetricGoogleSheetsSpreadsheet: MetricGoogleSheetsSpreadsheetDeleteResult;
  deleteMetricSource: MetricSourceDeleteResult;
  deleteMetricTemplate: MetricTemplateDeleteResult;
  deleteOpportunity: OpportunityDeleteResult;
  deletePersona: PersonaDeleteResult;
  deletePersonaBlock: PersonaBlockDeleteResult;
  deletePersonaBlockItem: PersonaBlockItemDeleteResult;
  deletePhase: PhaseDeleteResult;
  deletePicture: PictureDeleteResult;
  deleteTag: TagDeleteResult;
  deleteTeam: TeamDeleteResult;
  deleteTouchpoint: TouchpointDeleteResult;
  deleteWidget: WidgetDeleteResult;
  inviteMember: MemberCreateResult;
  query: Query;
  reactivateMember?: Maybe<MemberUpdateResult>;
  refreshActivityWarnings: RefreshActivityWarningsResult;
  requestImageUpload: ImageUploadRequestResult;
  resetPassword?: Maybe<ResetPasswordResponse>;
  setGoogleSheetsConfiguration: SetGoogleSheetsConfigurationResult;
  setGoogleSheetsMetricTemplateMapping: SetGoogleSheetsMetricTemplateMappingResult;
  setSingleSheetMapping: SetSingleSheetMappingResult;
  signIn?: Maybe<SignInResponse>;
  signOut?: Maybe<SignOutResponse>;
  transaction: MutationTransaction;
  triggerMetricsSync: TriggerMetricsSyncResult;
  updateAction: ActionUpdateResult;
  updateActivity: ActivityUpdateResult;
  updateActivityDuration: ActivityDurationUpdateResult;
  updateActivityWarning: ActivityWarningUpdateResult;
  updateContentMetric: ContentMetricUpdateResult;
  updateContentMetricDataPoint: ContentMetricDataPointUpdateResult;
  updateContentMetricDataSetToGoogleSheet: UpdateSingleExistingContentMetricDataSetResult;
  updateControlCycle: ControlCycleUpdateResult;
  updateControlCycleCheck: ControlCycleCheckUpdateResult;
  updateDashboard: DashboardUpdateResult;
  updateDashboardJourney: DashboardJourneyUpdateResult;
  updateDashboardMetric: DashboardMetricUpdateResult;
  updateJourney: JourneyUpdateResult;
  updateKeboolaSyncEvent: KeboolaSyncEventUpdateResult;
  updateMember: MemberUpdateResult;
  updateMemberSettings: MemberSettingsUpdateResult;
  updateMetric: MetricUpdateResult;
  updateMetricDataLabel: MetricDataLabelUpdateResult;
  updateMetricDataPoint: MetricDataPointUpdateResult;
  updateMetricDataSet: MetricDataSetUpdateResult;
  updateMetricGoogleSheetsMapping: MetricGoogleSheetsMappingUpdateResult;
  updateMetricGoogleSheetsSheet: MetricGoogleSheetsSheetUpdateResult;
  updateMetricGoogleSheetsSource: MetricGoogleSheetsSourceUpdateResult;
  updateMetricGoogleSheetsSpreadsheet: MetricGoogleSheetsSpreadsheetUpdateResult;
  updateMetricSource: MetricSourceUpdateResult;
  updateMetricTemplate: MetricTemplateUpdateResult;
  updateMyProfile: MemberUpdateResult;
  updateOpportunity: OpportunityUpdateResult;
  updateOrganization: UpdateOrganizationResult;
  updatePersona: PersonaUpdateResult;
  updatePersonaBlock: PersonaBlockUpdateResult;
  updatePersonaBlockItem: PersonaBlockItemUpdateResult;
  updatePhase: PhaseUpdateResult;
  updatePicture: PictureUpdateResult;
  updateTag: TagUpdateResult;
  updateTeam: TeamUpdateResult;
  updateTouchpoint: TouchpointUpdateResult;
  updateWidget: WidgetUpdateResult;
  upsertAction: ActionUpsertResult;
  upsertActivity: ActivityUpsertResult;
  upsertActivityDuration: ActivityDurationUpsertResult;
  upsertActivityWarning: ActivityWarningUpsertResult;
  upsertContentMetric: ContentMetricUpsertResult;
  upsertContentMetricDataPoint: ContentMetricDataPointUpsertResult;
  upsertControlCycle: ControlCycleUpsertResult;
  upsertControlCycleCheck: ControlCycleCheckUpsertResult;
  upsertDashboard: DashboardUpsertResult;
  upsertDashboardJourney: DashboardJourneyUpsertResult;
  upsertDashboardMetric: DashboardMetricUpsertResult;
  upsertJourney: JourneyUpsertResult;
  upsertKeboolaSyncEvent: KeboolaSyncEventUpsertResult;
  upsertMemberSettings: MemberSettingsUpsertResult;
  upsertMetric: MetricUpsertResult;
  upsertMetricDataLabel: MetricDataLabelUpsertResult;
  upsertMetricDataPoint: MetricDataPointUpsertResult;
  upsertMetricDataSet: MetricDataSetUpsertResult;
  upsertMetricGoogleSheetsMapping: MetricGoogleSheetsMappingUpsertResult;
  upsertMetricGoogleSheetsSheet: MetricGoogleSheetsSheetUpsertResult;
  upsertMetricGoogleSheetsSource: MetricGoogleSheetsSourceUpsertResult;
  upsertMetricGoogleSheetsSpreadsheet: MetricGoogleSheetsSpreadsheetUpsertResult;
  upsertMetricSource: MetricSourceUpsertResult;
  upsertMetricTemplate: MetricTemplateUpsertResult;
  upsertOpportunity: OpportunityUpsertResult;
  upsertPersona: PersonaUpsertResult;
  upsertPersonaBlock: PersonaBlockUpsertResult;
  upsertPersonaBlockItem: PersonaBlockItemUpsertResult;
  upsertPhase: PhaseUpsertResult;
  upsertPicture: PictureUpsertResult;
  upsertTag: TagUpsertResult;
  upsertTeam: TeamUpsertResult;
  upsertTouchpoint: TouchpointUpsertResult;
  upsertWidget: WidgetUpsertResult;
  webhookCheckoutCompleted: WebhookCheckoutCompletedResult;
  webhookImageProcessed: WebhookImageProcessingResult;
};


export type MutationChangeMyPasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationChangeMyProfileArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateActionArgs = {
  data: ActionCreateInput;
};


export type MutationCreateActivityArgs = {
  data: ActivityCreateInput;
};


export type MutationCreateActivityDeepCloneArgs = {
  activityId: Scalars['UUID']['input'];
};


export type MutationCreateActivityDurationArgs = {
  data: ActivityDurationCreateInput;
};


export type MutationCreateActivityWarningArgs = {
  data: ActivityWarningCreateInput;
};


export type MutationCreateContentMetricArgs = {
  data: ContentMetricCreateInput;
};


export type MutationCreateContentMetricDataPointArgs = {
  data: ContentMetricDataPointCreateInput;
};


export type MutationCreateControlCycleArgs = {
  data: ControlCycleCreateInput;
};


export type MutationCreateControlCycleCheckArgs = {
  data: ControlCycleCheckCreateInput;
};


export type MutationCreateDashboardArgs = {
  data: DashboardCreateInput;
};


export type MutationCreateDashboardJourneyArgs = {
  data: DashboardJourneyCreateInput;
};


export type MutationCreateDashboardMetricArgs = {
  data: DashboardMetricCreateInput;
};


export type MutationCreateJourneyArgs = {
  data: JourneyCreateInput;
};


export type MutationCreateJourneyDeepCloneArgs = {
  journeyId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateKeboolaSyncEventArgs = {
  data: KeboolaSyncEventCreateInput;
};


export type MutationCreateMemberSettingsArgs = {
  data: MemberSettingsCreateInput;
};


export type MutationCreateMetricArgs = {
  data: MetricCreateInput;
};


export type MutationCreateMetricDataLabelArgs = {
  data: MetricDataLabelCreateInput;
};


export type MutationCreateMetricDataPointArgs = {
  data: MetricDataPointCreateInput;
};


export type MutationCreateMetricDataSetArgs = {
  data: MetricDataSetCreateInput;
};


export type MutationCreateMetricGoogleSheetsMappingArgs = {
  data: MetricGoogleSheetsMappingCreateInput;
};


export type MutationCreateMetricGoogleSheetsSheetArgs = {
  data: MetricGoogleSheetsSheetCreateInput;
};


export type MutationCreateMetricGoogleSheetsSourceArgs = {
  data: MetricGoogleSheetsSourceCreateInput;
};


export type MutationCreateMetricGoogleSheetsSpreadsheetArgs = {
  data: MetricGoogleSheetsSpreadsheetCreateInput;
};


export type MutationCreateMetricSourceArgs = {
  data: MetricSourceCreateInput;
};


export type MutationCreateMetricTemplateArgs = {
  data: MetricTemplateCreateInput;
};


export type MutationCreateOpportunityArgs = {
  data: OpportunityCreateInput;
};


export type MutationCreatePersonaArgs = {
  data: PersonaCreateInput;
};


export type MutationCreatePersonaBlockArgs = {
  data: PersonaBlockCreateInput;
};


export type MutationCreatePersonaBlockItemArgs = {
  data: PersonaBlockItemCreateInput;
};


export type MutationCreatePhaseArgs = {
  data: PhaseCreateInput;
};


export type MutationCreatePictureArgs = {
  data: PictureCreateInput;
};


export type MutationCreateResetPasswordArgs = {
  email: Scalars['String']['input'];
  options?: InputMaybe<CreateResetPasswordRequestOptions>;
};


export type MutationCreateResetPasswordRequestArgs = {
  email: Scalars['String']['input'];
  options?: InputMaybe<CreateResetPasswordRequestOptions>;
};


export type MutationCreateTagArgs = {
  data: TagCreateInput;
};


export type MutationCreateTeamArgs = {
  data: TeamCreateInput;
};


export type MutationCreateTouchpointArgs = {
  data: TouchpointCreateInput;
};


export type MutationCreateWidgetArgs = {
  data: WidgetCreateInput;
};


export type MutationDeactivateMemberArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteActionArgs = {
  by: ActionUniqueWhere;
  filter?: InputMaybe<ActionWhere>;
};


export type MutationDeleteActivityArgs = {
  by: ActivityUniqueWhere;
  filter?: InputMaybe<ActivityWhere>;
};


export type MutationDeleteActivityDurationArgs = {
  by: ActivityDurationUniqueWhere;
  filter?: InputMaybe<ActivityDurationWhere>;
};


export type MutationDeleteActivityWarningArgs = {
  by: ActivityWarningUniqueWhere;
  filter?: InputMaybe<ActivityWarningWhere>;
};


export type MutationDeleteContentMetricArgs = {
  by: MemberUniqueWhere;
  filter?: InputMaybe<MemberWhere>;
};


export type MutationDeleteContentMetricDataPointArgs = {
  by: ContentMetricDataPointUniqueWhere;
  filter?: InputMaybe<ContentMetricDataPointWhere>;
};


export type MutationDeleteControlCycleArgs = {
  by: ControlCycleUniqueWhere;
  filter?: InputMaybe<ControlCycleWhere>;
};


export type MutationDeleteControlCycleCheckArgs = {
  by: ControlCycleCheckUniqueWhere;
  filter?: InputMaybe<ControlCycleCheckWhere>;
};


export type MutationDeleteDashboardArgs = {
  by: DashboardUniqueWhere;
  filter?: InputMaybe<DashboardWhere>;
};


export type MutationDeleteDashboardJourneyArgs = {
  by: DashboardJourneyUniqueWhere;
  filter?: InputMaybe<DashboardJourneyWhere>;
};


export type MutationDeleteDashboardMetricArgs = {
  by: DashboardMetricUniqueWhere;
  filter?: InputMaybe<DashboardMetricWhere>;
};


export type MutationDeleteJourneyArgs = {
  by: JourneyUniqueWhere;
  filter?: InputMaybe<JourneyWhere>;
};


export type MutationDeleteKeboolaSyncEventArgs = {
  by: KeboolaSyncEventUniqueWhere;
  filter?: InputMaybe<KeboolaSyncEventWhere>;
};


export type MutationDeleteMemberArgs = {
  by: MemberUniqueWhere;
  filter?: InputMaybe<MemberWhere>;
};


export type MutationDeleteMemberSettingsArgs = {
  by: MemberSettingsUniqueWhere;
  filter?: InputMaybe<MemberSettingsWhere>;
};


export type MutationDeleteMetricArgs = {
  by: MetricUniqueWhere;
  filter?: InputMaybe<MetricWhere>;
};


export type MutationDeleteMetricDataLabelArgs = {
  by: MetricDataLabelUniqueWhere;
  filter?: InputMaybe<MetricDataLabelWhere>;
};


export type MutationDeleteMetricDataPointArgs = {
  by: MetricDataPointUniqueWhere;
  filter?: InputMaybe<MetricDataPointWhere>;
};


export type MutationDeleteMetricDataSetArgs = {
  by: MetricDataSetUniqueWhere;
  filter?: InputMaybe<MetricDataSetWhere>;
};


export type MutationDeleteMetricGoogleSheetsMappingArgs = {
  by: MetricGoogleSheetsMappingUniqueWhere;
  filter?: InputMaybe<MetricGoogleSheetsMappingWhere>;
};


export type MutationDeleteMetricGoogleSheetsSheetArgs = {
  by: MetricGoogleSheetsSheetUniqueWhere;
  filter?: InputMaybe<MetricGoogleSheetsSheetWhere>;
};


export type MutationDeleteMetricGoogleSheetsSourceArgs = {
  by: MetricGoogleSheetsSourceUniqueWhere;
  filter?: InputMaybe<MetricGoogleSheetsSourceWhere>;
};


export type MutationDeleteMetricGoogleSheetsSpreadsheetArgs = {
  by: MetricGoogleSheetsSpreadsheetUniqueWhere;
  filter?: InputMaybe<MetricGoogleSheetsSpreadsheetWhere>;
};


export type MutationDeleteMetricSourceArgs = {
  by: MetricSourceUniqueWhere;
  filter?: InputMaybe<MetricSourceWhere>;
};


export type MutationDeleteMetricTemplateArgs = {
  by: MetricTemplateUniqueWhere;
  filter?: InputMaybe<MetricTemplateWhere>;
};


export type MutationDeleteOpportunityArgs = {
  by: OpportunityUniqueWhere;
  filter?: InputMaybe<OpportunityWhere>;
};


export type MutationDeletePersonaArgs = {
  by: PersonaUniqueWhere;
  filter?: InputMaybe<PersonaWhere>;
};


export type MutationDeletePersonaBlockArgs = {
  by: PersonaBlockUniqueWhere;
  filter?: InputMaybe<PersonaBlockWhere>;
};


export type MutationDeletePersonaBlockItemArgs = {
  by: PersonaBlockItemUniqueWhere;
  filter?: InputMaybe<PersonaBlockItemWhere>;
};


export type MutationDeletePhaseArgs = {
  by: PhaseUniqueWhere;
  filter?: InputMaybe<PhaseWhere>;
};


export type MutationDeletePictureArgs = {
  by: PictureUniqueWhere;
  filter?: InputMaybe<PictureWhere>;
};


export type MutationDeleteTagArgs = {
  by: TagUniqueWhere;
  filter?: InputMaybe<TagWhere>;
};


export type MutationDeleteTeamArgs = {
  by: TeamUniqueWhere;
  filter?: InputMaybe<TeamWhere>;
};


export type MutationDeleteTouchpointArgs = {
  by: TouchpointUniqueWhere;
  filter?: InputMaybe<TouchpointWhere>;
};


export type MutationDeleteWidgetArgs = {
  by: WidgetUniqueWhere;
  filter?: InputMaybe<WidgetWhere>;
};


export type MutationInviteMemberArgs = {
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationReactivateMemberArgs = {
  id: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSetGoogleSheetsConfigurationArgs = {
  input: SetGoogleSheetsConfigurationInput;
};


export type MutationSetGoogleSheetsMetricTemplateMappingArgs = {
  input: SetGoogleSheetConfigurationMappingInput;
};


export type MutationSetSingleSheetMappingArgs = {
  input: SingleSheetMappingConfig;
};


export type MutationSignInArgs = {
  email: Scalars['String']['input'];
  expiration?: InputMaybe<Scalars['Int']['input']>;
  otpToken?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};


export type MutationSignOutArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationTransactionArgs = {
  options?: InputMaybe<MutationTransactionOptions>;
};


export type MutationUpdateActionArgs = {
  by: ActionUniqueWhere;
  data: ActionUpdateInput;
  filter?: InputMaybe<ActionWhere>;
};


export type MutationUpdateActivityArgs = {
  by: ActivityUniqueWhere;
  data: ActivityUpdateInput;
  filter?: InputMaybe<ActivityWhere>;
};


export type MutationUpdateActivityDurationArgs = {
  by: ActivityDurationUniqueWhere;
  data: ActivityDurationUpdateInput;
  filter?: InputMaybe<ActivityDurationWhere>;
};


export type MutationUpdateActivityWarningArgs = {
  by: ActivityWarningUniqueWhere;
  data: ActivityWarningUpdateInput;
  filter?: InputMaybe<ActivityWarningWhere>;
};


export type MutationUpdateContentMetricArgs = {
  by: ContentMetricUniqueWhere;
  data: ContentMetricUpdateInput;
  filter?: InputMaybe<ContentMetricWhere>;
};


export type MutationUpdateContentMetricDataPointArgs = {
  by: ContentMetricDataPointUniqueWhere;
  data: ContentMetricDataPointUpdateInput;
  filter?: InputMaybe<ContentMetricDataPointWhere>;
};


export type MutationUpdateContentMetricDataSetToGoogleSheetArgs = {
  input: UpdateSingleExistingContentMetricDataSet;
};


export type MutationUpdateControlCycleArgs = {
  by: ControlCycleUniqueWhere;
  data: ControlCycleUpdateInput;
  filter?: InputMaybe<ControlCycleWhere>;
};


export type MutationUpdateControlCycleCheckArgs = {
  by: ControlCycleCheckUniqueWhere;
  data: ControlCycleCheckUpdateInput;
  filter?: InputMaybe<ControlCycleCheckWhere>;
};


export type MutationUpdateDashboardArgs = {
  by: DashboardUniqueWhere;
  data: DashboardUpdateInput;
  filter?: InputMaybe<DashboardWhere>;
};


export type MutationUpdateDashboardJourneyArgs = {
  by: DashboardJourneyUniqueWhere;
  data: DashboardJourneyUpdateInput;
  filter?: InputMaybe<DashboardJourneyWhere>;
};


export type MutationUpdateDashboardMetricArgs = {
  by: DashboardMetricUniqueWhere;
  data: DashboardMetricUpdateInput;
  filter?: InputMaybe<DashboardMetricWhere>;
};


export type MutationUpdateJourneyArgs = {
  by: JourneyUniqueWhere;
  data: JourneyUpdateInput;
  filter?: InputMaybe<JourneyWhere>;
};


export type MutationUpdateKeboolaSyncEventArgs = {
  by: KeboolaSyncEventUniqueWhere;
  data: KeboolaSyncEventUpdateInput;
  filter?: InputMaybe<KeboolaSyncEventWhere>;
};


export type MutationUpdateMemberArgs = {
  by: MemberUniqueWhere;
  data: MemberUpdateInputFiltered;
  filter?: InputMaybe<MemberWhere>;
};


export type MutationUpdateMemberSettingsArgs = {
  by: MemberSettingsUniqueWhere;
  data: MemberSettingsUpdateInput;
  filter?: InputMaybe<MemberSettingsWhere>;
};


export type MutationUpdateMetricArgs = {
  by: MetricUniqueWhere;
  data: MetricUpdateInput;
  filter?: InputMaybe<MetricWhere>;
};


export type MutationUpdateMetricDataLabelArgs = {
  by: MetricDataLabelUniqueWhere;
  data: MetricDataLabelUpdateInput;
  filter?: InputMaybe<MetricDataLabelWhere>;
};


export type MutationUpdateMetricDataPointArgs = {
  by: MetricDataPointUniqueWhere;
  data: MetricDataPointUpdateInput;
  filter?: InputMaybe<MetricDataPointWhere>;
};


export type MutationUpdateMetricDataSetArgs = {
  by: MetricDataSetUniqueWhere;
  data: MetricDataSetUpdateInput;
  filter?: InputMaybe<MetricDataSetWhere>;
};


export type MutationUpdateMetricGoogleSheetsMappingArgs = {
  by: MetricGoogleSheetsMappingUniqueWhere;
  data: MetricGoogleSheetsMappingUpdateInput;
  filter?: InputMaybe<MetricGoogleSheetsMappingWhere>;
};


export type MutationUpdateMetricGoogleSheetsSheetArgs = {
  by: MetricGoogleSheetsSheetUniqueWhere;
  data: MetricGoogleSheetsSheetUpdateInput;
  filter?: InputMaybe<MetricGoogleSheetsSheetWhere>;
};


export type MutationUpdateMetricGoogleSheetsSourceArgs = {
  by: MetricGoogleSheetsSourceUniqueWhere;
  data: MetricGoogleSheetsSourceUpdateInput;
  filter?: InputMaybe<MetricGoogleSheetsSourceWhere>;
};


export type MutationUpdateMetricGoogleSheetsSpreadsheetArgs = {
  by: MetricGoogleSheetsSpreadsheetUniqueWhere;
  data: MetricGoogleSheetsSpreadsheetUpdateInput;
  filter?: InputMaybe<MetricGoogleSheetsSpreadsheetWhere>;
};


export type MutationUpdateMetricSourceArgs = {
  by: MetricSourceUniqueWhere;
  data: MetricSourceUpdateInput;
  filter?: InputMaybe<MetricSourceWhere>;
};


export type MutationUpdateMetricTemplateArgs = {
  by: MetricTemplateUniqueWhere;
  data: MetricTemplateUpdateInput;
  filter?: InputMaybe<MetricTemplateWhere>;
};


export type MutationUpdateMyProfileArgs = {
  data?: InputMaybe<MemberMyProfileData>;
  id: Scalars['String']['input'];
};


export type MutationUpdateOpportunityArgs = {
  by: OpportunityUniqueWhere;
  data: OpportunityUpdateInput;
  filter?: InputMaybe<OpportunityWhere>;
};


export type MutationUpdateOrganizationArgs = {
  config?: InputMaybe<OrganizationConfig>;
};


export type MutationUpdatePersonaArgs = {
  by: PersonaUniqueWhere;
  data: PersonaUpdateInput;
  filter?: InputMaybe<PersonaWhere>;
};


export type MutationUpdatePersonaBlockArgs = {
  by: PersonaBlockUniqueWhere;
  data: PersonaBlockUpdateInput;
  filter?: InputMaybe<PersonaBlockWhere>;
};


export type MutationUpdatePersonaBlockItemArgs = {
  by: PersonaBlockItemUniqueWhere;
  data: PersonaBlockItemUpdateInput;
  filter?: InputMaybe<PersonaBlockItemWhere>;
};


export type MutationUpdatePhaseArgs = {
  by: PhaseUniqueWhere;
  data: PhaseUpdateInput;
  filter?: InputMaybe<PhaseWhere>;
};


export type MutationUpdatePictureArgs = {
  by: PictureUniqueWhere;
  data: PictureUpdateInput;
  filter?: InputMaybe<PictureWhere>;
};


export type MutationUpdateTagArgs = {
  by: TagUniqueWhere;
  data: TagUpdateInput;
  filter?: InputMaybe<TagWhere>;
};


export type MutationUpdateTeamArgs = {
  by: TeamUniqueWhere;
  data: TeamUpdateInput;
  filter?: InputMaybe<TeamWhere>;
};


export type MutationUpdateTouchpointArgs = {
  by: TouchpointUniqueWhere;
  data: TouchpointUpdateInput;
  filter?: InputMaybe<TouchpointWhere>;
};


export type MutationUpdateWidgetArgs = {
  by: WidgetUniqueWhere;
  data: WidgetUpdateInput;
  filter?: InputMaybe<WidgetWhere>;
};


export type MutationUpsertActionArgs = {
  by: ActionUniqueWhere;
  create: ActionCreateInput;
  filter?: InputMaybe<ActionWhere>;
  update: ActionUpdateInput;
};


export type MutationUpsertActivityArgs = {
  by: ActivityUniqueWhere;
  create: ActivityCreateInput;
  filter?: InputMaybe<ActivityWhere>;
  update: ActivityUpdateInput;
};


export type MutationUpsertActivityDurationArgs = {
  by: ActivityDurationUniqueWhere;
  create: ActivityDurationCreateInput;
  filter?: InputMaybe<ActivityDurationWhere>;
  update: ActivityDurationUpdateInput;
};


export type MutationUpsertActivityWarningArgs = {
  by: ActivityWarningUniqueWhere;
  create: ActivityWarningCreateInput;
  filter?: InputMaybe<ActivityWarningWhere>;
  update: ActivityWarningUpdateInput;
};


export type MutationUpsertContentMetricArgs = {
  by: ContentMetricUniqueWhere;
  create: ContentMetricCreateInput;
  filter?: InputMaybe<ContentMetricWhere>;
  update: ContentMetricUpdateInput;
};


export type MutationUpsertContentMetricDataPointArgs = {
  by: ContentMetricDataPointUniqueWhere;
  create: ContentMetricDataPointCreateInput;
  filter?: InputMaybe<ContentMetricDataPointWhere>;
  update: ContentMetricDataPointUpdateInput;
};


export type MutationUpsertControlCycleArgs = {
  by: ControlCycleUniqueWhere;
  create: ControlCycleCreateInput;
  filter?: InputMaybe<ControlCycleWhere>;
  update: ControlCycleUpdateInput;
};


export type MutationUpsertControlCycleCheckArgs = {
  by: ControlCycleCheckUniqueWhere;
  create: ControlCycleCheckCreateInput;
  filter?: InputMaybe<ControlCycleCheckWhere>;
  update: ControlCycleCheckUpdateInput;
};


export type MutationUpsertDashboardArgs = {
  by: DashboardUniqueWhere;
  create: DashboardCreateInput;
  filter?: InputMaybe<DashboardWhere>;
  update: DashboardUpdateInput;
};


export type MutationUpsertDashboardJourneyArgs = {
  by: DashboardJourneyUniqueWhere;
  create: DashboardJourneyCreateInput;
  filter?: InputMaybe<DashboardJourneyWhere>;
  update: DashboardJourneyUpdateInput;
};


export type MutationUpsertDashboardMetricArgs = {
  by: DashboardMetricUniqueWhere;
  create: DashboardMetricCreateInput;
  filter?: InputMaybe<DashboardMetricWhere>;
  update: DashboardMetricUpdateInput;
};


export type MutationUpsertJourneyArgs = {
  by: JourneyUniqueWhere;
  create: JourneyCreateInput;
  filter?: InputMaybe<JourneyWhere>;
  update: JourneyUpdateInput;
};


export type MutationUpsertKeboolaSyncEventArgs = {
  by: KeboolaSyncEventUniqueWhere;
  create: KeboolaSyncEventCreateInput;
  filter?: InputMaybe<KeboolaSyncEventWhere>;
  update: KeboolaSyncEventUpdateInput;
};


export type MutationUpsertMemberSettingsArgs = {
  by: MemberSettingsUniqueWhere;
  create: MemberSettingsCreateInput;
  filter?: InputMaybe<MemberSettingsWhere>;
  update: MemberSettingsUpdateInput;
};


export type MutationUpsertMetricArgs = {
  by: MetricUniqueWhere;
  create: MetricCreateInput;
  filter?: InputMaybe<MetricWhere>;
  update: MetricUpdateInput;
};


export type MutationUpsertMetricDataLabelArgs = {
  by: MetricDataLabelUniqueWhere;
  create: MetricDataLabelCreateInput;
  filter?: InputMaybe<MetricDataLabelWhere>;
  update: MetricDataLabelUpdateInput;
};


export type MutationUpsertMetricDataPointArgs = {
  by: MetricDataPointUniqueWhere;
  create: MetricDataPointCreateInput;
  filter?: InputMaybe<MetricDataPointWhere>;
  update: MetricDataPointUpdateInput;
};


export type MutationUpsertMetricDataSetArgs = {
  by: MetricDataSetUniqueWhere;
  create: MetricDataSetCreateInput;
  filter?: InputMaybe<MetricDataSetWhere>;
  update: MetricDataSetUpdateInput;
};


export type MutationUpsertMetricGoogleSheetsMappingArgs = {
  by: MetricGoogleSheetsMappingUniqueWhere;
  create: MetricGoogleSheetsMappingCreateInput;
  filter?: InputMaybe<MetricGoogleSheetsMappingWhere>;
  update: MetricGoogleSheetsMappingUpdateInput;
};


export type MutationUpsertMetricGoogleSheetsSheetArgs = {
  by: MetricGoogleSheetsSheetUniqueWhere;
  create: MetricGoogleSheetsSheetCreateInput;
  filter?: InputMaybe<MetricGoogleSheetsSheetWhere>;
  update: MetricGoogleSheetsSheetUpdateInput;
};


export type MutationUpsertMetricGoogleSheetsSourceArgs = {
  by: MetricGoogleSheetsSourceUniqueWhere;
  create: MetricGoogleSheetsSourceCreateInput;
  filter?: InputMaybe<MetricGoogleSheetsSourceWhere>;
  update: MetricGoogleSheetsSourceUpdateInput;
};


export type MutationUpsertMetricGoogleSheetsSpreadsheetArgs = {
  by: MetricGoogleSheetsSpreadsheetUniqueWhere;
  create: MetricGoogleSheetsSpreadsheetCreateInput;
  filter?: InputMaybe<MetricGoogleSheetsSpreadsheetWhere>;
  update: MetricGoogleSheetsSpreadsheetUpdateInput;
};


export type MutationUpsertMetricSourceArgs = {
  by: MetricSourceUniqueWhere;
  create: MetricSourceCreateInput;
  filter?: InputMaybe<MetricSourceWhere>;
  update: MetricSourceUpdateInput;
};


export type MutationUpsertMetricTemplateArgs = {
  by: MetricTemplateUniqueWhere;
  create: MetricTemplateCreateInput;
  filter?: InputMaybe<MetricTemplateWhere>;
  update: MetricTemplateUpdateInput;
};


export type MutationUpsertOpportunityArgs = {
  by: OpportunityUniqueWhere;
  create: OpportunityCreateInput;
  filter?: InputMaybe<OpportunityWhere>;
  update: OpportunityUpdateInput;
};


export type MutationUpsertPersonaArgs = {
  by: PersonaUniqueWhere;
  create: PersonaCreateInput;
  filter?: InputMaybe<PersonaWhere>;
  update: PersonaUpdateInput;
};


export type MutationUpsertPersonaBlockArgs = {
  by: PersonaBlockUniqueWhere;
  create: PersonaBlockCreateInput;
  filter?: InputMaybe<PersonaBlockWhere>;
  update: PersonaBlockUpdateInput;
};


export type MutationUpsertPersonaBlockItemArgs = {
  by: PersonaBlockItemUniqueWhere;
  create: PersonaBlockItemCreateInput;
  filter?: InputMaybe<PersonaBlockItemWhere>;
  update: PersonaBlockItemUpdateInput;
};


export type MutationUpsertPhaseArgs = {
  by: PhaseUniqueWhere;
  create: PhaseCreateInput;
  filter?: InputMaybe<PhaseWhere>;
  update: PhaseUpdateInput;
};


export type MutationUpsertPictureArgs = {
  by: PictureUniqueWhere;
  create: PictureCreateInput;
  filter?: InputMaybe<PictureWhere>;
  update: PictureUpdateInput;
};


export type MutationUpsertTagArgs = {
  by: TagUniqueWhere;
  create: TagCreateInput;
  filter?: InputMaybe<TagWhere>;
  update: TagUpdateInput;
};


export type MutationUpsertTeamArgs = {
  by: TeamUniqueWhere;
  create: TeamCreateInput;
  filter?: InputMaybe<TeamWhere>;
  update: TeamUpdateInput;
};


export type MutationUpsertTouchpointArgs = {
  by: TouchpointUniqueWhere;
  create: TouchpointCreateInput;
  filter?: InputMaybe<TouchpointWhere>;
  update: TouchpointUpdateInput;
};


export type MutationUpsertWidgetArgs = {
  by: WidgetUniqueWhere;
  create: WidgetCreateInput;
  filter?: InputMaybe<WidgetWhere>;
  update: WidgetUpdateInput;
};


export type MutationWebhookCheckoutCompletedArgs = {
  customerId: Scalars['String']['input'];
};


export type MutationWebhookImageProcessedArgs = {
  id: Scalars['UUID']['input'];
  status: ImageProcessingStatus;
};

export type MutationResult = {
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  ok: Scalars['Boolean']['output'];
};

export type MutationTransaction = {
  __typename?: 'MutationTransaction';
  createAction: ActionCreateResult;
  createActivity: ActivityCreateResult;
  createActivityDuration: ActivityDurationCreateResult;
  createActivityWarning: ActivityWarningCreateResult;
  createContentMetric: ContentMetricCreateResult;
  createContentMetricDataPoint: ContentMetricDataPointCreateResult;
  createControlCycle: ControlCycleCreateResult;
  createControlCycleCheck: ControlCycleCheckCreateResult;
  createDashboard: DashboardCreateResult;
  createDashboardJourney: DashboardJourneyCreateResult;
  createDashboardMetric: DashboardMetricCreateResult;
  createImage: ImageCreateResult;
  createJourney: JourneyCreateResult;
  createKeboolaSyncEvent: KeboolaSyncEventCreateResult;
  createMember: MemberCreateResult;
  createMemberSettings: MemberSettingsCreateResult;
  createMetric: MetricCreateResult;
  createMetricDataLabel: MetricDataLabelCreateResult;
  createMetricDataPoint: MetricDataPointCreateResult;
  createMetricDataSet: MetricDataSetCreateResult;
  createMetricGoogleSheetsMapping: MetricGoogleSheetsMappingCreateResult;
  createMetricGoogleSheetsSheet: MetricGoogleSheetsSheetCreateResult;
  createMetricGoogleSheetsSource: MetricGoogleSheetsSourceCreateResult;
  createMetricGoogleSheetsSpreadsheet: MetricGoogleSheetsSpreadsheetCreateResult;
  createMetricSource: MetricSourceCreateResult;
  createMetricTemplate: MetricTemplateCreateResult;
  createOpportunity: OpportunityCreateResult;
  createOrganizationMeta: OrganizationMetaCreateResult;
  createPersona: PersonaCreateResult;
  createPersonaBlock: PersonaBlockCreateResult;
  createPersonaBlockItem: PersonaBlockItemCreateResult;
  createPhase: PhaseCreateResult;
  createPicture: PictureCreateResult;
  createTag: TagCreateResult;
  createTeam: TeamCreateResult;
  createTouchpoint: TouchpointCreateResult;
  createWidget: WidgetCreateResult;
  deleteAction: ActionDeleteResult;
  deleteActivity: ActivityDeleteResult;
  deleteActivityDuration: ActivityDurationDeleteResult;
  deleteActivityWarning: ActivityWarningDeleteResult;
  deleteContentMetric: ContentMetricDeleteResult;
  deleteContentMetricDataPoint: ContentMetricDataPointDeleteResult;
  deleteControlCycle: ControlCycleDeleteResult;
  deleteControlCycleCheck: ControlCycleCheckDeleteResult;
  deleteDashboard: DashboardDeleteResult;
  deleteDashboardJourney: DashboardJourneyDeleteResult;
  deleteDashboardMetric: DashboardMetricDeleteResult;
  deleteImage: ImageDeleteResult;
  deleteJourney: JourneyDeleteResult;
  deleteKeboolaSyncEvent: KeboolaSyncEventDeleteResult;
  deleteMember: MemberDeleteResult;
  deleteMemberSettings: MemberSettingsDeleteResult;
  deleteMetric: MetricDeleteResult;
  deleteMetricDataLabel: MetricDataLabelDeleteResult;
  deleteMetricDataPoint: MetricDataPointDeleteResult;
  deleteMetricDataSet: MetricDataSetDeleteResult;
  deleteMetricGoogleSheetsMapping: MetricGoogleSheetsMappingDeleteResult;
  deleteMetricGoogleSheetsSheet: MetricGoogleSheetsSheetDeleteResult;
  deleteMetricGoogleSheetsSource: MetricGoogleSheetsSourceDeleteResult;
  deleteMetricGoogleSheetsSpreadsheet: MetricGoogleSheetsSpreadsheetDeleteResult;
  deleteMetricSource: MetricSourceDeleteResult;
  deleteMetricTemplate: MetricTemplateDeleteResult;
  deleteOpportunity: OpportunityDeleteResult;
  deleteOrganizationMeta: OrganizationMetaDeleteResult;
  deletePersona: PersonaDeleteResult;
  deletePersonaBlock: PersonaBlockDeleteResult;
  deletePersonaBlockItem: PersonaBlockItemDeleteResult;
  deletePhase: PhaseDeleteResult;
  deletePicture: PictureDeleteResult;
  deleteTag: TagDeleteResult;
  deleteTeam: TeamDeleteResult;
  deleteTouchpoint: TouchpointDeleteResult;
  deleteWidget: WidgetDeleteResult;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  ok: Scalars['Boolean']['output'];
  query?: Maybe<Query>;
  updateAction: ActionUpdateResult;
  updateActivity: ActivityUpdateResult;
  updateActivityDuration: ActivityDurationUpdateResult;
  updateActivityWarning: ActivityWarningUpdateResult;
  updateContentMetric: ContentMetricUpdateResult;
  updateContentMetricDataPoint: ContentMetricDataPointUpdateResult;
  updateControlCycle: ControlCycleUpdateResult;
  updateControlCycleCheck: ControlCycleCheckUpdateResult;
  updateDashboard: DashboardUpdateResult;
  updateDashboardJourney: DashboardJourneyUpdateResult;
  updateDashboardMetric: DashboardMetricUpdateResult;
  updateImage: ImageUpdateResult;
  updateJourney: JourneyUpdateResult;
  updateKeboolaSyncEvent: KeboolaSyncEventUpdateResult;
  updateMember: MemberUpdateResult;
  updateMemberSettings: MemberSettingsUpdateResult;
  updateMetric: MetricUpdateResult;
  updateMetricDataLabel: MetricDataLabelUpdateResult;
  updateMetricDataPoint: MetricDataPointUpdateResult;
  updateMetricDataSet: MetricDataSetUpdateResult;
  updateMetricGoogleSheetsMapping: MetricGoogleSheetsMappingUpdateResult;
  updateMetricGoogleSheetsSheet: MetricGoogleSheetsSheetUpdateResult;
  updateMetricGoogleSheetsSource: MetricGoogleSheetsSourceUpdateResult;
  updateMetricGoogleSheetsSpreadsheet: MetricGoogleSheetsSpreadsheetUpdateResult;
  updateMetricSource: MetricSourceUpdateResult;
  updateMetricTemplate: MetricTemplateUpdateResult;
  updateOpportunity: OpportunityUpdateResult;
  updateOrganizationMeta: OrganizationMetaUpdateResult;
  updatePersona: PersonaUpdateResult;
  updatePersonaBlock: PersonaBlockUpdateResult;
  updatePersonaBlockItem: PersonaBlockItemUpdateResult;
  updatePhase: PhaseUpdateResult;
  updatePicture: PictureUpdateResult;
  updateTag: TagUpdateResult;
  updateTeam: TeamUpdateResult;
  updateTouchpoint: TouchpointUpdateResult;
  updateWidget: WidgetUpdateResult;
  upsertAction: ActionUpsertResult;
  upsertActivity: ActivityUpsertResult;
  upsertActivityDuration: ActivityDurationUpsertResult;
  upsertActivityWarning: ActivityWarningUpsertResult;
  upsertContentMetric: ContentMetricUpsertResult;
  upsertContentMetricDataPoint: ContentMetricDataPointUpsertResult;
  upsertControlCycle: ControlCycleUpsertResult;
  upsertControlCycleCheck: ControlCycleCheckUpsertResult;
  upsertDashboard: DashboardUpsertResult;
  upsertDashboardJourney: DashboardJourneyUpsertResult;
  upsertDashboardMetric: DashboardMetricUpsertResult;
  upsertImage: ImageUpsertResult;
  upsertJourney: JourneyUpsertResult;
  upsertKeboolaSyncEvent: KeboolaSyncEventUpsertResult;
  upsertMember: MemberUpsertResult;
  upsertMemberSettings: MemberSettingsUpsertResult;
  upsertMetric: MetricUpsertResult;
  upsertMetricDataLabel: MetricDataLabelUpsertResult;
  upsertMetricDataPoint: MetricDataPointUpsertResult;
  upsertMetricDataSet: MetricDataSetUpsertResult;
  upsertMetricGoogleSheetsMapping: MetricGoogleSheetsMappingUpsertResult;
  upsertMetricGoogleSheetsSheet: MetricGoogleSheetsSheetUpsertResult;
  upsertMetricGoogleSheetsSource: MetricGoogleSheetsSourceUpsertResult;
  upsertMetricGoogleSheetsSpreadsheet: MetricGoogleSheetsSpreadsheetUpsertResult;
  upsertMetricSource: MetricSourceUpsertResult;
  upsertMetricTemplate: MetricTemplateUpsertResult;
  upsertOpportunity: OpportunityUpsertResult;
  upsertOrganizationMeta: OrganizationMetaUpsertResult;
  upsertPersona: PersonaUpsertResult;
  upsertPersonaBlock: PersonaBlockUpsertResult;
  upsertPersonaBlockItem: PersonaBlockItemUpsertResult;
  upsertPhase: PhaseUpsertResult;
  upsertPicture: PictureUpsertResult;
  upsertTag: TagUpsertResult;
  upsertTeam: TeamUpsertResult;
  upsertTouchpoint: TouchpointUpsertResult;
  upsertWidget: WidgetUpsertResult;
  validation: _ValidationResult;
};


export type MutationTransactionCreateActionArgs = {
  data: ActionCreateInput;
};


export type MutationTransactionCreateActivityArgs = {
  data: ActivityCreateInput;
};


export type MutationTransactionCreateActivityDurationArgs = {
  data: ActivityDurationCreateInput;
};


export type MutationTransactionCreateActivityWarningArgs = {
  data: ActivityWarningCreateInput;
};


export type MutationTransactionCreateContentMetricArgs = {
  data: ContentMetricCreateInput;
};


export type MutationTransactionCreateContentMetricDataPointArgs = {
  data: ContentMetricDataPointCreateInput;
};


export type MutationTransactionCreateControlCycleArgs = {
  data: ControlCycleCreateInput;
};


export type MutationTransactionCreateControlCycleCheckArgs = {
  data: ControlCycleCheckCreateInput;
};


export type MutationTransactionCreateDashboardArgs = {
  data: DashboardCreateInput;
};


export type MutationTransactionCreateDashboardJourneyArgs = {
  data: DashboardJourneyCreateInput;
};


export type MutationTransactionCreateDashboardMetricArgs = {
  data: DashboardMetricCreateInput;
};


export type MutationTransactionCreateImageArgs = {
  data: ImageCreateInput;
};


export type MutationTransactionCreateJourneyArgs = {
  data: JourneyCreateInput;
};


export type MutationTransactionCreateKeboolaSyncEventArgs = {
  data: KeboolaSyncEventCreateInput;
};


export type MutationTransactionCreateMemberArgs = {
  data: MemberCreateInput;
};


export type MutationTransactionCreateMemberSettingsArgs = {
  data: MemberSettingsCreateInput;
};


export type MutationTransactionCreateMetricArgs = {
  data: MetricCreateInput;
};


export type MutationTransactionCreateMetricDataLabelArgs = {
  data: MetricDataLabelCreateInput;
};


export type MutationTransactionCreateMetricDataPointArgs = {
  data: MetricDataPointCreateInput;
};


export type MutationTransactionCreateMetricDataSetArgs = {
  data: MetricDataSetCreateInput;
};


export type MutationTransactionCreateMetricGoogleSheetsMappingArgs = {
  data: MetricGoogleSheetsMappingCreateInput;
};


export type MutationTransactionCreateMetricGoogleSheetsSheetArgs = {
  data: MetricGoogleSheetsSheetCreateInput;
};


export type MutationTransactionCreateMetricGoogleSheetsSourceArgs = {
  data: MetricGoogleSheetsSourceCreateInput;
};


export type MutationTransactionCreateMetricGoogleSheetsSpreadsheetArgs = {
  data: MetricGoogleSheetsSpreadsheetCreateInput;
};


export type MutationTransactionCreateMetricSourceArgs = {
  data: MetricSourceCreateInput;
};


export type MutationTransactionCreateMetricTemplateArgs = {
  data: MetricTemplateCreateInput;
};


export type MutationTransactionCreateOpportunityArgs = {
  data: OpportunityCreateInput;
};


export type MutationTransactionCreateOrganizationMetaArgs = {
  data: OrganizationMetaCreateInput;
};


export type MutationTransactionCreatePersonaArgs = {
  data: PersonaCreateInput;
};


export type MutationTransactionCreatePersonaBlockArgs = {
  data: PersonaBlockCreateInput;
};


export type MutationTransactionCreatePersonaBlockItemArgs = {
  data: PersonaBlockItemCreateInput;
};


export type MutationTransactionCreatePhaseArgs = {
  data: PhaseCreateInput;
};


export type MutationTransactionCreatePictureArgs = {
  data: PictureCreateInput;
};


export type MutationTransactionCreateTagArgs = {
  data: TagCreateInput;
};


export type MutationTransactionCreateTeamArgs = {
  data: TeamCreateInput;
};


export type MutationTransactionCreateTouchpointArgs = {
  data: TouchpointCreateInput;
};


export type MutationTransactionCreateWidgetArgs = {
  data: WidgetCreateInput;
};


export type MutationTransactionDeleteActionArgs = {
  by: ActionUniqueWhere;
  filter?: InputMaybe<ActionWhere>;
};


export type MutationTransactionDeleteActivityArgs = {
  by: ActivityUniqueWhere;
  filter?: InputMaybe<ActivityWhere>;
};


export type MutationTransactionDeleteActivityDurationArgs = {
  by: ActivityDurationUniqueWhere;
  filter?: InputMaybe<ActivityDurationWhere>;
};


export type MutationTransactionDeleteActivityWarningArgs = {
  by: ActivityWarningUniqueWhere;
  filter?: InputMaybe<ActivityWarningWhere>;
};


export type MutationTransactionDeleteContentMetricArgs = {
  by: ContentMetricUniqueWhere;
  filter?: InputMaybe<ContentMetricWhere>;
};


export type MutationTransactionDeleteContentMetricDataPointArgs = {
  by: ContentMetricDataPointUniqueWhere;
  filter?: InputMaybe<ContentMetricDataPointWhere>;
};


export type MutationTransactionDeleteControlCycleArgs = {
  by: ControlCycleUniqueWhere;
  filter?: InputMaybe<ControlCycleWhere>;
};


export type MutationTransactionDeleteControlCycleCheckArgs = {
  by: ControlCycleCheckUniqueWhere;
  filter?: InputMaybe<ControlCycleCheckWhere>;
};


export type MutationTransactionDeleteDashboardArgs = {
  by: DashboardUniqueWhere;
  filter?: InputMaybe<DashboardWhere>;
};


export type MutationTransactionDeleteDashboardJourneyArgs = {
  by: DashboardJourneyUniqueWhere;
  filter?: InputMaybe<DashboardJourneyWhere>;
};


export type MutationTransactionDeleteDashboardMetricArgs = {
  by: DashboardMetricUniqueWhere;
  filter?: InputMaybe<DashboardMetricWhere>;
};


export type MutationTransactionDeleteImageArgs = {
  by: ImageUniqueWhere;
  filter?: InputMaybe<ImageWhere>;
};


export type MutationTransactionDeleteJourneyArgs = {
  by: JourneyUniqueWhere;
  filter?: InputMaybe<JourneyWhere>;
};


export type MutationTransactionDeleteKeboolaSyncEventArgs = {
  by: KeboolaSyncEventUniqueWhere;
  filter?: InputMaybe<KeboolaSyncEventWhere>;
};


export type MutationTransactionDeleteMemberArgs = {
  by: MemberUniqueWhere;
  filter?: InputMaybe<MemberWhere>;
};


export type MutationTransactionDeleteMemberSettingsArgs = {
  by: MemberSettingsUniqueWhere;
  filter?: InputMaybe<MemberSettingsWhere>;
};


export type MutationTransactionDeleteMetricArgs = {
  by: MetricUniqueWhere;
  filter?: InputMaybe<MetricWhere>;
};


export type MutationTransactionDeleteMetricDataLabelArgs = {
  by: MetricDataLabelUniqueWhere;
  filter?: InputMaybe<MetricDataLabelWhere>;
};


export type MutationTransactionDeleteMetricDataPointArgs = {
  by: MetricDataPointUniqueWhere;
  filter?: InputMaybe<MetricDataPointWhere>;
};


export type MutationTransactionDeleteMetricDataSetArgs = {
  by: MetricDataSetUniqueWhere;
  filter?: InputMaybe<MetricDataSetWhere>;
};


export type MutationTransactionDeleteMetricGoogleSheetsMappingArgs = {
  by: MetricGoogleSheetsMappingUniqueWhere;
  filter?: InputMaybe<MetricGoogleSheetsMappingWhere>;
};


export type MutationTransactionDeleteMetricGoogleSheetsSheetArgs = {
  by: MetricGoogleSheetsSheetUniqueWhere;
  filter?: InputMaybe<MetricGoogleSheetsSheetWhere>;
};


export type MutationTransactionDeleteMetricGoogleSheetsSourceArgs = {
  by: MetricGoogleSheetsSourceUniqueWhere;
  filter?: InputMaybe<MetricGoogleSheetsSourceWhere>;
};


export type MutationTransactionDeleteMetricGoogleSheetsSpreadsheetArgs = {
  by: MetricGoogleSheetsSpreadsheetUniqueWhere;
  filter?: InputMaybe<MetricGoogleSheetsSpreadsheetWhere>;
};


export type MutationTransactionDeleteMetricSourceArgs = {
  by: MetricSourceUniqueWhere;
  filter?: InputMaybe<MetricSourceWhere>;
};


export type MutationTransactionDeleteMetricTemplateArgs = {
  by: MetricTemplateUniqueWhere;
  filter?: InputMaybe<MetricTemplateWhere>;
};


export type MutationTransactionDeleteOpportunityArgs = {
  by: OpportunityUniqueWhere;
  filter?: InputMaybe<OpportunityWhere>;
};


export type MutationTransactionDeleteOrganizationMetaArgs = {
  by: OrganizationMetaUniqueWhere;
  filter?: InputMaybe<OrganizationMetaWhere>;
};


export type MutationTransactionDeletePersonaArgs = {
  by: PersonaUniqueWhere;
  filter?: InputMaybe<PersonaWhere>;
};


export type MutationTransactionDeletePersonaBlockArgs = {
  by: PersonaBlockUniqueWhere;
  filter?: InputMaybe<PersonaBlockWhere>;
};


export type MutationTransactionDeletePersonaBlockItemArgs = {
  by: PersonaBlockItemUniqueWhere;
  filter?: InputMaybe<PersonaBlockItemWhere>;
};


export type MutationTransactionDeletePhaseArgs = {
  by: PhaseUniqueWhere;
  filter?: InputMaybe<PhaseWhere>;
};


export type MutationTransactionDeletePictureArgs = {
  by: PictureUniqueWhere;
  filter?: InputMaybe<PictureWhere>;
};


export type MutationTransactionDeleteTagArgs = {
  by: TagUniqueWhere;
  filter?: InputMaybe<TagWhere>;
};


export type MutationTransactionDeleteTeamArgs = {
  by: TeamUniqueWhere;
  filter?: InputMaybe<TeamWhere>;
};


export type MutationTransactionDeleteTouchpointArgs = {
  by: TouchpointUniqueWhere;
  filter?: InputMaybe<TouchpointWhere>;
};


export type MutationTransactionDeleteWidgetArgs = {
  by: WidgetUniqueWhere;
  filter?: InputMaybe<WidgetWhere>;
};


export type MutationTransactionUpdateActionArgs = {
  by: ActionUniqueWhere;
  data: ActionUpdateInput;
  filter?: InputMaybe<ActionWhere>;
};


export type MutationTransactionUpdateActivityArgs = {
  by: ActivityUniqueWhere;
  data: ActivityUpdateInput;
  filter?: InputMaybe<ActivityWhere>;
};


export type MutationTransactionUpdateActivityDurationArgs = {
  by: ActivityDurationUniqueWhere;
  data: ActivityDurationUpdateInput;
  filter?: InputMaybe<ActivityDurationWhere>;
};


export type MutationTransactionUpdateActivityWarningArgs = {
  by: ActivityWarningUniqueWhere;
  data: ActivityWarningUpdateInput;
  filter?: InputMaybe<ActivityWarningWhere>;
};


export type MutationTransactionUpdateContentMetricArgs = {
  by: ContentMetricUniqueWhere;
  data: ContentMetricUpdateInput;
  filter?: InputMaybe<ContentMetricWhere>;
};


export type MutationTransactionUpdateContentMetricDataPointArgs = {
  by: ContentMetricDataPointUniqueWhere;
  data: ContentMetricDataPointUpdateInput;
  filter?: InputMaybe<ContentMetricDataPointWhere>;
};


export type MutationTransactionUpdateControlCycleArgs = {
  by: ControlCycleUniqueWhere;
  data: ControlCycleUpdateInput;
  filter?: InputMaybe<ControlCycleWhere>;
};


export type MutationTransactionUpdateControlCycleCheckArgs = {
  by: ControlCycleCheckUniqueWhere;
  data: ControlCycleCheckUpdateInput;
  filter?: InputMaybe<ControlCycleCheckWhere>;
};


export type MutationTransactionUpdateDashboardArgs = {
  by: DashboardUniqueWhere;
  data: DashboardUpdateInput;
  filter?: InputMaybe<DashboardWhere>;
};


export type MutationTransactionUpdateDashboardJourneyArgs = {
  by: DashboardJourneyUniqueWhere;
  data: DashboardJourneyUpdateInput;
  filter?: InputMaybe<DashboardJourneyWhere>;
};


export type MutationTransactionUpdateDashboardMetricArgs = {
  by: DashboardMetricUniqueWhere;
  data: DashboardMetricUpdateInput;
  filter?: InputMaybe<DashboardMetricWhere>;
};


export type MutationTransactionUpdateImageArgs = {
  by: ImageUniqueWhere;
  data: ImageUpdateInput;
  filter?: InputMaybe<ImageWhere>;
};


export type MutationTransactionUpdateJourneyArgs = {
  by: JourneyUniqueWhere;
  data: JourneyUpdateInput;
  filter?: InputMaybe<JourneyWhere>;
};


export type MutationTransactionUpdateKeboolaSyncEventArgs = {
  by: KeboolaSyncEventUniqueWhere;
  data: KeboolaSyncEventUpdateInput;
  filter?: InputMaybe<KeboolaSyncEventWhere>;
};


export type MutationTransactionUpdateMemberArgs = {
  by: MemberUniqueWhere;
  data: MemberUpdateInput;
  filter?: InputMaybe<MemberWhere>;
};


export type MutationTransactionUpdateMemberSettingsArgs = {
  by: MemberSettingsUniqueWhere;
  data: MemberSettingsUpdateInput;
  filter?: InputMaybe<MemberSettingsWhere>;
};


export type MutationTransactionUpdateMetricArgs = {
  by: MetricUniqueWhere;
  data: MetricUpdateInput;
  filter?: InputMaybe<MetricWhere>;
};


export type MutationTransactionUpdateMetricDataLabelArgs = {
  by: MetricDataLabelUniqueWhere;
  data: MetricDataLabelUpdateInput;
  filter?: InputMaybe<MetricDataLabelWhere>;
};


export type MutationTransactionUpdateMetricDataPointArgs = {
  by: MetricDataPointUniqueWhere;
  data: MetricDataPointUpdateInput;
  filter?: InputMaybe<MetricDataPointWhere>;
};


export type MutationTransactionUpdateMetricDataSetArgs = {
  by: MetricDataSetUniqueWhere;
  data: MetricDataSetUpdateInput;
  filter?: InputMaybe<MetricDataSetWhere>;
};


export type MutationTransactionUpdateMetricGoogleSheetsMappingArgs = {
  by: MetricGoogleSheetsMappingUniqueWhere;
  data: MetricGoogleSheetsMappingUpdateInput;
  filter?: InputMaybe<MetricGoogleSheetsMappingWhere>;
};


export type MutationTransactionUpdateMetricGoogleSheetsSheetArgs = {
  by: MetricGoogleSheetsSheetUniqueWhere;
  data: MetricGoogleSheetsSheetUpdateInput;
  filter?: InputMaybe<MetricGoogleSheetsSheetWhere>;
};


export type MutationTransactionUpdateMetricGoogleSheetsSourceArgs = {
  by: MetricGoogleSheetsSourceUniqueWhere;
  data: MetricGoogleSheetsSourceUpdateInput;
  filter?: InputMaybe<MetricGoogleSheetsSourceWhere>;
};


export type MutationTransactionUpdateMetricGoogleSheetsSpreadsheetArgs = {
  by: MetricGoogleSheetsSpreadsheetUniqueWhere;
  data: MetricGoogleSheetsSpreadsheetUpdateInput;
  filter?: InputMaybe<MetricGoogleSheetsSpreadsheetWhere>;
};


export type MutationTransactionUpdateMetricSourceArgs = {
  by: MetricSourceUniqueWhere;
  data: MetricSourceUpdateInput;
  filter?: InputMaybe<MetricSourceWhere>;
};


export type MutationTransactionUpdateMetricTemplateArgs = {
  by: MetricTemplateUniqueWhere;
  data: MetricTemplateUpdateInput;
  filter?: InputMaybe<MetricTemplateWhere>;
};


export type MutationTransactionUpdateOpportunityArgs = {
  by: OpportunityUniqueWhere;
  data: OpportunityUpdateInput;
  filter?: InputMaybe<OpportunityWhere>;
};


export type MutationTransactionUpdateOrganizationMetaArgs = {
  by: OrganizationMetaUniqueWhere;
  data: OrganizationMetaUpdateInput;
  filter?: InputMaybe<OrganizationMetaWhere>;
};


export type MutationTransactionUpdatePersonaArgs = {
  by: PersonaUniqueWhere;
  data: PersonaUpdateInput;
  filter?: InputMaybe<PersonaWhere>;
};


export type MutationTransactionUpdatePersonaBlockArgs = {
  by: PersonaBlockUniqueWhere;
  data: PersonaBlockUpdateInput;
  filter?: InputMaybe<PersonaBlockWhere>;
};


export type MutationTransactionUpdatePersonaBlockItemArgs = {
  by: PersonaBlockItemUniqueWhere;
  data: PersonaBlockItemUpdateInput;
  filter?: InputMaybe<PersonaBlockItemWhere>;
};


export type MutationTransactionUpdatePhaseArgs = {
  by: PhaseUniqueWhere;
  data: PhaseUpdateInput;
  filter?: InputMaybe<PhaseWhere>;
};


export type MutationTransactionUpdatePictureArgs = {
  by: PictureUniqueWhere;
  data: PictureUpdateInput;
  filter?: InputMaybe<PictureWhere>;
};


export type MutationTransactionUpdateTagArgs = {
  by: TagUniqueWhere;
  data: TagUpdateInput;
  filter?: InputMaybe<TagWhere>;
};


export type MutationTransactionUpdateTeamArgs = {
  by: TeamUniqueWhere;
  data: TeamUpdateInput;
  filter?: InputMaybe<TeamWhere>;
};


export type MutationTransactionUpdateTouchpointArgs = {
  by: TouchpointUniqueWhere;
  data: TouchpointUpdateInput;
  filter?: InputMaybe<TouchpointWhere>;
};


export type MutationTransactionUpdateWidgetArgs = {
  by: WidgetUniqueWhere;
  data: WidgetUpdateInput;
  filter?: InputMaybe<WidgetWhere>;
};


export type MutationTransactionUpsertActionArgs = {
  by: ActionUniqueWhere;
  create: ActionCreateInput;
  filter?: InputMaybe<ActionWhere>;
  update: ActionUpdateInput;
};


export type MutationTransactionUpsertActivityArgs = {
  by: ActivityUniqueWhere;
  create: ActivityCreateInput;
  filter?: InputMaybe<ActivityWhere>;
  update: ActivityUpdateInput;
};


export type MutationTransactionUpsertActivityDurationArgs = {
  by: ActivityDurationUniqueWhere;
  create: ActivityDurationCreateInput;
  filter?: InputMaybe<ActivityDurationWhere>;
  update: ActivityDurationUpdateInput;
};


export type MutationTransactionUpsertActivityWarningArgs = {
  by: ActivityWarningUniqueWhere;
  create: ActivityWarningCreateInput;
  filter?: InputMaybe<ActivityWarningWhere>;
  update: ActivityWarningUpdateInput;
};


export type MutationTransactionUpsertContentMetricArgs = {
  by: ContentMetricUniqueWhere;
  create: ContentMetricCreateInput;
  filter?: InputMaybe<ContentMetricWhere>;
  update: ContentMetricUpdateInput;
};


export type MutationTransactionUpsertContentMetricDataPointArgs = {
  by: ContentMetricDataPointUniqueWhere;
  create: ContentMetricDataPointCreateInput;
  filter?: InputMaybe<ContentMetricDataPointWhere>;
  update: ContentMetricDataPointUpdateInput;
};


export type MutationTransactionUpsertControlCycleArgs = {
  by: ControlCycleUniqueWhere;
  create: ControlCycleCreateInput;
  filter?: InputMaybe<ControlCycleWhere>;
  update: ControlCycleUpdateInput;
};


export type MutationTransactionUpsertControlCycleCheckArgs = {
  by: ControlCycleCheckUniqueWhere;
  create: ControlCycleCheckCreateInput;
  filter?: InputMaybe<ControlCycleCheckWhere>;
  update: ControlCycleCheckUpdateInput;
};


export type MutationTransactionUpsertDashboardArgs = {
  by: DashboardUniqueWhere;
  create: DashboardCreateInput;
  filter?: InputMaybe<DashboardWhere>;
  update: DashboardUpdateInput;
};


export type MutationTransactionUpsertDashboardJourneyArgs = {
  by: DashboardJourneyUniqueWhere;
  create: DashboardJourneyCreateInput;
  filter?: InputMaybe<DashboardJourneyWhere>;
  update: DashboardJourneyUpdateInput;
};


export type MutationTransactionUpsertDashboardMetricArgs = {
  by: DashboardMetricUniqueWhere;
  create: DashboardMetricCreateInput;
  filter?: InputMaybe<DashboardMetricWhere>;
  update: DashboardMetricUpdateInput;
};


export type MutationTransactionUpsertImageArgs = {
  by: ImageUniqueWhere;
  create: ImageCreateInput;
  filter?: InputMaybe<ImageWhere>;
  update: ImageUpdateInput;
};


export type MutationTransactionUpsertJourneyArgs = {
  by: JourneyUniqueWhere;
  create: JourneyCreateInput;
  filter?: InputMaybe<JourneyWhere>;
  update: JourneyUpdateInput;
};


export type MutationTransactionUpsertKeboolaSyncEventArgs = {
  by: KeboolaSyncEventUniqueWhere;
  create: KeboolaSyncEventCreateInput;
  filter?: InputMaybe<KeboolaSyncEventWhere>;
  update: KeboolaSyncEventUpdateInput;
};


export type MutationTransactionUpsertMemberArgs = {
  by: MemberUniqueWhere;
  create: MemberCreateInput;
  filter?: InputMaybe<MemberWhere>;
  update: MemberUpdateInput;
};


export type MutationTransactionUpsertMemberSettingsArgs = {
  by: MemberSettingsUniqueWhere;
  create: MemberSettingsCreateInput;
  filter?: InputMaybe<MemberSettingsWhere>;
  update: MemberSettingsUpdateInput;
};


export type MutationTransactionUpsertMetricArgs = {
  by: MetricUniqueWhere;
  create: MetricCreateInput;
  filter?: InputMaybe<MetricWhere>;
  update: MetricUpdateInput;
};


export type MutationTransactionUpsertMetricDataLabelArgs = {
  by: MetricDataLabelUniqueWhere;
  create: MetricDataLabelCreateInput;
  filter?: InputMaybe<MetricDataLabelWhere>;
  update: MetricDataLabelUpdateInput;
};


export type MutationTransactionUpsertMetricDataPointArgs = {
  by: MetricDataPointUniqueWhere;
  create: MetricDataPointCreateInput;
  filter?: InputMaybe<MetricDataPointWhere>;
  update: MetricDataPointUpdateInput;
};


export type MutationTransactionUpsertMetricDataSetArgs = {
  by: MetricDataSetUniqueWhere;
  create: MetricDataSetCreateInput;
  filter?: InputMaybe<MetricDataSetWhere>;
  update: MetricDataSetUpdateInput;
};


export type MutationTransactionUpsertMetricGoogleSheetsMappingArgs = {
  by: MetricGoogleSheetsMappingUniqueWhere;
  create: MetricGoogleSheetsMappingCreateInput;
  filter?: InputMaybe<MetricGoogleSheetsMappingWhere>;
  update: MetricGoogleSheetsMappingUpdateInput;
};


export type MutationTransactionUpsertMetricGoogleSheetsSheetArgs = {
  by: MetricGoogleSheetsSheetUniqueWhere;
  create: MetricGoogleSheetsSheetCreateInput;
  filter?: InputMaybe<MetricGoogleSheetsSheetWhere>;
  update: MetricGoogleSheetsSheetUpdateInput;
};


export type MutationTransactionUpsertMetricGoogleSheetsSourceArgs = {
  by: MetricGoogleSheetsSourceUniqueWhere;
  create: MetricGoogleSheetsSourceCreateInput;
  filter?: InputMaybe<MetricGoogleSheetsSourceWhere>;
  update: MetricGoogleSheetsSourceUpdateInput;
};


export type MutationTransactionUpsertMetricGoogleSheetsSpreadsheetArgs = {
  by: MetricGoogleSheetsSpreadsheetUniqueWhere;
  create: MetricGoogleSheetsSpreadsheetCreateInput;
  filter?: InputMaybe<MetricGoogleSheetsSpreadsheetWhere>;
  update: MetricGoogleSheetsSpreadsheetUpdateInput;
};


export type MutationTransactionUpsertMetricSourceArgs = {
  by: MetricSourceUniqueWhere;
  create: MetricSourceCreateInput;
  filter?: InputMaybe<MetricSourceWhere>;
  update: MetricSourceUpdateInput;
};


export type MutationTransactionUpsertMetricTemplateArgs = {
  by: MetricTemplateUniqueWhere;
  create: MetricTemplateCreateInput;
  filter?: InputMaybe<MetricTemplateWhere>;
  update: MetricTemplateUpdateInput;
};


export type MutationTransactionUpsertOpportunityArgs = {
  by: OpportunityUniqueWhere;
  create: OpportunityCreateInput;
  filter?: InputMaybe<OpportunityWhere>;
  update: OpportunityUpdateInput;
};


export type MutationTransactionUpsertOrganizationMetaArgs = {
  by: OrganizationMetaUniqueWhere;
  create: OrganizationMetaCreateInput;
  filter?: InputMaybe<OrganizationMetaWhere>;
  update: OrganizationMetaUpdateInput;
};


export type MutationTransactionUpsertPersonaArgs = {
  by: PersonaUniqueWhere;
  create: PersonaCreateInput;
  filter?: InputMaybe<PersonaWhere>;
  update: PersonaUpdateInput;
};


export type MutationTransactionUpsertPersonaBlockArgs = {
  by: PersonaBlockUniqueWhere;
  create: PersonaBlockCreateInput;
  filter?: InputMaybe<PersonaBlockWhere>;
  update: PersonaBlockUpdateInput;
};


export type MutationTransactionUpsertPersonaBlockItemArgs = {
  by: PersonaBlockItemUniqueWhere;
  create: PersonaBlockItemCreateInput;
  filter?: InputMaybe<PersonaBlockItemWhere>;
  update: PersonaBlockItemUpdateInput;
};


export type MutationTransactionUpsertPhaseArgs = {
  by: PhaseUniqueWhere;
  create: PhaseCreateInput;
  filter?: InputMaybe<PhaseWhere>;
  update: PhaseUpdateInput;
};


export type MutationTransactionUpsertPictureArgs = {
  by: PictureUniqueWhere;
  create: PictureCreateInput;
  filter?: InputMaybe<PictureWhere>;
  update: PictureUpdateInput;
};


export type MutationTransactionUpsertTagArgs = {
  by: TagUniqueWhere;
  create: TagCreateInput;
  filter?: InputMaybe<TagWhere>;
  update: TagUpdateInput;
};


export type MutationTransactionUpsertTeamArgs = {
  by: TeamUniqueWhere;
  create: TeamCreateInput;
  filter?: InputMaybe<TeamWhere>;
  update: TeamUpdateInput;
};


export type MutationTransactionUpsertTouchpointArgs = {
  by: TouchpointUniqueWhere;
  create: TouchpointCreateInput;
  filter?: InputMaybe<TouchpointWhere>;
  update: TouchpointUpdateInput;
};


export type MutationTransactionUpsertWidgetArgs = {
  by: WidgetUniqueWhere;
  create: WidgetCreateInput;
  filter?: InputMaybe<WidgetWhere>;
  update: WidgetUpdateInput;
};

export type MutationTransactionOptions = {
  deferForeignKeyConstraints?: InputMaybe<Scalars['Boolean']['input']>;
  deferUniqueConstraints?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Opportunity = {
  __typename?: 'Opportunity';
  _meta?: Maybe<OpportunityMeta>;
  actions: Array<Action>;
  activities: Array<Activity>;
  benefit: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  journeys?: Maybe<Array<Journey>>;
  links?: Maybe<Scalars['Json']['output']>;
  name: Scalars['String']['output'];
  owner?: Maybe<Member>;
  paginateActions: ActionConnection;
  paginateActivities: ActivityConnection;
  paginateTags: TagConnection;
  solvedAt?: Maybe<Scalars['DateTime']['output']>;
  status: OpportunityStatus;
  tags: Array<Tag>;
};


export type OpportunityActionsArgs = {
  filter?: InputMaybe<ActionWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionOrderBy>>;
};


export type OpportunityActivitiesArgs = {
  filter?: InputMaybe<ActivityWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityOrderBy>>;
};


export type OpportunityOwnerArgs = {
  filter?: InputMaybe<MemberWhere>;
};


export type OpportunityPaginateActionsArgs = {
  filter?: InputMaybe<ActionWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type OpportunityPaginateActivitiesArgs = {
  filter?: InputMaybe<ActivityWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type OpportunityPaginateTagsArgs = {
  filter?: InputMaybe<TagWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type OpportunityTagsArgs = {
  filter?: InputMaybe<TagWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderBy>>;
};

export type OpportunityConnectOrCreateActionsRelationInput = {
  connect: ActionUniqueWhere;
  create: ActionWithoutOpportunitiesCreateInput;
};

export type OpportunityConnectOrCreateActivitiesRelationInput = {
  connect: ActivityUniqueWhere;
  create: ActivityWithoutOpportunitiesCreateInput;
};

export type OpportunityConnectOrCreateOwnerRelationInput = {
  connect: MemberUniqueWhere;
  create: MemberWithoutOpportunitiesCreateInput;
};

export type OpportunityConnectOrCreateTagsRelationInput = {
  connect: TagUniqueWhere;
  create: TagWithoutOpportunitiesCreateInput;
};

export type OpportunityConnection = {
  __typename?: 'OpportunityConnection';
  edges: Array<OpportunityEdge>;
  pageInfo: PageInfo;
};

export type OpportunityCreateActionsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ActionUniqueWhere>;
  connectOrCreate?: InputMaybe<OpportunityConnectOrCreateActionsRelationInput>;
  create?: InputMaybe<ActionWithoutOpportunitiesCreateInput>;
};

export type OpportunityCreateActivitiesEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ActivityUniqueWhere>;
  connectOrCreate?: InputMaybe<OpportunityConnectOrCreateActivitiesRelationInput>;
  create?: InputMaybe<ActivityWithoutOpportunitiesCreateInput>;
};

export type OpportunityCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<OpportunityCreateActionsEntityRelationInput>>;
  activities?: InputMaybe<Array<OpportunityCreateActivitiesEntityRelationInput>>;
  benefit?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<OpportunityCreateOwnerEntityRelationInput>;
  solvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<OpportunityStatus>;
  tags?: InputMaybe<Array<OpportunityCreateTagsEntityRelationInput>>;
};

export type OpportunityCreateOwnerEntityRelationInput = {
  connect?: InputMaybe<MemberUniqueWhere>;
  connectOrCreate?: InputMaybe<OpportunityConnectOrCreateOwnerRelationInput>;
  create?: InputMaybe<MemberWithoutOpportunitiesCreateInput>;
};

export type OpportunityCreateResult = MutationResult & {
  __typename?: 'OpportunityCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Opportunity>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type OpportunityCreateTagsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<TagUniqueWhere>;
  connectOrCreate?: InputMaybe<OpportunityConnectOrCreateTagsRelationInput>;
  create?: InputMaybe<TagWithoutOpportunitiesCreateInput>;
};

export type OpportunityDeleteResult = MutationResult & {
  __typename?: 'OpportunityDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Opportunity>;
  ok: Scalars['Boolean']['output'];
};

export type OpportunityEdge = {
  __typename?: 'OpportunityEdge';
  node: Opportunity;
};

export type OpportunityMeta = {
  __typename?: 'OpportunityMeta';
  actions?: Maybe<FieldMeta>;
  activities?: Maybe<FieldMeta>;
  benefit?: Maybe<FieldMeta>;
  createdAt?: Maybe<FieldMeta>;
  description?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  links?: Maybe<FieldMeta>;
  name?: Maybe<FieldMeta>;
  owner?: Maybe<FieldMeta>;
  solvedAt?: Maybe<FieldMeta>;
  status?: Maybe<FieldMeta>;
  tags?: Maybe<FieldMeta>;
};

export type OpportunityOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  benefit?: InputMaybe<OrderDirection>;
  createdAt?: InputMaybe<OrderDirection>;
  description?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  links?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  owner?: InputMaybe<MemberOrderBy>;
  solvedAt?: InputMaybe<OrderDirection>;
  status?: InputMaybe<OrderDirection>;
};

export type OpportunityStatus =
  | 'archived'
  | 'new'
  | 'open'
  | 'postponed'
  | 'resolved';

export type OpportunityStatusCondition = {
  and?: InputMaybe<Array<OpportunityStatusCondition>>;
  eq?: InputMaybe<OpportunityStatus>;
  gt?: InputMaybe<OpportunityStatus>;
  gte?: InputMaybe<OpportunityStatus>;
  in?: InputMaybe<Array<OpportunityStatus>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<OpportunityStatus>;
  lte?: InputMaybe<OpportunityStatus>;
  not?: InputMaybe<OpportunityStatusCondition>;
  notEq?: InputMaybe<OpportunityStatus>;
  notIn?: InputMaybe<Array<OpportunityStatus>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<OpportunityStatusCondition>>;
};

export type OpportunityUniqueWhere = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type OpportunityUpdateActionsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ActionUniqueWhere>;
  create?: InputMaybe<ActionWithoutOpportunitiesCreateInput>;
  delete?: InputMaybe<ActionUniqueWhere>;
  disconnect?: InputMaybe<ActionUniqueWhere>;
  update?: InputMaybe<OpportunityUpdateActionsRelationInput>;
  upsert?: InputMaybe<OpportunityUpsertActionsRelationInput>;
};

export type OpportunityUpdateActionsRelationInput = {
  by: ActionUniqueWhere;
  data: ActionWithoutOpportunitiesUpdateInput;
};

export type OpportunityUpdateActivitiesEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ActivityUniqueWhere>;
  create?: InputMaybe<ActivityWithoutOpportunitiesCreateInput>;
  delete?: InputMaybe<ActivityUniqueWhere>;
  disconnect?: InputMaybe<ActivityUniqueWhere>;
  update?: InputMaybe<OpportunityUpdateActivitiesRelationInput>;
  upsert?: InputMaybe<OpportunityUpsertActivitiesRelationInput>;
};

export type OpportunityUpdateActivitiesRelationInput = {
  by: ActivityUniqueWhere;
  data: ActivityWithoutOpportunitiesUpdateInput;
};

export type OpportunityUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<OpportunityUpdateActionsEntityRelationInput>>;
  activities?: InputMaybe<Array<OpportunityUpdateActivitiesEntityRelationInput>>;
  benefit?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<OpportunityUpdateOwnerEntityRelationInput>;
  solvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<OpportunityStatus>;
  tags?: InputMaybe<Array<OpportunityUpdateTagsEntityRelationInput>>;
};

export type OpportunityUpdateOwnerEntityRelationInput = {
  connect?: InputMaybe<MemberUniqueWhere>;
  connectOrCreate?: InputMaybe<OpportunityConnectOrCreateOwnerRelationInput>;
  create?: InputMaybe<MemberWithoutOpportunitiesCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<MemberWithoutOpportunitiesUpdateInput>;
  upsert?: InputMaybe<OpportunityUpsertOwnerRelationInput>;
};

export type OpportunityUpdateResult = MutationResult & {
  __typename?: 'OpportunityUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Opportunity>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type OpportunityUpdateTagsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<TagUniqueWhere>;
  create?: InputMaybe<TagWithoutOpportunitiesCreateInput>;
  delete?: InputMaybe<TagUniqueWhere>;
  disconnect?: InputMaybe<TagUniqueWhere>;
  update?: InputMaybe<OpportunityUpdateTagsRelationInput>;
  upsert?: InputMaybe<OpportunityUpsertTagsRelationInput>;
};

export type OpportunityUpdateTagsRelationInput = {
  by: TagUniqueWhere;
  data: TagWithoutOpportunitiesUpdateInput;
};

export type OpportunityUpsertActionsRelationInput = {
  by: ActionUniqueWhere;
  create: ActionWithoutOpportunitiesCreateInput;
  update: ActionWithoutOpportunitiesUpdateInput;
};

export type OpportunityUpsertActivitiesRelationInput = {
  by: ActivityUniqueWhere;
  create: ActivityWithoutOpportunitiesCreateInput;
  update: ActivityWithoutOpportunitiesUpdateInput;
};

export type OpportunityUpsertOwnerRelationInput = {
  create: MemberWithoutOpportunitiesCreateInput;
  update: MemberWithoutOpportunitiesUpdateInput;
};

export type OpportunityUpsertResult = MutationResult & {
  __typename?: 'OpportunityUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Opportunity>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type OpportunityUpsertTagsRelationInput = {
  by: TagUniqueWhere;
  create: TagWithoutOpportunitiesCreateInput;
  update: TagWithoutOpportunitiesUpdateInput;
};

export type OpportunityWhere = {
  actions?: InputMaybe<ActionWhere>;
  activities?: InputMaybe<ActivityWhere>;
  and?: InputMaybe<Array<InputMaybe<OpportunityWhere>>>;
  benefit?: InputMaybe<IntCondition>;
  createdAt?: InputMaybe<DateTimeCondition>;
  description?: InputMaybe<StringCondition>;
  id?: InputMaybe<UuidCondition>;
  links?: InputMaybe<JsonCondition>;
  name?: InputMaybe<StringCondition>;
  not?: InputMaybe<OpportunityWhere>;
  or?: InputMaybe<Array<InputMaybe<OpportunityWhere>>>;
  owner?: InputMaybe<MemberWhere>;
  solvedAt?: InputMaybe<DateTimeCondition>;
  status?: InputMaybe<OpportunityStatusCondition>;
  tags?: InputMaybe<TagWhere>;
};

export type OpportunityWithoutActionsCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activities?: InputMaybe<Array<OpportunityCreateActivitiesEntityRelationInput>>;
  benefit?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<OpportunityCreateOwnerEntityRelationInput>;
  solvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<OpportunityStatus>;
  tags?: InputMaybe<Array<OpportunityCreateTagsEntityRelationInput>>;
};

export type OpportunityWithoutActionsUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activities?: InputMaybe<Array<OpportunityUpdateActivitiesEntityRelationInput>>;
  benefit?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<OpportunityUpdateOwnerEntityRelationInput>;
  solvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<OpportunityStatus>;
  tags?: InputMaybe<Array<OpportunityUpdateTagsEntityRelationInput>>;
};

export type OpportunityWithoutActivitiesCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<OpportunityCreateActionsEntityRelationInput>>;
  benefit?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<OpportunityCreateOwnerEntityRelationInput>;
  solvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<OpportunityStatus>;
  tags?: InputMaybe<Array<OpportunityCreateTagsEntityRelationInput>>;
};

export type OpportunityWithoutActivitiesUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<OpportunityUpdateActionsEntityRelationInput>>;
  benefit?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<OpportunityUpdateOwnerEntityRelationInput>;
  solvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<OpportunityStatus>;
  tags?: InputMaybe<Array<OpportunityUpdateTagsEntityRelationInput>>;
};

export type OpportunityWithoutOwnerCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<OpportunityCreateActionsEntityRelationInput>>;
  activities?: InputMaybe<Array<OpportunityCreateActivitiesEntityRelationInput>>;
  benefit?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  solvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<OpportunityStatus>;
  tags?: InputMaybe<Array<OpportunityCreateTagsEntityRelationInput>>;
};

export type OpportunityWithoutOwnerUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<OpportunityUpdateActionsEntityRelationInput>>;
  activities?: InputMaybe<Array<OpportunityUpdateActivitiesEntityRelationInput>>;
  benefit?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  solvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<OpportunityStatus>;
  tags?: InputMaybe<Array<OpportunityUpdateTagsEntityRelationInput>>;
};

export type OpportunityWithoutTagsCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<OpportunityCreateActionsEntityRelationInput>>;
  activities?: InputMaybe<Array<OpportunityCreateActivitiesEntityRelationInput>>;
  benefit?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<OpportunityCreateOwnerEntityRelationInput>;
  solvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<OpportunityStatus>;
};

export type OpportunityWithoutTagsUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<OpportunityUpdateActionsEntityRelationInput>>;
  activities?: InputMaybe<Array<OpportunityUpdateActivitiesEntityRelationInput>>;
  benefit?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<OpportunityUpdateOwnerEntityRelationInput>;
  solvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<OpportunityStatus>;
};

export type OrderDirection =
  | 'asc'
  | 'ascNullsFirst'
  | 'desc'
  | 'descNullsLast';

export type OrganizationConfig = {
  alias?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationLicense =
  | 'expired'
  | 'full'
  | 'trial';

export type OrganizationLicenseCondition = {
  and?: InputMaybe<Array<OrganizationLicenseCondition>>;
  eq?: InputMaybe<OrganizationLicense>;
  gt?: InputMaybe<OrganizationLicense>;
  gte?: InputMaybe<OrganizationLicense>;
  in?: InputMaybe<Array<OrganizationLicense>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<OrganizationLicense>;
  lte?: InputMaybe<OrganizationLicense>;
  not?: InputMaybe<OrganizationLicenseCondition>;
  notEq?: InputMaybe<OrganizationLicense>;
  notIn?: InputMaybe<Array<OrganizationLicense>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<OrganizationLicenseCondition>>;
};

export type OrganizationMeta = {
  __typename?: 'OrganizationMeta';
  _meta?: Maybe<OrganizationMetaMeta>;
  createdAt: Scalars['DateTime']['output'];
  hubSpotCompanyId?: Maybe<Scalars['String']['output']>;
  hubSpotLastSync?: Maybe<Scalars['DateTime']['output']>;
  id: Singleton;
  keboolaProjectApiTokenId?: Maybe<Scalars['String']['output']>;
  keboolaProjectApiTokenValue?: Maybe<Scalars['String']['output']>;
  keboolaProjectId?: Maybe<Scalars['Int']['output']>;
  license: OrganizationLicense;
  paidEndDate?: Maybe<Scalars['DateTime']['output']>;
  paidMembers: Scalars['Int']['output'];
  paidStartDate?: Maybe<Scalars['DateTime']['output']>;
  status: OrganizationStatus;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  trialDaysLeft?: Maybe<Scalars['Int']['output']>;
  trialEndDate?: Maybe<Scalars['DateTime']['output']>;
  trialStartDate?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationMetaConnection = {
  __typename?: 'OrganizationMetaConnection';
  edges: Array<OrganizationMetaEdge>;
  pageInfo: PageInfo;
};

export type OrganizationMetaCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  hubSpotCompanyId?: InputMaybe<Scalars['String']['input']>;
  hubSpotLastSync?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Singleton>;
  keboolaProjectApiTokenId?: InputMaybe<Scalars['String']['input']>;
  keboolaProjectApiTokenValue?: InputMaybe<Scalars['String']['input']>;
  keboolaProjectId?: InputMaybe<Scalars['Int']['input']>;
  license?: InputMaybe<OrganizationLicense>;
  paidEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  paidMembers?: InputMaybe<Scalars['Int']['input']>;
  paidStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<OrganizationStatus>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  trialDaysLeft?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  trialStartDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrganizationMetaCreateResult = MutationResult & {
  __typename?: 'OrganizationMetaCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<OrganizationMeta>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type OrganizationMetaDeleteResult = MutationResult & {
  __typename?: 'OrganizationMetaDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<OrganizationMeta>;
  ok: Scalars['Boolean']['output'];
};

export type OrganizationMetaEdge = {
  __typename?: 'OrganizationMetaEdge';
  node: OrganizationMeta;
};

export type OrganizationMetaMeta = {
  __typename?: 'OrganizationMetaMeta';
  createdAt?: Maybe<FieldMeta>;
  hubSpotCompanyId?: Maybe<FieldMeta>;
  hubSpotLastSync?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  keboolaProjectApiTokenId?: Maybe<FieldMeta>;
  keboolaProjectApiTokenValue?: Maybe<FieldMeta>;
  keboolaProjectId?: Maybe<FieldMeta>;
  license?: Maybe<FieldMeta>;
  paidEndDate?: Maybe<FieldMeta>;
  paidMembers?: Maybe<FieldMeta>;
  paidStartDate?: Maybe<FieldMeta>;
  status?: Maybe<FieldMeta>;
  stripeCustomerId?: Maybe<FieldMeta>;
  trialDaysLeft?: Maybe<FieldMeta>;
  trialEndDate?: Maybe<FieldMeta>;
  trialStartDate?: Maybe<FieldMeta>;
};

export type OrganizationMetaOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<OrderDirection>;
  hubSpotCompanyId?: InputMaybe<OrderDirection>;
  hubSpotLastSync?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  keboolaProjectApiTokenId?: InputMaybe<OrderDirection>;
  keboolaProjectApiTokenValue?: InputMaybe<OrderDirection>;
  keboolaProjectId?: InputMaybe<OrderDirection>;
  license?: InputMaybe<OrderDirection>;
  paidEndDate?: InputMaybe<OrderDirection>;
  paidMembers?: InputMaybe<OrderDirection>;
  paidStartDate?: InputMaybe<OrderDirection>;
  status?: InputMaybe<OrderDirection>;
  stripeCustomerId?: InputMaybe<OrderDirection>;
  trialDaysLeft?: InputMaybe<OrderDirection>;
  trialEndDate?: InputMaybe<OrderDirection>;
  trialStartDate?: InputMaybe<OrderDirection>;
};

export type OrganizationMetaUniqueWhere = {
  id?: InputMaybe<Singleton>;
};

export type OrganizationMetaUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  hubSpotCompanyId?: InputMaybe<Scalars['String']['input']>;
  hubSpotLastSync?: InputMaybe<Scalars['DateTime']['input']>;
  keboolaProjectApiTokenId?: InputMaybe<Scalars['String']['input']>;
  keboolaProjectApiTokenValue?: InputMaybe<Scalars['String']['input']>;
  keboolaProjectId?: InputMaybe<Scalars['Int']['input']>;
  license?: InputMaybe<OrganizationLicense>;
  paidEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  paidMembers?: InputMaybe<Scalars['Int']['input']>;
  paidStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<OrganizationStatus>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  trialDaysLeft?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  trialStartDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrganizationMetaUpdateResult = MutationResult & {
  __typename?: 'OrganizationMetaUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<OrganizationMeta>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type OrganizationMetaUpsertResult = MutationResult & {
  __typename?: 'OrganizationMetaUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<OrganizationMeta>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type OrganizationMetaWhere = {
  and?: InputMaybe<Array<InputMaybe<OrganizationMetaWhere>>>;
  createdAt?: InputMaybe<DateTimeCondition>;
  hubSpotCompanyId?: InputMaybe<StringCondition>;
  hubSpotLastSync?: InputMaybe<DateTimeCondition>;
  id?: InputMaybe<SingletonCondition>;
  keboolaProjectApiTokenId?: InputMaybe<StringCondition>;
  keboolaProjectApiTokenValue?: InputMaybe<StringCondition>;
  keboolaProjectId?: InputMaybe<IntCondition>;
  license?: InputMaybe<OrganizationLicenseCondition>;
  not?: InputMaybe<OrganizationMetaWhere>;
  or?: InputMaybe<Array<InputMaybe<OrganizationMetaWhere>>>;
  paidEndDate?: InputMaybe<DateTimeCondition>;
  paidMembers?: InputMaybe<IntCondition>;
  paidStartDate?: InputMaybe<DateTimeCondition>;
  status?: InputMaybe<OrganizationStatusCondition>;
  stripeCustomerId?: InputMaybe<StringCondition>;
  trialDaysLeft?: InputMaybe<IntCondition>;
  trialEndDate?: InputMaybe<DateTimeCondition>;
  trialStartDate?: InputMaybe<DateTimeCondition>;
};

export type OrganizationStatus =
  | 'Ended'
  | 'Production'
  | 'Trial';

export type OrganizationStatusCondition = {
  and?: InputMaybe<Array<OrganizationStatusCondition>>;
  eq?: InputMaybe<OrganizationStatus>;
  gt?: InputMaybe<OrganizationStatus>;
  gte?: InputMaybe<OrganizationStatus>;
  in?: InputMaybe<Array<OrganizationStatus>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<OrganizationStatus>;
  lte?: InputMaybe<OrganizationStatus>;
  not?: InputMaybe<OrganizationStatusCondition>;
  notEq?: InputMaybe<OrganizationStatus>;
  notIn?: InputMaybe<Array<OrganizationStatus>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<OrganizationStatusCondition>>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  totalCount: Scalars['Int']['output'];
};

export type PaymentLink = {
  __typename?: 'PaymentLink';
  costPerMember?: Maybe<Scalars['Float']['output']>;
  costTotal?: Maybe<Scalars['Float']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  membersCount?: Maybe<Scalars['Int']['output']>;
};

export type PaymentPlan =
  | 'annual'
  | 'monthly';

export type Person = {
  __typename?: 'Person';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identity: Identity;
  name?: Maybe<Scalars['String']['output']>;
  otpEnabled: Scalars['Boolean']['output'];
};

export type Persona = {
  __typename?: 'Persona';
  _meta?: Maybe<PersonaMeta>;
  activities: Array<Activity>;
  age?: Maybe<Scalars['Int']['output']>;
  avatar?: Maybe<Image>;
  blocks: Array<PersonaBlock>;
  blocksByItems?: Maybe<PersonaBlock>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<PersonaGender>;
  id: Scalars['UUID']['output'];
  job?: Maybe<Scalars['String']['output']>;
  journeys?: Maybe<Array<Journey>>;
  location?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  paginateActivities: ActivityConnection;
  paginateBlocks: PersonaBlockConnection;
  quote?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PersonaStatus>;
};


export type PersonaActivitiesArgs = {
  filter?: InputMaybe<ActivityWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityOrderBy>>;
};


export type PersonaAvatarArgs = {
  filter?: InputMaybe<ImageWhere>;
};


export type PersonaBlocksArgs = {
  filter?: InputMaybe<PersonaBlockWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PersonaBlockOrderBy>>;
};


export type PersonaBlocksByItemsArgs = {
  by: PersonaBlocksByItemsUniqueWhere;
  filter?: InputMaybe<PersonaBlockWhere>;
};


export type PersonaPaginateActivitiesArgs = {
  filter?: InputMaybe<ActivityWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonaPaginateBlocksArgs = {
  filter?: InputMaybe<PersonaBlockWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PersonaBlockOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonaBlock = {
  __typename?: 'PersonaBlock';
  _meta?: Maybe<PersonaBlockMeta>;
  color: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  items: Array<PersonaBlockItem>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  paginateItems: PersonaBlockItemConnection;
  persona?: Maybe<Persona>;
};


export type PersonaBlockItemsArgs = {
  filter?: InputMaybe<PersonaBlockItemWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PersonaBlockItemOrderBy>>;
};


export type PersonaBlockPaginateItemsArgs = {
  filter?: InputMaybe<PersonaBlockItemWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PersonaBlockItemOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonaBlockPersonaArgs = {
  filter?: InputMaybe<PersonaWhere>;
};

export type PersonaBlockConnectOrCreateItemsRelationInput = {
  connect: PersonaBlockItemUniqueWhere;
  create: PersonaBlockItemWithoutBlockCreateInput;
};

export type PersonaBlockConnectOrCreatePersonaRelationInput = {
  connect: PersonaUniqueWhere;
  create: PersonaWithoutBlocksCreateInput;
};

export type PersonaBlockConnection = {
  __typename?: 'PersonaBlockConnection';
  edges: Array<PersonaBlockEdge>;
  pageInfo: PageInfo;
};

export type PersonaBlockCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  items?: InputMaybe<Array<PersonaBlockCreateItemsEntityRelationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  persona?: InputMaybe<PersonaBlockCreatePersonaEntityRelationInput>;
};

export type PersonaBlockCreateItemsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<PersonaBlockItemUniqueWhere>;
  connectOrCreate?: InputMaybe<PersonaBlockConnectOrCreateItemsRelationInput>;
  create?: InputMaybe<PersonaBlockItemWithoutBlockCreateInput>;
};

export type PersonaBlockCreatePersonaEntityRelationInput = {
  connect?: InputMaybe<PersonaUniqueWhere>;
  connectOrCreate?: InputMaybe<PersonaBlockConnectOrCreatePersonaRelationInput>;
  create?: InputMaybe<PersonaWithoutBlocksCreateInput>;
};

export type PersonaBlockCreateResult = MutationResult & {
  __typename?: 'PersonaBlockCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<PersonaBlock>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type PersonaBlockDeleteResult = MutationResult & {
  __typename?: 'PersonaBlockDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<PersonaBlock>;
  ok: Scalars['Boolean']['output'];
};

export type PersonaBlockEdge = {
  __typename?: 'PersonaBlockEdge';
  node: PersonaBlock;
};

export type PersonaBlockItem = {
  __typename?: 'PersonaBlockItem';
  _meta?: Maybe<PersonaBlockItemMeta>;
  block?: Maybe<PersonaBlock>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
};


export type PersonaBlockItemBlockArgs = {
  filter?: InputMaybe<PersonaBlockWhere>;
};

export type PersonaBlockItemConnectOrCreateBlockRelationInput = {
  connect: PersonaBlockUniqueWhere;
  create: PersonaBlockWithoutItemsCreateInput;
};

export type PersonaBlockItemConnection = {
  __typename?: 'PersonaBlockItemConnection';
  edges: Array<PersonaBlockItemEdge>;
  pageInfo: PageInfo;
};

export type PersonaBlockItemCreateBlockEntityRelationInput = {
  connect?: InputMaybe<PersonaBlockUniqueWhere>;
  connectOrCreate?: InputMaybe<PersonaBlockItemConnectOrCreateBlockRelationInput>;
  create?: InputMaybe<PersonaBlockWithoutItemsCreateInput>;
};

export type PersonaBlockItemCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  block?: InputMaybe<PersonaBlockItemCreateBlockEntityRelationInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonaBlockItemCreateResult = MutationResult & {
  __typename?: 'PersonaBlockItemCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<PersonaBlockItem>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type PersonaBlockItemDeleteResult = MutationResult & {
  __typename?: 'PersonaBlockItemDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<PersonaBlockItem>;
  ok: Scalars['Boolean']['output'];
};

export type PersonaBlockItemEdge = {
  __typename?: 'PersonaBlockItemEdge';
  node: PersonaBlockItem;
};

export type PersonaBlockItemMeta = {
  __typename?: 'PersonaBlockItemMeta';
  block?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  name?: Maybe<FieldMeta>;
  order?: Maybe<FieldMeta>;
  value?: Maybe<FieldMeta>;
};

export type PersonaBlockItemOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  block?: InputMaybe<PersonaBlockOrderBy>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  order?: InputMaybe<OrderDirection>;
  value?: InputMaybe<OrderDirection>;
};

export type PersonaBlockItemUniqueWhere = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type PersonaBlockItemUpdateBlockEntityRelationInput = {
  connect?: InputMaybe<PersonaBlockUniqueWhere>;
  connectOrCreate?: InputMaybe<PersonaBlockItemConnectOrCreateBlockRelationInput>;
  create?: InputMaybe<PersonaBlockWithoutItemsCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<PersonaBlockWithoutItemsUpdateInput>;
  upsert?: InputMaybe<PersonaBlockItemUpsertBlockRelationInput>;
};

export type PersonaBlockItemUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  block?: InputMaybe<PersonaBlockItemUpdateBlockEntityRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonaBlockItemUpdateResult = MutationResult & {
  __typename?: 'PersonaBlockItemUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<PersonaBlockItem>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type PersonaBlockItemUpsertBlockRelationInput = {
  create: PersonaBlockWithoutItemsCreateInput;
  update: PersonaBlockWithoutItemsUpdateInput;
};

export type PersonaBlockItemUpsertResult = MutationResult & {
  __typename?: 'PersonaBlockItemUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<PersonaBlockItem>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type PersonaBlockItemWhere = {
  and?: InputMaybe<Array<InputMaybe<PersonaBlockItemWhere>>>;
  block?: InputMaybe<PersonaBlockWhere>;
  id?: InputMaybe<UuidCondition>;
  name?: InputMaybe<StringCondition>;
  not?: InputMaybe<PersonaBlockItemWhere>;
  or?: InputMaybe<Array<InputMaybe<PersonaBlockItemWhere>>>;
  order?: InputMaybe<IntCondition>;
  value?: InputMaybe<IntCondition>;
};

export type PersonaBlockItemWithoutBlockCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonaBlockItemWithoutBlockUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonaBlockMeta = {
  __typename?: 'PersonaBlockMeta';
  color?: Maybe<FieldMeta>;
  description?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  items?: Maybe<FieldMeta>;
  name?: Maybe<FieldMeta>;
  order?: Maybe<FieldMeta>;
  persona?: Maybe<FieldMeta>;
};

export type PersonaBlockOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<OrderDirection>;
  description?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  order?: InputMaybe<OrderDirection>;
  persona?: InputMaybe<PersonaOrderBy>;
};

export type PersonaBlockUniqueWhere = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  items?: InputMaybe<PersonaBlockItemUniqueWhere>;
};

export type PersonaBlockUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<PersonaBlockUpdateItemsEntityRelationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  persona?: InputMaybe<PersonaBlockUpdatePersonaEntityRelationInput>;
};

export type PersonaBlockUpdateItemsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<PersonaBlockItemUniqueWhere>;
  create?: InputMaybe<PersonaBlockItemWithoutBlockCreateInput>;
  delete?: InputMaybe<PersonaBlockItemUniqueWhere>;
  disconnect?: InputMaybe<PersonaBlockItemUniqueWhere>;
  update?: InputMaybe<PersonaBlockUpdateItemsRelationInput>;
  upsert?: InputMaybe<PersonaBlockUpsertItemsRelationInput>;
};

export type PersonaBlockUpdateItemsRelationInput = {
  by: PersonaBlockItemUniqueWhere;
  data: PersonaBlockItemWithoutBlockUpdateInput;
};

export type PersonaBlockUpdatePersonaEntityRelationInput = {
  connect?: InputMaybe<PersonaUniqueWhere>;
  connectOrCreate?: InputMaybe<PersonaBlockConnectOrCreatePersonaRelationInput>;
  create?: InputMaybe<PersonaWithoutBlocksCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<PersonaWithoutBlocksUpdateInput>;
  upsert?: InputMaybe<PersonaBlockUpsertPersonaRelationInput>;
};

export type PersonaBlockUpdateResult = MutationResult & {
  __typename?: 'PersonaBlockUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<PersonaBlock>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type PersonaBlockUpsertItemsRelationInput = {
  by: PersonaBlockItemUniqueWhere;
  create: PersonaBlockItemWithoutBlockCreateInput;
  update: PersonaBlockItemWithoutBlockUpdateInput;
};

export type PersonaBlockUpsertPersonaRelationInput = {
  create: PersonaWithoutBlocksCreateInput;
  update: PersonaWithoutBlocksUpdateInput;
};

export type PersonaBlockUpsertResult = MutationResult & {
  __typename?: 'PersonaBlockUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<PersonaBlock>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type PersonaBlockWhere = {
  and?: InputMaybe<Array<InputMaybe<PersonaBlockWhere>>>;
  color?: InputMaybe<StringCondition>;
  description?: InputMaybe<StringCondition>;
  id?: InputMaybe<UuidCondition>;
  items?: InputMaybe<PersonaBlockItemWhere>;
  name?: InputMaybe<StringCondition>;
  not?: InputMaybe<PersonaBlockWhere>;
  or?: InputMaybe<Array<InputMaybe<PersonaBlockWhere>>>;
  order?: InputMaybe<IntCondition>;
  persona?: InputMaybe<PersonaWhere>;
};

export type PersonaBlockWithoutItemsCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  persona?: InputMaybe<PersonaBlockCreatePersonaEntityRelationInput>;
};

export type PersonaBlockWithoutItemsUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  persona?: InputMaybe<PersonaBlockUpdatePersonaEntityRelationInput>;
};

export type PersonaBlockWithoutPersonaCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  items?: InputMaybe<Array<PersonaBlockCreateItemsEntityRelationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonaBlockWithoutPersonaUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<PersonaBlockUpdateItemsEntityRelationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonaBlocksByItemsUniqueWhere = {
  items?: InputMaybe<PersonaBlockItemUniqueWhere>;
};

export type PersonaConnectOrCreateActivitiesRelationInput = {
  connect: ActivityUniqueWhere;
  create: ActivityWithoutPersonasCreateInput;
};

export type PersonaConnectOrCreateAvatarRelationInput = {
  connect: ImageUniqueWhere;
  create: ImageCreateInput;
};

export type PersonaConnectOrCreateBlocksRelationInput = {
  connect: PersonaBlockUniqueWhere;
  create: PersonaBlockWithoutPersonaCreateInput;
};

export type PersonaConnection = {
  __typename?: 'PersonaConnection';
  edges: Array<PersonaEdge>;
  pageInfo: PageInfo;
};

export type PersonaCreateActivitiesEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ActivityUniqueWhere>;
  connectOrCreate?: InputMaybe<PersonaConnectOrCreateActivitiesRelationInput>;
  create?: InputMaybe<ActivityWithoutPersonasCreateInput>;
};

export type PersonaCreateAvatarEntityRelationInput = {
  connect?: InputMaybe<ImageUniqueWhere>;
  connectOrCreate?: InputMaybe<PersonaConnectOrCreateAvatarRelationInput>;
  create?: InputMaybe<ImageCreateInput>;
};

export type PersonaCreateBlocksEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<PersonaBlockUniqueWhere>;
  connectOrCreate?: InputMaybe<PersonaConnectOrCreateBlocksRelationInput>;
  create?: InputMaybe<PersonaBlockWithoutPersonaCreateInput>;
};

export type PersonaCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activities?: InputMaybe<Array<PersonaCreateActivitiesEntityRelationInput>>;
  age?: InputMaybe<Scalars['Int']['input']>;
  avatar?: InputMaybe<PersonaCreateAvatarEntityRelationInput>;
  blocks?: InputMaybe<Array<PersonaCreateBlocksEntityRelationInput>>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<PersonaGender>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  job?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quote?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PersonaStatus>;
};

export type PersonaCreateResult = MutationResult & {
  __typename?: 'PersonaCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Persona>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type PersonaDeleteResult = MutationResult & {
  __typename?: 'PersonaDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Persona>;
  ok: Scalars['Boolean']['output'];
};

export type PersonaEdge = {
  __typename?: 'PersonaEdge';
  node: Persona;
};

export type PersonaGender =
  | 'female'
  | 'male';

export type PersonaGenderCondition = {
  and?: InputMaybe<Array<PersonaGenderCondition>>;
  eq?: InputMaybe<PersonaGender>;
  gt?: InputMaybe<PersonaGender>;
  gte?: InputMaybe<PersonaGender>;
  in?: InputMaybe<Array<PersonaGender>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<PersonaGender>;
  lte?: InputMaybe<PersonaGender>;
  not?: InputMaybe<PersonaGenderCondition>;
  notEq?: InputMaybe<PersonaGender>;
  notIn?: InputMaybe<Array<PersonaGender>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<PersonaGenderCondition>>;
};

export type PersonaMeta = {
  __typename?: 'PersonaMeta';
  activities?: Maybe<FieldMeta>;
  age?: Maybe<FieldMeta>;
  avatar?: Maybe<FieldMeta>;
  blocks?: Maybe<FieldMeta>;
  color?: Maybe<FieldMeta>;
  createdAt?: Maybe<FieldMeta>;
  description?: Maybe<FieldMeta>;
  gender?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  job?: Maybe<FieldMeta>;
  location?: Maybe<FieldMeta>;
  name?: Maybe<FieldMeta>;
  quote?: Maybe<FieldMeta>;
  status?: Maybe<FieldMeta>;
};

export type PersonaOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  age?: InputMaybe<OrderDirection>;
  avatar?: InputMaybe<ImageOrderBy>;
  color?: InputMaybe<OrderDirection>;
  createdAt?: InputMaybe<OrderDirection>;
  description?: InputMaybe<OrderDirection>;
  gender?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  job?: InputMaybe<OrderDirection>;
  location?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  quote?: InputMaybe<OrderDirection>;
  status?: InputMaybe<OrderDirection>;
};

export type PersonaStatus =
  | 'divorced'
  | 'married'
  | 'single'
  | 'widow';

export type PersonaStatusCondition = {
  and?: InputMaybe<Array<PersonaStatusCondition>>;
  eq?: InputMaybe<PersonaStatus>;
  gt?: InputMaybe<PersonaStatus>;
  gte?: InputMaybe<PersonaStatus>;
  in?: InputMaybe<Array<PersonaStatus>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<PersonaStatus>;
  lte?: InputMaybe<PersonaStatus>;
  not?: InputMaybe<PersonaStatusCondition>;
  notEq?: InputMaybe<PersonaStatus>;
  notIn?: InputMaybe<Array<PersonaStatus>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<PersonaStatusCondition>>;
};

export type PersonaUniqueWhere = {
  blocks?: InputMaybe<PersonaBlockUniqueWhere>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type PersonaUpdateActivitiesEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ActivityUniqueWhere>;
  create?: InputMaybe<ActivityWithoutPersonasCreateInput>;
  delete?: InputMaybe<ActivityUniqueWhere>;
  disconnect?: InputMaybe<ActivityUniqueWhere>;
  update?: InputMaybe<PersonaUpdateActivitiesRelationInput>;
  upsert?: InputMaybe<PersonaUpsertActivitiesRelationInput>;
};

export type PersonaUpdateActivitiesRelationInput = {
  by: ActivityUniqueWhere;
  data: ActivityWithoutPersonasUpdateInput;
};

export type PersonaUpdateAvatarEntityRelationInput = {
  connect?: InputMaybe<ImageUniqueWhere>;
  connectOrCreate?: InputMaybe<PersonaConnectOrCreateAvatarRelationInput>;
  create?: InputMaybe<ImageCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<ImageUpdateInput>;
  upsert?: InputMaybe<PersonaUpsertAvatarRelationInput>;
};

export type PersonaUpdateBlocksEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<PersonaBlockUniqueWhere>;
  create?: InputMaybe<PersonaBlockWithoutPersonaCreateInput>;
  delete?: InputMaybe<PersonaBlockUniqueWhere>;
  disconnect?: InputMaybe<PersonaBlockUniqueWhere>;
  update?: InputMaybe<PersonaUpdateBlocksRelationInput>;
  upsert?: InputMaybe<PersonaUpsertBlocksRelationInput>;
};

export type PersonaUpdateBlocksRelationInput = {
  by: PersonaBlockUniqueWhere;
  data: PersonaBlockWithoutPersonaUpdateInput;
};

export type PersonaUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activities?: InputMaybe<Array<PersonaUpdateActivitiesEntityRelationInput>>;
  age?: InputMaybe<Scalars['Int']['input']>;
  avatar?: InputMaybe<PersonaUpdateAvatarEntityRelationInput>;
  blocks?: InputMaybe<Array<PersonaUpdateBlocksEntityRelationInput>>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<PersonaGender>;
  job?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quote?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PersonaStatus>;
};

export type PersonaUpdateResult = MutationResult & {
  __typename?: 'PersonaUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Persona>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type PersonaUpsertActivitiesRelationInput = {
  by: ActivityUniqueWhere;
  create: ActivityWithoutPersonasCreateInput;
  update: ActivityWithoutPersonasUpdateInput;
};

export type PersonaUpsertAvatarRelationInput = {
  create: ImageCreateInput;
  update: ImageUpdateInput;
};

export type PersonaUpsertBlocksRelationInput = {
  by: PersonaBlockUniqueWhere;
  create: PersonaBlockWithoutPersonaCreateInput;
  update: PersonaBlockWithoutPersonaUpdateInput;
};

export type PersonaUpsertResult = MutationResult & {
  __typename?: 'PersonaUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Persona>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type PersonaWhere = {
  activities?: InputMaybe<ActivityWhere>;
  age?: InputMaybe<IntCondition>;
  and?: InputMaybe<Array<InputMaybe<PersonaWhere>>>;
  avatar?: InputMaybe<ImageWhere>;
  blocks?: InputMaybe<PersonaBlockWhere>;
  color?: InputMaybe<StringCondition>;
  createdAt?: InputMaybe<DateTimeCondition>;
  description?: InputMaybe<StringCondition>;
  gender?: InputMaybe<PersonaGenderCondition>;
  id?: InputMaybe<UuidCondition>;
  job?: InputMaybe<StringCondition>;
  location?: InputMaybe<StringCondition>;
  name?: InputMaybe<StringCondition>;
  not?: InputMaybe<PersonaWhere>;
  or?: InputMaybe<Array<InputMaybe<PersonaWhere>>>;
  quote?: InputMaybe<StringCondition>;
  status?: InputMaybe<PersonaStatusCondition>;
};

export type PersonaWithoutActivitiesCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  avatar?: InputMaybe<PersonaCreateAvatarEntityRelationInput>;
  blocks?: InputMaybe<Array<PersonaCreateBlocksEntityRelationInput>>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<PersonaGender>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  job?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quote?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PersonaStatus>;
};

export type PersonaWithoutActivitiesUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  avatar?: InputMaybe<PersonaUpdateAvatarEntityRelationInput>;
  blocks?: InputMaybe<Array<PersonaUpdateBlocksEntityRelationInput>>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<PersonaGender>;
  job?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quote?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PersonaStatus>;
};

export type PersonaWithoutBlocksCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activities?: InputMaybe<Array<PersonaCreateActivitiesEntityRelationInput>>;
  age?: InputMaybe<Scalars['Int']['input']>;
  avatar?: InputMaybe<PersonaCreateAvatarEntityRelationInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<PersonaGender>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  job?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quote?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PersonaStatus>;
};

export type PersonaWithoutBlocksUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activities?: InputMaybe<Array<PersonaUpdateActivitiesEntityRelationInput>>;
  age?: InputMaybe<Scalars['Int']['input']>;
  avatar?: InputMaybe<PersonaUpdateAvatarEntityRelationInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<PersonaGender>;
  job?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quote?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PersonaStatus>;
};

export type Phase = {
  __typename?: 'Phase';
  _meta?: Maybe<PhaseMeta>;
  contentMetrics: Array<ContentMetric>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  journey?: Maybe<Journey>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  paginateContentMetrics: ContentMetricConnection;
  paginateTouchpoints: TouchpointConnection;
  touchpoints: Array<Touchpoint>;
  touchpointsByActivity?: Maybe<Touchpoint>;
};


export type PhaseContentMetricsArgs = {
  filter?: InputMaybe<ContentMetricWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentMetricOrderBy>>;
};


export type PhaseJourneyArgs = {
  filter?: InputMaybe<JourneyWhere>;
};


export type PhasePaginateContentMetricsArgs = {
  filter?: InputMaybe<ContentMetricWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentMetricOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type PhasePaginateTouchpointsArgs = {
  filter?: InputMaybe<TouchpointWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TouchpointOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type PhaseTouchpointsArgs = {
  filter?: InputMaybe<TouchpointWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TouchpointOrderBy>>;
};


export type PhaseTouchpointsByActivityArgs = {
  by: PhaseTouchpointsByActivityUniqueWhere;
  filter?: InputMaybe<TouchpointWhere>;
};

export type PhaseConnectOrCreateContentMetricsRelationInput = {
  connect: ContentMetricUniqueWhere;
  create: ContentMetricCreateInput;
};

export type PhaseConnectOrCreateJourneyRelationInput = {
  connect: JourneyUniqueWhere;
  create: JourneyWithoutPhasesCreateInput;
};

export type PhaseConnectOrCreateTouchpointsRelationInput = {
  connect: TouchpointUniqueWhere;
  create: TouchpointWithoutPhaseCreateInput;
};

export type PhaseConnection = {
  __typename?: 'PhaseConnection';
  edges: Array<PhaseEdge>;
  pageInfo: PageInfo;
};

export type PhaseCreateContentMetricsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ContentMetricUniqueWhere>;
  connectOrCreate?: InputMaybe<PhaseConnectOrCreateContentMetricsRelationInput>;
  create?: InputMaybe<ContentMetricCreateInput>;
};

export type PhaseCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  contentMetrics?: InputMaybe<Array<PhaseCreateContentMetricsEntityRelationInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  journey?: InputMaybe<PhaseCreateJourneyEntityRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  touchpoints?: InputMaybe<Array<PhaseCreateTouchpointsEntityRelationInput>>;
};

export type PhaseCreateJourneyEntityRelationInput = {
  connect?: InputMaybe<JourneyUniqueWhere>;
  connectOrCreate?: InputMaybe<PhaseConnectOrCreateJourneyRelationInput>;
  create?: InputMaybe<JourneyWithoutPhasesCreateInput>;
};

export type PhaseCreateResult = MutationResult & {
  __typename?: 'PhaseCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Phase>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type PhaseCreateTouchpointsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<TouchpointUniqueWhere>;
  connectOrCreate?: InputMaybe<PhaseConnectOrCreateTouchpointsRelationInput>;
  create?: InputMaybe<TouchpointWithoutPhaseCreateInput>;
};

export type PhaseDeleteResult = MutationResult & {
  __typename?: 'PhaseDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Phase>;
  ok: Scalars['Boolean']['output'];
};

export type PhaseEdge = {
  __typename?: 'PhaseEdge';
  node: Phase;
};

export type PhaseMeta = {
  __typename?: 'PhaseMeta';
  contentMetrics?: Maybe<FieldMeta>;
  createdAt?: Maybe<FieldMeta>;
  description?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  journey?: Maybe<FieldMeta>;
  name?: Maybe<FieldMeta>;
  order?: Maybe<FieldMeta>;
  touchpoints?: Maybe<FieldMeta>;
};

export type PhaseOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<OrderDirection>;
  description?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  journey?: InputMaybe<JourneyOrderBy>;
  name?: InputMaybe<OrderDirection>;
  order?: InputMaybe<OrderDirection>;
};

export type PhaseTouchpointsByActivityUniqueWhere = {
  activity?: InputMaybe<ActivityUniqueWhere>;
};

export type PhaseUniqueWhere = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  touchpoints?: InputMaybe<TouchpointUniqueWhere>;
};

export type PhaseUpdateContentMetricsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ContentMetricUniqueWhere>;
  create?: InputMaybe<ContentMetricCreateInput>;
  delete?: InputMaybe<ContentMetricUniqueWhere>;
  disconnect?: InputMaybe<ContentMetricUniqueWhere>;
  update?: InputMaybe<PhaseUpdateContentMetricsRelationInput>;
  upsert?: InputMaybe<PhaseUpsertContentMetricsRelationInput>;
};

export type PhaseUpdateContentMetricsRelationInput = {
  by: ContentMetricUniqueWhere;
  data: ContentMetricUpdateInput;
};

export type PhaseUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  contentMetrics?: InputMaybe<Array<PhaseUpdateContentMetricsEntityRelationInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  journey?: InputMaybe<PhaseUpdateJourneyEntityRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  touchpoints?: InputMaybe<Array<PhaseUpdateTouchpointsEntityRelationInput>>;
};

export type PhaseUpdateJourneyEntityRelationInput = {
  connect?: InputMaybe<JourneyUniqueWhere>;
  connectOrCreate?: InputMaybe<PhaseConnectOrCreateJourneyRelationInput>;
  create?: InputMaybe<JourneyWithoutPhasesCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<JourneyWithoutPhasesUpdateInput>;
  upsert?: InputMaybe<PhaseUpsertJourneyRelationInput>;
};

export type PhaseUpdateResult = MutationResult & {
  __typename?: 'PhaseUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Phase>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type PhaseUpdateTouchpointsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<TouchpointUniqueWhere>;
  create?: InputMaybe<TouchpointWithoutPhaseCreateInput>;
  delete?: InputMaybe<TouchpointUniqueWhere>;
  disconnect?: InputMaybe<TouchpointUniqueWhere>;
  update?: InputMaybe<PhaseUpdateTouchpointsRelationInput>;
  upsert?: InputMaybe<PhaseUpsertTouchpointsRelationInput>;
};

export type PhaseUpdateTouchpointsRelationInput = {
  by: TouchpointUniqueWhere;
  data: TouchpointWithoutPhaseUpdateInput;
};

export type PhaseUpsertContentMetricsRelationInput = {
  by: ContentMetricUniqueWhere;
  create: ContentMetricCreateInput;
  update: ContentMetricUpdateInput;
};

export type PhaseUpsertJourneyRelationInput = {
  create: JourneyWithoutPhasesCreateInput;
  update: JourneyWithoutPhasesUpdateInput;
};

export type PhaseUpsertResult = MutationResult & {
  __typename?: 'PhaseUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Phase>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type PhaseUpsertTouchpointsRelationInput = {
  by: TouchpointUniqueWhere;
  create: TouchpointWithoutPhaseCreateInput;
  update: TouchpointWithoutPhaseUpdateInput;
};

export type PhaseWhere = {
  and?: InputMaybe<Array<InputMaybe<PhaseWhere>>>;
  contentMetrics?: InputMaybe<ContentMetricWhere>;
  createdAt?: InputMaybe<DateTimeCondition>;
  description?: InputMaybe<StringCondition>;
  id?: InputMaybe<UuidCondition>;
  journey?: InputMaybe<JourneyWhere>;
  name?: InputMaybe<StringCondition>;
  not?: InputMaybe<PhaseWhere>;
  or?: InputMaybe<Array<InputMaybe<PhaseWhere>>>;
  order?: InputMaybe<IntCondition>;
  touchpoints?: InputMaybe<TouchpointWhere>;
};

export type PhaseWithoutJourneyCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  contentMetrics?: InputMaybe<Array<PhaseCreateContentMetricsEntityRelationInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  touchpoints?: InputMaybe<Array<PhaseCreateTouchpointsEntityRelationInput>>;
};

export type PhaseWithoutJourneyUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  contentMetrics?: InputMaybe<Array<PhaseUpdateContentMetricsEntityRelationInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  touchpoints?: InputMaybe<Array<PhaseUpdateTouchpointsEntityRelationInput>>;
};

export type PhaseWithoutTouchpointsCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  contentMetrics?: InputMaybe<Array<PhaseCreateContentMetricsEntityRelationInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  journey?: InputMaybe<PhaseCreateJourneyEntityRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type PhaseWithoutTouchpointsUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  contentMetrics?: InputMaybe<Array<PhaseUpdateContentMetricsEntityRelationInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  journey?: InputMaybe<PhaseUpdateJourneyEntityRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type Picture = {
  __typename?: 'Picture';
  _meta?: Maybe<PictureMeta>;
  activity?: Maybe<Activity>;
  id: Scalars['UUID']['output'];
  image?: Maybe<Image>;
  order: Scalars['Int']['output'];
};


export type PictureActivityArgs = {
  filter?: InputMaybe<ActivityWhere>;
};


export type PictureImageArgs = {
  filter?: InputMaybe<ImageWhere>;
};

export type PictureConnectOrCreateActivityRelationInput = {
  connect: ActivityUniqueWhere;
  create: ActivityWithoutPicturesCreateInput;
};

export type PictureConnectOrCreateImageRelationInput = {
  connect: ImageUniqueWhere;
  create: ImageCreateInput;
};

export type PictureConnection = {
  __typename?: 'PictureConnection';
  edges: Array<PictureEdge>;
  pageInfo: PageInfo;
};

export type PictureCreateActivityEntityRelationInput = {
  connect?: InputMaybe<ActivityUniqueWhere>;
  connectOrCreate?: InputMaybe<PictureConnectOrCreateActivityRelationInput>;
  create?: InputMaybe<ActivityWithoutPicturesCreateInput>;
};

export type PictureCreateImageEntityRelationInput = {
  connect?: InputMaybe<ImageUniqueWhere>;
  connectOrCreate?: InputMaybe<PictureConnectOrCreateImageRelationInput>;
  create?: InputMaybe<ImageCreateInput>;
};

export type PictureCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activity?: InputMaybe<PictureCreateActivityEntityRelationInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  image?: InputMaybe<PictureCreateImageEntityRelationInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type PictureCreateResult = MutationResult & {
  __typename?: 'PictureCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Picture>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type PictureDeleteResult = MutationResult & {
  __typename?: 'PictureDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Picture>;
  ok: Scalars['Boolean']['output'];
};

export type PictureEdge = {
  __typename?: 'PictureEdge';
  node: Picture;
};

export type PictureMeta = {
  __typename?: 'PictureMeta';
  activity?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  image?: Maybe<FieldMeta>;
  order?: Maybe<FieldMeta>;
};

export type PictureOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  activity?: InputMaybe<ActivityOrderBy>;
  id?: InputMaybe<OrderDirection>;
  image?: InputMaybe<ImageOrderBy>;
  order?: InputMaybe<OrderDirection>;
};

export type PictureUniqueWhere = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  image?: InputMaybe<ImageUniqueWhere>;
};

export type PictureUpdateActivityEntityRelationInput = {
  connect?: InputMaybe<ActivityUniqueWhere>;
  connectOrCreate?: InputMaybe<PictureConnectOrCreateActivityRelationInput>;
  create?: InputMaybe<ActivityWithoutPicturesCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<ActivityWithoutPicturesUpdateInput>;
  upsert?: InputMaybe<PictureUpsertActivityRelationInput>;
};

export type PictureUpdateImageEntityRelationInput = {
  connect?: InputMaybe<ImageUniqueWhere>;
  connectOrCreate?: InputMaybe<PictureConnectOrCreateImageRelationInput>;
  create?: InputMaybe<ImageCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<ImageUpdateInput>;
  upsert?: InputMaybe<PictureUpsertImageRelationInput>;
};

export type PictureUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activity?: InputMaybe<PictureUpdateActivityEntityRelationInput>;
  image?: InputMaybe<PictureUpdateImageEntityRelationInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type PictureUpdateResult = MutationResult & {
  __typename?: 'PictureUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Picture>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type PictureUpsertActivityRelationInput = {
  create: ActivityWithoutPicturesCreateInput;
  update: ActivityWithoutPicturesUpdateInput;
};

export type PictureUpsertImageRelationInput = {
  create: ImageCreateInput;
  update: ImageUpdateInput;
};

export type PictureUpsertResult = MutationResult & {
  __typename?: 'PictureUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Picture>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type PictureWhere = {
  activity?: InputMaybe<ActivityWhere>;
  and?: InputMaybe<Array<InputMaybe<PictureWhere>>>;
  id?: InputMaybe<UuidCondition>;
  image?: InputMaybe<ImageWhere>;
  not?: InputMaybe<PictureWhere>;
  or?: InputMaybe<Array<InputMaybe<PictureWhere>>>;
  order?: InputMaybe<IntCondition>;
};

export type PictureWithoutActivityCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  image?: InputMaybe<PictureCreateImageEntityRelationInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type PictureWithoutActivityUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<PictureUpdateImageEntityRelationInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type PrepareOtpResponse = {
  __typename?: 'PrepareOtpResponse';
  ok: Scalars['Boolean']['output'];
  result?: Maybe<PrepareOtpResult>;
};

export type PrepareOtpResult = {
  __typename?: 'PrepareOtpResult';
  otpSecret: Scalars['String']['output'];
  otpUri: Scalars['String']['output'];
};

export type Project = {
  __typename?: 'Project';
  config: Scalars['Json']['output'];
  id: Scalars['String']['output'];
  members: Array<ProjectIdentityRelation>;
  name: Scalars['String']['output'];
  roles: Array<RoleDefinition>;
  slug: Scalars['String']['output'];
};


export type ProjectMembersArgs = {
  input?: InputMaybe<ProjectMembersInput>;
};

export type ProjectIdentityRelation = {
  __typename?: 'ProjectIdentityRelation';
  identity: Identity;
  memberships: Array<Membership>;
};

export type ProjectMembersFilter = {
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  identityId?: InputMaybe<Array<Scalars['String']['input']>>;
  memberType?: InputMaybe<MemberType>;
  personId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProjectMembersInput = {
  filter?: InputMaybe<ProjectMembersFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectSecret = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  _info?: Maybe<Info>;
  _service: _Service;
  announcements: Array<Announcement>;
  displayMetric?: Maybe<DisplayMetric>;
  getAction?: Maybe<Action>;
  getActivity?: Maybe<Activity>;
  getActivityDuration?: Maybe<ActivityDuration>;
  getActivityWarning?: Maybe<ActivityWarning>;
  getContentMetric?: Maybe<ContentMetric>;
  getContentMetricDataPoint?: Maybe<ContentMetricDataPoint>;
  getControlCycle?: Maybe<ControlCycle>;
  getControlCycleCheck?: Maybe<ControlCycleCheck>;
  getDashboard?: Maybe<Dashboard>;
  getDashboardJourney?: Maybe<DashboardJourney>;
  getDashboardMetric?: Maybe<DashboardMetric>;
  getImage?: Maybe<Image>;
  getJourney?: Maybe<Journey>;
  getKeboolaSyncEvent?: Maybe<KeboolaSyncEvent>;
  getMember?: Maybe<Member>;
  getMemberSettings?: Maybe<MemberSettings>;
  getMetric?: Maybe<Metric>;
  getMetricDataLabel?: Maybe<MetricDataLabel>;
  getMetricDataPoint?: Maybe<MetricDataPoint>;
  getMetricDataSet?: Maybe<MetricDataSet>;
  getMetricGoogleSheetsMapping?: Maybe<MetricGoogleSheetsMapping>;
  getMetricGoogleSheetsSheet?: Maybe<MetricGoogleSheetsSheet>;
  getMetricGoogleSheetsSource?: Maybe<MetricGoogleSheetsSource>;
  getMetricGoogleSheetsSpreadsheet?: Maybe<MetricGoogleSheetsSpreadsheet>;
  getMetricSource?: Maybe<MetricSource>;
  getMetricTemplate?: Maybe<MetricTemplate>;
  getOpportunity?: Maybe<Opportunity>;
  getOrganizationMeta?: Maybe<OrganizationMeta>;
  getPersona?: Maybe<Persona>;
  getPersonaBlock?: Maybe<PersonaBlock>;
  getPersonaBlockItem?: Maybe<PersonaBlockItem>;
  getPhase?: Maybe<Phase>;
  getPicture?: Maybe<Picture>;
  getTag?: Maybe<Tag>;
  getTeam?: Maybe<Team>;
  getTouchpoint?: Maybe<Touchpoint>;
  getWidget?: Maybe<Widget>;
  googleSheetsConfiguration?: Maybe<GoogleSheetsConfiguration>;
  googleSpreadsheetSheets?: Maybe<GoogleSpreadsheetSheets>;
  heartbeat: Scalars['String']['output'];
  listAction: Array<Action>;
  listActivity: Array<Activity>;
  listActivityDuration: Array<ActivityDuration>;
  listActivityWarning: Array<ActivityWarning>;
  listContentMetric: Array<ContentMetric>;
  listContentMetricDataPoint: Array<ContentMetricDataPoint>;
  listControlCycle: Array<ControlCycle>;
  listControlCycleCheck: Array<ControlCycleCheck>;
  listDashboard: Array<Dashboard>;
  listDashboardJourney: Array<DashboardJourney>;
  listDashboardMetric: Array<DashboardMetric>;
  listImage: Array<Image>;
  listJourney: Array<Journey>;
  listKeboolaSyncEvent: Array<KeboolaSyncEvent>;
  listMember: Array<Member>;
  listMemberSettings: Array<MemberSettings>;
  listMetric: Array<Metric>;
  listMetricDataLabel: Array<MetricDataLabel>;
  listMetricDataPoint: Array<MetricDataPoint>;
  listMetricDataSet: Array<MetricDataSet>;
  listMetricGoogleSheetsMapping: Array<MetricGoogleSheetsMapping>;
  listMetricGoogleSheetsSheet: Array<MetricGoogleSheetsSheet>;
  listMetricGoogleSheetsSource: Array<MetricGoogleSheetsSource>;
  listMetricGoogleSheetsSpreadsheet: Array<MetricGoogleSheetsSpreadsheet>;
  listMetricSource: Array<MetricSource>;
  listMetricTemplate: Array<MetricTemplate>;
  listOpportunity: Array<Opportunity>;
  listOrganizationMeta: Array<OrganizationMeta>;
  listPersona: Array<Persona>;
  listPersonaBlock: Array<PersonaBlock>;
  listPersonaBlockItem: Array<PersonaBlockItem>;
  listPhase: Array<Phase>;
  listPicture: Array<Picture>;
  listTag: Array<Tag>;
  listTeam: Array<Team>;
  listTouchpoint: Array<Touchpoint>;
  listWidget: Array<Widget>;
  me: Member;
  paginateAction: ActionConnection;
  paginateActivity: ActivityConnection;
  paginateActivityDuration: ActivityDurationConnection;
  paginateActivityWarning: ActivityWarningConnection;
  paginateContentMetric: ContentMetricConnection;
  paginateContentMetricDataPoint: ContentMetricDataPointConnection;
  paginateControlCycle: ControlCycleConnection;
  paginateControlCycleCheck: ControlCycleCheckConnection;
  paginateDashboard: DashboardConnection;
  paginateDashboardJourney: DashboardJourneyConnection;
  paginateDashboardMetric: DashboardMetricConnection;
  paginateImage: ImageConnection;
  paginateJourney: JourneyConnection;
  paginateKeboolaSyncEvent: KeboolaSyncEventConnection;
  paginateMember: MemberConnection;
  paginateMemberSettings: MemberSettingsConnection;
  paginateMetric: MetricConnection;
  paginateMetricDataLabel: MetricDataLabelConnection;
  paginateMetricDataPoint: MetricDataPointConnection;
  paginateMetricDataSet: MetricDataSetConnection;
  paginateMetricGoogleSheetsMapping: MetricGoogleSheetsMappingConnection;
  paginateMetricGoogleSheetsSheet: MetricGoogleSheetsSheetConnection;
  paginateMetricGoogleSheetsSource: MetricGoogleSheetsSourceConnection;
  paginateMetricGoogleSheetsSpreadsheet: MetricGoogleSheetsSpreadsheetConnection;
  paginateMetricSource: MetricSourceConnection;
  paginateMetricTemplate: MetricTemplateConnection;
  paginateOpportunity: OpportunityConnection;
  paginateOrganizationMeta: OrganizationMetaConnection;
  paginatePersona: PersonaConnection;
  paginatePersonaBlock: PersonaBlockConnection;
  paginatePersonaBlockItem: PersonaBlockItemConnection;
  paginatePhase: PhaseConnection;
  paginatePicture: PictureConnection;
  paginateTag: TagConnection;
  paginateTeam: TeamConnection;
  paginateTouchpoint: TouchpointConnection;
  paginateWidget: WidgetConnection;
  paymentLink?: Maybe<PaymentLink>;
  schema?: Maybe<_Schema>;
  stripeCustomerPortal?: Maybe<StripeCustomerPortal>;
  stripeLinks?: Maybe<StripeLinksResult>;
  transaction?: Maybe<QueryTransaction>;
  validateCreateAction: _ValidationResult;
  validateCreateActivity: _ValidationResult;
  validateCreateActivityDuration: _ValidationResult;
  validateCreateActivityWarning: _ValidationResult;
  validateCreateContentMetric: _ValidationResult;
  validateCreateContentMetricDataPoint: _ValidationResult;
  validateCreateControlCycle: _ValidationResult;
  validateCreateControlCycleCheck: _ValidationResult;
  validateCreateDashboard: _ValidationResult;
  validateCreateDashboardJourney: _ValidationResult;
  validateCreateDashboardMetric: _ValidationResult;
  validateCreateImage: _ValidationResult;
  validateCreateJourney: _ValidationResult;
  validateCreateKeboolaSyncEvent: _ValidationResult;
  validateCreateMember: _ValidationResult;
  validateCreateMemberSettings: _ValidationResult;
  validateCreateMetric: _ValidationResult;
  validateCreateMetricDataLabel: _ValidationResult;
  validateCreateMetricDataPoint: _ValidationResult;
  validateCreateMetricDataSet: _ValidationResult;
  validateCreateMetricGoogleSheetsMapping: _ValidationResult;
  validateCreateMetricGoogleSheetsSheet: _ValidationResult;
  validateCreateMetricGoogleSheetsSource: _ValidationResult;
  validateCreateMetricGoogleSheetsSpreadsheet: _ValidationResult;
  validateCreateMetricSource: _ValidationResult;
  validateCreateMetricTemplate: _ValidationResult;
  validateCreateOpportunity: _ValidationResult;
  validateCreateOrganizationMeta: _ValidationResult;
  validateCreatePersona: _ValidationResult;
  validateCreatePersonaBlock: _ValidationResult;
  validateCreatePersonaBlockItem: _ValidationResult;
  validateCreatePhase: _ValidationResult;
  validateCreatePicture: _ValidationResult;
  validateCreateTag: _ValidationResult;
  validateCreateTeam: _ValidationResult;
  validateCreateTouchpoint: _ValidationResult;
  validateCreateWidget: _ValidationResult;
  validateUpdateAction: _ValidationResult;
  validateUpdateActivity: _ValidationResult;
  validateUpdateActivityDuration: _ValidationResult;
  validateUpdateActivityWarning: _ValidationResult;
  validateUpdateContentMetric: _ValidationResult;
  validateUpdateContentMetricDataPoint: _ValidationResult;
  validateUpdateControlCycle: _ValidationResult;
  validateUpdateControlCycleCheck: _ValidationResult;
  validateUpdateDashboard: _ValidationResult;
  validateUpdateDashboardJourney: _ValidationResult;
  validateUpdateDashboardMetric: _ValidationResult;
  validateUpdateImage: _ValidationResult;
  validateUpdateJourney: _ValidationResult;
  validateUpdateKeboolaSyncEvent: _ValidationResult;
  validateUpdateMember: _ValidationResult;
  validateUpdateMemberSettings: _ValidationResult;
  validateUpdateMetric: _ValidationResult;
  validateUpdateMetricDataLabel: _ValidationResult;
  validateUpdateMetricDataPoint: _ValidationResult;
  validateUpdateMetricDataSet: _ValidationResult;
  validateUpdateMetricGoogleSheetsMapping: _ValidationResult;
  validateUpdateMetricGoogleSheetsSheet: _ValidationResult;
  validateUpdateMetricGoogleSheetsSource: _ValidationResult;
  validateUpdateMetricGoogleSheetsSpreadsheet: _ValidationResult;
  validateUpdateMetricSource: _ValidationResult;
  validateUpdateMetricTemplate: _ValidationResult;
  validateUpdateOpportunity: _ValidationResult;
  validateUpdateOrganizationMeta: _ValidationResult;
  validateUpdatePersona: _ValidationResult;
  validateUpdatePersonaBlock: _ValidationResult;
  validateUpdatePersonaBlockItem: _ValidationResult;
  validateUpdatePhase: _ValidationResult;
  validateUpdatePicture: _ValidationResult;
  validateUpdateTag: _ValidationResult;
  validateUpdateTeam: _ValidationResult;
  validateUpdateTouchpoint: _ValidationResult;
  validateUpdateWidget: _ValidationResult;
};


export type QueryDisplayMetricArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGetActionArgs = {
  by: ActionUniqueWhere;
  filter?: InputMaybe<ActionWhere>;
};


export type QueryGetActivityArgs = {
  by: ActivityUniqueWhere;
  filter?: InputMaybe<ActivityWhere>;
};


export type QueryGetActivityDurationArgs = {
  by: ActivityDurationUniqueWhere;
  filter?: InputMaybe<ActivityDurationWhere>;
};


export type QueryGetActivityWarningArgs = {
  by: ActivityWarningUniqueWhere;
  filter?: InputMaybe<ActivityWarningWhere>;
};


export type QueryGetContentMetricArgs = {
  by: ContentMetricUniqueWhere;
  filter?: InputMaybe<ContentMetricWhere>;
};


export type QueryGetContentMetricDataPointArgs = {
  by: ContentMetricDataPointUniqueWhere;
  filter?: InputMaybe<ContentMetricDataPointWhere>;
};


export type QueryGetControlCycleArgs = {
  by: ControlCycleUniqueWhere;
  filter?: InputMaybe<ControlCycleWhere>;
};


export type QueryGetControlCycleCheckArgs = {
  by: ControlCycleCheckUniqueWhere;
  filter?: InputMaybe<ControlCycleCheckWhere>;
};


export type QueryGetDashboardArgs = {
  by: DashboardUniqueWhere;
  filter?: InputMaybe<DashboardWhere>;
};


export type QueryGetDashboardJourneyArgs = {
  by: DashboardJourneyUniqueWhere;
  filter?: InputMaybe<DashboardJourneyWhere>;
};


export type QueryGetDashboardMetricArgs = {
  by: DashboardMetricUniqueWhere;
  filter?: InputMaybe<DashboardMetricWhere>;
};


export type QueryGetImageArgs = {
  by: ImageUniqueWhere;
  filter?: InputMaybe<ImageWhere>;
};


export type QueryGetJourneyArgs = {
  by: JourneyUniqueWhere;
  filter?: InputMaybe<JourneyWhere>;
};


export type QueryGetKeboolaSyncEventArgs = {
  by: KeboolaSyncEventUniqueWhere;
  filter?: InputMaybe<KeboolaSyncEventWhere>;
};


export type QueryGetMemberArgs = {
  by: MemberUniqueWhere;
  filter?: InputMaybe<MemberWhere>;
};


export type QueryGetMemberSettingsArgs = {
  by: MemberSettingsUniqueWhere;
  filter?: InputMaybe<MemberSettingsWhere>;
};


export type QueryGetMetricArgs = {
  by: MetricUniqueWhere;
  filter?: InputMaybe<MetricWhere>;
};


export type QueryGetMetricDataLabelArgs = {
  by: MetricDataLabelUniqueWhere;
  filter?: InputMaybe<MetricDataLabelWhere>;
};


export type QueryGetMetricDataPointArgs = {
  by: MetricDataPointUniqueWhere;
  filter?: InputMaybe<MetricDataPointWhere>;
};


export type QueryGetMetricDataSetArgs = {
  by: MetricDataSetUniqueWhere;
  filter?: InputMaybe<MetricDataSetWhere>;
};


export type QueryGetMetricGoogleSheetsMappingArgs = {
  by: MetricGoogleSheetsMappingUniqueWhere;
  filter?: InputMaybe<MetricGoogleSheetsMappingWhere>;
};


export type QueryGetMetricGoogleSheetsSheetArgs = {
  by: MetricGoogleSheetsSheetUniqueWhere;
  filter?: InputMaybe<MetricGoogleSheetsSheetWhere>;
};


export type QueryGetMetricGoogleSheetsSourceArgs = {
  by: MetricGoogleSheetsSourceUniqueWhere;
  filter?: InputMaybe<MetricGoogleSheetsSourceWhere>;
};


export type QueryGetMetricGoogleSheetsSpreadsheetArgs = {
  by: MetricGoogleSheetsSpreadsheetUniqueWhere;
  filter?: InputMaybe<MetricGoogleSheetsSpreadsheetWhere>;
};


export type QueryGetMetricSourceArgs = {
  by: MetricSourceUniqueWhere;
  filter?: InputMaybe<MetricSourceWhere>;
};


export type QueryGetMetricTemplateArgs = {
  by: MetricTemplateUniqueWhere;
  filter?: InputMaybe<MetricTemplateWhere>;
};


export type QueryGetOpportunityArgs = {
  by: OpportunityUniqueWhere;
  filter?: InputMaybe<OpportunityWhere>;
};


export type QueryGetOrganizationMetaArgs = {
  by: OrganizationMetaUniqueWhere;
  filter?: InputMaybe<OrganizationMetaWhere>;
};


export type QueryGetPersonaArgs = {
  by: PersonaUniqueWhere;
  filter?: InputMaybe<PersonaWhere>;
};


export type QueryGetPersonaBlockArgs = {
  by: PersonaBlockUniqueWhere;
  filter?: InputMaybe<PersonaBlockWhere>;
};


export type QueryGetPersonaBlockItemArgs = {
  by: PersonaBlockItemUniqueWhere;
  filter?: InputMaybe<PersonaBlockItemWhere>;
};


export type QueryGetPhaseArgs = {
  by: PhaseUniqueWhere;
  filter?: InputMaybe<PhaseWhere>;
};


export type QueryGetPictureArgs = {
  by: PictureUniqueWhere;
  filter?: InputMaybe<PictureWhere>;
};


export type QueryGetTagArgs = {
  by: TagUniqueWhere;
  filter?: InputMaybe<TagWhere>;
};


export type QueryGetTeamArgs = {
  by: TeamUniqueWhere;
  filter?: InputMaybe<TeamWhere>;
};


export type QueryGetTouchpointArgs = {
  by: TouchpointUniqueWhere;
  filter?: InputMaybe<TouchpointWhere>;
};


export type QueryGetWidgetArgs = {
  by: WidgetUniqueWhere;
  filter?: InputMaybe<WidgetWhere>;
};


export type QueryGoogleSpreadsheetSheetsArgs = {
  spreadsheetId: Scalars['String']['input'];
};


export type QueryListActionArgs = {
  filter?: InputMaybe<ActionWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionOrderBy>>;
};


export type QueryListActivityArgs = {
  filter?: InputMaybe<ActivityWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityOrderBy>>;
};


export type QueryListActivityDurationArgs = {
  filter?: InputMaybe<ActivityDurationWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityDurationOrderBy>>;
};


export type QueryListActivityWarningArgs = {
  filter?: InputMaybe<ActivityWarningWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityWarningOrderBy>>;
};


export type QueryListContentMetricArgs = {
  filter?: InputMaybe<ContentMetricWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentMetricOrderBy>>;
};


export type QueryListContentMetricDataPointArgs = {
  filter?: InputMaybe<ContentMetricDataPointWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentMetricDataPointOrderBy>>;
};


export type QueryListControlCycleArgs = {
  filter?: InputMaybe<ControlCycleWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ControlCycleOrderBy>>;
};


export type QueryListControlCycleCheckArgs = {
  filter?: InputMaybe<ControlCycleCheckWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ControlCycleCheckOrderBy>>;
};


export type QueryListDashboardArgs = {
  filter?: InputMaybe<DashboardWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DashboardOrderBy>>;
};


export type QueryListDashboardJourneyArgs = {
  filter?: InputMaybe<DashboardJourneyWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DashboardJourneyOrderBy>>;
};


export type QueryListDashboardMetricArgs = {
  filter?: InputMaybe<DashboardMetricWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DashboardMetricOrderBy>>;
};


export type QueryListImageArgs = {
  filter?: InputMaybe<ImageWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ImageOrderBy>>;
};


export type QueryListJourneyArgs = {
  filter?: InputMaybe<JourneyWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<JourneyOrderBy>>;
};


export type QueryListKeboolaSyncEventArgs = {
  filter?: InputMaybe<KeboolaSyncEventWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<KeboolaSyncEventOrderBy>>;
};


export type QueryListMemberArgs = {
  filter?: InputMaybe<MemberWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberOrderBy>>;
};


export type QueryListMemberSettingsArgs = {
  filter?: InputMaybe<MemberSettingsWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberSettingsOrderBy>>;
};


export type QueryListMetricArgs = {
  filter?: InputMaybe<MetricWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricOrderBy>>;
};


export type QueryListMetricDataLabelArgs = {
  filter?: InputMaybe<MetricDataLabelWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricDataLabelOrderBy>>;
};


export type QueryListMetricDataPointArgs = {
  filter?: InputMaybe<MetricDataPointWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricDataPointOrderBy>>;
};


export type QueryListMetricDataSetArgs = {
  filter?: InputMaybe<MetricDataSetWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricDataSetOrderBy>>;
};


export type QueryListMetricGoogleSheetsMappingArgs = {
  filter?: InputMaybe<MetricGoogleSheetsMappingWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricGoogleSheetsMappingOrderBy>>;
};


export type QueryListMetricGoogleSheetsSheetArgs = {
  filter?: InputMaybe<MetricGoogleSheetsSheetWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricGoogleSheetsSheetOrderBy>>;
};


export type QueryListMetricGoogleSheetsSourceArgs = {
  filter?: InputMaybe<MetricGoogleSheetsSourceWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricGoogleSheetsSourceOrderBy>>;
};


export type QueryListMetricGoogleSheetsSpreadsheetArgs = {
  filter?: InputMaybe<MetricGoogleSheetsSpreadsheetWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricGoogleSheetsSpreadsheetOrderBy>>;
};


export type QueryListMetricSourceArgs = {
  filter?: InputMaybe<MetricSourceWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricSourceOrderBy>>;
};


export type QueryListMetricTemplateArgs = {
  filter?: InputMaybe<MetricTemplateWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricTemplateOrderBy>>;
};


export type QueryListOpportunityArgs = {
  filter?: InputMaybe<OpportunityWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpportunityOrderBy>>;
};


export type QueryListOrganizationMetaArgs = {
  filter?: InputMaybe<OrganizationMetaWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationMetaOrderBy>>;
};


export type QueryListPersonaArgs = {
  filter?: InputMaybe<PersonaWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PersonaOrderBy>>;
};


export type QueryListPersonaBlockArgs = {
  filter?: InputMaybe<PersonaBlockWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PersonaBlockOrderBy>>;
};


export type QueryListPersonaBlockItemArgs = {
  filter?: InputMaybe<PersonaBlockItemWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PersonaBlockItemOrderBy>>;
};


export type QueryListPhaseArgs = {
  filter?: InputMaybe<PhaseWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PhaseOrderBy>>;
};


export type QueryListPictureArgs = {
  filter?: InputMaybe<PictureWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PictureOrderBy>>;
};


export type QueryListTagArgs = {
  filter?: InputMaybe<TagWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderBy>>;
};


export type QueryListTeamArgs = {
  filter?: InputMaybe<TeamWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TeamOrderBy>>;
};


export type QueryListTouchpointArgs = {
  filter?: InputMaybe<TouchpointWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TouchpointOrderBy>>;
};


export type QueryListWidgetArgs = {
  filter?: InputMaybe<WidgetWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WidgetOrderBy>>;
};


export type QueryPaginateActionArgs = {
  filter?: InputMaybe<ActionWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateActivityArgs = {
  filter?: InputMaybe<ActivityWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateActivityDurationArgs = {
  filter?: InputMaybe<ActivityDurationWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityDurationOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateActivityWarningArgs = {
  filter?: InputMaybe<ActivityWarningWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityWarningOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateContentMetricArgs = {
  filter?: InputMaybe<ContentMetricWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentMetricOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateContentMetricDataPointArgs = {
  filter?: InputMaybe<ContentMetricDataPointWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentMetricDataPointOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateControlCycleArgs = {
  filter?: InputMaybe<ControlCycleWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ControlCycleOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateControlCycleCheckArgs = {
  filter?: InputMaybe<ControlCycleCheckWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ControlCycleCheckOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateDashboardArgs = {
  filter?: InputMaybe<DashboardWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DashboardOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateDashboardJourneyArgs = {
  filter?: InputMaybe<DashboardJourneyWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DashboardJourneyOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateDashboardMetricArgs = {
  filter?: InputMaybe<DashboardMetricWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DashboardMetricOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateImageArgs = {
  filter?: InputMaybe<ImageWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ImageOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateJourneyArgs = {
  filter?: InputMaybe<JourneyWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<JourneyOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateKeboolaSyncEventArgs = {
  filter?: InputMaybe<KeboolaSyncEventWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<KeboolaSyncEventOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateMemberArgs = {
  filter?: InputMaybe<MemberWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateMemberSettingsArgs = {
  filter?: InputMaybe<MemberSettingsWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberSettingsOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateMetricArgs = {
  filter?: InputMaybe<MetricWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateMetricDataLabelArgs = {
  filter?: InputMaybe<MetricDataLabelWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricDataLabelOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateMetricDataPointArgs = {
  filter?: InputMaybe<MetricDataPointWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricDataPointOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateMetricDataSetArgs = {
  filter?: InputMaybe<MetricDataSetWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricDataSetOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateMetricGoogleSheetsMappingArgs = {
  filter?: InputMaybe<MetricGoogleSheetsMappingWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricGoogleSheetsMappingOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateMetricGoogleSheetsSheetArgs = {
  filter?: InputMaybe<MetricGoogleSheetsSheetWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricGoogleSheetsSheetOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateMetricGoogleSheetsSourceArgs = {
  filter?: InputMaybe<MetricGoogleSheetsSourceWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricGoogleSheetsSourceOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateMetricGoogleSheetsSpreadsheetArgs = {
  filter?: InputMaybe<MetricGoogleSheetsSpreadsheetWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricGoogleSheetsSpreadsheetOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateMetricSourceArgs = {
  filter?: InputMaybe<MetricSourceWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricSourceOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateMetricTemplateArgs = {
  filter?: InputMaybe<MetricTemplateWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricTemplateOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateOpportunityArgs = {
  filter?: InputMaybe<OpportunityWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpportunityOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateOrganizationMetaArgs = {
  filter?: InputMaybe<OrganizationMetaWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationMetaOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginatePersonaArgs = {
  filter?: InputMaybe<PersonaWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PersonaOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginatePersonaBlockArgs = {
  filter?: InputMaybe<PersonaBlockWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PersonaBlockOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginatePersonaBlockItemArgs = {
  filter?: InputMaybe<PersonaBlockItemWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PersonaBlockItemOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginatePhaseArgs = {
  filter?: InputMaybe<PhaseWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PhaseOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginatePictureArgs = {
  filter?: InputMaybe<PictureWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PictureOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateTagArgs = {
  filter?: InputMaybe<TagWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateTeamArgs = {
  filter?: InputMaybe<TeamWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TeamOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateTouchpointArgs = {
  filter?: InputMaybe<TouchpointWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TouchpointOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginateWidgetArgs = {
  filter?: InputMaybe<WidgetWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WidgetOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaymentLinkArgs = {
  plan: PaymentPlan;
};


export type QueryStripeLinksArgs = {
  paymentPlan?: InputMaybe<PaymentPlan>;
};


export type QueryValidateCreateActionArgs = {
  data: ActionCreateInput;
};


export type QueryValidateCreateActivityArgs = {
  data: ActivityCreateInput;
};


export type QueryValidateCreateActivityDurationArgs = {
  data: ActivityDurationCreateInput;
};


export type QueryValidateCreateActivityWarningArgs = {
  data: ActivityWarningCreateInput;
};


export type QueryValidateCreateContentMetricArgs = {
  data: ContentMetricCreateInput;
};


export type QueryValidateCreateContentMetricDataPointArgs = {
  data: ContentMetricDataPointCreateInput;
};


export type QueryValidateCreateControlCycleArgs = {
  data: ControlCycleCreateInput;
};


export type QueryValidateCreateControlCycleCheckArgs = {
  data: ControlCycleCheckCreateInput;
};


export type QueryValidateCreateDashboardArgs = {
  data: DashboardCreateInput;
};


export type QueryValidateCreateDashboardJourneyArgs = {
  data: DashboardJourneyCreateInput;
};


export type QueryValidateCreateDashboardMetricArgs = {
  data: DashboardMetricCreateInput;
};


export type QueryValidateCreateImageArgs = {
  data: ImageCreateInput;
};


export type QueryValidateCreateJourneyArgs = {
  data: JourneyCreateInput;
};


export type QueryValidateCreateKeboolaSyncEventArgs = {
  data: KeboolaSyncEventCreateInput;
};


export type QueryValidateCreateMemberArgs = {
  data: MemberCreateInput;
};


export type QueryValidateCreateMemberSettingsArgs = {
  data: MemberSettingsCreateInput;
};


export type QueryValidateCreateMetricArgs = {
  data: MetricCreateInput;
};


export type QueryValidateCreateMetricDataLabelArgs = {
  data: MetricDataLabelCreateInput;
};


export type QueryValidateCreateMetricDataPointArgs = {
  data: MetricDataPointCreateInput;
};


export type QueryValidateCreateMetricDataSetArgs = {
  data: MetricDataSetCreateInput;
};


export type QueryValidateCreateMetricGoogleSheetsMappingArgs = {
  data: MetricGoogleSheetsMappingCreateInput;
};


export type QueryValidateCreateMetricGoogleSheetsSheetArgs = {
  data: MetricGoogleSheetsSheetCreateInput;
};


export type QueryValidateCreateMetricGoogleSheetsSourceArgs = {
  data: MetricGoogleSheetsSourceCreateInput;
};


export type QueryValidateCreateMetricGoogleSheetsSpreadsheetArgs = {
  data: MetricGoogleSheetsSpreadsheetCreateInput;
};


export type QueryValidateCreateMetricSourceArgs = {
  data: MetricSourceCreateInput;
};


export type QueryValidateCreateMetricTemplateArgs = {
  data: MetricTemplateCreateInput;
};


export type QueryValidateCreateOpportunityArgs = {
  data: OpportunityCreateInput;
};


export type QueryValidateCreateOrganizationMetaArgs = {
  data: OrganizationMetaCreateInput;
};


export type QueryValidateCreatePersonaArgs = {
  data: PersonaCreateInput;
};


export type QueryValidateCreatePersonaBlockArgs = {
  data: PersonaBlockCreateInput;
};


export type QueryValidateCreatePersonaBlockItemArgs = {
  data: PersonaBlockItemCreateInput;
};


export type QueryValidateCreatePhaseArgs = {
  data: PhaseCreateInput;
};


export type QueryValidateCreatePictureArgs = {
  data: PictureCreateInput;
};


export type QueryValidateCreateTagArgs = {
  data: TagCreateInput;
};


export type QueryValidateCreateTeamArgs = {
  data: TeamCreateInput;
};


export type QueryValidateCreateTouchpointArgs = {
  data: TouchpointCreateInput;
};


export type QueryValidateCreateWidgetArgs = {
  data: WidgetCreateInput;
};


export type QueryValidateUpdateActionArgs = {
  by: ActionUniqueWhere;
  data: ActionUpdateInput;
};


export type QueryValidateUpdateActivityArgs = {
  by: ActivityUniqueWhere;
  data: ActivityUpdateInput;
};


export type QueryValidateUpdateActivityDurationArgs = {
  by: ActivityDurationUniqueWhere;
  data: ActivityDurationUpdateInput;
};


export type QueryValidateUpdateActivityWarningArgs = {
  by: ActivityWarningUniqueWhere;
  data: ActivityWarningUpdateInput;
};


export type QueryValidateUpdateContentMetricArgs = {
  by: ContentMetricUniqueWhere;
  data: ContentMetricUpdateInput;
};


export type QueryValidateUpdateContentMetricDataPointArgs = {
  by: ContentMetricDataPointUniqueWhere;
  data: ContentMetricDataPointUpdateInput;
};


export type QueryValidateUpdateControlCycleArgs = {
  by: ControlCycleUniqueWhere;
  data: ControlCycleUpdateInput;
};


export type QueryValidateUpdateControlCycleCheckArgs = {
  by: ControlCycleCheckUniqueWhere;
  data: ControlCycleCheckUpdateInput;
};


export type QueryValidateUpdateDashboardArgs = {
  by: DashboardUniqueWhere;
  data: DashboardUpdateInput;
};


export type QueryValidateUpdateDashboardJourneyArgs = {
  by: DashboardJourneyUniqueWhere;
  data: DashboardJourneyUpdateInput;
};


export type QueryValidateUpdateDashboardMetricArgs = {
  by: DashboardMetricUniqueWhere;
  data: DashboardMetricUpdateInput;
};


export type QueryValidateUpdateImageArgs = {
  by: ImageUniqueWhere;
  data: ImageUpdateInput;
};


export type QueryValidateUpdateJourneyArgs = {
  by: JourneyUniqueWhere;
  data: JourneyUpdateInput;
};


export type QueryValidateUpdateKeboolaSyncEventArgs = {
  by: KeboolaSyncEventUniqueWhere;
  data: KeboolaSyncEventUpdateInput;
};


export type QueryValidateUpdateMemberArgs = {
  by: MemberUniqueWhere;
  data: MemberUpdateInput;
};


export type QueryValidateUpdateMemberSettingsArgs = {
  by: MemberSettingsUniqueWhere;
  data: MemberSettingsUpdateInput;
};


export type QueryValidateUpdateMetricArgs = {
  by: MetricUniqueWhere;
  data: MetricUpdateInput;
};


export type QueryValidateUpdateMetricDataLabelArgs = {
  by: MetricDataLabelUniqueWhere;
  data: MetricDataLabelUpdateInput;
};


export type QueryValidateUpdateMetricDataPointArgs = {
  by: MetricDataPointUniqueWhere;
  data: MetricDataPointUpdateInput;
};


export type QueryValidateUpdateMetricDataSetArgs = {
  by: MetricDataSetUniqueWhere;
  data: MetricDataSetUpdateInput;
};


export type QueryValidateUpdateMetricGoogleSheetsMappingArgs = {
  by: MetricGoogleSheetsMappingUniqueWhere;
  data: MetricGoogleSheetsMappingUpdateInput;
};


export type QueryValidateUpdateMetricGoogleSheetsSheetArgs = {
  by: MetricGoogleSheetsSheetUniqueWhere;
  data: MetricGoogleSheetsSheetUpdateInput;
};


export type QueryValidateUpdateMetricGoogleSheetsSourceArgs = {
  by: MetricGoogleSheetsSourceUniqueWhere;
  data: MetricGoogleSheetsSourceUpdateInput;
};


export type QueryValidateUpdateMetricGoogleSheetsSpreadsheetArgs = {
  by: MetricGoogleSheetsSpreadsheetUniqueWhere;
  data: MetricGoogleSheetsSpreadsheetUpdateInput;
};


export type QueryValidateUpdateMetricSourceArgs = {
  by: MetricSourceUniqueWhere;
  data: MetricSourceUpdateInput;
};


export type QueryValidateUpdateMetricTemplateArgs = {
  by: MetricTemplateUniqueWhere;
  data: MetricTemplateUpdateInput;
};


export type QueryValidateUpdateOpportunityArgs = {
  by: OpportunityUniqueWhere;
  data: OpportunityUpdateInput;
};


export type QueryValidateUpdateOrganizationMetaArgs = {
  by: OrganizationMetaUniqueWhere;
  data: OrganizationMetaUpdateInput;
};


export type QueryValidateUpdatePersonaArgs = {
  by: PersonaUniqueWhere;
  data: PersonaUpdateInput;
};


export type QueryValidateUpdatePersonaBlockArgs = {
  by: PersonaBlockUniqueWhere;
  data: PersonaBlockUpdateInput;
};


export type QueryValidateUpdatePersonaBlockItemArgs = {
  by: PersonaBlockItemUniqueWhere;
  data: PersonaBlockItemUpdateInput;
};


export type QueryValidateUpdatePhaseArgs = {
  by: PhaseUniqueWhere;
  data: PhaseUpdateInput;
};


export type QueryValidateUpdatePictureArgs = {
  by: PictureUniqueWhere;
  data: PictureUpdateInput;
};


export type QueryValidateUpdateTagArgs = {
  by: TagUniqueWhere;
  data: TagUpdateInput;
};


export type QueryValidateUpdateTeamArgs = {
  by: TeamUniqueWhere;
  data: TeamUpdateInput;
};


export type QueryValidateUpdateTouchpointArgs = {
  by: TouchpointUniqueWhere;
  data: TouchpointUpdateInput;
};


export type QueryValidateUpdateWidgetArgs = {
  by: WidgetUniqueWhere;
  data: WidgetUpdateInput;
};

export type QueryTransaction = {
  __typename?: 'QueryTransaction';
  getAction?: Maybe<Action>;
  getActivity?: Maybe<Activity>;
  getActivityDuration?: Maybe<ActivityDuration>;
  getActivityWarning?: Maybe<ActivityWarning>;
  getContentMetric?: Maybe<ContentMetric>;
  getContentMetricDataPoint?: Maybe<ContentMetricDataPoint>;
  getControlCycle?: Maybe<ControlCycle>;
  getControlCycleCheck?: Maybe<ControlCycleCheck>;
  getDashboard?: Maybe<Dashboard>;
  getDashboardJourney?: Maybe<DashboardJourney>;
  getDashboardMetric?: Maybe<DashboardMetric>;
  getImage?: Maybe<Image>;
  getJourney?: Maybe<Journey>;
  getKeboolaSyncEvent?: Maybe<KeboolaSyncEvent>;
  getMember?: Maybe<Member>;
  getMemberSettings?: Maybe<MemberSettings>;
  getMetric?: Maybe<Metric>;
  getMetricDataLabel?: Maybe<MetricDataLabel>;
  getMetricDataPoint?: Maybe<MetricDataPoint>;
  getMetricDataSet?: Maybe<MetricDataSet>;
  getMetricGoogleSheetsMapping?: Maybe<MetricGoogleSheetsMapping>;
  getMetricGoogleSheetsSheet?: Maybe<MetricGoogleSheetsSheet>;
  getMetricGoogleSheetsSource?: Maybe<MetricGoogleSheetsSource>;
  getMetricGoogleSheetsSpreadsheet?: Maybe<MetricGoogleSheetsSpreadsheet>;
  getMetricSource?: Maybe<MetricSource>;
  getMetricTemplate?: Maybe<MetricTemplate>;
  getOpportunity?: Maybe<Opportunity>;
  getOrganizationMeta?: Maybe<OrganizationMeta>;
  getPersona?: Maybe<Persona>;
  getPersonaBlock?: Maybe<PersonaBlock>;
  getPersonaBlockItem?: Maybe<PersonaBlockItem>;
  getPhase?: Maybe<Phase>;
  getPicture?: Maybe<Picture>;
  getTag?: Maybe<Tag>;
  getTeam?: Maybe<Team>;
  getTouchpoint?: Maybe<Touchpoint>;
  getWidget?: Maybe<Widget>;
  listAction: Array<Action>;
  listActivity: Array<Activity>;
  listActivityDuration: Array<ActivityDuration>;
  listActivityWarning: Array<ActivityWarning>;
  listContentMetric: Array<ContentMetric>;
  listContentMetricDataPoint: Array<ContentMetricDataPoint>;
  listControlCycle: Array<ControlCycle>;
  listControlCycleCheck: Array<ControlCycleCheck>;
  listDashboard: Array<Dashboard>;
  listDashboardJourney: Array<DashboardJourney>;
  listDashboardMetric: Array<DashboardMetric>;
  listImage: Array<Image>;
  listJourney: Array<Journey>;
  listKeboolaSyncEvent: Array<KeboolaSyncEvent>;
  listMember: Array<Member>;
  listMemberSettings: Array<MemberSettings>;
  listMetric: Array<Metric>;
  listMetricDataLabel: Array<MetricDataLabel>;
  listMetricDataPoint: Array<MetricDataPoint>;
  listMetricDataSet: Array<MetricDataSet>;
  listMetricGoogleSheetsMapping: Array<MetricGoogleSheetsMapping>;
  listMetricGoogleSheetsSheet: Array<MetricGoogleSheetsSheet>;
  listMetricGoogleSheetsSource: Array<MetricGoogleSheetsSource>;
  listMetricGoogleSheetsSpreadsheet: Array<MetricGoogleSheetsSpreadsheet>;
  listMetricSource: Array<MetricSource>;
  listMetricTemplate: Array<MetricTemplate>;
  listOpportunity: Array<Opportunity>;
  listOrganizationMeta: Array<OrganizationMeta>;
  listPersona: Array<Persona>;
  listPersonaBlock: Array<PersonaBlock>;
  listPersonaBlockItem: Array<PersonaBlockItem>;
  listPhase: Array<Phase>;
  listPicture: Array<Picture>;
  listTag: Array<Tag>;
  listTeam: Array<Team>;
  listTouchpoint: Array<Touchpoint>;
  listWidget: Array<Widget>;
  paginateAction: ActionConnection;
  paginateActivity: ActivityConnection;
  paginateActivityDuration: ActivityDurationConnection;
  paginateActivityWarning: ActivityWarningConnection;
  paginateContentMetric: ContentMetricConnection;
  paginateContentMetricDataPoint: ContentMetricDataPointConnection;
  paginateControlCycle: ControlCycleConnection;
  paginateControlCycleCheck: ControlCycleCheckConnection;
  paginateDashboard: DashboardConnection;
  paginateDashboardJourney: DashboardJourneyConnection;
  paginateDashboardMetric: DashboardMetricConnection;
  paginateImage: ImageConnection;
  paginateJourney: JourneyConnection;
  paginateKeboolaSyncEvent: KeboolaSyncEventConnection;
  paginateMember: MemberConnection;
  paginateMemberSettings: MemberSettingsConnection;
  paginateMetric: MetricConnection;
  paginateMetricDataLabel: MetricDataLabelConnection;
  paginateMetricDataPoint: MetricDataPointConnection;
  paginateMetricDataSet: MetricDataSetConnection;
  paginateMetricGoogleSheetsMapping: MetricGoogleSheetsMappingConnection;
  paginateMetricGoogleSheetsSheet: MetricGoogleSheetsSheetConnection;
  paginateMetricGoogleSheetsSource: MetricGoogleSheetsSourceConnection;
  paginateMetricGoogleSheetsSpreadsheet: MetricGoogleSheetsSpreadsheetConnection;
  paginateMetricSource: MetricSourceConnection;
  paginateMetricTemplate: MetricTemplateConnection;
  paginateOpportunity: OpportunityConnection;
  paginateOrganizationMeta: OrganizationMetaConnection;
  paginatePersona: PersonaConnection;
  paginatePersonaBlock: PersonaBlockConnection;
  paginatePersonaBlockItem: PersonaBlockItemConnection;
  paginatePhase: PhaseConnection;
  paginatePicture: PictureConnection;
  paginateTag: TagConnection;
  paginateTeam: TeamConnection;
  paginateTouchpoint: TouchpointConnection;
  paginateWidget: WidgetConnection;
  schema?: Maybe<_Schema>;
  validateCreateAction: _ValidationResult;
  validateCreateActivity: _ValidationResult;
  validateCreateActivityDuration: _ValidationResult;
  validateCreateActivityWarning: _ValidationResult;
  validateCreateContentMetric: _ValidationResult;
  validateCreateContentMetricDataPoint: _ValidationResult;
  validateCreateControlCycle: _ValidationResult;
  validateCreateControlCycleCheck: _ValidationResult;
  validateCreateDashboard: _ValidationResult;
  validateCreateDashboardJourney: _ValidationResult;
  validateCreateDashboardMetric: _ValidationResult;
  validateCreateImage: _ValidationResult;
  validateCreateJourney: _ValidationResult;
  validateCreateKeboolaSyncEvent: _ValidationResult;
  validateCreateMember: _ValidationResult;
  validateCreateMemberSettings: _ValidationResult;
  validateCreateMetric: _ValidationResult;
  validateCreateMetricDataLabel: _ValidationResult;
  validateCreateMetricDataPoint: _ValidationResult;
  validateCreateMetricDataSet: _ValidationResult;
  validateCreateMetricGoogleSheetsMapping: _ValidationResult;
  validateCreateMetricGoogleSheetsSheet: _ValidationResult;
  validateCreateMetricGoogleSheetsSource: _ValidationResult;
  validateCreateMetricGoogleSheetsSpreadsheet: _ValidationResult;
  validateCreateMetricSource: _ValidationResult;
  validateCreateMetricTemplate: _ValidationResult;
  validateCreateOpportunity: _ValidationResult;
  validateCreateOrganizationMeta: _ValidationResult;
  validateCreatePersona: _ValidationResult;
  validateCreatePersonaBlock: _ValidationResult;
  validateCreatePersonaBlockItem: _ValidationResult;
  validateCreatePhase: _ValidationResult;
  validateCreatePicture: _ValidationResult;
  validateCreateTag: _ValidationResult;
  validateCreateTeam: _ValidationResult;
  validateCreateTouchpoint: _ValidationResult;
  validateCreateWidget: _ValidationResult;
  validateUpdateAction: _ValidationResult;
  validateUpdateActivity: _ValidationResult;
  validateUpdateActivityDuration: _ValidationResult;
  validateUpdateActivityWarning: _ValidationResult;
  validateUpdateContentMetric: _ValidationResult;
  validateUpdateContentMetricDataPoint: _ValidationResult;
  validateUpdateControlCycle: _ValidationResult;
  validateUpdateControlCycleCheck: _ValidationResult;
  validateUpdateDashboard: _ValidationResult;
  validateUpdateDashboardJourney: _ValidationResult;
  validateUpdateDashboardMetric: _ValidationResult;
  validateUpdateImage: _ValidationResult;
  validateUpdateJourney: _ValidationResult;
  validateUpdateKeboolaSyncEvent: _ValidationResult;
  validateUpdateMember: _ValidationResult;
  validateUpdateMemberSettings: _ValidationResult;
  validateUpdateMetric: _ValidationResult;
  validateUpdateMetricDataLabel: _ValidationResult;
  validateUpdateMetricDataPoint: _ValidationResult;
  validateUpdateMetricDataSet: _ValidationResult;
  validateUpdateMetricGoogleSheetsMapping: _ValidationResult;
  validateUpdateMetricGoogleSheetsSheet: _ValidationResult;
  validateUpdateMetricGoogleSheetsSource: _ValidationResult;
  validateUpdateMetricGoogleSheetsSpreadsheet: _ValidationResult;
  validateUpdateMetricSource: _ValidationResult;
  validateUpdateMetricTemplate: _ValidationResult;
  validateUpdateOpportunity: _ValidationResult;
  validateUpdateOrganizationMeta: _ValidationResult;
  validateUpdatePersona: _ValidationResult;
  validateUpdatePersonaBlock: _ValidationResult;
  validateUpdatePersonaBlockItem: _ValidationResult;
  validateUpdatePhase: _ValidationResult;
  validateUpdatePicture: _ValidationResult;
  validateUpdateTag: _ValidationResult;
  validateUpdateTeam: _ValidationResult;
  validateUpdateTouchpoint: _ValidationResult;
  validateUpdateWidget: _ValidationResult;
};


export type QueryTransactionGetActionArgs = {
  by: ActionUniqueWhere;
  filter?: InputMaybe<ActionWhere>;
};


export type QueryTransactionGetActivityArgs = {
  by: ActivityUniqueWhere;
  filter?: InputMaybe<ActivityWhere>;
};


export type QueryTransactionGetActivityDurationArgs = {
  by: ActivityDurationUniqueWhere;
  filter?: InputMaybe<ActivityDurationWhere>;
};


export type QueryTransactionGetActivityWarningArgs = {
  by: ActivityWarningUniqueWhere;
  filter?: InputMaybe<ActivityWarningWhere>;
};


export type QueryTransactionGetContentMetricArgs = {
  by: ContentMetricUniqueWhere;
  filter?: InputMaybe<ContentMetricWhere>;
};


export type QueryTransactionGetContentMetricDataPointArgs = {
  by: ContentMetricDataPointUniqueWhere;
  filter?: InputMaybe<ContentMetricDataPointWhere>;
};


export type QueryTransactionGetControlCycleArgs = {
  by: ControlCycleUniqueWhere;
  filter?: InputMaybe<ControlCycleWhere>;
};


export type QueryTransactionGetControlCycleCheckArgs = {
  by: ControlCycleCheckUniqueWhere;
  filter?: InputMaybe<ControlCycleCheckWhere>;
};


export type QueryTransactionGetDashboardArgs = {
  by: DashboardUniqueWhere;
  filter?: InputMaybe<DashboardWhere>;
};


export type QueryTransactionGetDashboardJourneyArgs = {
  by: DashboardJourneyUniqueWhere;
  filter?: InputMaybe<DashboardJourneyWhere>;
};


export type QueryTransactionGetDashboardMetricArgs = {
  by: DashboardMetricUniqueWhere;
  filter?: InputMaybe<DashboardMetricWhere>;
};


export type QueryTransactionGetImageArgs = {
  by: ImageUniqueWhere;
  filter?: InputMaybe<ImageWhere>;
};


export type QueryTransactionGetJourneyArgs = {
  by: JourneyUniqueWhere;
  filter?: InputMaybe<JourneyWhere>;
};


export type QueryTransactionGetKeboolaSyncEventArgs = {
  by: KeboolaSyncEventUniqueWhere;
  filter?: InputMaybe<KeboolaSyncEventWhere>;
};


export type QueryTransactionGetMemberArgs = {
  by: MemberUniqueWhere;
  filter?: InputMaybe<MemberWhere>;
};


export type QueryTransactionGetMemberSettingsArgs = {
  by: MemberSettingsUniqueWhere;
  filter?: InputMaybe<MemberSettingsWhere>;
};


export type QueryTransactionGetMetricArgs = {
  by: MetricUniqueWhere;
  filter?: InputMaybe<MetricWhere>;
};


export type QueryTransactionGetMetricDataLabelArgs = {
  by: MetricDataLabelUniqueWhere;
  filter?: InputMaybe<MetricDataLabelWhere>;
};


export type QueryTransactionGetMetricDataPointArgs = {
  by: MetricDataPointUniqueWhere;
  filter?: InputMaybe<MetricDataPointWhere>;
};


export type QueryTransactionGetMetricDataSetArgs = {
  by: MetricDataSetUniqueWhere;
  filter?: InputMaybe<MetricDataSetWhere>;
};


export type QueryTransactionGetMetricGoogleSheetsMappingArgs = {
  by: MetricGoogleSheetsMappingUniqueWhere;
  filter?: InputMaybe<MetricGoogleSheetsMappingWhere>;
};


export type QueryTransactionGetMetricGoogleSheetsSheetArgs = {
  by: MetricGoogleSheetsSheetUniqueWhere;
  filter?: InputMaybe<MetricGoogleSheetsSheetWhere>;
};


export type QueryTransactionGetMetricGoogleSheetsSourceArgs = {
  by: MetricGoogleSheetsSourceUniqueWhere;
  filter?: InputMaybe<MetricGoogleSheetsSourceWhere>;
};


export type QueryTransactionGetMetricGoogleSheetsSpreadsheetArgs = {
  by: MetricGoogleSheetsSpreadsheetUniqueWhere;
  filter?: InputMaybe<MetricGoogleSheetsSpreadsheetWhere>;
};


export type QueryTransactionGetMetricSourceArgs = {
  by: MetricSourceUniqueWhere;
  filter?: InputMaybe<MetricSourceWhere>;
};


export type QueryTransactionGetMetricTemplateArgs = {
  by: MetricTemplateUniqueWhere;
  filter?: InputMaybe<MetricTemplateWhere>;
};


export type QueryTransactionGetOpportunityArgs = {
  by: OpportunityUniqueWhere;
  filter?: InputMaybe<OpportunityWhere>;
};


export type QueryTransactionGetOrganizationMetaArgs = {
  by: OrganizationMetaUniqueWhere;
  filter?: InputMaybe<OrganizationMetaWhere>;
};


export type QueryTransactionGetPersonaArgs = {
  by: PersonaUniqueWhere;
  filter?: InputMaybe<PersonaWhere>;
};


export type QueryTransactionGetPersonaBlockArgs = {
  by: PersonaBlockUniqueWhere;
  filter?: InputMaybe<PersonaBlockWhere>;
};


export type QueryTransactionGetPersonaBlockItemArgs = {
  by: PersonaBlockItemUniqueWhere;
  filter?: InputMaybe<PersonaBlockItemWhere>;
};


export type QueryTransactionGetPhaseArgs = {
  by: PhaseUniqueWhere;
  filter?: InputMaybe<PhaseWhere>;
};


export type QueryTransactionGetPictureArgs = {
  by: PictureUniqueWhere;
  filter?: InputMaybe<PictureWhere>;
};


export type QueryTransactionGetTagArgs = {
  by: TagUniqueWhere;
  filter?: InputMaybe<TagWhere>;
};


export type QueryTransactionGetTeamArgs = {
  by: TeamUniqueWhere;
  filter?: InputMaybe<TeamWhere>;
};


export type QueryTransactionGetTouchpointArgs = {
  by: TouchpointUniqueWhere;
  filter?: InputMaybe<TouchpointWhere>;
};


export type QueryTransactionGetWidgetArgs = {
  by: WidgetUniqueWhere;
  filter?: InputMaybe<WidgetWhere>;
};


export type QueryTransactionListActionArgs = {
  filter?: InputMaybe<ActionWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionOrderBy>>;
};


export type QueryTransactionListActivityArgs = {
  filter?: InputMaybe<ActivityWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityOrderBy>>;
};


export type QueryTransactionListActivityDurationArgs = {
  filter?: InputMaybe<ActivityDurationWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityDurationOrderBy>>;
};


export type QueryTransactionListActivityWarningArgs = {
  filter?: InputMaybe<ActivityWarningWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityWarningOrderBy>>;
};


export type QueryTransactionListContentMetricArgs = {
  filter?: InputMaybe<ContentMetricWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentMetricOrderBy>>;
};


export type QueryTransactionListContentMetricDataPointArgs = {
  filter?: InputMaybe<ContentMetricDataPointWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentMetricDataPointOrderBy>>;
};


export type QueryTransactionListControlCycleArgs = {
  filter?: InputMaybe<ControlCycleWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ControlCycleOrderBy>>;
};


export type QueryTransactionListControlCycleCheckArgs = {
  filter?: InputMaybe<ControlCycleCheckWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ControlCycleCheckOrderBy>>;
};


export type QueryTransactionListDashboardArgs = {
  filter?: InputMaybe<DashboardWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DashboardOrderBy>>;
};


export type QueryTransactionListDashboardJourneyArgs = {
  filter?: InputMaybe<DashboardJourneyWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DashboardJourneyOrderBy>>;
};


export type QueryTransactionListDashboardMetricArgs = {
  filter?: InputMaybe<DashboardMetricWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DashboardMetricOrderBy>>;
};


export type QueryTransactionListImageArgs = {
  filter?: InputMaybe<ImageWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ImageOrderBy>>;
};


export type QueryTransactionListJourneyArgs = {
  filter?: InputMaybe<JourneyWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<JourneyOrderBy>>;
};


export type QueryTransactionListKeboolaSyncEventArgs = {
  filter?: InputMaybe<KeboolaSyncEventWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<KeboolaSyncEventOrderBy>>;
};


export type QueryTransactionListMemberArgs = {
  filter?: InputMaybe<MemberWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberOrderBy>>;
};


export type QueryTransactionListMemberSettingsArgs = {
  filter?: InputMaybe<MemberSettingsWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberSettingsOrderBy>>;
};


export type QueryTransactionListMetricArgs = {
  filter?: InputMaybe<MetricWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricOrderBy>>;
};


export type QueryTransactionListMetricDataLabelArgs = {
  filter?: InputMaybe<MetricDataLabelWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricDataLabelOrderBy>>;
};


export type QueryTransactionListMetricDataPointArgs = {
  filter?: InputMaybe<MetricDataPointWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricDataPointOrderBy>>;
};


export type QueryTransactionListMetricDataSetArgs = {
  filter?: InputMaybe<MetricDataSetWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricDataSetOrderBy>>;
};


export type QueryTransactionListMetricGoogleSheetsMappingArgs = {
  filter?: InputMaybe<MetricGoogleSheetsMappingWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricGoogleSheetsMappingOrderBy>>;
};


export type QueryTransactionListMetricGoogleSheetsSheetArgs = {
  filter?: InputMaybe<MetricGoogleSheetsSheetWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricGoogleSheetsSheetOrderBy>>;
};


export type QueryTransactionListMetricGoogleSheetsSourceArgs = {
  filter?: InputMaybe<MetricGoogleSheetsSourceWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricGoogleSheetsSourceOrderBy>>;
};


export type QueryTransactionListMetricGoogleSheetsSpreadsheetArgs = {
  filter?: InputMaybe<MetricGoogleSheetsSpreadsheetWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricGoogleSheetsSpreadsheetOrderBy>>;
};


export type QueryTransactionListMetricSourceArgs = {
  filter?: InputMaybe<MetricSourceWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricSourceOrderBy>>;
};


export type QueryTransactionListMetricTemplateArgs = {
  filter?: InputMaybe<MetricTemplateWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricTemplateOrderBy>>;
};


export type QueryTransactionListOpportunityArgs = {
  filter?: InputMaybe<OpportunityWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpportunityOrderBy>>;
};


export type QueryTransactionListOrganizationMetaArgs = {
  filter?: InputMaybe<OrganizationMetaWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationMetaOrderBy>>;
};


export type QueryTransactionListPersonaArgs = {
  filter?: InputMaybe<PersonaWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PersonaOrderBy>>;
};


export type QueryTransactionListPersonaBlockArgs = {
  filter?: InputMaybe<PersonaBlockWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PersonaBlockOrderBy>>;
};


export type QueryTransactionListPersonaBlockItemArgs = {
  filter?: InputMaybe<PersonaBlockItemWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PersonaBlockItemOrderBy>>;
};


export type QueryTransactionListPhaseArgs = {
  filter?: InputMaybe<PhaseWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PhaseOrderBy>>;
};


export type QueryTransactionListPictureArgs = {
  filter?: InputMaybe<PictureWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PictureOrderBy>>;
};


export type QueryTransactionListTagArgs = {
  filter?: InputMaybe<TagWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderBy>>;
};


export type QueryTransactionListTeamArgs = {
  filter?: InputMaybe<TeamWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TeamOrderBy>>;
};


export type QueryTransactionListTouchpointArgs = {
  filter?: InputMaybe<TouchpointWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TouchpointOrderBy>>;
};


export type QueryTransactionListWidgetArgs = {
  filter?: InputMaybe<WidgetWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WidgetOrderBy>>;
};


export type QueryTransactionPaginateActionArgs = {
  filter?: InputMaybe<ActionWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateActivityArgs = {
  filter?: InputMaybe<ActivityWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateActivityDurationArgs = {
  filter?: InputMaybe<ActivityDurationWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityDurationOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateActivityWarningArgs = {
  filter?: InputMaybe<ActivityWarningWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityWarningOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateContentMetricArgs = {
  filter?: InputMaybe<ContentMetricWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentMetricOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateContentMetricDataPointArgs = {
  filter?: InputMaybe<ContentMetricDataPointWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentMetricDataPointOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateControlCycleArgs = {
  filter?: InputMaybe<ControlCycleWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ControlCycleOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateControlCycleCheckArgs = {
  filter?: InputMaybe<ControlCycleCheckWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ControlCycleCheckOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateDashboardArgs = {
  filter?: InputMaybe<DashboardWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DashboardOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateDashboardJourneyArgs = {
  filter?: InputMaybe<DashboardJourneyWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DashboardJourneyOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateDashboardMetricArgs = {
  filter?: InputMaybe<DashboardMetricWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DashboardMetricOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateImageArgs = {
  filter?: InputMaybe<ImageWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ImageOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateJourneyArgs = {
  filter?: InputMaybe<JourneyWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<JourneyOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateKeboolaSyncEventArgs = {
  filter?: InputMaybe<KeboolaSyncEventWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<KeboolaSyncEventOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateMemberArgs = {
  filter?: InputMaybe<MemberWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateMemberSettingsArgs = {
  filter?: InputMaybe<MemberSettingsWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberSettingsOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateMetricArgs = {
  filter?: InputMaybe<MetricWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateMetricDataLabelArgs = {
  filter?: InputMaybe<MetricDataLabelWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricDataLabelOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateMetricDataPointArgs = {
  filter?: InputMaybe<MetricDataPointWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricDataPointOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateMetricDataSetArgs = {
  filter?: InputMaybe<MetricDataSetWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricDataSetOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateMetricGoogleSheetsMappingArgs = {
  filter?: InputMaybe<MetricGoogleSheetsMappingWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricGoogleSheetsMappingOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateMetricGoogleSheetsSheetArgs = {
  filter?: InputMaybe<MetricGoogleSheetsSheetWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricGoogleSheetsSheetOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateMetricGoogleSheetsSourceArgs = {
  filter?: InputMaybe<MetricGoogleSheetsSourceWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricGoogleSheetsSourceOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateMetricGoogleSheetsSpreadsheetArgs = {
  filter?: InputMaybe<MetricGoogleSheetsSpreadsheetWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricGoogleSheetsSpreadsheetOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateMetricSourceArgs = {
  filter?: InputMaybe<MetricSourceWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricSourceOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateMetricTemplateArgs = {
  filter?: InputMaybe<MetricTemplateWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricTemplateOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateOpportunityArgs = {
  filter?: InputMaybe<OpportunityWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpportunityOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateOrganizationMetaArgs = {
  filter?: InputMaybe<OrganizationMetaWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationMetaOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginatePersonaArgs = {
  filter?: InputMaybe<PersonaWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PersonaOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginatePersonaBlockArgs = {
  filter?: InputMaybe<PersonaBlockWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PersonaBlockOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginatePersonaBlockItemArgs = {
  filter?: InputMaybe<PersonaBlockItemWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PersonaBlockItemOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginatePhaseArgs = {
  filter?: InputMaybe<PhaseWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PhaseOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginatePictureArgs = {
  filter?: InputMaybe<PictureWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PictureOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateTagArgs = {
  filter?: InputMaybe<TagWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateTeamArgs = {
  filter?: InputMaybe<TeamWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TeamOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateTouchpointArgs = {
  filter?: InputMaybe<TouchpointWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TouchpointOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPaginateWidgetArgs = {
  filter?: InputMaybe<WidgetWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WidgetOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionValidateCreateActionArgs = {
  data: ActionCreateInput;
};


export type QueryTransactionValidateCreateActivityArgs = {
  data: ActivityCreateInput;
};


export type QueryTransactionValidateCreateActivityDurationArgs = {
  data: ActivityDurationCreateInput;
};


export type QueryTransactionValidateCreateActivityWarningArgs = {
  data: ActivityWarningCreateInput;
};


export type QueryTransactionValidateCreateContentMetricArgs = {
  data: ContentMetricCreateInput;
};


export type QueryTransactionValidateCreateContentMetricDataPointArgs = {
  data: ContentMetricDataPointCreateInput;
};


export type QueryTransactionValidateCreateControlCycleArgs = {
  data: ControlCycleCreateInput;
};


export type QueryTransactionValidateCreateControlCycleCheckArgs = {
  data: ControlCycleCheckCreateInput;
};


export type QueryTransactionValidateCreateDashboardArgs = {
  data: DashboardCreateInput;
};


export type QueryTransactionValidateCreateDashboardJourneyArgs = {
  data: DashboardJourneyCreateInput;
};


export type QueryTransactionValidateCreateDashboardMetricArgs = {
  data: DashboardMetricCreateInput;
};


export type QueryTransactionValidateCreateImageArgs = {
  data: ImageCreateInput;
};


export type QueryTransactionValidateCreateJourneyArgs = {
  data: JourneyCreateInput;
};


export type QueryTransactionValidateCreateKeboolaSyncEventArgs = {
  data: KeboolaSyncEventCreateInput;
};


export type QueryTransactionValidateCreateMemberArgs = {
  data: MemberCreateInput;
};


export type QueryTransactionValidateCreateMemberSettingsArgs = {
  data: MemberSettingsCreateInput;
};


export type QueryTransactionValidateCreateMetricArgs = {
  data: MetricCreateInput;
};


export type QueryTransactionValidateCreateMetricDataLabelArgs = {
  data: MetricDataLabelCreateInput;
};


export type QueryTransactionValidateCreateMetricDataPointArgs = {
  data: MetricDataPointCreateInput;
};


export type QueryTransactionValidateCreateMetricDataSetArgs = {
  data: MetricDataSetCreateInput;
};


export type QueryTransactionValidateCreateMetricGoogleSheetsMappingArgs = {
  data: MetricGoogleSheetsMappingCreateInput;
};


export type QueryTransactionValidateCreateMetricGoogleSheetsSheetArgs = {
  data: MetricGoogleSheetsSheetCreateInput;
};


export type QueryTransactionValidateCreateMetricGoogleSheetsSourceArgs = {
  data: MetricGoogleSheetsSourceCreateInput;
};


export type QueryTransactionValidateCreateMetricGoogleSheetsSpreadsheetArgs = {
  data: MetricGoogleSheetsSpreadsheetCreateInput;
};


export type QueryTransactionValidateCreateMetricSourceArgs = {
  data: MetricSourceCreateInput;
};


export type QueryTransactionValidateCreateMetricTemplateArgs = {
  data: MetricTemplateCreateInput;
};


export type QueryTransactionValidateCreateOpportunityArgs = {
  data: OpportunityCreateInput;
};


export type QueryTransactionValidateCreateOrganizationMetaArgs = {
  data: OrganizationMetaCreateInput;
};


export type QueryTransactionValidateCreatePersonaArgs = {
  data: PersonaCreateInput;
};


export type QueryTransactionValidateCreatePersonaBlockArgs = {
  data: PersonaBlockCreateInput;
};


export type QueryTransactionValidateCreatePersonaBlockItemArgs = {
  data: PersonaBlockItemCreateInput;
};


export type QueryTransactionValidateCreatePhaseArgs = {
  data: PhaseCreateInput;
};


export type QueryTransactionValidateCreatePictureArgs = {
  data: PictureCreateInput;
};


export type QueryTransactionValidateCreateTagArgs = {
  data: TagCreateInput;
};


export type QueryTransactionValidateCreateTeamArgs = {
  data: TeamCreateInput;
};


export type QueryTransactionValidateCreateTouchpointArgs = {
  data: TouchpointCreateInput;
};


export type QueryTransactionValidateCreateWidgetArgs = {
  data: WidgetCreateInput;
};


export type QueryTransactionValidateUpdateActionArgs = {
  by: ActionUniqueWhere;
  data: ActionUpdateInput;
};


export type QueryTransactionValidateUpdateActivityArgs = {
  by: ActivityUniqueWhere;
  data: ActivityUpdateInput;
};


export type QueryTransactionValidateUpdateActivityDurationArgs = {
  by: ActivityDurationUniqueWhere;
  data: ActivityDurationUpdateInput;
};


export type QueryTransactionValidateUpdateActivityWarningArgs = {
  by: ActivityWarningUniqueWhere;
  data: ActivityWarningUpdateInput;
};


export type QueryTransactionValidateUpdateContentMetricArgs = {
  by: ContentMetricUniqueWhere;
  data: ContentMetricUpdateInput;
};


export type QueryTransactionValidateUpdateContentMetricDataPointArgs = {
  by: ContentMetricDataPointUniqueWhere;
  data: ContentMetricDataPointUpdateInput;
};


export type QueryTransactionValidateUpdateControlCycleArgs = {
  by: ControlCycleUniqueWhere;
  data: ControlCycleUpdateInput;
};


export type QueryTransactionValidateUpdateControlCycleCheckArgs = {
  by: ControlCycleCheckUniqueWhere;
  data: ControlCycleCheckUpdateInput;
};


export type QueryTransactionValidateUpdateDashboardArgs = {
  by: DashboardUniqueWhere;
  data: DashboardUpdateInput;
};


export type QueryTransactionValidateUpdateDashboardJourneyArgs = {
  by: DashboardJourneyUniqueWhere;
  data: DashboardJourneyUpdateInput;
};


export type QueryTransactionValidateUpdateDashboardMetricArgs = {
  by: DashboardMetricUniqueWhere;
  data: DashboardMetricUpdateInput;
};


export type QueryTransactionValidateUpdateImageArgs = {
  by: ImageUniqueWhere;
  data: ImageUpdateInput;
};


export type QueryTransactionValidateUpdateJourneyArgs = {
  by: JourneyUniqueWhere;
  data: JourneyUpdateInput;
};


export type QueryTransactionValidateUpdateKeboolaSyncEventArgs = {
  by: KeboolaSyncEventUniqueWhere;
  data: KeboolaSyncEventUpdateInput;
};


export type QueryTransactionValidateUpdateMemberArgs = {
  by: MemberUniqueWhere;
  data: MemberUpdateInput;
};


export type QueryTransactionValidateUpdateMemberSettingsArgs = {
  by: MemberSettingsUniqueWhere;
  data: MemberSettingsUpdateInput;
};


export type QueryTransactionValidateUpdateMetricArgs = {
  by: MetricUniqueWhere;
  data: MetricUpdateInput;
};


export type QueryTransactionValidateUpdateMetricDataLabelArgs = {
  by: MetricDataLabelUniqueWhere;
  data: MetricDataLabelUpdateInput;
};


export type QueryTransactionValidateUpdateMetricDataPointArgs = {
  by: MetricDataPointUniqueWhere;
  data: MetricDataPointUpdateInput;
};


export type QueryTransactionValidateUpdateMetricDataSetArgs = {
  by: MetricDataSetUniqueWhere;
  data: MetricDataSetUpdateInput;
};


export type QueryTransactionValidateUpdateMetricGoogleSheetsMappingArgs = {
  by: MetricGoogleSheetsMappingUniqueWhere;
  data: MetricGoogleSheetsMappingUpdateInput;
};


export type QueryTransactionValidateUpdateMetricGoogleSheetsSheetArgs = {
  by: MetricGoogleSheetsSheetUniqueWhere;
  data: MetricGoogleSheetsSheetUpdateInput;
};


export type QueryTransactionValidateUpdateMetricGoogleSheetsSourceArgs = {
  by: MetricGoogleSheetsSourceUniqueWhere;
  data: MetricGoogleSheetsSourceUpdateInput;
};


export type QueryTransactionValidateUpdateMetricGoogleSheetsSpreadsheetArgs = {
  by: MetricGoogleSheetsSpreadsheetUniqueWhere;
  data: MetricGoogleSheetsSpreadsheetUpdateInput;
};


export type QueryTransactionValidateUpdateMetricSourceArgs = {
  by: MetricSourceUniqueWhere;
  data: MetricSourceUpdateInput;
};


export type QueryTransactionValidateUpdateMetricTemplateArgs = {
  by: MetricTemplateUniqueWhere;
  data: MetricTemplateUpdateInput;
};


export type QueryTransactionValidateUpdateOpportunityArgs = {
  by: OpportunityUniqueWhere;
  data: OpportunityUpdateInput;
};


export type QueryTransactionValidateUpdateOrganizationMetaArgs = {
  by: OrganizationMetaUniqueWhere;
  data: OrganizationMetaUpdateInput;
};


export type QueryTransactionValidateUpdatePersonaArgs = {
  by: PersonaUniqueWhere;
  data: PersonaUpdateInput;
};


export type QueryTransactionValidateUpdatePersonaBlockArgs = {
  by: PersonaBlockUniqueWhere;
  data: PersonaBlockUpdateInput;
};


export type QueryTransactionValidateUpdatePersonaBlockItemArgs = {
  by: PersonaBlockItemUniqueWhere;
  data: PersonaBlockItemUpdateInput;
};


export type QueryTransactionValidateUpdatePhaseArgs = {
  by: PhaseUniqueWhere;
  data: PhaseUpdateInput;
};


export type QueryTransactionValidateUpdatePictureArgs = {
  by: PictureUniqueWhere;
  data: PictureUpdateInput;
};


export type QueryTransactionValidateUpdateTagArgs = {
  by: TagUniqueWhere;
  data: TagUpdateInput;
};


export type QueryTransactionValidateUpdateTeamArgs = {
  by: TeamUniqueWhere;
  data: TeamUpdateInput;
};


export type QueryTransactionValidateUpdateTouchpointArgs = {
  by: TouchpointUniqueWhere;
  data: TouchpointUpdateInput;
};


export type QueryTransactionValidateUpdateWidgetArgs = {
  by: WidgetUniqueWhere;
  data: WidgetUpdateInput;
};

export type RefreshActivityWarningsResult = {
  __typename?: 'RefreshActivityWarningsResult';
  ok: Scalars['Boolean']['output'];
};

export type RemoveGlobalIdentityRolesError = {
  __typename?: 'RemoveGlobalIdentityRolesError';
  code: RemoveGlobalIdentityRolesErrorCode;
  developerMessage: Scalars['String']['output'];
};

export type RemoveGlobalIdentityRolesErrorCode =
  | 'IDENTITY_NOT_FOUND'
  | 'INVALID_ROLE';

export type RemoveGlobalIdentityRolesResponse = {
  __typename?: 'RemoveGlobalIdentityRolesResponse';
  error?: Maybe<RemoveGlobalIdentityRolesError>;
  ok: Scalars['Boolean']['output'];
  result?: Maybe<RemoveGlobalIdentityRolesResult>;
};

export type RemoveGlobalIdentityRolesResult = {
  __typename?: 'RemoveGlobalIdentityRolesResult';
  identity: Identity;
};

export type RemoveMailTemplateError = {
  __typename?: 'RemoveMailTemplateError';
  code: RemoveMailTemplateErrorCode;
  developerMessage: Scalars['String']['output'];
  /** @deprecated Field no longer supported */
  endUserMessage?: Maybe<Scalars['String']['output']>;
};

export type RemoveMailTemplateErrorCode =
  | 'PROJECT_NOT_FOUND'
  | 'TEMPLATE_NOT_FOUND';

export type RemoveMailTemplateResponse = {
  __typename?: 'RemoveMailTemplateResponse';
  error?: Maybe<RemoveMailTemplateError>;
  errors: Array<RemoveMailTemplateError>;
  ok: Scalars['Boolean']['output'];
};

export type RemoveProjectMemberError = {
  __typename?: 'RemoveProjectMemberError';
  code: RemoveProjectMemberErrorCode;
  developerMessage: Scalars['String']['output'];
  /** @deprecated Field no longer supported */
  endUserMessage?: Maybe<Scalars['String']['output']>;
};

export type RemoveProjectMemberErrorCode =
  | 'NOT_MEMBER'
  | 'PROJECT_NOT_FOUND';

export type RemoveProjectMemberResponse = {
  __typename?: 'RemoveProjectMemberResponse';
  error?: Maybe<RemoveProjectMemberError>;
  errors: Array<RemoveProjectMemberError>;
  ok: Scalars['Boolean']['output'];
};

export type ResetPasswordError = {
  __typename?: 'ResetPasswordError';
  code: ResetPasswordErrorCode;
  developerMessage: Scalars['String']['output'];
  /** @deprecated Field no longer supported */
  endUserMessage?: Maybe<Scalars['String']['output']>;
};

export type ResetPasswordErrorCode =
  | 'PASSWORD_TOO_WEAK'
  | 'TOKEN_EXPIRED'
  | 'TOKEN_NOT_FOUND'
  | 'TOKEN_USED';

export type ResetPasswordResponse = {
  __typename?: 'ResetPasswordResponse';
  error?: Maybe<ResetPasswordError>;
  /** @deprecated Field no longer supported */
  errors: Array<ResetPasswordError>;
  ok: Scalars['Boolean']['output'];
};

export type RoleConditionVariableDefinition = RoleVariableDefinition & {
  __typename?: 'RoleConditionVariableDefinition';
  name: Scalars['String']['output'];
};

export type RoleDefinition = {
  __typename?: 'RoleDefinition';
  name: Scalars['String']['output'];
  variables: Array<RoleVariableDefinition>;
};

export type RoleEntityVariableDefinition = RoleVariableDefinition & {
  __typename?: 'RoleEntityVariableDefinition';
  entityName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RolePredefinedVariableDefinition = RoleVariableDefinition & {
  __typename?: 'RolePredefinedVariableDefinition';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type RoleVariableDefinition = {
  name: Scalars['String']['output'];
};

export type SetGoogleSheetConfigurationMappingInput = {
  config: Array<SheetMappingConfig>;
  spreadsheetId: Scalars['String']['input'];
};

export type SetGoogleSheetsConfigurationInput = {
  authorizationCode?: InputMaybe<Scalars['String']['input']>;
  currentUserId?: InputMaybe<Scalars['UUID']['input']>;
  spreadsheetId?: InputMaybe<Scalars['String']['input']>;
};

export type SetGoogleSheetsConfigurationResult = {
  __typename?: 'SetGoogleSheetsConfigurationResult';
  accessToken?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  sheets?: Maybe<Array<SheetToTemplateMap>>;
};

export type SetGoogleSheetsMetricTemplateMappingResult = {
  __typename?: 'SetGoogleSheetsMetricTemplateMappingResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetProjectSecretError = {
  __typename?: 'SetProjectSecretError';
  code: SetProjectSecretErrorCode;
  developerMessage: Scalars['String']['output'];
};

export type SetProjectSecretErrorCode =
  | 'PROJECT_NOT_FOUND';

export type SetProjectSecretResponse = {
  __typename?: 'SetProjectSecretResponse';
  error?: Maybe<SetProjectSecretError>;
  ok: Scalars['Boolean']['output'];
};

export type SetSingleSheetMappingResult = {
  __typename?: 'SetSingleSheetMappingResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SheetMappingConfig = {
  enableSynchronization: Scalars['Boolean']['input'];
  metricId?: InputMaybe<Scalars['String']['input']>;
  metricTemplateId: Scalars['String']['input'];
  sheetTitle: Scalars['String']['input'];
};

export type SheetToTemplateMap = {
  __typename?: 'SheetToTemplateMap';
  sheetTitle?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
};

export type SignInError = {
  __typename?: 'SignInError';
  code: SignInErrorCode;
  developerMessage: Scalars['String']['output'];
  /** @deprecated Field no longer supported */
  endUserMessage?: Maybe<Scalars['String']['output']>;
};

export type SignInErrorCode =
  | 'INVALID_OTP_TOKEN'
  | 'INVALID_PASSWORD'
  | 'NO_PASSWORD_SET'
  | 'OTP_REQUIRED'
  | 'PERSON_DISABLED'
  | 'UNKNOWN_EMAIL';

export type SignInIdpError = {
  __typename?: 'SignInIDPError';
  code: SignInIdpErrorCode;
  developerMessage: Scalars['String']['output'];
  /** @deprecated Field no longer supported */
  endUserMessage?: Maybe<Scalars['String']['output']>;
};

export type SignInIdpErrorCode =
  | 'IDP_VALIDATION_FAILED'
  | 'INVALID_IDP_RESPONSE'
  | 'PERSON_ALREADY_EXISTS'
  | 'PERSON_DISABLED'
  | 'PERSON_NOT_FOUND';

export type SignInIdpResponse = {
  __typename?: 'SignInIDPResponse';
  error?: Maybe<SignInIdpError>;
  /** @deprecated Field no longer supported */
  errors: Array<SignInIdpError>;
  ok: Scalars['Boolean']['output'];
  result?: Maybe<SignInIdpResult>;
};

export type SignInIdpResult = CommonSignInResult & {
  __typename?: 'SignInIDPResult';
  person: Person;
  token: Scalars['String']['output'];
};

export type SignInResponse = {
  __typename?: 'SignInResponse';
  error?: Maybe<SignInError>;
  /** @deprecated Field no longer supported */
  errors: Array<SignInError>;
  ok: Scalars['Boolean']['output'];
  result?: Maybe<SignInResult>;
};

export type SignInResult = CommonSignInResult & {
  __typename?: 'SignInResult';
  memberPerson?: Maybe<MemberPerson>;
  person: Person;
  token: Scalars['String']['output'];
};

export type SignOutError = {
  __typename?: 'SignOutError';
  code: SignOutErrorCode;
  developerMessage: Scalars['String']['output'];
  /** @deprecated Field no longer supported */
  endUserMessage?: Maybe<Scalars['String']['output']>;
};

export type SignOutErrorCode =
  | 'NOT_A_PERSON'
  | 'NOT_POSSIBLE_SIGN_OUT_WITH_PERMANENT_API_KEY';

export type SignOutResponse = {
  __typename?: 'SignOutResponse';
  error?: Maybe<SignOutError>;
  /** @deprecated Field no longer supported */
  errors: Array<SignOutError>;
  ok: Scalars['Boolean']['output'];
};

export type SignUpError = {
  __typename?: 'SignUpError';
  code: SignUpErrorCode;
  developerMessage: Scalars['String']['output'];
  /** @deprecated Field no longer supported */
  endPersonMessage?: Maybe<Scalars['String']['output']>;
};

export type SignUpErrorCode =
  | 'EMAIL_ALREADY_EXISTS'
  | 'INVALID_EMAIL_FORMAT'
  | 'TOO_WEAK';

export type SignUpResponse = {
  __typename?: 'SignUpResponse';
  error?: Maybe<SignUpError>;
  /** @deprecated Field no longer supported */
  errors: Array<SignUpError>;
  ok: Scalars['Boolean']['output'];
  result?: Maybe<SignUpResult>;
};

export type SignUpResult = {
  __typename?: 'SignUpResult';
  person: Person;
};

export type SingleSheetMappingConfig = {
  metricName: Scalars['String']['input'];
  metricTemplateId: Scalars['String']['input'];
  sheetTitle: Scalars['String']['input'];
  spreadsheetId: Scalars['String']['input'];
};

export type Singleton =
  | 'singleton';

export type SingletonCondition = {
  and?: InputMaybe<Array<SingletonCondition>>;
  eq?: InputMaybe<Singleton>;
  gt?: InputMaybe<Singleton>;
  gte?: InputMaybe<Singleton>;
  in?: InputMaybe<Array<Singleton>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Singleton>;
  lte?: InputMaybe<Singleton>;
  not?: InputMaybe<SingletonCondition>;
  notEq?: InputMaybe<Singleton>;
  notIn?: InputMaybe<Array<Singleton>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<SingletonCondition>>;
};

export type SourceType =
  | 'google_analytics'
  | 'google_sheets'
  | 'manual';

export type SourceTypeCondition = {
  and?: InputMaybe<Array<SourceTypeCondition>>;
  eq?: InputMaybe<SourceType>;
  gt?: InputMaybe<SourceType>;
  gte?: InputMaybe<SourceType>;
  in?: InputMaybe<Array<SourceType>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<SourceType>;
  lte?: InputMaybe<SourceType>;
  not?: InputMaybe<SourceTypeCondition>;
  notEq?: InputMaybe<SourceType>;
  notIn?: InputMaybe<Array<SourceType>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<SourceTypeCondition>>;
};

export type StringCondition = {
  and?: InputMaybe<Array<StringCondition>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsCI?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  endsWithCI?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringCondition>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<StringCondition>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
  startsWithCI?: InputMaybe<Scalars['String']['input']>;
};

export type StripeCustomerPortal = {
  __typename?: 'StripeCustomerPortal';
  customerId?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

export type StripeLinks = {
  __typename?: 'StripeLinks';
  memberCount?: Maybe<Scalars['Int']['output']>;
  payment?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
};

export type StripeLinksResult = ExceptionResult | StripeLinks;

export type Tag = {
  __typename?: 'Tag';
  _meta?: Maybe<TagMeta>;
  actions: Array<Action>;
  activities: Array<Activity>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  opportunities: Array<Opportunity>;
  paginateActions: ActionConnection;
  paginateActivities: ActivityConnection;
  paginateOpportunities: OpportunityConnection;
};


export type TagActionsArgs = {
  filter?: InputMaybe<ActionWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionOrderBy>>;
};


export type TagActivitiesArgs = {
  filter?: InputMaybe<ActivityWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityOrderBy>>;
};


export type TagOpportunitiesArgs = {
  filter?: InputMaybe<OpportunityWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpportunityOrderBy>>;
};


export type TagPaginateActionsArgs = {
  filter?: InputMaybe<ActionWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type TagPaginateActivitiesArgs = {
  filter?: InputMaybe<ActivityWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type TagPaginateOpportunitiesArgs = {
  filter?: InputMaybe<OpportunityWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpportunityOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type TagConnectOrCreateActionsRelationInput = {
  connect: ActionUniqueWhere;
  create: ActionWithoutTagsCreateInput;
};

export type TagConnectOrCreateActivitiesRelationInput = {
  connect: ActivityUniqueWhere;
  create: ActivityWithoutTagsCreateInput;
};

export type TagConnectOrCreateOpportunitiesRelationInput = {
  connect: OpportunityUniqueWhere;
  create: OpportunityWithoutTagsCreateInput;
};

export type TagConnection = {
  __typename?: 'TagConnection';
  edges: Array<TagEdge>;
  pageInfo: PageInfo;
};

export type TagCreateActionsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ActionUniqueWhere>;
  connectOrCreate?: InputMaybe<TagConnectOrCreateActionsRelationInput>;
  create?: InputMaybe<ActionWithoutTagsCreateInput>;
};

export type TagCreateActivitiesEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ActivityUniqueWhere>;
  connectOrCreate?: InputMaybe<TagConnectOrCreateActivitiesRelationInput>;
  create?: InputMaybe<ActivityWithoutTagsCreateInput>;
};

export type TagCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<TagCreateActionsEntityRelationInput>>;
  activities?: InputMaybe<Array<TagCreateActivitiesEntityRelationInput>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<TagCreateOpportunitiesEntityRelationInput>>;
};

export type TagCreateOpportunitiesEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<OpportunityUniqueWhere>;
  connectOrCreate?: InputMaybe<TagConnectOrCreateOpportunitiesRelationInput>;
  create?: InputMaybe<OpportunityWithoutTagsCreateInput>;
};

export type TagCreateResult = MutationResult & {
  __typename?: 'TagCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Tag>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type TagDeleteResult = MutationResult & {
  __typename?: 'TagDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Tag>;
  ok: Scalars['Boolean']['output'];
};

export type TagEdge = {
  __typename?: 'TagEdge';
  node: Tag;
};

export type TagMeta = {
  __typename?: 'TagMeta';
  actions?: Maybe<FieldMeta>;
  activities?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  name?: Maybe<FieldMeta>;
  opportunities?: Maybe<FieldMeta>;
};

export type TagOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type TagUniqueWhere = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type TagUpdateActionsEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ActionUniqueWhere>;
  create?: InputMaybe<ActionWithoutTagsCreateInput>;
  delete?: InputMaybe<ActionUniqueWhere>;
  disconnect?: InputMaybe<ActionUniqueWhere>;
  update?: InputMaybe<TagUpdateActionsRelationInput>;
  upsert?: InputMaybe<TagUpsertActionsRelationInput>;
};

export type TagUpdateActionsRelationInput = {
  by: ActionUniqueWhere;
  data: ActionWithoutTagsUpdateInput;
};

export type TagUpdateActivitiesEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<ActivityUniqueWhere>;
  create?: InputMaybe<ActivityWithoutTagsCreateInput>;
  delete?: InputMaybe<ActivityUniqueWhere>;
  disconnect?: InputMaybe<ActivityUniqueWhere>;
  update?: InputMaybe<TagUpdateActivitiesRelationInput>;
  upsert?: InputMaybe<TagUpsertActivitiesRelationInput>;
};

export type TagUpdateActivitiesRelationInput = {
  by: ActivityUniqueWhere;
  data: ActivityWithoutTagsUpdateInput;
};

export type TagUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<TagUpdateActionsEntityRelationInput>>;
  activities?: InputMaybe<Array<TagUpdateActivitiesEntityRelationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<TagUpdateOpportunitiesEntityRelationInput>>;
};

export type TagUpdateOpportunitiesEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<OpportunityUniqueWhere>;
  create?: InputMaybe<OpportunityWithoutTagsCreateInput>;
  delete?: InputMaybe<OpportunityUniqueWhere>;
  disconnect?: InputMaybe<OpportunityUniqueWhere>;
  update?: InputMaybe<TagUpdateOpportunitiesRelationInput>;
  upsert?: InputMaybe<TagUpsertOpportunitiesRelationInput>;
};

export type TagUpdateOpportunitiesRelationInput = {
  by: OpportunityUniqueWhere;
  data: OpportunityWithoutTagsUpdateInput;
};

export type TagUpdateResult = MutationResult & {
  __typename?: 'TagUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Tag>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type TagUpsertActionsRelationInput = {
  by: ActionUniqueWhere;
  create: ActionWithoutTagsCreateInput;
  update: ActionWithoutTagsUpdateInput;
};

export type TagUpsertActivitiesRelationInput = {
  by: ActivityUniqueWhere;
  create: ActivityWithoutTagsCreateInput;
  update: ActivityWithoutTagsUpdateInput;
};

export type TagUpsertOpportunitiesRelationInput = {
  by: OpportunityUniqueWhere;
  create: OpportunityWithoutTagsCreateInput;
  update: OpportunityWithoutTagsUpdateInput;
};

export type TagUpsertResult = MutationResult & {
  __typename?: 'TagUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Tag>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type TagWhere = {
  actions?: InputMaybe<ActionWhere>;
  activities?: InputMaybe<ActivityWhere>;
  and?: InputMaybe<Array<InputMaybe<TagWhere>>>;
  id?: InputMaybe<UuidCondition>;
  name?: InputMaybe<StringCondition>;
  not?: InputMaybe<TagWhere>;
  opportunities?: InputMaybe<OpportunityWhere>;
  or?: InputMaybe<Array<InputMaybe<TagWhere>>>;
};

export type TagWithoutActionsCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activities?: InputMaybe<Array<TagCreateActivitiesEntityRelationInput>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<TagCreateOpportunitiesEntityRelationInput>>;
};

export type TagWithoutActionsUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activities?: InputMaybe<Array<TagUpdateActivitiesEntityRelationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<TagUpdateOpportunitiesEntityRelationInput>>;
};

export type TagWithoutActivitiesCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<TagCreateActionsEntityRelationInput>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<TagCreateOpportunitiesEntityRelationInput>>;
};

export type TagWithoutActivitiesUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<TagUpdateActionsEntityRelationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunities?: InputMaybe<Array<TagUpdateOpportunitiesEntityRelationInput>>;
};

export type TagWithoutOpportunitiesCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<TagCreateActionsEntityRelationInput>>;
  activities?: InputMaybe<Array<TagCreateActivitiesEntityRelationInput>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TagWithoutOpportunitiesUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  actions?: InputMaybe<Array<TagUpdateActionsEntityRelationInput>>;
  activities?: InputMaybe<Array<TagUpdateActivitiesEntityRelationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Team = {
  __typename?: 'Team';
  _meta?: Maybe<TeamMeta>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  journeys: Array<Journey>;
  members: Array<Member>;
  membersByActions?: Maybe<Member>;
  membersByActivities?: Maybe<Member>;
  membersByGoogleSheetsConsent?: Maybe<Member>;
  membersByOpportunities?: Maybe<Member>;
  membersBySettings?: Maybe<Member>;
  name: Scalars['String']['output'];
  paginateJourneys: JourneyConnection;
  paginateMembers: MemberConnection;
};


export type TeamJourneysArgs = {
  filter?: InputMaybe<JourneyWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<JourneyOrderBy>>;
};


export type TeamMembersArgs = {
  filter?: InputMaybe<MemberWhere>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberOrderBy>>;
};


export type TeamMembersByActionsArgs = {
  by: TeamMembersByActionsUniqueWhere;
  filter?: InputMaybe<MemberWhere>;
};


export type TeamMembersByActivitiesArgs = {
  by: TeamMembersByActivitiesUniqueWhere;
  filter?: InputMaybe<MemberWhere>;
};


export type TeamMembersByGoogleSheetsConsentArgs = {
  by: TeamMembersByGoogleSheetsConsentUniqueWhere;
  filter?: InputMaybe<MemberWhere>;
};


export type TeamMembersByOpportunitiesArgs = {
  by: TeamMembersByOpportunitiesUniqueWhere;
  filter?: InputMaybe<MemberWhere>;
};


export type TeamMembersBySettingsArgs = {
  by: TeamMembersBySettingsUniqueWhere;
  filter?: InputMaybe<MemberWhere>;
};


export type TeamPaginateJourneysArgs = {
  filter?: InputMaybe<JourneyWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<JourneyOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type TeamPaginateMembersArgs = {
  filter?: InputMaybe<MemberWhere>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type TeamConnectOrCreateJourneysRelationInput = {
  connect: JourneyUniqueWhere;
  create: JourneyWithoutTeamsCreateInput;
};

export type TeamConnectOrCreateMembersRelationInput = {
  connect: MemberUniqueWhere;
  create: MemberWithoutTeamCreateInput;
};

export type TeamConnection = {
  __typename?: 'TeamConnection';
  edges: Array<TeamEdge>;
  pageInfo: PageInfo;
};

export type TeamCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  journeys?: InputMaybe<Array<TeamCreateJourneysEntityRelationInput>>;
  members?: InputMaybe<Array<TeamCreateMembersEntityRelationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreateJourneysEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<JourneyUniqueWhere>;
  connectOrCreate?: InputMaybe<TeamConnectOrCreateJourneysRelationInput>;
  create?: InputMaybe<JourneyWithoutTeamsCreateInput>;
};

export type TeamCreateMembersEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<MemberUniqueWhere>;
  connectOrCreate?: InputMaybe<TeamConnectOrCreateMembersRelationInput>;
  create?: InputMaybe<MemberWithoutTeamCreateInput>;
};

export type TeamCreateResult = MutationResult & {
  __typename?: 'TeamCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Team>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type TeamDeleteResult = MutationResult & {
  __typename?: 'TeamDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Team>;
  ok: Scalars['Boolean']['output'];
};

export type TeamEdge = {
  __typename?: 'TeamEdge';
  node: Team;
};

export type TeamMembersByActionsUniqueWhere = {
  actions?: InputMaybe<ActionUniqueWhere>;
};

export type TeamMembersByActivitiesUniqueWhere = {
  activities?: InputMaybe<ActivityUniqueWhere>;
};

export type TeamMembersByGoogleSheetsConsentUniqueWhere = {
  googleSheetsConsent?: InputMaybe<MetricGoogleSheetsSourceUniqueWhere>;
};

export type TeamMembersByOpportunitiesUniqueWhere = {
  opportunities?: InputMaybe<OpportunityUniqueWhere>;
};

export type TeamMembersBySettingsUniqueWhere = {
  settings?: InputMaybe<MemberSettingsUniqueWhere>;
};

export type TeamMeta = {
  __typename?: 'TeamMeta';
  createdAt?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  journeys?: Maybe<FieldMeta>;
  members?: Maybe<FieldMeta>;
  name?: Maybe<FieldMeta>;
};

export type TeamOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type TeamUniqueWhere = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  members?: InputMaybe<MemberUniqueWhere>;
};

export type TeamUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  journeys?: InputMaybe<Array<TeamUpdateJourneysEntityRelationInput>>;
  members?: InputMaybe<Array<TeamUpdateMembersEntityRelationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TeamUpdateJourneysEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<JourneyUniqueWhere>;
  create?: InputMaybe<JourneyWithoutTeamsCreateInput>;
  delete?: InputMaybe<JourneyUniqueWhere>;
  disconnect?: InputMaybe<JourneyUniqueWhere>;
  update?: InputMaybe<TeamUpdateJourneysRelationInput>;
  upsert?: InputMaybe<TeamUpsertJourneysRelationInput>;
};

export type TeamUpdateJourneysRelationInput = {
  by: JourneyUniqueWhere;
  data: JourneyWithoutTeamsUpdateInput;
};

export type TeamUpdateMembersEntityRelationInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  connect?: InputMaybe<MemberUniqueWhere>;
  create?: InputMaybe<MemberWithoutTeamCreateInput>;
  delete?: InputMaybe<MemberUniqueWhere>;
  disconnect?: InputMaybe<MemberUniqueWhere>;
  update?: InputMaybe<TeamUpdateMembersRelationInput>;
  upsert?: InputMaybe<TeamUpsertMembersRelationInput>;
};

export type TeamUpdateMembersRelationInput = {
  by: MemberUniqueWhere;
  data: MemberWithoutTeamUpdateInput;
};

export type TeamUpdateResult = MutationResult & {
  __typename?: 'TeamUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Team>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type TeamUpsertJourneysRelationInput = {
  by: JourneyUniqueWhere;
  create: JourneyWithoutTeamsCreateInput;
  update: JourneyWithoutTeamsUpdateInput;
};

export type TeamUpsertMembersRelationInput = {
  by: MemberUniqueWhere;
  create: MemberWithoutTeamCreateInput;
  update: MemberWithoutTeamUpdateInput;
};

export type TeamUpsertResult = MutationResult & {
  __typename?: 'TeamUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Team>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type TeamWhere = {
  and?: InputMaybe<Array<InputMaybe<TeamWhere>>>;
  createdAt?: InputMaybe<DateTimeCondition>;
  id?: InputMaybe<UuidCondition>;
  journeys?: InputMaybe<JourneyWhere>;
  members?: InputMaybe<MemberWhere>;
  name?: InputMaybe<StringCondition>;
  not?: InputMaybe<TeamWhere>;
  or?: InputMaybe<Array<InputMaybe<TeamWhere>>>;
};

export type TeamWithoutJourneysCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  members?: InputMaybe<Array<TeamCreateMembersEntityRelationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TeamWithoutJourneysUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  members?: InputMaybe<Array<TeamUpdateMembersEntityRelationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TeamWithoutMembersCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  journeys?: InputMaybe<Array<TeamCreateJourneysEntityRelationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TeamWithoutMembersUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  journeys?: InputMaybe<Array<TeamUpdateJourneysEntityRelationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Touchpoint = {
  __typename?: 'Touchpoint';
  _meta?: Maybe<TouchpointMeta>;
  activity?: Maybe<Activity>;
  id: Scalars['UUID']['output'];
  journey?: Maybe<Journey>;
  order: Scalars['Int']['output'];
  parentActivity?: Maybe<Activity>;
  phase?: Maybe<Phase>;
  type: TouchpointType;
};


export type TouchpointActivityArgs = {
  filter?: InputMaybe<ActivityWhere>;
};


export type TouchpointJourneyArgs = {
  filter?: InputMaybe<JourneyWhere>;
};


export type TouchpointParentActivityArgs = {
  filter?: InputMaybe<ActivityWhere>;
};


export type TouchpointPhaseArgs = {
  filter?: InputMaybe<PhaseWhere>;
};

export type TouchpointConnectOrCreateActivityRelationInput = {
  connect: ActivityUniqueWhere;
  create: ActivityWithoutTouchpointCreateInput;
};

export type TouchpointConnectOrCreateJourneyRelationInput = {
  connect: JourneyUniqueWhere;
  create: JourneyCreateInput;
};

export type TouchpointConnectOrCreateParentActivityRelationInput = {
  connect: ActivityUniqueWhere;
  create: ActivityWithoutSubTouchpointsCreateInput;
};

export type TouchpointConnectOrCreatePhaseRelationInput = {
  connect: PhaseUniqueWhere;
  create: PhaseWithoutTouchpointsCreateInput;
};

export type TouchpointConnection = {
  __typename?: 'TouchpointConnection';
  edges: Array<TouchpointEdge>;
  pageInfo: PageInfo;
};

export type TouchpointCreateActivityEntityRelationInput = {
  connect?: InputMaybe<ActivityUniqueWhere>;
  connectOrCreate?: InputMaybe<TouchpointConnectOrCreateActivityRelationInput>;
  create?: InputMaybe<ActivityWithoutTouchpointCreateInput>;
};

export type TouchpointCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activity?: InputMaybe<TouchpointCreateActivityEntityRelationInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  journey?: InputMaybe<TouchpointCreateJourneyEntityRelationInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parentActivity?: InputMaybe<TouchpointCreateParentActivityEntityRelationInput>;
  phase?: InputMaybe<TouchpointCreatePhaseEntityRelationInput>;
  type?: InputMaybe<TouchpointType>;
};

export type TouchpointCreateJourneyEntityRelationInput = {
  connect?: InputMaybe<JourneyUniqueWhere>;
  connectOrCreate?: InputMaybe<TouchpointConnectOrCreateJourneyRelationInput>;
  create?: InputMaybe<JourneyCreateInput>;
};

export type TouchpointCreateParentActivityEntityRelationInput = {
  connect?: InputMaybe<ActivityUniqueWhere>;
  connectOrCreate?: InputMaybe<TouchpointConnectOrCreateParentActivityRelationInput>;
  create?: InputMaybe<ActivityWithoutSubTouchpointsCreateInput>;
};

export type TouchpointCreatePhaseEntityRelationInput = {
  connect?: InputMaybe<PhaseUniqueWhere>;
  connectOrCreate?: InputMaybe<TouchpointConnectOrCreatePhaseRelationInput>;
  create?: InputMaybe<PhaseWithoutTouchpointsCreateInput>;
};

export type TouchpointCreateResult = MutationResult & {
  __typename?: 'TouchpointCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Touchpoint>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type TouchpointDeleteResult = MutationResult & {
  __typename?: 'TouchpointDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Touchpoint>;
  ok: Scalars['Boolean']['output'];
};

export type TouchpointEdge = {
  __typename?: 'TouchpointEdge';
  node: Touchpoint;
};

export type TouchpointMeta = {
  __typename?: 'TouchpointMeta';
  activity?: Maybe<FieldMeta>;
  id?: Maybe<FieldMeta>;
  journey?: Maybe<FieldMeta>;
  order?: Maybe<FieldMeta>;
  parentActivity?: Maybe<FieldMeta>;
  phase?: Maybe<FieldMeta>;
  type?: Maybe<FieldMeta>;
};

export type TouchpointOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  activity?: InputMaybe<ActivityOrderBy>;
  id?: InputMaybe<OrderDirection>;
  journey?: InputMaybe<JourneyOrderBy>;
  order?: InputMaybe<OrderDirection>;
  parentActivity?: InputMaybe<ActivityOrderBy>;
  phase?: InputMaybe<PhaseOrderBy>;
  type?: InputMaybe<OrderDirection>;
};

export type TouchpointType =
  | 'activity'
  | 'journey'
  | 'subactivity';

export type TouchpointTypeCondition = {
  and?: InputMaybe<Array<TouchpointTypeCondition>>;
  eq?: InputMaybe<TouchpointType>;
  gt?: InputMaybe<TouchpointType>;
  gte?: InputMaybe<TouchpointType>;
  in?: InputMaybe<Array<TouchpointType>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<TouchpointType>;
  lte?: InputMaybe<TouchpointType>;
  not?: InputMaybe<TouchpointTypeCondition>;
  notEq?: InputMaybe<TouchpointType>;
  notIn?: InputMaybe<Array<TouchpointType>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<TouchpointTypeCondition>>;
};

export type TouchpointUniqueWhere = {
  activity?: InputMaybe<ActivityUniqueWhere>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type TouchpointUpdateActivityEntityRelationInput = {
  connect?: InputMaybe<ActivityUniqueWhere>;
  connectOrCreate?: InputMaybe<TouchpointConnectOrCreateActivityRelationInput>;
  create?: InputMaybe<ActivityWithoutTouchpointCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<ActivityWithoutTouchpointUpdateInput>;
  upsert?: InputMaybe<TouchpointUpsertActivityRelationInput>;
};

export type TouchpointUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activity?: InputMaybe<TouchpointUpdateActivityEntityRelationInput>;
  journey?: InputMaybe<TouchpointUpdateJourneyEntityRelationInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parentActivity?: InputMaybe<TouchpointUpdateParentActivityEntityRelationInput>;
  phase?: InputMaybe<TouchpointUpdatePhaseEntityRelationInput>;
  type?: InputMaybe<TouchpointType>;
};

export type TouchpointUpdateJourneyEntityRelationInput = {
  connect?: InputMaybe<JourneyUniqueWhere>;
  connectOrCreate?: InputMaybe<TouchpointConnectOrCreateJourneyRelationInput>;
  create?: InputMaybe<JourneyCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<JourneyUpdateInput>;
  upsert?: InputMaybe<TouchpointUpsertJourneyRelationInput>;
};

export type TouchpointUpdateParentActivityEntityRelationInput = {
  connect?: InputMaybe<ActivityUniqueWhere>;
  connectOrCreate?: InputMaybe<TouchpointConnectOrCreateParentActivityRelationInput>;
  create?: InputMaybe<ActivityWithoutSubTouchpointsCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<ActivityWithoutSubTouchpointsUpdateInput>;
  upsert?: InputMaybe<TouchpointUpsertParentActivityRelationInput>;
};

export type TouchpointUpdatePhaseEntityRelationInput = {
  connect?: InputMaybe<PhaseUniqueWhere>;
  connectOrCreate?: InputMaybe<TouchpointConnectOrCreatePhaseRelationInput>;
  create?: InputMaybe<PhaseWithoutTouchpointsCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<PhaseWithoutTouchpointsUpdateInput>;
  upsert?: InputMaybe<TouchpointUpsertPhaseRelationInput>;
};

export type TouchpointUpdateResult = MutationResult & {
  __typename?: 'TouchpointUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Touchpoint>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type TouchpointUpsertActivityRelationInput = {
  create: ActivityWithoutTouchpointCreateInput;
  update: ActivityWithoutTouchpointUpdateInput;
};

export type TouchpointUpsertJourneyRelationInput = {
  create: JourneyCreateInput;
  update: JourneyUpdateInput;
};

export type TouchpointUpsertParentActivityRelationInput = {
  create: ActivityWithoutSubTouchpointsCreateInput;
  update: ActivityWithoutSubTouchpointsUpdateInput;
};

export type TouchpointUpsertPhaseRelationInput = {
  create: PhaseWithoutTouchpointsCreateInput;
  update: PhaseWithoutTouchpointsUpdateInput;
};

export type TouchpointUpsertResult = MutationResult & {
  __typename?: 'TouchpointUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Touchpoint>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type TouchpointWhere = {
  activity?: InputMaybe<ActivityWhere>;
  and?: InputMaybe<Array<InputMaybe<TouchpointWhere>>>;
  id?: InputMaybe<UuidCondition>;
  journey?: InputMaybe<JourneyWhere>;
  not?: InputMaybe<TouchpointWhere>;
  or?: InputMaybe<Array<InputMaybe<TouchpointWhere>>>;
  order?: InputMaybe<IntCondition>;
  parentActivity?: InputMaybe<ActivityWhere>;
  phase?: InputMaybe<PhaseWhere>;
  type?: InputMaybe<TouchpointTypeCondition>;
};

export type TouchpointWithoutActivityCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  journey?: InputMaybe<TouchpointCreateJourneyEntityRelationInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parentActivity?: InputMaybe<TouchpointCreateParentActivityEntityRelationInput>;
  phase?: InputMaybe<TouchpointCreatePhaseEntityRelationInput>;
  type?: InputMaybe<TouchpointType>;
};

export type TouchpointWithoutActivityUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  journey?: InputMaybe<TouchpointUpdateJourneyEntityRelationInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parentActivity?: InputMaybe<TouchpointUpdateParentActivityEntityRelationInput>;
  phase?: InputMaybe<TouchpointUpdatePhaseEntityRelationInput>;
  type?: InputMaybe<TouchpointType>;
};

export type TouchpointWithoutParentActivityCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activity?: InputMaybe<TouchpointCreateActivityEntityRelationInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  journey?: InputMaybe<TouchpointCreateJourneyEntityRelationInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  phase?: InputMaybe<TouchpointCreatePhaseEntityRelationInput>;
  type?: InputMaybe<TouchpointType>;
};

export type TouchpointWithoutParentActivityUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activity?: InputMaybe<TouchpointUpdateActivityEntityRelationInput>;
  journey?: InputMaybe<TouchpointUpdateJourneyEntityRelationInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  phase?: InputMaybe<TouchpointUpdatePhaseEntityRelationInput>;
  type?: InputMaybe<TouchpointType>;
};

export type TouchpointWithoutPhaseCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activity?: InputMaybe<TouchpointCreateActivityEntityRelationInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  journey?: InputMaybe<TouchpointCreateJourneyEntityRelationInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parentActivity?: InputMaybe<TouchpointCreateParentActivityEntityRelationInput>;
  type?: InputMaybe<TouchpointType>;
};

export type TouchpointWithoutPhaseUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  activity?: InputMaybe<TouchpointUpdateActivityEntityRelationInput>;
  journey?: InputMaybe<TouchpointUpdateJourneyEntityRelationInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parentActivity?: InputMaybe<TouchpointUpdateParentActivityEntityRelationInput>;
  type?: InputMaybe<TouchpointType>;
};

export type TrendComparison =
  | 'absolute'
  | 'relative';

export type TriggerMetricsSyncResult = {
  __typename?: 'TriggerMetricsSyncResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UuidCondition = {
  and?: InputMaybe<Array<UuidCondition>>;
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  not?: InputMaybe<UuidCondition>;
  notEq?: InputMaybe<Scalars['UUID']['input']>;
  notIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<UuidCondition>>;
};

export type Units =
  | 'currency'
  | 'number'
  | 'percentage';

export type UnmanagedInviteOptions = {
  password?: InputMaybe<Scalars['String']['input']>;
  resetTokenHash?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateIdpError = {
  __typename?: 'UpdateIDPError';
  code: UpdateIdpErrorCode;
  developerMessage: Scalars['String']['output'];
};

export type UpdateIdpErrorCode =
  | 'INVALID_CONFIGURATION'
  | 'NOT_FOUND';

export type UpdateIdpResponse = {
  __typename?: 'UpdateIDPResponse';
  error?: Maybe<UpdateIdpError>;
  ok: Scalars['Boolean']['output'];
};

export type UpdateOrganizationResult = {
  __typename?: 'UpdateOrganizationResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UpdateProjectError = {
  __typename?: 'UpdateProjectError';
  code: UpdateProjectErrorCode;
  developerMessage: Scalars['String']['output'];
};

export type UpdateProjectErrorCode =
  | 'PROJECT_NOT_FOUND';

export type UpdateProjectMemberError = {
  __typename?: 'UpdateProjectMemberError';
  code: UpdateProjectMemberErrorCode;
  developerMessage: Scalars['String']['output'];
  /** @deprecated Field no longer supported */
  endUserMessage?: Maybe<Scalars['String']['output']>;
  membershipValidation?: Maybe<Array<MembershipValidationError>>;
};

export type UpdateProjectMemberErrorCode =
  | 'INVALID_MEMBERSHIP'
  | 'NOT_MEMBER'
  | 'PROJECT_NOT_FOUND'
  | 'ROLE_NOT_FOUND'
  | 'VARIABLE_EMPTY'
  | 'VARIABLE_NOT_FOUND';

export type UpdateProjectMemberResponse = {
  __typename?: 'UpdateProjectMemberResponse';
  error?: Maybe<UpdateProjectMemberError>;
  /** @deprecated Field no longer supported */
  errors: Array<UpdateProjectMemberError>;
  ok: Scalars['Boolean']['output'];
};

export type UpdateProjectResponse = {
  __typename?: 'UpdateProjectResponse';
  error?: Maybe<UpdateProjectError>;
  ok: Scalars['Boolean']['output'];
};

export type UpdateSingleExistingContentMetricDataSet = {
  metricId: Scalars['String']['input'];
  metricTemplateId: Scalars['String']['input'];
  sheetTitle: Scalars['String']['input'];
  spreadsheetId: Scalars['String']['input'];
};

export type UpdateSingleExistingContentMetricDataSetResult = {
  __typename?: 'UpdateSingleExistingContentMetricDataSetResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type VariableEntry = {
  __typename?: 'VariableEntry';
  name: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type VariableEntryInput = {
  name: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type WebhookCheckoutCompletedResult = {
  __typename?: 'WebhookCheckoutCompletedResult';
  ok: Scalars['Boolean']['output'];
};

export type WebhookImageProcessingResult = {
  __typename?: 'WebhookImageProcessingResult';
  ok: Scalars['Boolean']['output'];
};

export type Widget = {
  __typename?: 'Widget';
  _meta?: Maybe<WidgetMeta>;
  id: Scalars['UUID']['output'];
  journey?: Maybe<Journey>;
  name?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  type: WidgetType;
};


export type WidgetJourneyArgs = {
  filter?: InputMaybe<JourneyWhere>;
};

export type WidgetConnectOrCreateJourneyRelationInput = {
  connect: JourneyUniqueWhere;
  create: JourneyWithoutWidgetsCreateInput;
};

export type WidgetConnection = {
  __typename?: 'WidgetConnection';
  edges: Array<WidgetEdge>;
  pageInfo: PageInfo;
};

export type WidgetCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  journey?: InputMaybe<WidgetCreateJourneyEntityRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<WidgetType>;
};

export type WidgetCreateJourneyEntityRelationInput = {
  connect?: InputMaybe<JourneyUniqueWhere>;
  connectOrCreate?: InputMaybe<WidgetConnectOrCreateJourneyRelationInput>;
  create?: InputMaybe<JourneyWithoutWidgetsCreateInput>;
};

export type WidgetCreateResult = MutationResult & {
  __typename?: 'WidgetCreateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Widget>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type WidgetDeleteResult = MutationResult & {
  __typename?: 'WidgetDeleteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Widget>;
  ok: Scalars['Boolean']['output'];
};

export type WidgetEdge = {
  __typename?: 'WidgetEdge';
  node: Widget;
};

export type WidgetMeta = {
  __typename?: 'WidgetMeta';
  id?: Maybe<FieldMeta>;
  journey?: Maybe<FieldMeta>;
  name?: Maybe<FieldMeta>;
  order?: Maybe<FieldMeta>;
  type?: Maybe<FieldMeta>;
};

export type WidgetOrderBy = {
  _random?: InputMaybe<Scalars['Boolean']['input']>;
  _randomSeeded?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<OrderDirection>;
  journey?: InputMaybe<JourneyOrderBy>;
  name?: InputMaybe<OrderDirection>;
  order?: InputMaybe<OrderDirection>;
  type?: InputMaybe<OrderDirection>;
};

export type WidgetType =
  | 'actions'
  | 'connectedjourneys'
  | 'description'
  | 'duration'
  | 'goalsandobjectives'
  | 'links'
  | 'metrics'
  | 'notes'
  | 'opportunities'
  | 'owner'
  | 'personas'
  | 'pictures'
  | 'satisfaction'
  | 'subactivities'
  | 'tags';

export type WidgetTypeCondition = {
  and?: InputMaybe<Array<WidgetTypeCondition>>;
  eq?: InputMaybe<WidgetType>;
  gt?: InputMaybe<WidgetType>;
  gte?: InputMaybe<WidgetType>;
  in?: InputMaybe<Array<WidgetType>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<WidgetType>;
  lte?: InputMaybe<WidgetType>;
  not?: InputMaybe<WidgetTypeCondition>;
  notEq?: InputMaybe<WidgetType>;
  notIn?: InputMaybe<Array<WidgetType>>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<WidgetTypeCondition>>;
};

export type WidgetUniqueWhere = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type WidgetUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  journey?: InputMaybe<WidgetUpdateJourneyEntityRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<WidgetType>;
};

export type WidgetUpdateJourneyEntityRelationInput = {
  connect?: InputMaybe<JourneyUniqueWhere>;
  connectOrCreate?: InputMaybe<WidgetConnectOrCreateJourneyRelationInput>;
  create?: InputMaybe<JourneyWithoutWidgetsCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<JourneyWithoutWidgetsUpdateInput>;
  upsert?: InputMaybe<WidgetUpsertJourneyRelationInput>;
};

export type WidgetUpdateResult = MutationResult & {
  __typename?: 'WidgetUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Widget>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type WidgetUpsertJourneyRelationInput = {
  create: JourneyWithoutWidgetsCreateInput;
  update: JourneyWithoutWidgetsUpdateInput;
};

export type WidgetUpsertResult = MutationResult & {
  __typename?: 'WidgetUpsertResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<_MutationError>;
  node?: Maybe<Widget>;
  ok: Scalars['Boolean']['output'];
  validation: _ValidationResult;
};

export type WidgetWhere = {
  and?: InputMaybe<Array<InputMaybe<WidgetWhere>>>;
  id?: InputMaybe<UuidCondition>;
  journey?: InputMaybe<JourneyWhere>;
  name?: InputMaybe<StringCondition>;
  not?: InputMaybe<WidgetWhere>;
  or?: InputMaybe<Array<InputMaybe<WidgetWhere>>>;
  order?: InputMaybe<IntCondition>;
  type?: InputMaybe<WidgetTypeCondition>;
};

export type WidgetWithoutJourneyCreateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<WidgetType>;
};

export type WidgetWithoutJourneyUpdateInput = {
  _dummy_field_?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<WidgetType>;
};

export type _Argument = _LiteralArgument | _PathArgument | _ValidatorArgument;

export type _Column = _Field & {
  __typename?: '_Column';
  defaultValue?: Maybe<Scalars['Json']['output']>;
  enumName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nullable: Scalars['Boolean']['output'];
  rules: Array<_Rule>;
  type: Scalars['String']['output'];
  validators: Array<_Validator>;
};

export type _Entity = {
  __typename?: '_Entity';
  customPrimaryAllowed: Scalars['Boolean']['output'];
  fields: Array<_Field>;
  name: Scalars['String']['output'];
  unique: Array<_UniqueConstraint>;
};

export type _Enum = {
  __typename?: '_Enum';
  name: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type _Field = {
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  rules: Array<_Rule>;
  type: Scalars['String']['output'];
  validators: Array<_Validator>;
};

export type _FieldPathFragment = {
  __typename?: '_FieldPathFragment';
  field: Scalars['String']['output'];
};

export type _IndexPathFragment = {
  __typename?: '_IndexPathFragment';
  alias?: Maybe<Scalars['String']['output']>;
  index: Scalars['Int']['output'];
};

export type _LiteralArgument = {
  __typename?: '_LiteralArgument';
  value?: Maybe<Scalars['Json']['output']>;
};

export type _MutationError = {
  __typename?: '_MutationError';
  message?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `paths`. */
  path: Array<_PathFragment>;
  paths: Array<Array<_PathFragment>>;
  type: _MutationErrorType;
};

export type _MutationErrorType =
  | 'ForeignKeyConstraintViolation'
  | 'InvalidDataInput'
  | 'NonUniqueWhereInput'
  | 'NotFoundOrDenied'
  | 'NotNullConstraintViolation'
  | 'SqlError'
  | 'UniqueConstraintViolation';

export type _OnDeleteBehaviour =
  | 'cascade'
  | 'restrict'
  | 'setNull';

export type _OrderBy = {
  __typename?: '_OrderBy';
  direction: _OrderByDirection;
  path: Array<Scalars['String']['output']>;
};

export type _OrderByDirection =
  | 'asc'
  | 'desc';

export type _PathArgument = {
  __typename?: '_PathArgument';
  path: Array<Scalars['String']['output']>;
};

export type _PathFragment = _FieldPathFragment | _IndexPathFragment;

export type _Relation = _Field & {
  __typename?: '_Relation';
  inversedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  onDelete?: Maybe<_OnDeleteBehaviour>;
  orderBy?: Maybe<Array<_OrderBy>>;
  orphanRemoval?: Maybe<Scalars['Boolean']['output']>;
  ownedBy?: Maybe<Scalars['String']['output']>;
  rules: Array<_Rule>;
  side: _RelationSide;
  targetEntity: Scalars['String']['output'];
  type: Scalars['String']['output'];
  validators: Array<_Validator>;
};

export type _RelationSide =
  | 'inverse'
  | 'owning';

export type _Rule = {
  __typename?: '_Rule';
  message?: Maybe<_RuleMessage>;
  validator: Scalars['Int']['output'];
};

export type _RuleMessage = {
  __typename?: '_RuleMessage';
  text?: Maybe<Scalars['String']['output']>;
};

export type _Schema = {
  __typename?: '_Schema';
  entities: Array<_Entity>;
  enums: Array<_Enum>;
};

export type _Service = {
  __typename?: '_Service';
  sdl?: Maybe<Scalars['String']['output']>;
};

export type _UniqueConstraint = {
  __typename?: '_UniqueConstraint';
  fields: Array<Scalars['String']['output']>;
};

export type _ValidationError = {
  __typename?: '_ValidationError';
  message: _ValidationMessage;
  path: Array<_PathFragment>;
};

export type _ValidationMessage = {
  __typename?: '_ValidationMessage';
  text: Scalars['String']['output'];
};

export type _ValidationResult = {
  __typename?: '_ValidationResult';
  errors: Array<_ValidationError>;
  valid: Scalars['Boolean']['output'];
};

export type _Validator = {
  __typename?: '_Validator';
  arguments: Array<_Argument>;
  operation: Scalars['String']['output'];
};

export type _ValidatorArgument = {
  __typename?: '_ValidatorArgument';
  validator: Scalars['Int']['output'];
};

export type JourneyEditDrawer_GetJourneyUniqueMetricsQueryVariables = Exact<{
  journeyId: Scalars['UUID']['input'];
}>;


export type JourneyEditDrawer_GetJourneyUniqueMetricsQuery = { __typename?: 'Query', getJourney?: { __typename?: 'Journey', phases: Array<{ __typename?: 'Phase', contentMetrics: Array<{ __typename?: 'ContentMetric', metric?: { __typename?: 'Metric', id: string, name: string } | null }> }>, mainMetric?: { __typename?: 'ContentMetric', metric?: { __typename?: 'Metric', id: string } | null } | null } | null };

export type JourneyEditDrawer_SetJourneyMainMetricMutationVariables = Exact<{
  journeyId: Scalars['UUID']['input'];
  mainMetric: Scalars['UUID']['input'];
}>;


export type JourneyEditDrawer_SetJourneyMainMetricMutation = { __typename?: 'Mutation', updateJourney: { __typename?: 'JourneyUpdateResult', ok: boolean, errorMessage?: string | null } };

export type JourneyEditDrawer_DisconnectJourneyMainMetricMutationVariables = Exact<{
  journeyId: Scalars['UUID']['input'];
}>;


export type JourneyEditDrawer_DisconnectJourneyMainMetricMutation = { __typename?: 'Mutation', updateJourney: { __typename?: 'JourneyUpdateResult', ok: boolean, errorMessage?: string | null } };

export type Journey_SelectTeamQueryVariables = Exact<{ [key: string]: never; }>;


export type Journey_SelectTeamQuery = { __typename?: 'Query', listTeam: Array<{ __typename?: 'Team', id: string, name: string }> };

export type ActionAddOpportunityModal_ListOpportunitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type ActionAddOpportunityModal_ListOpportunitiesQuery = { __typename?: 'Query', listOpportunity: Array<{ __typename?: 'Opportunity', id: string, name: string }> };

export type ActionAddOpportunityModal_GetActionQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ActionAddOpportunityModal_GetActionQuery = { __typename?: 'Query', getAction?: { __typename?: 'Action', opportunities: Array<{ __typename?: 'Opportunity', id: string }> } | null };

export type ActionAddOpportunityModal_CreateOpportunityMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  benefit?: InputMaybe<Scalars['Int']['input']>;
  status: OpportunityStatus;
  links: Scalars['Json']['input'];
  activities?: InputMaybe<Array<OpportunityCreateActivitiesEntityRelationInput> | OpportunityCreateActivitiesEntityRelationInput>;
}>;


export type ActionAddOpportunityModal_CreateOpportunityMutation = { __typename?: 'Mutation', createOpportunity: { __typename?: 'OpportunityCreateResult', ok: boolean, errorMessage?: string | null, node?: { __typename?: 'Opportunity', id: string } | null } };

export type ActionAddOpportunityModal_UpdateActionOpportunitiesMutationVariables = Exact<{
  actionId: Scalars['UUID']['input'];
  opportunityId: Scalars['UUID']['input'];
}>;


export type ActionAddOpportunityModal_UpdateActionOpportunitiesMutation = { __typename?: 'Mutation', updateAction: { __typename?: 'ActionUpdateResult', ok: boolean, errorMessage?: string | null } };

export type ActionOpportunitiesList_GetActionQueryVariables = Exact<{
  actionId: Scalars['UUID']['input'];
}>;


export type ActionOpportunitiesList_GetActionQuery = { __typename?: 'Query', getAction?: { __typename?: 'Action', opportunities: Array<{ __typename?: 'Opportunity', id: string, name: string, status: OpportunityStatus, benefit: number, owner?: { __typename?: 'Member', name: string, avatar?: { __typename?: 'Image', url?: string | null } | null } | null }> } | null };

export type ActionOpportunitiesList_RemoveActionOpportunityMutationVariables = Exact<{
  actionId: Scalars['UUID']['input'];
  opportunityId: Scalars['UUID']['input'];
}>;


export type ActionOpportunitiesList_RemoveActionOpportunityMutation = { __typename?: 'Mutation', updateAction: { __typename?: 'ActionUpdateResult', ok: boolean } };

export type AssignActionModal_UpdateActionMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data: ActionUpdateInput;
}>;


export type AssignActionModal_UpdateActionMutation = { __typename?: 'Mutation', updateAction: { __typename?: 'ActionUpdateResult', ok: boolean, errorMessage?: string | null } };

export type ActionDetailContent_UpdateActionMutationVariables = Exact<{
  actionId: Scalars['UUID']['input'];
  data: ActionUpdateInput;
}>;


export type ActionDetailContent_UpdateActionMutation = { __typename?: 'Mutation', updateAction: { __typename?: 'ActionUpdateResult', ok: boolean, errorMessage?: string | null } };

export type ActionDetailForm_UpdateActionMutationVariables = Exact<{
  actionId: Scalars['UUID']['input'];
  data: ActionUpdateInput;
}>;


export type ActionDetailForm_UpdateActionMutation = { __typename?: 'Mutation', updateAction: { __typename?: 'ActionUpdateResult', ok: boolean, errorMessage?: string | null } };

export type ActionDetailHeader_UpdateActionMutationVariables = Exact<{
  actionId: Scalars['UUID']['input'];
  data: ActionUpdateInput;
}>;


export type ActionDetailHeader_UpdateActionMutation = { __typename?: 'Mutation', updateAction: { __typename?: 'ActionUpdateResult', ok: boolean, errorMessage?: string | null } };

export type ActionDetailPage_GetActionQueryVariables = Exact<{
  actionId: Scalars['UUID']['input'];
}>;


export type ActionDetailPage_GetActionQuery = { __typename?: 'Query', getAction?: { __typename?: 'Action', id: string, name: string, description?: string | null, deadline?: string | null, status: ActionStatus, priority: ActionPriority, links?: unknown | null, createdAt: string, opportunities: Array<{ __typename?: 'Opportunity', id: string, name: string, benefit: number, status: OpportunityStatus, owner?: { __typename?: 'Member', id: string, name: string, avatar?: { __typename?: 'Image', url?: string | null } | null } | null }>, owner?: { __typename?: 'Member', id: string } | null, tags: Array<{ __typename?: 'Tag', id: string }>, activities: Array<{ __typename?: 'Activity', id: string, name: string }> } | null };

export type ActionDeleteModal_GetActionQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ActionDeleteModal_GetActionQuery = { __typename?: 'Query', getAction?: { __typename?: 'Action', name: string } | null };

export type ActionDeleteModal_DeleteActionMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ActionDeleteModal_DeleteActionMutation = { __typename?: 'Mutation', deleteAction: { __typename?: 'ActionDeleteResult', ok: boolean, errorMessage?: string | null } };

export type ActionHeader_ListActionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActionHeader_ListActionsQuery = { __typename?: 'Query', listAction: Array<{ __typename?: 'Action', id: string }> };

export type ActionListHeader_CreateActionMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  priority: ActionPriority;
  status: ActionStatus;
  links: Scalars['Json']['input'];
}>;


export type ActionListHeader_CreateActionMutation = { __typename?: 'Mutation', createAction: { __typename?: 'ActionCreateResult', ok: boolean, errorMessage?: string | null, node?: { __typename?: 'Action', id: string } | null } };

export type ActionList_GetActionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActionList_GetActionsQuery = { __typename?: 'Query', listAction: Array<{ __typename?: 'Action', id: string, name: string, createdAt: string, priority: ActionPriority, status: ActionStatus, deadline?: string | null, owner?: { __typename?: 'Member', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, opportunities: Array<{ __typename?: 'Opportunity', id: string, name: string }>, activities: Array<{ __typename?: 'Activity', id: string, name: string, touchpoint?: { __typename?: 'Touchpoint', phase?: { __typename?: 'Phase', journey?: { __typename?: 'Journey', id: string, name: string, color?: string | null } | null } | null } | null }> }> };

export type Announcement_AnnouncementQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type Announcement_AnnouncementQueryQuery = { __typename?: 'Query', announcements: Array<{ __typename?: 'Announcement', id: string, type: AnnouncementType, message: string }> };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me: { __typename?: 'Member', id: string, name: string, createdAt: string, jobTitle?: string | null, avatar?: { __typename?: 'Image', url?: string | null } | null, person?: { __typename?: 'MemberPerson', id: string, name?: string | null, email: string, roles: Array<string>, organizations: Array<{ __typename?: 'MemberOrganization', id: string, name?: string | null, roles: Array<string>, slug: string, slugAlias?: string | null, slugPreferred: string, isCurrent: boolean }>, currentOrganization?: { __typename?: 'MemberOrganization', id: string, name?: string | null, slug: string, slugAlias?: string | null, slugPreferred: string, isCurrent: boolean, roles: Array<string> } | null } | null } };

export type Auth_SignInMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type Auth_SignInMutation = { __typename?: 'Mutation', signIn?: { __typename?: 'SignInResponse', ok: boolean, result?: { __typename?: 'SignInResult', token: string, memberPerson?: { __typename?: 'MemberPerson', roles: Array<string> } | null } | null, error?: { __typename?: 'SignInError', code: SignInErrorCode } | null } | null };

export type Auth_SignOutMutationVariables = Exact<{ [key: string]: never; }>;


export type Auth_SignOutMutation = { __typename?: 'Mutation', signOut?: { __typename?: 'SignOutResponse', ok: boolean, error?: { __typename?: 'SignOutError', code: SignOutErrorCode } | null } | null };

export type Connection_PaginateActivityQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type Connection_PaginateActivityQuery = { __typename?: 'Query', paginateActivity: { __typename?: 'ActivityConnection', edges: Array<{ __typename?: 'ActivityEdge', node: { __typename?: 'Activity', id: string, name: string, contentMetrics: Array<{ __typename?: 'ContentMetric', id: string, metric?: { __typename?: 'Metric', name: string } | null }>, touchpoint?: { __typename?: 'Touchpoint', phase?: { __typename?: 'Phase', journey?: { __typename?: 'Journey', id: string, name: string } | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type DataPointTable_GetMetricQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DataPointTable_GetMetricQuery = { __typename?: 'Query', getContentMetric?: { __typename?: 'ContentMetric', metric?: { __typename?: 'Metric', dataSet?: { __typename?: 'MetricDataSet', id: string } | null, dataLabels: Array<{ __typename?: 'MetricDataLabel', id: string }> } | null } | null };

export type DataPointTable_ListMetricDataPointQueryVariables = Exact<{
  filter: MetricDataPointWhere;
}>;


export type DataPointTable_ListMetricDataPointQuery = { __typename?: 'Query', listContentMetricDataPoint: Array<{ __typename?: 'ContentMetricDataPoint', id: string, createdAt: string, metricDataPoint?: { __typename?: 'MetricDataPoint', id: string, value: number, start: string, end?: string | null } | null, creator?: { __typename?: 'Member', name: string, avatar?: { __typename?: 'Image', url?: string | null } | null } | null }> };

export type Connections_DeleteMetricDataPointMutationVariables = Exact<{
  contentMetricDataPointId: Scalars['UUID']['input'];
}>;


export type Connections_DeleteMetricDataPointMutation = { __typename?: 'Mutation', deleteContentMetricDataPoint: { __typename?: 'ContentMetricDataPointDeleteResult', ok: boolean, errorMessage?: string | null } };

export type EditDataPoint_GetMetricDataPointQueryVariables = Exact<{
  contentDataPointId: Scalars['UUID']['input'];
}>;


export type EditDataPoint_GetMetricDataPointQuery = { __typename?: 'Query', getContentMetricDataPoint?: { __typename?: 'ContentMetricDataPoint', metricDataPoint?: { __typename?: 'MetricDataPoint', start: string, end?: string | null, value: number } | null } | null };

export type EditDataPoint_GetMetricQueryVariables = Exact<{
  contentMetricId: Scalars['UUID']['input'];
}>;


export type EditDataPoint_GetMetricQuery = { __typename?: 'Query', getContentMetric?: { __typename?: 'ContentMetric', metric?: { __typename?: 'Metric', dataSet?: { __typename?: 'MetricDataSet', id: string } | null } | null } | null };

export type EditDataPoint_CreateMetricDataPointMutationVariables = Exact<{
  start?: InputMaybe<Scalars['DateTime']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  dataSetId: Scalars['UUID']['input'];
  creatorId: Scalars['UUID']['input'];
}>;


export type EditDataPoint_CreateMetricDataPointMutation = { __typename?: 'Mutation', createContentMetricDataPoint: { __typename?: 'ContentMetricDataPointCreateResult', ok: boolean, errorMessage?: string | null } };

export type EditDataPoint_UpdateMetricDataPointMutationVariables = Exact<{
  dataPointId: Scalars['UUID']['input'];
  start?: InputMaybe<Scalars['DateTime']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
}>;


export type EditDataPoint_UpdateMetricDataPointMutation = { __typename?: 'Mutation', updateContentMetricDataPoint: { __typename?: 'ContentMetricDataPointUpdateResult', ok: boolean, errorMessage?: string | null } };

export type Connections_ListMetricTemplateQueryVariables = Exact<{ [key: string]: never; }>;


export type Connections_ListMetricTemplateQuery = { __typename?: 'Query', listMetricTemplate: Array<{ __typename?: 'MetricTemplate', id: string, name: string, isSystem: boolean }> };

export type ListMetricQueryVariables = Exact<{ [key: string]: never; }>;


export type ListMetricQuery = { __typename?: 'Query', listContentMetric: Array<{ __typename?: 'ContentMetric', id: string, metric?: { __typename?: 'Metric', name: string, dataSet?: { __typename?: 'MetricDataSet', metricTemplate?: { __typename?: 'MetricTemplate', id: string } | null } | null } | null }> };

export type SetMapSheetsToMetricTemplateMutationMutationVariables = Exact<{
  input: SetGoogleSheetConfigurationMappingInput;
}>;


export type SetMapSheetsToMetricTemplateMutationMutation = { __typename?: 'Mutation', setGoogleSheetsMetricTemplateMapping: { __typename?: 'SetGoogleSheetsMetricTemplateMappingResult', ok: boolean, errorMessage?: string | null } };

export type DataSourcesList_GoogleSheetsConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type DataSourcesList_GoogleSheetsConfigurationQuery = { __typename?: 'Query', googleSheetsConfiguration?: { __typename?: 'GoogleSheetsConfiguration', spreadsheetId?: string | null } | null };

export type DataSourceList_GoogleSheetsAuthorizedByQueryVariables = Exact<{
  externalId: Scalars['String']['input'];
}>;


export type DataSourceList_GoogleSheetsAuthorizedByQuery = { __typename?: 'Query', getMetricGoogleSheetsSource?: { __typename?: 'MetricGoogleSheetsSource', consent?: { __typename?: 'Member', id: string, name: string, avatar?: { __typename?: 'Image', url?: string | null } | null } | null } | null };

export type GoogleSheetsModal_SetGoogleSheetsConfigurationMutationVariables = Exact<{
  spreadsheetId: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
}>;


export type GoogleSheetsModal_SetGoogleSheetsConfigurationMutation = { __typename?: 'Mutation', setGoogleSheetsConfiguration: { __typename?: 'SetGoogleSheetsConfigurationResult', ok: boolean, errorMessage?: string | null } };

export type TriggerMetricsSyncMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerMetricsSyncMutation = { __typename?: 'Mutation', triggerMetricsSync: { __typename?: 'TriggerMetricsSyncResult', ok: boolean, errorMessage?: string | null } };

export type GoogleSheetsModal_GoogleSheetsConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type GoogleSheetsModal_GoogleSheetsConfigurationQuery = { __typename?: 'Query', googleSheetsConfiguration?: { __typename?: 'GoogleSheetsConfiguration', spreadsheetId?: string | null } | null };

export type GoogleSheetsModal_TriggerMetricsSyncMutationVariables = Exact<{ [key: string]: never; }>;


export type GoogleSheetsModal_TriggerMetricsSyncMutation = { __typename?: 'Mutation', triggerMetricsSync: { __typename?: 'TriggerMetricsSyncResult', ok: boolean, errorMessage?: string | null } };

export type DataSourcelastUpdates_KeboolaSyncEventQueryVariables = Exact<{ [key: string]: never; }>;


export type DataSourcelastUpdates_KeboolaSyncEventQuery = { __typename?: 'Query', listKeboolaSyncEvent: Array<{ __typename?: 'KeboolaSyncEvent', id: string, start: string, end?: string | null, status: KeboolaSyncLogStatus, errorMessage?: string | null }> };

export type GetUnmappedSpreadsheetSheetsQueryQueryVariables = Exact<{
  spreadsheetId: Scalars['String']['input'];
}>;


export type GetUnmappedSpreadsheetSheetsQueryQuery = { __typename?: 'Query', googleSpreadsheetSheets?: { __typename?: 'GoogleSpreadsheetSheets', sheets: Array<{ __typename?: 'GoogleSpreadsheetSheet', sheetTitle?: string | null, templateId?: string | null, templateName?: string | null } | null> } | null };

export type MetricsTable_GoogleSheetsMetricsQueryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MetricsTable_GoogleSheetsMetricsQueryQuery = { __typename?: 'Query', paginateContentMetric: { __typename?: 'ContentMetricConnection', edges: Array<{ __typename?: 'ContentMetricEdge', node: { __typename?: 'ContentMetric', id: string, metric?: { __typename?: 'Metric', id: string, name: string, dataSet?: { __typename?: 'MetricDataSet', id: string } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type MetricsTable_GoogleSpreadsheetsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type MetricsTable_GoogleSpreadsheetsQueryQuery = { __typename?: 'Query', listMetricGoogleSheetsSpreadsheet: Array<{ __typename?: 'MetricGoogleSheetsSpreadsheet', externalId: string }> };

export type SourceMetricsTableRow_ListMetricDataPointQueryVariables = Exact<{
  filter: MetricDataPointWhere;
}>;


export type SourceMetricsTableRow_ListMetricDataPointQuery = { __typename?: 'Query', listContentMetricDataPoint: Array<{ __typename?: 'ContentMetricDataPoint', id: string }> };

export type MapSingleSheetToExistingMetricMutationVariables = Exact<{
  input: UpdateSingleExistingContentMetricDataSet;
}>;


export type MapSingleSheetToExistingMetricMutation = { __typename?: 'Mutation', updateContentMetricDataSetToGoogleSheet: { __typename?: 'UpdateSingleExistingContentMetricDataSetResult', ok: boolean, errorMessage?: string | null } };

export type MapSingleSheetMutationVariables = Exact<{
  input: SingleSheetMappingConfig;
}>;


export type MapSingleSheetMutation = { __typename?: 'Mutation', setSingleSheetMapping: { __typename?: 'SetSingleSheetMappingResult', ok: boolean, errorMessage?: string | null } };

export type UseGoogleAuthorization_SetGoogleSheetsConfigurationMutationVariables = Exact<{
  authorizationCode: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
}>;


export type UseGoogleAuthorization_SetGoogleSheetsConfigurationMutation = { __typename?: 'Mutation', setGoogleSheetsConfiguration: { __typename?: 'SetGoogleSheetsConfigurationResult', ok: boolean, errorMessage?: string | null, accessToken?: string | null } };

export type GoogleSheetsModal_SetGoogleSheetsConfigurationPickerMutationVariables = Exact<{
  spreadsheetId: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
}>;


export type GoogleSheetsModal_SetGoogleSheetsConfigurationPickerMutation = { __typename?: 'Mutation', setGoogleSheetsConfiguration: { __typename?: 'SetGoogleSheetsConfigurationResult', ok: boolean, errorMessage?: string | null, sheets?: Array<{ __typename?: 'SheetToTemplateMap', sheetTitle?: string | null, templateId?: string | null, templateName?: string | null }> | null } };

export type Connections_PaginateMetricsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type Connections_PaginateMetricsQuery = { __typename?: 'Query', paginateContentMetric: { __typename?: 'ContentMetricConnection', edges: Array<{ __typename?: 'ContentMetricEdge', node: { __typename?: 'ContentMetric', id: string, activities: Array<{ __typename?: 'Activity', id: string, name: string, touchpoint?: { __typename?: 'Touchpoint', phase?: { __typename?: 'Phase', journey?: { __typename?: 'Journey', id: string, name: string } | null } | null } | null }>, metric?: { __typename?: 'Metric', name: string, dataSet?: { __typename?: 'MetricDataSet', metricTemplate?: { __typename?: 'MetricTemplate', name: string } | null, source?: { __typename?: 'MetricSource', name: string } | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type Connections_ListMetricDataSetQueryVariables = Exact<{
  sourceId: Scalars['UUID']['input'];
}>;


export type Connections_ListMetricDataSetQuery = { __typename?: 'Query', listMetricDataSet: Array<{ __typename?: 'MetricDataSet', id: string, name: string }> };

export type Connections_CreateMetricDataSetMutationVariables = Exact<{
  sourceId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
}>;


export type Connections_CreateMetricDataSetMutation = { __typename?: 'Mutation', createMetricDataSet: { __typename?: 'MetricDataSetCreateResult', ok: boolean, errorMessage?: string | null, node?: { __typename?: 'MetricDataSet', id: string } | null } };

export type Connections_DeleteMetricMutationVariables = Exact<{
  contentMetricId: Scalars['UUID']['input'];
}>;


export type Connections_DeleteMetricMutation = { __typename?: 'Mutation', deleteContentMetric: { __typename?: 'ContentMetricDeleteResult', ok: boolean, errorMessage?: string | null, node?: { __typename?: 'ContentMetric', metric?: { __typename?: 'Metric', dataSet?: { __typename?: 'MetricDataSet', id: string, source?: { __typename?: 'MetricSource', type: SourceType } | null } | null } | null } | null } };

export type Connections_GetMetricQueryVariables = Exact<{
  contentMetricId: Scalars['UUID']['input'];
}>;


export type Connections_GetMetricQuery = { __typename?: 'Query', getContentMetric?: { __typename?: 'ContentMetric', metric?: { __typename?: 'Metric', name: string, dataSet?: { __typename?: 'MetricDataSet', id: string, name: string, source?: { __typename?: 'MetricSource', id: string, name: string, type: SourceType } | null } | null } | null } | null };

export type Connections_ListMetricDataSourceQueryVariables = Exact<{ [key: string]: never; }>;


export type Connections_ListMetricDataSourceQuery = { __typename?: 'Query', listMetricSource: Array<{ __typename?: 'MetricSource', id: string, name: string }> };

export type Connections_GetMetricDataSetQueryVariables = Exact<{
  dataSetId: Scalars['UUID']['input'];
}>;


export type Connections_GetMetricDataSetQuery = { __typename?: 'Query', getMetricDataSet?: { __typename?: 'MetricDataSet', metricTemplate?: { __typename?: 'MetricTemplate', id: string } | null } | null };

export type Connections_UpdateMetricMutationVariables = Exact<{
  contentMetricId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  dataSetId: Scalars['UUID']['input'];
  templateId: Scalars['UUID']['input'];
}>;


export type Connections_UpdateMetricMutation = { __typename?: 'Mutation', updateContentMetric: { __typename?: 'ContentMetricUpdateResult', ok: boolean, errorMessage?: string | null }, updateMetricDataSet: { __typename?: 'MetricDataSetUpdateResult', ok: boolean, errorMessage?: string | null } };

export type MetricTemplateDescription_GetMetricTemplateQueryVariables = Exact<{
  metricTemplateId: Scalars['UUID']['input'];
}>;


export type MetricTemplateDescription_GetMetricTemplateQuery = { __typename?: 'Query', getMetricTemplate?: { __typename?: 'MetricTemplate', description?: string | null } | null };

export type CreateMetricStepLocation_GetActivityQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CreateMetricStepLocation_GetActivityQuery = { __typename?: 'Query', getActivity?: { __typename?: 'Activity', id: string, touchpoint?: { __typename?: 'Touchpoint', phase?: { __typename?: 'Phase', id: string, journey?: { __typename?: 'Journey', id: string } | null } | null } | null } | null };

export type AssignMetricModal_UpdateMetricMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data: ContentMetricUpdateInput;
}>;


export type AssignMetricModal_UpdateMetricMutation = { __typename?: 'Mutation', updateContentMetric: { __typename?: 'ContentMetricUpdateResult', ok: boolean, errorMessage?: string | null } };

export type Settings_DeleteMetricTemplateMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type Settings_DeleteMetricTemplateMutation = { __typename?: 'Mutation', deleteMetricTemplate: { __typename?: 'MetricTemplateDeleteResult', ok: boolean, errorMessage?: string | null } };

export type Settings_GetMetricTemplateQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type Settings_GetMetricTemplateQuery = { __typename?: 'Query', getMetricTemplate?: { __typename?: 'MetricTemplate', id: string, name: string, isSystem: boolean, behavior: MetricBehavior, precision: number, unit: MetricUnit, unitSign?: string | null, expectations: MetricTemplateExpectations, defaultTrendComparison: MetricTemplateDefaultTrendComparison } | null };

export type Settings_CreateMetricTemplateMutationVariables = Exact<{
  data: MetricTemplateCreateInput;
}>;


export type Settings_CreateMetricTemplateMutation = { __typename?: 'Mutation', createMetricTemplate: { __typename?: 'MetricTemplateCreateResult', ok: boolean, errorMessage?: string | null } };

export type Settings_UpdateMetricTemplateMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data: MetricTemplateUpdateInput;
}>;


export type Settings_UpdateMetricTemplateMutation = { __typename?: 'Mutation', updateMetricTemplate: { __typename?: 'MetricTemplateUpdateResult', ok: boolean, errorMessage?: string | null } };

export type Settings_PaginateMetricTemplateQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type Settings_PaginateMetricTemplateQuery = { __typename?: 'Query', paginateMetricTemplate: { __typename?: 'MetricTemplateConnection', edges: Array<{ __typename?: 'MetricTemplateEdge', node: { __typename?: 'MetricTemplate', id: string, name: string, isSystem: boolean, behavior: MetricBehavior, expectations: MetricTemplateExpectations, precision: number, defaultTrendComparison: MetricTemplateDefaultTrendComparison, paginateDataSets: { __typename?: 'MetricDataSetConnection', pageInfo: { __typename?: 'PageInfo', totalCount: number } } } }>, pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type CreatableMetricTemplateSelect_MetricTemplateFragment = { __typename?: 'MetricTemplate', id: string, name: string, isSystem: boolean } & { ' $fragmentName'?: 'CreatableMetricTemplateSelect_MetricTemplateFragment' };

export type Connections_GetManualMetricSourceQueryVariables = Exact<{ [key: string]: never; }>;


export type Connections_GetManualMetricSourceQuery = { __typename?: 'Query', listMetricSource: Array<{ __typename?: 'MetricSource', id: string }> };

export type Connections_GetMetricTemplateQueryVariables = Exact<{
  templateId: Scalars['UUID']['input'];
}>;


export type Connections_GetMetricTemplateQuery = { __typename?: 'Query', getMetricTemplate?: { __typename?: 'MetricTemplate', behavior: MetricBehavior } | null };

export type Connections_CreateMetricMutationVariables = Exact<{
  data: ContentMetricCreateInput;
}>;


export type Connections_CreateMetricMutation = { __typename?: 'Mutation', createContentMetric: { __typename?: 'ContentMetricCreateResult', ok: boolean, errorMessage?: string | null, node?: { __typename?: 'ContentMetric', id: string } | null } };

export type CreateMetricModal_UpdateMetricMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data: ContentMetricUpdateInput;
}>;


export type CreateMetricModal_UpdateMetricMutation = { __typename?: 'Mutation', updateContentMetric: { __typename?: 'ContentMetricUpdateResult', ok: boolean, errorMessage?: string | null } };

export type CreateMetricStepBasics_ListMetricTemplateQueryVariables = Exact<{ [key: string]: never; }>;


export type CreateMetricStepBasics_ListMetricTemplateQuery = { __typename?: 'Query', listMetricTemplate: Array<(
    { __typename?: 'MetricTemplate', id: string, name: string, description?: string | null }
    & { ' $fragmentRefs'?: { 'CreatableMetricTemplateSelect_MetricTemplateFragment': CreatableMetricTemplateSelect_MetricTemplateFragment } }
  )> };

export type Dashboard_ListMetricQueryVariables = Exact<{ [key: string]: never; }>;


export type Dashboard_ListMetricQuery = { __typename?: 'Query', listContentMetric: Array<{ __typename?: 'ContentMetric', id: string, metric?: { __typename?: 'Metric', id: string, name: string } | null }> };

export type Dashboard_AddedMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type Dashboard_AddedMetricsQuery = { __typename?: 'Query', listDashboardMetric: Array<{ __typename?: 'DashboardMetric', contentMetric?: { __typename?: 'ContentMetric', id: string } | null }> };

export type CreateDashboardMetricMutationVariables = Exact<{
  data: DashboardMetricCreateInput;
}>;


export type CreateDashboardMetricMutation = { __typename?: 'Mutation', createDashboardMetric: { __typename?: 'DashboardMetricCreateResult', ok: boolean, errorMessage?: string | null } };

export type Dashboard_MetricsCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type Dashboard_MetricsCardsQuery = { __typename?: 'Query', listDashboardMetric: Array<{ __typename?: 'DashboardMetric', order: number, contentMetric?: { __typename?: 'ContentMetric', id: string, metric?: { __typename?: 'Metric', id: string, name: string, unitSign?: string | null, dataSet?: { __typename?: 'MetricDataSet', metricTemplate?: { __typename?: 'MetricTemplate', unitSign?: string | null } | null } | null } | null, activities: Array<{ __typename?: 'Activity', touchpoint?: { __typename?: 'Touchpoint', phase?: { __typename?: 'Phase', journey?: { __typename?: 'Journey', color?: string | null, id: string, name: string } | null } | null } | null }> } | null }> };

export type Dashboard_GetJourneysQueryVariables = Exact<{ [key: string]: never; }>;


export type Dashboard_GetJourneysQuery = { __typename?: 'Query', listJourney: Array<{ __typename?: 'Journey', color?: string | null, id: string, name: string, satisfaction?: number | null, personas?: Array<(
      { __typename?: 'Persona', id: string }
      & { ' $fragmentRefs'?: { 'PersonaAvatar_PersonaFragment': PersonaAvatar_PersonaFragment } }
    )> | null, teams: Array<{ __typename?: 'Team', id: string, name: string }>, mainMetric?: { __typename?: 'ContentMetric', metric?: { __typename?: 'Metric', id: string, unitSign?: string | null, dataSet?: { __typename?: 'MetricDataSet', metricTemplate?: { __typename?: 'MetricTemplate', unitSign?: string | null } | null } | null } | null } | null }> };

export type Dashboard_GetMetricValuesQueryVariables = Exact<{
  metricId: Scalars['UUID']['input'];
  range: DateTimeRangeInput;
}>;


export type Dashboard_GetMetricValuesQuery = { __typename?: 'Query', displayMetric?: { __typename?: 'DisplayMetric', chartDataPoints: Array<{ __typename?: 'ChartDataPoint', value?: number | null, time: string }> } | null };

export type Dashboard_UpdateMetricsOrderMutationVariables = Exact<{
  data?: InputMaybe<Array<DashboardUpdateDashboardMetricsEntityRelationInput> | DashboardUpdateDashboardMetricsEntityRelationInput>;
  id: Scalars['UUID']['input'];
}>;


export type Dashboard_UpdateMetricsOrderMutation = { __typename?: 'Mutation', updateDashboard: { __typename?: 'DashboardUpdateResult', ok: boolean, errorMessage?: string | null } };

export type DeleteDashboardMetricMutationVariables = Exact<{
  contentMetricId: Scalars['UUID']['input'];
}>;


export type DeleteDashboardMetricMutation = { __typename?: 'Mutation', deleteDashboardMetric: { __typename?: 'DashboardMetricDeleteResult', ok: boolean, errorMessage?: string | null } };

export type Dashbord_SortedDashboardMetricQueryVariables = Exact<{ [key: string]: never; }>;


export type Dashbord_SortedDashboardMetricQuery = { __typename?: 'Query', listDashboardMetric: Array<{ __typename?: 'DashboardMetric', id: string, contentMetric?: { __typename?: 'ContentMetric', id: string, metric?: { __typename?: 'Metric', id: string, name: string } | null, activities: Array<{ __typename?: 'Activity', touchpoint?: { __typename?: 'Touchpoint', phase?: { __typename?: 'Phase', journey?: { __typename?: 'Journey', color?: string | null, id: string, name: string } | null } | null } | null }> } | null }> };

export type Dashboard_ListDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type Dashboard_ListDashboardQuery = { __typename?: 'Query', listDashboard: Array<{ __typename?: 'Dashboard', id: string }> };

export type DashboardImprovementsActions_ListQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<ActionOrderBy> | ActionOrderBy>;
}>;


export type DashboardImprovementsActions_ListQuery = { __typename?: 'Query', listAction: Array<{ __typename?: 'Action', id: string, name: string, priority: ActionPriority, status: ActionStatus, deadline?: string | null, owner?: { __typename?: 'Member', name: string, avatar?: { __typename?: 'Image', url?: string | null } | null } | null }> };

export type DashboardImprovementsOpportunities_ListQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<OpportunityOrderBy> | OpportunityOrderBy>;
}>;


export type DashboardImprovementsOpportunities_ListQuery = { __typename?: 'Query', listOpportunity: Array<{ __typename?: 'Opportunity', id: string, name: string, status: OpportunityStatus, benefit: number, createdAt: string, owner?: { __typename?: 'Member', name: string, avatar?: { __typename?: 'Image', url?: string | null } | null } | null }> };

export type ActivitiesSelect_ListActivitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type ActivitiesSelect_ListActivitiesQuery = { __typename?: 'Query', listActivity: Array<{ __typename?: 'Activity', id: string, name: string, touchpoint?: { __typename?: 'Touchpoint', phase?: { __typename?: 'Phase', journey?: { __typename?: 'Journey', id: string, name: string, color?: string | null } | null } | null } | null }> };

export type FormJourneySelect_ListJourneyQueryVariables = Exact<{ [key: string]: never; }>;


export type FormJourneySelect_ListJourneyQuery = { __typename?: 'Query', listJourney: Array<{ __typename?: 'Journey', id: string, name: string }> };

export type OpportunitiesMemberSelect_ListMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type OpportunitiesMemberSelect_ListMembersQuery = { __typename?: 'Query', listMember: Array<{ __typename?: 'Member', id: string, name: string, avatar?: { __typename?: 'Image', url?: string | null } | null }> };

export type MembersSelect_ListMemberQueryVariables = Exact<{ [key: string]: never; }>;


export type MembersSelect_ListMemberQuery = { __typename?: 'Query', listMember: Array<{ __typename?: 'Member', id: string, name: string, avatar?: { __typename?: 'Image', url?: string | null } | null }> };

export type PersonasSelect_ListPersonaQueryVariables = Exact<{ [key: string]: never; }>;


export type PersonasSelect_ListPersonaQuery = { __typename?: 'Query', listPersona: Array<(
    { __typename?: 'Persona', id: string, name: string }
    & { ' $fragmentRefs'?: { 'PersonaAvatar_PersonaFragment': PersonaAvatar_PersonaFragment } }
  )> };

export type TagsSelect_ListTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type TagsSelect_ListTagsQuery = { __typename?: 'Query', listTag: Array<{ __typename?: 'Tag', id: string, name: string }> };

export type TagsSelect_CreateTagMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type TagsSelect_CreateTagMutation = { __typename?: 'Mutation', createTag: { __typename?: 'TagCreateResult', ok: boolean, errorMessage?: string | null, node?: { __typename?: 'Tag', id: string } | null } };

export type UseImageUpload_RequestImageUploadMutationVariables = Exact<{ [key: string]: never; }>;


export type UseImageUpload_RequestImageUploadMutation = { __typename?: 'Mutation', requestImageUpload: { __typename?: 'ImageUploadRequestResult', id: string, uploadUrl: string, formDataFields: Array<{ __typename?: 'ImageUploadFormDataField', key: string, value: string }> } };

export type UseImageUpload_GetImageQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type UseImageUpload_GetImageQuery = { __typename?: 'Query', getImage?: { __typename?: 'Image', status?: ImageStatus | null } | null };

export type ActivitySelect_ListTouchpointQueryVariables = Exact<{
  phaseId: Scalars['UUID']['input'];
}>;


export type ActivitySelect_ListTouchpointQuery = { __typename?: 'Query', listTouchpoint: Array<{ __typename?: 'Touchpoint', id: string, activity?: { __typename?: 'Activity', id: string, name: string } | null }> };

export type Journey_ActivityDeleteMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type Journey_ActivityDeleteMutation = { __typename?: 'Mutation', deleteTouchpoint: { __typename?: 'TouchpointDeleteResult', ok: boolean, errorMessage?: string | null } };

export type Journey_GetActivityQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type Journey_GetActivityQuery = { __typename?: 'Query', getTouchpoint?: { __typename?: 'Touchpoint', activity?: { __typename?: 'Activity', description?: string | null, notes?: string | null, goalsAndObjectives?: string | null, links?: unknown | null, opportunities: Array<{ __typename?: 'Opportunity', id: string }>, contentMetrics: Array<{ __typename?: 'ContentMetric', id: string }>, controlCycle?: { __typename?: 'ControlCycle', id: string } | null, owner?: { __typename?: 'Member', id: string } | null, personas: Array<{ __typename?: 'Persona', id: string }>, pictures: Array<{ __typename?: 'Picture', id: string }>, tags: Array<{ __typename?: 'Tag', id: string }>, actions: Array<{ __typename?: 'Action', id: string }> } | null } | null };

export type Journey_DeleteJourneyMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type Journey_DeleteJourneyMutation = { __typename?: 'Mutation', deleteJourney: { __typename?: 'JourneyDeleteResult', ok: boolean, errorMessage?: string | null } };

export type Journey_GetJourneyQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type Journey_GetJourneyQuery = { __typename?: 'Query', getJourney?: { __typename?: 'Journey', phases: Array<{ __typename?: 'Phase', id: string }> } | null };

export type Journey_DeletePhaseMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type Journey_DeletePhaseMutation = { __typename?: 'Mutation', deletePhase: { __typename?: 'PhaseDeleteResult', ok: boolean, errorMessage?: string | null } };

export type Journey_GetPhaseQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type Journey_GetPhaseQuery = { __typename?: 'Query', getPhase?: { __typename?: 'Phase', touchpoints: Array<{ __typename?: 'Touchpoint', id: string }> } | null };

export type Journey_ActivityDuplicateMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type Journey_ActivityDuplicateMutation = { __typename?: 'Mutation', createActivityDeepClone: { __typename?: 'ActivityCreateResult', ok: boolean, errorMessage?: string | null } };

export type EditJourney_SingleJourneyQueryQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type EditJourney_SingleJourneyQueryQuery = { __typename?: 'Query', getJourney?: { __typename?: 'Journey', name: string, teams: Array<{ __typename?: 'Team', id: string, name: string }> } | null };

export type JourneyWarnings_GetJourneyQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type JourneyWarnings_GetJourneyQuery = { __typename?: 'Query', getJourney?: { __typename?: 'Journey', id: string, name: string, color?: string | null, satisfaction?: number | null, widgets: Array<{ __typename?: 'Widget', id: string, order: number, name?: string | null, type: WidgetType }>, phases: Array<{ __typename?: 'Phase', id: string }>, personas?: Array<(
      { __typename?: 'Persona', id: string }
      & { ' $fragmentRefs'?: { 'PersonaAvatar_PersonaFragment': PersonaAvatar_PersonaFragment } }
    )> | null, activityWarnings?: Array<{ __typename?: 'ActivityWarning', id: string }> | null, mainMetric?: { __typename?: 'ContentMetric', metric?: { __typename?: 'Metric', id: string, unitSign?: string | null, dataSet?: { __typename?: 'MetricDataSet', metricTemplate?: { __typename?: 'MetricTemplate', unitSign?: string | null } | null } | null } | null } | null } | null };

export type GetActivityQueryVariables = Exact<{
  activityId: Scalars['UUID']['input'];
}>;


export type GetActivityQuery = { __typename?: 'Query', getActivity?: { __typename?: 'Activity', touchpoint?: { __typename?: 'Touchpoint', parentActivity?: { __typename?: 'Activity', name: string } | null } | null } | null };

export type Journey_UpdateColorMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  color: Scalars['String']['input'];
}>;


export type Journey_UpdateColorMutation = { __typename?: 'Mutation', updateJourney: { __typename?: 'JourneyUpdateResult', ok: boolean, errorMessage?: string | null } };

export type JourneySelect_ListJourneyQueryVariables = Exact<{ [key: string]: never; }>;


export type JourneySelect_ListJourneyQuery = { __typename?: 'Query', listJourney: Array<{ __typename?: 'Journey', id: string, name: string }> };

export type PhaseSelect_ListPhaseQueryVariables = Exact<{
  journeyId: Scalars['UUID']['input'];
}>;


export type PhaseSelect_ListPhaseQuery = { __typename?: 'Query', listPhase: Array<{ __typename?: 'Phase', id: string, name: string }> };

export type JourneyFilters_PhasesFragment = { __typename?: 'Phase', id: string, touchpoints: Array<{ __typename?: 'Touchpoint', id: string, activity?: { __typename?: 'Activity', satisfaction: number, duration?: { __typename?: 'ActivityDuration', end?: string | null, start?: string | null, type: ActivityDurationType } | null, tags: Array<{ __typename?: 'Tag', id: string }>, personas: Array<{ __typename?: 'Persona', id: string }>, owner?: { __typename?: 'Member', id: string } | null } | null }> } & { ' $fragmentName'?: 'JourneyFilters_PhasesFragment' };

export type Journey_CreateJourneyFromTemplateMutationVariables = Exact<{
  journeyId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
}>;


export type Journey_CreateJourneyFromTemplateMutation = { __typename?: 'Mutation', createJourneyDeepClone: { __typename?: 'JourneyCreateResult', ok: boolean, errorMessage?: string | null, node?: { __typename?: 'Journey', id: string } | null } };

export type Journey_CreateJourneyMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type Journey_CreateJourneyMutation = { __typename?: 'Mutation', createJourney: { __typename?: 'JourneyCreateResult', ok: boolean, errorMessage?: string | null, node?: { __typename?: 'Journey', id: string } | null } };

export type JourneyCreateModal_ListJourneyTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type JourneyCreateModal_ListJourneyTemplatesQuery = { __typename?: 'Query', listJourney: Array<{ __typename?: 'Journey', id: string, name: string, color?: string | null, description?: string | null }> };

export type Journey_ListJourneyTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type Journey_ListJourneyTemplatesQuery = { __typename?: 'Query', listJourney: Array<(
    { __typename?: 'Journey', id: string }
    & { ' $fragmentRefs'?: { 'JourneyTemplateTile_JourneyFragmentFragment': JourneyTemplateTile_JourneyFragmentFragment } }
  )> };

export type JourneyTemplateTile_JourneyFragmentFragment = { __typename?: 'Journey', id: string, name: string, color?: string | null, description?: string | null } & { ' $fragmentName'?: 'JourneyTemplateTile_JourneyFragmentFragment' };

export type JourneyDetail_ActivityCountQueryVariables = Exact<{
  phaseId: Scalars['UUID']['input'];
}>;


export type JourneyDetail_ActivityCountQuery = { __typename?: 'Query', listTouchpoint: Array<{ __typename?: 'Touchpoint', id: string, order: number }> };

export type JourneyDetail_CreateActivityMutationVariables = Exact<{
  phaseId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
}>;


export type JourneyDetail_CreateActivityMutation = { __typename?: 'Mutation', createActivity: { __typename?: 'ActivityCreateResult', ok: boolean, errorMessage?: string | null, node?: { __typename?: 'Activity', id: string, name: string, touchpoint?: { __typename?: 'Touchpoint', id: string } | null } | null } };

export type JourneyDetail_UpdatePhaseTouchpointsOrderMutationVariables = Exact<{
  phaseId: Scalars['UUID']['input'];
  touchpoints: Array<PhaseUpdateTouchpointsEntityRelationInput> | PhaseUpdateTouchpointsEntityRelationInput;
}>;


export type JourneyDetail_UpdatePhaseTouchpointsOrderMutation = { __typename?: 'Mutation', updatePhase: { __typename?: 'PhaseUpdateResult', ok: boolean, errorMessage?: string | null } };

export type JourneyCreatePhaseModal_CreatePhaseAndReorderMutationVariables = Exact<{
  journeyId: Scalars['UUID']['input'];
  phaseName: Scalars['String']['input'];
  phaseDesc: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  phases: Array<JourneyUpdatePhasesEntityRelationInput> | JourneyUpdatePhasesEntityRelationInput;
}>;


export type JourneyCreatePhaseModal_CreatePhaseAndReorderMutation = { __typename?: 'Mutation', createPhase: { __typename?: 'PhaseCreateResult', ok: boolean, errorMessage?: string | null }, updateJourney: { __typename?: 'JourneyUpdateResult', ok: boolean, errorMessage?: string | null } };

export type JourneyCreatePhaseModal_GetJourneyQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type JourneyCreatePhaseModal_GetJourneyQuery = { __typename?: 'Query', getJourney?: { __typename?: 'Journey', id: string, phases: Array<{ __typename?: 'Phase', id: string }> } | null };

export type JourneyDetail_GetJourneyDetailQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type JourneyDetail_GetJourneyDetailQuery = { __typename?: 'Query', getJourney?: { __typename?: 'Journey', id: string, name: string, widgets: Array<{ __typename?: 'Widget', id: string, order: number, name?: string | null, type: WidgetType }>, phases: Array<(
      { __typename?: 'Phase', id: string, name: string, description?: string | null, contentMetrics: Array<{ __typename?: 'ContentMetric', id: string }>, touchpoints: Array<{ __typename?: 'Touchpoint', id: string, activity?: (
          { __typename?: 'Activity', id: string, name: string, description?: string | null, warnings: Array<{ __typename?: 'ActivityWarning', id: string }> }
          & { ' $fragmentRefs'?: { 'JourneyDetail_WidgetsFragment': JourneyDetail_WidgetsFragment } }
        ) | null }> }
      & { ' $fragmentRefs'?: { 'JourneyDetail_PhasesFragment': JourneyDetail_PhasesFragment;'JourneyFilters_PhasesFragment': JourneyFilters_PhasesFragment } }
    )> } | null };

export type JourneyEditDrawer_GetJourneyQueryVariables = Exact<{
  journeyId: Scalars['UUID']['input'];
}>;


export type JourneyEditDrawer_GetJourneyQuery = { __typename?: 'Query', getJourney?: { __typename?: 'Journey', name: string, description?: string | null } | null };

export type EditJourney_UpdateMutationVariables = Exact<{
  journeyId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditJourney_UpdateMutation = { __typename?: 'Mutation', updateJourney: { __typename?: 'JourneyUpdateResult', ok: boolean, errorMessage?: string | null } };

export type JourneyDetail_CreateWidgetMutationVariables = Exact<{
  type: WidgetType;
  journeyId: Scalars['UUID']['input'];
  order: Scalars['Int']['input'];
}>;


export type JourneyDetail_CreateWidgetMutation = { __typename?: 'Mutation', createWidget: { __typename?: 'WidgetCreateResult', ok: boolean, errorMessage?: string | null } };

export type JourneyDetail_DeleteWidgetMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type JourneyDetail_DeleteWidgetMutation = { __typename?: 'Mutation', deleteWidget: { __typename?: 'WidgetDeleteResult', ok: boolean, errorMessage?: string | null } };

export type JourneyDetail_UpdateWidgetsOrderMutationVariables = Exact<{
  widgets?: InputMaybe<Array<JourneyUpdateWidgetsEntityRelationInput> | JourneyUpdateWidgetsEntityRelationInput>;
  journeyId: Scalars['UUID']['input'];
}>;


export type JourneyDetail_UpdateWidgetsOrderMutation = { __typename?: 'Mutation', updateJourney: { __typename?: 'JourneyUpdateResult', ok: boolean, errorMessage?: string | null } };

export type Detail_UpdateWidgetMutationVariables = Exact<{
  widgetId: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type Detail_UpdateWidgetMutation = { __typename?: 'Mutation', updateWidget: { __typename?: 'WidgetUpdateResult', ok: boolean, errorMessage?: string | null } };

export type Detail_GetWidgetQueryVariables = Exact<{
  widgetId: Scalars['UUID']['input'];
}>;


export type Detail_GetWidgetQuery = { __typename?: 'Query', getWidget?: { __typename?: 'Widget', type: WidgetType, name?: string | null } | null };

export type Journey_DisplayMainMetricQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  compareStart: Scalars['DateTime']['input'];
  compareEnd: Scalars['DateTime']['input'];
  targetStart: Scalars['DateTime']['input'];
  targetEnd: Scalars['DateTime']['input'];
}>;


export type Journey_DisplayMainMetricQuery = { __typename?: 'Query', displayMetric?: { __typename?: 'DisplayMetric', name: string, expectations?: Expectations | null, precision?: number | null, trendComparison?: TrendComparison | null, values: { __typename?: 'DisplayMetricValues', targetValue?: number | null, comparison?: number | null, lastUpdateAt?: string | null } } | null };

export type Journey_DisplayPhaseMetricQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  compareStart: Scalars['DateTime']['input'];
  compareEnd: Scalars['DateTime']['input'];
  targetStart: Scalars['DateTime']['input'];
  targetEnd: Scalars['DateTime']['input'];
}>;


export type Journey_DisplayPhaseMetricQuery = { __typename?: 'Query', displayMetric?: { __typename?: 'DisplayMetric', name: string, expectations?: Expectations | null, precision?: number | null, trendComparison?: TrendComparison | null, values: { __typename?: 'DisplayMetricValues', targetValue?: number | null, comparison?: number | null, lastUpdateAt?: string | null } } | null };

export type JourneyDetail_PhasesFragment = (
  { __typename?: 'Phase', id: string, name: string, description?: string | null, contentMetrics: Array<{ __typename?: 'ContentMetric', id: string, activities: Array<{ __typename?: 'Activity', name: string }>, metric?: { __typename?: 'Metric', id: string, unitSign?: string | null, dataSet?: { __typename?: 'MetricDataSet', metricTemplate?: { __typename?: 'MetricTemplate', unitSign?: string | null } | null } | null } | null }>, touchpoints: Array<{ __typename?: 'Touchpoint', id: string, activity?: (
      { __typename?: 'Activity' }
      & { ' $fragmentRefs'?: { 'ActivityCard_ActivityFragment': ActivityCard_ActivityFragment } }
    ) | null }> }
  & { ' $fragmentRefs'?: { 'JourneyFilters_PhasesFragment': JourneyFilters_PhasesFragment } }
) & { ' $fragmentName'?: 'JourneyDetail_PhasesFragment' };

export type Detail_ReorderPhasesMutationVariables = Exact<{
  journeyId: Scalars['UUID']['input'];
  phases: Array<JourneyUpdatePhasesEntityRelationInput> | JourneyUpdatePhasesEntityRelationInput;
}>;


export type Detail_ReorderPhasesMutation = { __typename?: 'Mutation', updateJourney: { __typename?: 'JourneyUpdateResult', ok: boolean, errorMessage?: string | null } };

export type JourneyDetail_WidgetsFragment = (
  { __typename?: 'Activity', id: string, links?: unknown | null, description?: string | null, notes?: string | null, goalsAndObjectives?: string | null, satisfaction: number, personas: Array<(
    { __typename?: 'Persona', id: string, name: string }
    & { ' $fragmentRefs'?: { 'PersonaAvatar_PersonaFragment': PersonaAvatar_PersonaFragment } }
  )>, duration?: { __typename?: 'ActivityDuration', type: ActivityDurationType, start?: string | null, id: string, end?: string | null, occurence?: number | null, unit?: ActivityDurationOccurenceUnitType | null, showOnActivityMap: boolean } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, controlCycle?: { __typename?: 'ControlCycle', days?: number | null, history: Array<{ __typename?: 'ControlCycleCheck', at: string }> } | null, owner?: (
    { __typename?: 'Member' }
    & { ' $fragmentRefs'?: { 'OwnerCell_MemberFragment': OwnerCell_MemberFragment } }
  ) | null, contentMetrics: Array<{ __typename?: 'ContentMetric', id: string, metric?: { __typename?: 'Metric', id: string, name: string, unitSign?: string | null, dataSet?: { __typename?: 'MetricDataSet', metricTemplate?: { __typename?: 'MetricTemplate', unitSign?: string | null } | null } | null } | null }>, pictures: Array<{ __typename?: 'Picture', id: string, order: number, image?: { __typename?: 'Image', id: string, url?: string | null } | null }>, opportunities: Array<{ __typename?: 'Opportunity', id: string, name: string, description?: string | null, status: OpportunityStatus }>, actions: Array<{ __typename?: 'Action', id: string, name: string, description?: string | null, status: ActionStatus, deadline?: string | null }>, subTouchpoints: Array<{ __typename?: 'Touchpoint', id: string, type: TouchpointType, activity?: { __typename?: 'Activity', name: string, id: string } | null }>, touchpoint?: { __typename?: 'Touchpoint', parentActivity?: { __typename?: 'Activity', name: string } | null } | null, connectedJourneys: Array<{ __typename?: 'Journey', id: string, name: string, color?: string | null }> }
  & { ' $fragmentRefs'?: { 'PictureGrid_GalleryFragment': PictureGrid_GalleryFragment } }
) & { ' $fragmentName'?: 'JourneyDetail_WidgetsFragment' };

export type Timeline_UpdatePhasesTouchpointsMutationVariables = Exact<{
  destinationPhase: Scalars['UUID']['input'];
  touchpointId: Scalars['UUID']['input'];
  order: Scalars['Int']['input'];
}>;


export type Timeline_UpdatePhasesTouchpointsMutation = { __typename?: 'Mutation', updateTouchpoint: { __typename?: 'TouchpointUpdateResult', ok: boolean, errorMessage?: string | null } };

export type Timeline_UpdatePhaseTouchpointsOrderMutationVariables = Exact<{
  phaseId: Scalars['UUID']['input'];
  touchpoints: Array<PhaseUpdateTouchpointsEntityRelationInput> | PhaseUpdateTouchpointsEntityRelationInput;
}>;


export type Timeline_UpdatePhaseTouchpointsOrderMutation = { __typename?: 'Mutation', updatePhase: { __typename?: 'PhaseUpdateResult', ok: boolean, errorMessage?: string | null } };

export type SatisfactionCell_UpdateSatisfactionMutationVariables = Exact<{
  activityId: Scalars['UUID']['input'];
  satisfactionValue: Scalars['Int']['input'];
}>;


export type SatisfactionCell_UpdateSatisfactionMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'ActivityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type ActionDrawerForm_GetActionQueryVariables = Exact<{
  actionId: Scalars['UUID']['input'];
}>;


export type ActionDrawerForm_GetActionQuery = { __typename?: 'Query', getAction?: { __typename?: 'Action', name: string, deadline?: string | null, status: ActionStatus, priority: ActionPriority, links?: unknown | null, createdAt: string, owner?: { __typename?: 'Member', id: string } | null, tags: Array<{ __typename?: 'Tag', id: string }> } | null };

export type ActionDrawerForm_UpdateActionMutationVariables = Exact<{
  actionId: Scalars['UUID']['input'];
  data: ActionUpdateInput;
}>;


export type ActionDrawerForm_UpdateActionMutation = { __typename?: 'Mutation', updateAction: { __typename?: 'ActionUpdateResult', ok: boolean, errorMessage?: string | null } };

export type ActionDrawerTabs_GetActionQueryVariables = Exact<{
  actionId: Scalars['UUID']['input'];
}>;


export type ActionDrawerTabs_GetActionQuery = { __typename?: 'Query', getAction?: { __typename?: 'Action', description?: string | null, opportunities: Array<{ __typename?: 'Opportunity', id: string }> } | null };

export type ActionDrawerTabs_UpdateActionMutationVariables = Exact<{
  actionId: Scalars['UUID']['input'];
  data: ActionUpdateInput;
}>;


export type ActionDrawerTabs_UpdateActionMutation = { __typename?: 'Mutation', updateAction: { __typename?: 'ActionUpdateResult', ok: boolean, errorMessage?: string | null } };

export type ActionsWidget_AddActionMutationVariables = Exact<{
  activityId: Scalars['UUID']['input'];
  actionId: Scalars['UUID']['input'];
}>;


export type ActionsWidget_AddActionMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'ActivityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type ActionsWidget_RemoveActionMutationVariables = Exact<{
  activityId: Scalars['UUID']['input'];
  actionId: Scalars['UUID']['input'];
}>;


export type ActionsWidget_RemoveActionMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'ActivityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type ActionSelect_ListActionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActionSelect_ListActionsQuery = { __typename?: 'Query', listAction: Array<{ __typename?: 'Action', id: string, name: string }> };

export type CreateActionAndAddToActivityModal_CreateActionMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  priority: ActionPriority;
  status: ActionStatus;
  links: Scalars['Json']['input'];
}>;


export type CreateActionAndAddToActivityModal_CreateActionMutation = { __typename?: 'Mutation', createAction: { __typename?: 'ActionCreateResult', ok: boolean, errorMessage?: string | null, node?: { __typename?: 'Action', id: string } | null } };

export type CreateActionAndAddToActivityModal_UpdateActivityMutationVariables = Exact<{
  activityId: Scalars['UUID']['input'];
  actionId: Scalars['UUID']['input'];
}>;


export type CreateActionAndAddToActivityModal_UpdateActivityMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'ActivityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type ConnectJourneyToActivityMutationVariables = Exact<{
  activityId: Scalars['UUID']['input'];
  data: ActivityUpdateInput;
}>;


export type ConnectJourneyToActivityMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'ActivityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type Widget_ListJourneyQueryVariables = Exact<{ [key: string]: never; }>;


export type Widget_ListJourneyQuery = { __typename?: 'Query', listJourney: Array<(
    { __typename?: 'Journey', id: string, name: string, color?: string | null }
    & { ' $fragmentRefs'?: { 'Journey_SingleJourneyFragmentFragment': Journey_SingleJourneyFragmentFragment } }
  )> };

export type JourneyDetail_GetActivityDescriptionQueryVariables = Exact<{
  activityId: Scalars['UUID']['input'];
}>;


export type JourneyDetail_GetActivityDescriptionQuery = { __typename?: 'Query', getActivity?: { __typename?: 'Activity', description?: string | null } | null };

export type JourneyDetail_UpdateDescriptionMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type JourneyDetail_UpdateDescriptionMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'ActivityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type DurationDrawer_GetActivityDurationQueryVariables = Exact<{
  activityId: Scalars['UUID']['input'];
}>;


export type DurationDrawer_GetActivityDurationQuery = { __typename?: 'Query', getActivity?: { __typename?: 'Activity', duration?: { __typename?: 'ActivityDuration', start?: string | null, end?: string | null, type: ActivityDurationType, showOnActivityMap: boolean, unit?: ActivityDurationOccurenceUnitType | null, occurence?: number | null } | null } | null };

export type DurationDrawer_UpdateActivityDurationMutationVariables = Exact<{
  activityId: Scalars['UUID']['input'];
  duration?: InputMaybe<ActivityUpdateDurationEntityRelationInput>;
}>;


export type DurationDrawer_UpdateActivityDurationMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'ActivityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type DurationDrawer_UpdateActivityMapPresenceMutationVariables = Exact<{
  activityId: Scalars['UUID']['input'];
  showOnActivityMap: Scalars['Boolean']['input'];
}>;


export type DurationDrawer_UpdateActivityMapPresenceMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'ActivityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type JourneyDetail_GetActivityGoalsAndObjectivesQueryVariables = Exact<{
  activityId: Scalars['UUID']['input'];
}>;


export type JourneyDetail_GetActivityGoalsAndObjectivesQuery = { __typename?: 'Query', getActivity?: { __typename?: 'Activity', goalsAndObjectives?: string | null } | null };

export type JourneyDetail_UpdateGoalsAndObjectivesMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  goalsAndObjectives?: InputMaybe<Scalars['String']['input']>;
}>;


export type JourneyDetail_UpdateGoalsAndObjectivesMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'ActivityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type JourneyDetail_ListActivityLinksQueryVariables = Exact<{
  activityId: Scalars['UUID']['input'];
}>;


export type JourneyDetail_ListActivityLinksQuery = { __typename?: 'Query', activityLinks?: { __typename?: 'Activity', links?: unknown | null } | null };

export type Links_UpdateLinksMutationVariables = Exact<{
  activityId: Scalars['UUID']['input'];
  links: Scalars['Json']['input'];
}>;


export type Links_UpdateLinksMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'ActivityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type AddMetricSelect_ListMetricQueryVariables = Exact<{ [key: string]: never; }>;


export type AddMetricSelect_ListMetricQuery = { __typename?: 'Query', listContentMetric: Array<{ __typename?: 'ContentMetric', id: string, metric?: { __typename?: 'Metric', name: string } | null }> };

export type AddMetricSelect_UpdateActivityMutationVariables = Exact<{
  activityId: Scalars['UUID']['input'];
  data: ActivityUpdateInput;
}>;


export type AddMetricSelect_UpdateActivityMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'ActivityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type Metrics_GetMetricBoundsQueryVariables = Exact<{
  contentMetricId: Scalars['UUID']['input'];
}>;


export type Metrics_GetMetricBoundsQuery = { __typename?: 'Query', getContentMetric?: { __typename?: 'ContentMetric', metric?: { __typename?: 'Metric', lowerWarningBound?: number | null, upperWarningBound?: number | null } | null } | null };

export type Metrics_UpdateMetricBoundMutationVariables = Exact<{
  contentMetricId: Scalars['UUID']['input'];
  data: ContentMetricUpdateInput;
}>;


export type Metrics_UpdateMetricBoundMutation = { __typename?: 'Mutation', updateContentMetric: { __typename?: 'ContentMetricUpdateResult', ok: boolean, errorMessage?: string | null } };

export type EditMetricWidgetDrawer_GetMetricQueryVariables = Exact<{
  contentMetricId: Scalars['UUID']['input'];
}>;


export type EditMetricWidgetDrawer_GetMetricQuery = { __typename?: 'Query', getContentMetric?: { __typename?: 'ContentMetric', metric?: { __typename?: 'Metric', name: string } | null } | null };

export type EditMetricWidgetDrawer_UpdateActivityMutationVariables = Exact<{
  activityId: Scalars['UUID']['input'];
  data: ActivityUpdateInput;
}>;


export type EditMetricWidgetDrawer_UpdateActivityMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'ActivityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type GetDashboardMetricsListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardMetricsListQuery = { __typename?: 'Query', listDashboardMetric: Array<{ __typename?: 'DashboardMetric', contentMetric?: { __typename?: 'ContentMetric', id: string } | null }> };

export type UpdateDashboardMetricMutationVariables = Exact<{
  contentMetricId: Scalars['UUID']['input'];
  data: DashboardMetricUpdateInput;
}>;


export type UpdateDashboardMetricMutation = { __typename?: 'Mutation', updateDashboardMetric: { __typename?: 'DashboardMetricUpdateResult', ok: boolean, errorMessage?: string | null } };

export type SourceDrawer_GetContentMetricQueryQueryVariables = Exact<{
  contentMetricId: Scalars['UUID']['input'];
}>;


export type SourceDrawer_GetContentMetricQueryQuery = { __typename?: 'Query', getContentMetric?: { __typename?: 'ContentMetric', hideFromPlanning: boolean } | null };

export type SourceDrawer_UpdateContentMetricMutationMutationVariables = Exact<{
  contentMetricId: Scalars['UUID']['input'];
  value: Scalars['Boolean']['input'];
}>;


export type SourceDrawer_UpdateContentMetricMutationMutation = { __typename?: 'Mutation', updateContentMetric: { __typename?: 'ContentMetricUpdateResult', ok: boolean, errorMessage?: string | null } };

export type JourneyDetail_GetActivityNameQueryVariables = Exact<{
  activityId: Scalars['UUID']['input'];
}>;


export type JourneyDetail_GetActivityNameQuery = { __typename?: 'Query', getActivity?: { __typename?: 'Activity', name: string } | null };

export type JourneyDetail_UpdateNameMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
}>;


export type JourneyDetail_UpdateNameMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'ActivityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type JourneyDetail_GetActivityNotesQueryVariables = Exact<{
  activityId: Scalars['UUID']['input'];
}>;


export type JourneyDetail_GetActivityNotesQuery = { __typename?: 'Query', getActivity?: { __typename?: 'Activity', notes?: string | null } | null };

export type JourneyDetail_UpdateNotesMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
}>;


export type JourneyDetail_UpdateNotesMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'ActivityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type OpportunitySelect_ListOpportunitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type OpportunitySelect_ListOpportunitiesQuery = { __typename?: 'Query', listOpportunity: Array<{ __typename?: 'Opportunity', id: string, name: string }> };

export type CreateOpportunityAndAddToActivityModal_CreateOpportunityMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  benefit?: InputMaybe<Scalars['Int']['input']>;
  status: OpportunityStatus;
  links: Scalars['Json']['input'];
}>;


export type CreateOpportunityAndAddToActivityModal_CreateOpportunityMutation = { __typename?: 'Mutation', createOpportunity: { __typename?: 'OpportunityCreateResult', ok: boolean, errorMessage?: string | null, node?: { __typename?: 'Opportunity', id: string } | null } };

export type CreateOpportunityAndAddToActivityModal_UpdateActivityMutationVariables = Exact<{
  activityId: Scalars['UUID']['input'];
  opportunityId: Scalars['UUID']['input'];
}>;


export type CreateOpportunityAndAddToActivityModal_UpdateActivityMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'ActivityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type OpportunitiesWidget_AddOpportunityMutationVariables = Exact<{
  activityId: Scalars['UUID']['input'];
  opportunityId: Scalars['UUID']['input'];
}>;


export type OpportunitiesWidget_AddOpportunityMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'ActivityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type OpportunitiesWidget_RemoveOpportunityMutationVariables = Exact<{
  activityId: Scalars['UUID']['input'];
  opportunityId: Scalars['UUID']['input'];
}>;


export type OpportunitiesWidget_RemoveOpportunityMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'ActivityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type OpportunityDrawerForm_GetOpportunityQueryVariables = Exact<{
  opportunityId: Scalars['UUID']['input'];
}>;


export type OpportunityDrawerForm_GetOpportunityQuery = { __typename?: 'Query', getOpportunity?: { __typename?: 'Opportunity', name: string, status: OpportunityStatus, links?: unknown | null, benefit: number, createdAt: string, owner?: { __typename?: 'Member', id: string } | null, tags: Array<{ __typename?: 'Tag', id: string }> } | null };

export type OpportunityDrawerForm_UpdateOpportunityMutationVariables = Exact<{
  opportunityId: Scalars['UUID']['input'];
  data: OpportunityUpdateInput;
}>;


export type OpportunityDrawerForm_UpdateOpportunityMutation = { __typename?: 'Mutation', updateOpportunity: { __typename?: 'OpportunityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type OpportunityDrawerTabs_GetOpportunityQueryVariables = Exact<{
  opportunityId: Scalars['UUID']['input'];
}>;


export type OpportunityDrawerTabs_GetOpportunityQuery = { __typename?: 'Query', getOpportunity?: { __typename?: 'Opportunity', description?: string | null, actions: Array<{ __typename?: 'Action', id: string }> } | null };

export type OpportunityDrawerTabs_UpdateOpportunityMutationVariables = Exact<{
  opportunityId: Scalars['UUID']['input'];
  data: OpportunityUpdateInput;
}>;


export type OpportunityDrawerTabs_UpdateOpportunityMutation = { __typename?: 'Mutation', updateOpportunity: { __typename?: 'OpportunityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type JourneyDetail_GetControlCycleHistoryQueryQueryVariables = Exact<{
  activityId: Scalars['UUID']['input'];
}>;


export type JourneyDetail_GetControlCycleHistoryQueryQuery = { __typename?: 'Query', getActivity?: { __typename?: 'Activity', controlCycle?: { __typename?: 'ControlCycle', history: Array<{ __typename?: 'ControlCycleCheck', id: string, at: string, who?: { __typename?: 'Member', id: string, name: string, avatar?: { __typename?: 'Image', url?: string | null } | null } | null }> } | null } | null };

export type OwnerCell_MemberFragment = { __typename?: 'Member', id: string, name: string, jobTitle?: string | null, avatar?: { __typename?: 'Image', url?: string | null } | null } & { ' $fragmentName'?: 'OwnerCell_MemberFragment' };

export type JourneyDetail_GetActivityOwnerQueryVariables = Exact<{
  activityId: Scalars['UUID']['input'];
}>;


export type JourneyDetail_GetActivityOwnerQuery = { __typename?: 'Query', currentOwner?: { __typename?: 'Activity', controlCycle?: { __typename?: 'ControlCycle', id: string, days?: number | null } | null, owner?: { __typename?: 'Member', id: string, name: string } | null } | null, selectOptions: Array<{ __typename?: 'Member', id: string, name: string }> };

export type JourneyDetail_UpdateOwnerMutationMutationVariables = Exact<{
  activityId: Scalars['UUID']['input'];
  ownerData: ActivityUpdateOwnerEntityRelationInput;
}>;


export type JourneyDetail_UpdateOwnerMutationMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'ActivityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type JourneyDetail_UpdateControlCycleMutationVariables = Exact<{
  activityId: Scalars['UUID']['input'];
  controlCycle: ActivityUpdateControlCycleEntityRelationInput;
}>;


export type JourneyDetail_UpdateControlCycleMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'ActivityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type JourneyDetail_CreateControlCycleCheckMutationVariables = Exact<{
  controlCycleId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
}>;


export type JourneyDetail_CreateControlCycleCheckMutation = { __typename?: 'Mutation', createControlCycleCheck: { __typename?: 'ControlCycleCheckCreateResult', ok: boolean, errorMessage?: string | null } };

export type PersonasWidget_ConnectPersonaToWidgetMutationVariables = Exact<{
  activityId: Scalars['UUID']['input'];
  personaId: Scalars['UUID']['input'];
}>;


export type PersonasWidget_ConnectPersonaToWidgetMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'ActivityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type PersonasWidget_DisconnectPersonaFromWidgetMutationVariables = Exact<{
  activityId: Scalars['UUID']['input'];
  personaId: Scalars['UUID']['input'];
}>;


export type PersonasWidget_DisconnectPersonaFromWidgetMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'ActivityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type JourneyDetail_ListActivityPersonasQueryVariables = Exact<{
  activityId: Scalars['UUID']['input'];
}>;


export type JourneyDetail_ListActivityPersonasQuery = { __typename?: 'Query', activityPersonas?: { __typename?: 'Activity', personas: Array<(
      { __typename?: 'Persona', id: string, name: string }
      & { ' $fragmentRefs'?: { 'PersonaAvatar_PersonaFragment': PersonaAvatar_PersonaFragment } }
    )> } | null, listPersona: Array<(
    { __typename?: 'Persona', id: string, name: string }
    & { ' $fragmentRefs'?: { 'PersonaAvatar_PersonaFragment': PersonaAvatar_PersonaFragment } }
  )> };

export type JourneyDetail_GetActivityPicturesQueryVariables = Exact<{
  activityId: Scalars['UUID']['input'];
}>;


export type JourneyDetail_GetActivityPicturesQuery = { __typename?: 'Query', getActivity?: { __typename?: 'Activity', pictures: Array<{ __typename?: 'Picture', id: string, order: number, image?: { __typename?: 'Image', url?: string | null } | null }> } | null };

export type PicturesDrawer_ConnectPicutreToActivityMutationVariables = Exact<{
  activityId: Scalars['UUID']['input'];
  imageId: Scalars['UUID']['input'];
  order: Scalars['Int']['input'];
}>;


export type PicturesDrawer_ConnectPicutreToActivityMutation = { __typename?: 'Mutation', createPicture: { __typename?: 'PictureCreateResult', ok: boolean } };

export type PicturesDrawer_UpdatePictureOrderMutationVariables = Exact<{
  activityId: Scalars['UUID']['input'];
  pictures?: InputMaybe<Array<ActivityUpdatePicturesEntityRelationInput> | ActivityUpdatePicturesEntityRelationInput>;
}>;


export type PicturesDrawer_UpdatePictureOrderMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'ActivityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type PictureGrid_GalleryFragment = { __typename?: 'Activity', galleryImgSource: Array<{ __typename?: 'Picture', id: string, order: number, image?: { __typename?: 'Image', url?: string | null } | null }> } & { ' $fragmentName'?: 'PictureGrid_GalleryFragment' };

export type PictureItem_DeleteFromActivityMutationVariables = Exact<{
  pictureId: Scalars['UUID']['input'];
}>;


export type PictureItem_DeleteFromActivityMutation = { __typename?: 'Mutation', deletePicture: { __typename?: 'PictureDeleteResult', ok: boolean, errorMessage?: string | null } };

export type JourneyDetail_GetActivitySubtouchpointsQueryVariables = Exact<{
  activityId: Scalars['UUID']['input'];
}>;


export type JourneyDetail_GetActivitySubtouchpointsQuery = { __typename?: 'Query', getActivity?: { __typename?: 'Activity', subTouchpoints: Array<{ __typename?: 'Touchpoint', id: string, type: TouchpointType, activity?: { __typename?: 'Activity', name: string } | null }> } | null };

export type JourneyDetail_DeleteSubTouchpointMutationVariables = Exact<{
  subTouchpointId: Scalars['UUID']['input'];
}>;


export type JourneyDetail_DeleteSubTouchpointMutation = { __typename?: 'Mutation', deleteTouchpoint: { __typename?: 'TouchpointDeleteResult', ok: boolean, errorMessage?: string | null } };

export type JourneyDetail_CreateSubactivityMutationVariables = Exact<{
  parentActivityId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
}>;


export type JourneyDetail_CreateSubactivityMutation = { __typename?: 'Mutation', createActivity: { __typename?: 'ActivityCreateResult', ok: boolean, errorMessage?: string | null } };

export type TagsCell_UpdateActivityMutationMutationVariables = Exact<{
  activityId: Scalars['UUID']['input'];
  data: ActivityUpdateInput;
}>;


export type TagsCell_UpdateActivityMutationMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'ActivityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type CreateTagMutationMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateTagMutationMutation = { __typename?: 'Mutation', createTag: { __typename?: 'TagCreateResult', ok: boolean, errorMessage?: string | null } };

export type UpdateTagMutationMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateTagMutationMutation = { __typename?: 'Mutation', updateTag: { __typename?: 'TagUpdateResult', ok: boolean, errorMessage?: string | null } };

export type Tags_GetTagsQueryVariables = Exact<{
  activityId: Scalars['UUID']['input'];
}>;


export type Tags_GetTagsQuery = { __typename?: 'Query', availableTags: Array<{ __typename?: 'Tag', id: string, name: string }>, assignedTags: Array<{ __typename?: 'Tag', id: string, name: string }> };

export type UpdateActivityMutationVariables = Exact<{
  activityId: Scalars['UUID']['input'];
  data: ActivityUpdateInput;
}>;


export type UpdateActivityMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'ActivityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type Journey_JourneysQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type Journey_JourneysQueryQuery = { __typename?: 'Query', listJourney: Array<(
    { __typename?: 'Journey', id: string, color?: string | null }
    & { ' $fragmentRefs'?: { 'Journey_SingleJourneyFragmentFragment': Journey_SingleJourneyFragmentFragment } }
  )> };

export type Journey_SingleJourneyFragmentFragment = { __typename?: 'Journey', id: string, createdAt: string, name: string, description?: string | null, color?: string | null, satisfaction?: number | null, teams: Array<{ __typename?: 'Team', id: string, name: string }>, personas?: Array<(
    { __typename?: 'Persona', id: string }
    & { ' $fragmentRefs'?: { 'PersonaAvatar_PersonaFragment': PersonaAvatar_PersonaFragment } }
  )> | null, activityWarnings?: Array<{ __typename?: 'ActivityWarning', id: string }> | null, mainMetric?: { __typename?: 'ContentMetric', metric?: { __typename?: 'Metric', id: string, unitSign?: string | null, dataSet?: { __typename?: 'MetricDataSet', metricTemplate?: { __typename?: 'MetricTemplate', unitSign?: string | null } | null } | null } | null } | null } & { ' $fragmentName'?: 'Journey_SingleJourneyFragmentFragment' };

export type JourneyUpdateTeamMutationMutationVariables = Exact<{
  journeyId: Scalars['UUID']['input'];
  journeyName: Scalars['String']['input'];
  teams?: InputMaybe<Array<JourneyUpdateTeamsEntityRelationInput> | JourneyUpdateTeamsEntityRelationInput>;
}>;


export type JourneyUpdateTeamMutationMutation = { __typename?: 'Mutation', updateJourney: { __typename?: 'JourneyUpdateResult', ok: boolean, errorMessage?: string | null } };

export type Planning_UpdateActionStatusMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  status: ActionStatus;
}>;


export type Planning_UpdateActionStatusMutation = { __typename?: 'Mutation', updateAction: { __typename?: 'ActionUpdateResult', ok: boolean, errorMessage?: string | null } };

export type Planning_ActivityActionsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  fromThis: Scalars['DateTime']['input'];
  toThis: Scalars['DateTime']['input'];
  fromLast: Scalars['DateTime']['input'];
  toLast: Scalars['DateTime']['input'];
}>;


export type Planning_ActivityActionsQuery = { __typename?: 'Query', getJourney?: { __typename?: 'Journey', id: string, phases: Array<{ __typename?: 'Phase', touchpoints: Array<{ __typename?: 'Touchpoint', activity?: (
          { __typename?: 'Activity', id: string, name: string, actions: Array<{ __typename?: 'Action', id: string }> }
          & { ' $fragmentRefs'?: { 'Planning_ActivityUnresolvedActionsFragment': Planning_ActivityUnresolvedActionsFragment;'Planning_ActivityActionsThisWeekOrMonthFragment': Planning_ActivityActionsThisWeekOrMonthFragment;'Planning_ActivityActionsLastWeekOrMonthFragment': Planning_ActivityActionsLastWeekOrMonthFragment } }
        ) | null }> }> } | null };

export type CreateActionModal_UpdateActivityMutationVariables = Exact<{
  activityId: Scalars['UUID']['input'];
  actionId: Scalars['UUID']['input'];
}>;


export type CreateActionModal_UpdateActivityMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'ActivityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type Journey_PlanningMetricsOverviewQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type Journey_PlanningMetricsOverviewQuery = { __typename?: 'Query', getJourney?: { __typename?: 'Journey', contentMetrics?: Array<{ __typename?: 'ContentMetric', id: string, hideFromPlanning: boolean, metric?: { __typename?: 'Metric', id: string, unitSign?: string | null, dataSet?: { __typename?: 'MetricDataSet', metricTemplate?: { __typename?: 'MetricTemplate', unitSign?: string | null } | null } | null } | null }> | null } | null };

export type Planning_GetJourneyPlanningWeeklyQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  actionFromThisWeek: Scalars['DateTime']['input'];
  actionToThisWeek: Scalars['DateTime']['input'];
  actionFromLastWeek: Scalars['DateTime']['input'];
  actionToLastWeek: Scalars['DateTime']['input'];
  opportunityFromThisWeek: Scalars['DateTime']['input'];
  opportunityToThisWeek: Scalars['DateTime']['input'];
  opportunityFromLastWeek: Scalars['DateTime']['input'];
  opportunityToLastWeek: Scalars['DateTime']['input'];
}>;


export type Planning_GetJourneyPlanningWeeklyQuery = { __typename?: 'Query', getJourney?: { __typename?: 'Journey', satisfaction?: number | null, solvedActionsThisWeek?: number | null, solvedActionsLastWeek?: number | null, createdOpportunitiesThisWeek?: number | null, createdOpportunitiesLastWeek?: number | null } | null };

export type Planning_GetJourneyPlanningMonthlyQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  actionFromThisMonth: Scalars['DateTime']['input'];
  actionToThisMonth: Scalars['DateTime']['input'];
  actionFromLastMonth: Scalars['DateTime']['input'];
  actionToLastMonth: Scalars['DateTime']['input'];
  opportunityFromThisMonth: Scalars['DateTime']['input'];
  opportunityToThisMonth: Scalars['DateTime']['input'];
  opportunityFromLastMonth: Scalars['DateTime']['input'];
  opportunityToLastMonth: Scalars['DateTime']['input'];
}>;


export type Planning_GetJourneyPlanningMonthlyQuery = { __typename?: 'Query', getJourney?: { __typename?: 'Journey', satisfaction?: number | null, solvedActionsThisMonth?: number | null, solvedActionsLastMonth?: number | null, createdOpportunitiesThisMonth?: number | null, createdOpportunitiesLastMonth?: number | null } | null };

export type Planning_ActivityUnresolvedActionsFragment = { __typename?: 'Activity', activityActionsUnresolved: Array<{ __typename?: 'Action', id: string, name: string, priority: ActionPriority, status: ActionStatus, deadline?: string | null, owner?: { __typename?: 'Member', name: string, avatar?: { __typename?: 'Image', url?: string | null } | null } | null, activities: Array<{ __typename?: 'Activity', id: string }> }> } & { ' $fragmentName'?: 'Planning_ActivityUnresolvedActionsFragment' };

export type Planning_ActivityActionsLastWeekOrMonthFragment = { __typename?: 'Activity', activityActionsLastWeekOrMonth: Array<{ __typename?: 'Action', id: string, name: string, priority: ActionPriority, status: ActionStatus, deadline?: string | null, owner?: { __typename?: 'Member', name: string, avatar?: { __typename?: 'Image', url?: string | null } | null } | null, activities: Array<{ __typename?: 'Activity', id: string }> }> } & { ' $fragmentName'?: 'Planning_ActivityActionsLastWeekOrMonthFragment' };

export type Planning_ActivityActionsThisWeekOrMonthFragment = { __typename?: 'Activity', activityActionsThisWeekOrMonth: Array<{ __typename?: 'Action', id: string, name: string, priority: ActionPriority, status: ActionStatus, deadline?: string | null, owner?: { __typename?: 'Member', name: string, avatar?: { __typename?: 'Image', url?: string | null } | null } | null, activities: Array<{ __typename?: 'Activity', id: string }> }> } & { ' $fragmentName'?: 'Planning_ActivityActionsThisWeekOrMonthFragment' };

export type Planning_GeneralUnresolvedActionsQueryVariables = Exact<{ [key: string]: never; }>;


export type Planning_GeneralUnresolvedActionsQuery = { __typename?: 'Query', listAction: Array<{ __typename?: 'Action', id: string, name: string, priority: ActionPriority, status: ActionStatus, deadline?: string | null, owner?: { __typename?: 'Member', name: string, avatar?: { __typename?: 'Image', url?: string | null } | null } | null, activities: Array<{ __typename?: 'Activity', id: string }> }> };

export type Planning_GeneralActionsQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type Planning_GeneralActionsQuery = { __typename?: 'Query', listAction: Array<{ __typename?: 'Action', id: string, name: string, priority: ActionPriority, status: ActionStatus, deadline?: string | null, owner?: { __typename?: 'Member', name: string, avatar?: { __typename?: 'Image', url?: string | null } | null } | null, activities: Array<{ __typename?: 'Activity', id: string }> }> };

export type PlanningTableRow_DisplayMetricQueryVariables = Exact<{
  metricId: Scalars['UUID']['input'];
  rangeStart: Scalars['DateTime']['input'];
  rangeEnd: Scalars['DateTime']['input'];
  breakdownInterval: BreakdownInterval;
}>;


export type PlanningTableRow_DisplayMetricQuery = { __typename?: 'Query', displayMetric?: { __typename?: 'DisplayMetric', name: string, expectations?: Expectations | null, precision?: number | null, trendComparison?: TrendComparison | null, breakdown: Array<{ __typename?: 'DisplayMetricBreakdown', range: { __typename?: 'DateTimeRange', start: string, end: string }, values?: { __typename?: 'DisplayMetricValues', targetValue?: number | null, comparedValue?: number | null, comparison?: number | null } | null, chartDataPoints: Array<{ __typename?: 'ChartDataPoint', time: string, value?: number | null }> }> } | null };

export type SubactivityDetail_GetActivityQueryVariables = Exact<{
  activityId: Scalars['UUID']['input'];
}>;


export type SubactivityDetail_GetActivityQuery = { __typename?: 'Query', getActivity?: (
    { __typename?: 'Activity', id: string, name: string, touchpoint?: { __typename?: 'Touchpoint', id: string, parentActivity?: { __typename?: 'Activity', name: string, touchpoint?: { __typename?: 'Touchpoint', phase?: { __typename?: 'Phase', id: string, journey?: { __typename?: 'Journey', widgets: Array<{ __typename?: 'Widget', id: string, order: number, name?: string | null, type: WidgetType }> } | null } | null } | null, subTouchpoints: Array<{ __typename?: 'Touchpoint', activity?: { __typename?: 'Activity', id: string, name: string, subTouchpoints: Array<{ __typename?: 'Touchpoint', id: string }> } | null }> } | null } | null }
    & { ' $fragmentRefs'?: { 'JourneyDetail_WidgetsFragment': JourneyDetail_WidgetsFragment } }
  ) | null };

export type Journey_SummaryBannerQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type Journey_SummaryBannerQuery = { __typename?: 'Query', getJourney?: { __typename?: 'Journey', satisfaction?: number | null, personas?: Array<(
      { __typename?: 'Persona', id: string }
      & { ' $fragmentRefs'?: { 'PersonaAvatar_PersonaFragment': PersonaAvatar_PersonaFragment } }
    )> | null } | null };

export type Journey_SummaryDrawerQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type Journey_SummaryDrawerQuery = { __typename?: 'Query', getJourney?: { __typename?: 'Journey', name: string, satisfaction?: number | null, phases: Array<{ __typename?: 'Phase', touchpoints: Array<{ __typename?: 'Touchpoint', activity?: { __typename?: 'Activity', id: string } | null }> }>, contentMetrics?: Array<{ __typename?: 'ContentMetric', id: string, activities: Array<{ __typename?: 'Activity', name: string }>, metric?: { __typename?: 'Metric', id: string, unitSign?: string | null, dataSet?: { __typename?: 'MetricDataSet', metricTemplate?: { __typename?: 'MetricTemplate', unitSign?: string | null } | null } | null } | null }> | null, personas?: Array<(
      { __typename?: 'Persona', id: string, name: string, activities: Array<{ __typename?: 'Activity', id: string }> }
      & { ' $fragmentRefs'?: { 'PersonaAvatar_PersonaFragment': PersonaAvatar_PersonaFragment } }
    )> | null } | null };

export type ActivityMap_GetJourneyDetailQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ActivityMap_GetJourneyDetailQuery = { __typename?: 'Query', getJourney?: { __typename?: 'Journey', id: string, name: string, widgets: Array<{ __typename?: 'Widget', id: string, order: number, name?: string | null, type: WidgetType }>, phases: Array<(
      { __typename?: 'Phase' }
      & { ' $fragmentRefs'?: { 'JourneyDetail_PhasesFragment': JourneyDetail_PhasesFragment;'TimelineBody_PhasesFragment': TimelineBody_PhasesFragment } }
    )> } | null };

export type TimelineBody_PhasesFragment = (
  { __typename?: 'Phase', id: string, touchpoints: Array<{ __typename?: 'Touchpoint', id: string, activity?: (
      { __typename?: 'Activity', id: string, subTouchpoints: Array<{ __typename?: 'Touchpoint', id: string }> }
      & { ' $fragmentRefs'?: { 'ActivityCard_ActivityFragment': ActivityCard_ActivityFragment } }
    ) | null }> }
  & { ' $fragmentRefs'?: { 'JourneyFilters_PhasesFragment': JourneyFilters_PhasesFragment } }
) & { ' $fragmentName'?: 'TimelineBody_PhasesFragment' };

export type ActivityMap_TouchpointSubactivitiesQueryVariables = Exact<{
  activityId: Scalars['UUID']['input'];
}>;


export type ActivityMap_TouchpointSubactivitiesQuery = { __typename?: 'Query', getActivity?: { __typename?: 'Activity', subTouchpoints: Array<{ __typename?: 'Touchpoint', id: string, activity?: (
        { __typename?: 'Activity' }
        & { ' $fragmentRefs'?: { 'ActivityCard_ActivityFragment': ActivityCard_ActivityFragment } }
      ) | null }> } | null };

export type Journey_DisplayMetricQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  compareStart: Scalars['DateTime']['input'];
  compareEnd: Scalars['DateTime']['input'];
  targetStart: Scalars['DateTime']['input'];
  targetEnd: Scalars['DateTime']['input'];
}>;


export type Journey_DisplayMetricQuery = { __typename?: 'Query', displayMetric?: { __typename?: 'DisplayMetric', name: string, expectations?: Expectations | null, precision?: number | null, trendComparison?: TrendComparison | null, values: { __typename?: 'DisplayMetricValues', targetValue?: number | null, comparedValue?: number | null, comparison?: number | null, lastUpdateAt?: string | null } } | null };

export type CustomAvatarGroup_MemberFragment = { __typename?: 'Member', id: string, name: string, avatar?: { __typename?: 'Image', url24?: string | null } | null } & { ' $fragmentName'?: 'CustomAvatarGroup_MemberFragment' };

export type PhaseEditDrawer_GetPhaseQueryVariables = Exact<{
  phaseId: Scalars['UUID']['input'];
}>;


export type PhaseEditDrawer_GetPhaseQuery = { __typename?: 'Query', getPhase?: { __typename?: 'Phase', id: string, name: string, description?: string | null, touchpoints: Array<{ __typename?: 'Touchpoint', activity?: { __typename?: 'Activity', contentMetrics: Array<{ __typename?: 'ContentMetric', id: string, metric?: { __typename?: 'Metric', name: string } | null }> } | null }>, contentMetrics: Array<{ __typename?: 'ContentMetric', id: string, metric?: { __typename?: 'Metric', name: string } | null }> } | null };

export type EditPhase_UpdateMutationVariables = Exact<{
  phaseId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  contentMetrics?: InputMaybe<Array<PhaseUpdateContentMetricsEntityRelationInput> | PhaseUpdateContentMetricsEntityRelationInput>;
}>;


export type EditPhase_UpdateMutation = { __typename?: 'Mutation', updatePhase: { __typename?: 'PhaseUpdateResult', ok: boolean, errorMessage?: string | null } };

export type Warnings_ListPhasesQueryVariables = Exact<{
  journeyId: Scalars['UUID']['input'];
}>;


export type Warnings_ListPhasesQuery = { __typename?: 'Query', listPhase: Array<(
    { __typename?: 'Phase', id: string, name: string, order: number, touchpoints: Array<{ __typename?: 'Touchpoint', id: string, type: TouchpointType, activity?: (
        { __typename?: 'Activity' }
        & { ' $fragmentRefs'?: { 'ActivityCard_ActivityFragment': ActivityCard_ActivityFragment } }
      ) | null }> }
    & { ' $fragmentRefs'?: { 'JourneyFilters_PhasesFragment': JourneyFilters_PhasesFragment } }
  )> };

export type Warnings_ReorderPhasesMutationVariables = Exact<{
  journeyId: Scalars['UUID']['input'];
  phases: Array<JourneyUpdatePhasesEntityRelationInput> | JourneyUpdatePhasesEntityRelationInput;
}>;


export type Warnings_ReorderPhasesMutation = { __typename?: 'Mutation', updateJourney: { __typename?: 'JourneyUpdateResult', ok: boolean, errorMessage?: string | null } };

export type Warnings_ConnectTpToColumnMutationVariables = Exact<{
  touchpointId?: InputMaybe<Scalars['UUID']['input']>;
  targetPhaseId: Scalars['UUID']['input'];
}>;


export type Warnings_ConnectTpToColumnMutation = { __typename?: 'Mutation', updateTouchpoint: { __typename?: 'TouchpointUpdateResult', ok: boolean, errorMessage?: string | null } };

export type Warnings_TouchpointsReorderMutationVariables = Exact<{
  phaseId: Scalars['UUID']['input'];
  touchpoints: Array<PhaseUpdateTouchpointsEntityRelationInput> | PhaseUpdateTouchpointsEntityRelationInput;
}>;


export type Warnings_TouchpointsReorderMutation = { __typename?: 'Mutation', updatePhase: { __typename?: 'PhaseUpdateResult', ok: boolean, errorMessage?: string | null } };

export type ActivityCard_ActivityFragment = { __typename?: 'Activity', id: string, name: string, description?: string | null, satisfaction: number, contentMetrics: Array<{ __typename?: 'ContentMetric', id: string, metric?: { __typename?: 'Metric', id: string, name: string, unitSign?: string | null, dataSet?: { __typename?: 'MetricDataSet', metricTemplate?: { __typename?: 'MetricTemplate', unitSign?: string | null } | null } | null } | null }>, duration?: { __typename?: 'ActivityDuration', start?: string | null, end?: string | null, type: ActivityDurationType, id: string, showOnActivityMap: boolean, unit?: ActivityDurationOccurenceUnitType | null, occurence?: number | null } | null, controlCycle?: { __typename?: 'ControlCycle', history: Array<{ __typename?: 'ControlCycleCheck', at: string }> } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, owner?: (
    { __typename?: 'Member' }
    & { ' $fragmentRefs'?: { 'CustomAvatarGroup_MemberFragment': CustomAvatarGroup_MemberFragment } }
  ) | null, pictures: Array<{ __typename?: 'Picture', id: string, order: number, image?: { __typename?: 'Image', id: string, url?: string | null } | null }>, warnings: Array<{ __typename?: 'ActivityWarning', id: string, contentMetrics?: { __typename?: 'ContentMetric', id: string } | null }> } & { ' $fragmentName'?: 'ActivityCard_ActivityFragment' };

export type Warnings_CreateActivityMutationVariables = Exact<{
  order: Scalars['Int']['input'];
  phaseId: Scalars['UUID']['input'];
}>;


export type Warnings_CreateActivityMutation = { __typename?: 'Mutation', createActivity: { __typename?: 'ActivityCreateResult', ok: boolean, errorMessage?: string | null } };

export type OpportunityActionsList_GetOpportunityQueryVariables = Exact<{
  opportunityId: Scalars['UUID']['input'];
}>;


export type OpportunityActionsList_GetOpportunityQuery = { __typename?: 'Query', getOpportunity?: { __typename?: 'Opportunity', actions: Array<{ __typename?: 'Action', id: string, name: string, status: ActionStatus, deadline?: string | null, priority: ActionPriority, owner?: { __typename?: 'Member', name: string, avatar?: { __typename?: 'Image', url?: string | null } | null } | null }> } | null };

export type OpportunityActionssList_RemoveOpportunityActionMutationVariables = Exact<{
  opportunityId: Scalars['UUID']['input'];
  actionId: Scalars['UUID']['input'];
}>;


export type OpportunityActionssList_RemoveOpportunityActionMutation = { __typename?: 'Mutation', updateOpportunity: { __typename?: 'OpportunityUpdateResult', ok: boolean } };

export type OpportunityAddActionModal_ListActionsQueryVariables = Exact<{ [key: string]: never; }>;


export type OpportunityAddActionModal_ListActionsQuery = { __typename?: 'Query', listAction: Array<{ __typename?: 'Action', id: string, name: string }> };

export type OpportunityAddActionModal_GetOpportunityQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type OpportunityAddActionModal_GetOpportunityQuery = { __typename?: 'Query', getOpportunity?: { __typename?: 'Opportunity', actions: Array<{ __typename?: 'Action', id: string }> } | null };

export type OpportunityAddActionModal_CreateActionMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  priority: ActionPriority;
  status: ActionStatus;
  links: Scalars['Json']['input'];
  activities?: InputMaybe<Array<ActionCreateActivitiesEntityRelationInput> | ActionCreateActivitiesEntityRelationInput>;
}>;


export type OpportunityAddActionModal_CreateActionMutation = { __typename?: 'Mutation', createAction: { __typename?: 'ActionCreateResult', ok: boolean, errorMessage?: string | null, node?: { __typename?: 'Action', id: string } | null } };

export type OpportunityAddActionModal_UpdateOpportunityActionsMutationVariables = Exact<{
  opportunityId: Scalars['UUID']['input'];
  actionId: Scalars['UUID']['input'];
}>;


export type OpportunityAddActionModal_UpdateOpportunityActionsMutation = { __typename?: 'Mutation', updateOpportunity: { __typename?: 'OpportunityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type OpportunityDeleteModal_GetOpportunityQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type OpportunityDeleteModal_GetOpportunityQuery = { __typename?: 'Query', getOpportunity?: { __typename?: 'Opportunity', name: string } | null };

export type OpportunityDeleteModal_DeleteOpportunityMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type OpportunityDeleteModal_DeleteOpportunityMutation = { __typename?: 'Mutation', deleteOpportunity: { __typename?: 'OpportunityDeleteResult', ok: boolean, errorMessage?: string | null } };

export type AssignOpportunityModal_UpdateOpportunityMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data: OpportunityUpdateInput;
}>;


export type AssignOpportunityModal_UpdateOpportunityMutation = { __typename?: 'Mutation', updateOpportunity: { __typename?: 'OpportunityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type OpportunityDetailContent_UpdateOpportunityMutationVariables = Exact<{
  opportunityId: Scalars['UUID']['input'];
  data: OpportunityUpdateInput;
}>;


export type OpportunityDetailContent_UpdateOpportunityMutation = { __typename?: 'Mutation', updateOpportunity: { __typename?: 'OpportunityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type OpportunityDetailForm_UpdateOpportunityMutationVariables = Exact<{
  opportunityId: Scalars['UUID']['input'];
  data: OpportunityUpdateInput;
}>;


export type OpportunityDetailForm_UpdateOpportunityMutation = { __typename?: 'Mutation', updateOpportunity: { __typename?: 'OpportunityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type OpportunityDetailHeader_UpdateOpportunityMutationVariables = Exact<{
  opportunityId: Scalars['UUID']['input'];
  data: OpportunityUpdateInput;
}>;


export type OpportunityDetailHeader_UpdateOpportunityMutation = { __typename?: 'Mutation', updateOpportunity: { __typename?: 'OpportunityUpdateResult', ok: boolean, errorMessage?: string | null } };

export type OpportunityDetailPage_GetOpportunityQueryVariables = Exact<{
  opportunityId: Scalars['UUID']['input'];
}>;


export type OpportunityDetailPage_GetOpportunityQuery = { __typename?: 'Query', getOpportunity?: { __typename?: 'Opportunity', id: string, name: string, description?: string | null, status: OpportunityStatus, links?: unknown | null, benefit: number, createdAt: string, owner?: { __typename?: 'Member', id: string } | null, tags: Array<{ __typename?: 'Tag', id: string }>, actions: Array<{ __typename?: 'Action', id: string }>, activities: Array<{ __typename?: 'Activity', id: string, name: string }> } | null };

export type OpportunityHeader_ListOpportunitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type OpportunityHeader_ListOpportunitiesQuery = { __typename?: 'Query', listOpportunity: Array<{ __typename?: 'Opportunity', id: string }> };

export type OpportunityListHeader_CreateOpportunityMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  benefit?: InputMaybe<Scalars['Int']['input']>;
  status: OpportunityStatus;
  links: Scalars['Json']['input'];
}>;


export type OpportunityListHeader_CreateOpportunityMutation = { __typename?: 'Mutation', createOpportunity: { __typename?: 'OpportunityCreateResult', ok: boolean, errorMessage?: string | null, node?: { __typename?: 'Opportunity', id: string } | null } };

export type OpportunityList_GetOpportunitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type OpportunityList_GetOpportunitiesQuery = { __typename?: 'Query', listOpportunity: Array<{ __typename?: 'Opportunity', id: string, name: string, createdAt: string, status: OpportunityStatus, benefit: number, owner?: { __typename?: 'Member', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, actions: Array<{ __typename?: 'Action', id: string, name: string }>, journeys?: Array<{ __typename?: 'Journey', id: string, name: string }> | null, activities: Array<{ __typename?: 'Activity', id: string, name: string, touchpoint?: { __typename?: 'Touchpoint', phase?: { __typename?: 'Phase', journey?: { __typename?: 'Journey', id: string, name: string, color?: string | null } | null } | null } | null }> }> };

export type Settings_GetMemberSettingsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type Settings_GetMemberSettingsQuery = { __typename?: 'Query', getMemberSettings?: { __typename?: 'MemberSettings', id: string, language?: string | null, currency?: string | null, dateFormat?: string | null, firstDayOfWeek?: MemberSettingsFirstDayOfWeek | null, timezone?: string | null } | null };

export type Settings_UpdateMemberSettingsMutationVariables = Exact<{
  memberId: Scalars['UUID']['input'];
  update: MemberSettingsUpdateInput;
  create: MemberSettingsCreateInput;
}>;


export type Settings_UpdateMemberSettingsMutation = { __typename?: 'Mutation', upsertMemberSettings: { __typename?: 'MemberSettingsUpsertResult', ok: boolean, errorMessage?: string | null, node?: { __typename?: 'MemberSettings', language?: string | null, currency?: string | null, dateFormat?: string | null, firstDayOfWeek?: MemberSettingsFirstDayOfWeek | null, timezone?: string | null } | null } };

export type OrganizationSettings_UpdateOrganizationMutationVariables = Exact<{
  name: Scalars['String']['input'];
  alias: Scalars['String']['input'];
}>;


export type OrganizationSettings_UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'UpdateOrganizationResult', ok: boolean, errorMessage?: string | null } };

export type Persona_DeletePersonaMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type Persona_DeletePersonaMutation = { __typename?: 'Mutation', deletePersona: { __typename?: 'PersonaDeleteResult', ok: boolean, errorMessage?: string | null } };

export type Persona_GetPersonaByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type Persona_GetPersonaByIdQuery = { __typename?: 'Query', getPersona?: { __typename?: 'Persona', activities: Array<{ __typename?: 'Activity', id: string }> } | null };

export type PersonaAvatar_PersonaFragment = { __typename?: 'Persona', name: string, avatar?: { __typename?: 'Image', url90?: string | null, url48?: string | null, url40?: string | null, url24?: string | null } | null } & { ' $fragmentName'?: 'PersonaAvatar_PersonaFragment' };

export type Persona_ListPersonasQueryVariables = Exact<{ [key: string]: never; }>;


export type Persona_ListPersonasQuery = { __typename?: 'Query', listPersona: Array<(
    { __typename?: 'Persona', id: string }
    & { ' $fragmentRefs'?: { 'PersonaDetail_PersonaFragmentFragment': PersonaDetail_PersonaFragmentFragment } }
  )> };

export type PersonaPopover_UpdatePersonaColorMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  color: Scalars['String']['input'];
}>;


export type PersonaPopover_UpdatePersonaColorMutation = { __typename?: 'Mutation', updatePersona: { __typename?: 'PersonaUpdateResult', ok: boolean, errorMessage?: string | null } };

export type PersonaPopover_PersonaFragmentFragment = { __typename?: 'Persona', id: string, name: string, color?: string | null } & { ' $fragmentName'?: 'PersonaPopover_PersonaFragmentFragment' };

export type Persona_DeletePersonaBlockMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type Persona_DeletePersonaBlockMutation = { __typename?: 'Mutation', deletePersonaBlock: { __typename?: 'PersonaBlockDeleteResult', ok: boolean, errorMessage?: string | null } };

export type EditPersonaAvatar_GetPersonaQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type EditPersonaAvatar_GetPersonaQuery = { __typename?: 'Query', getPersona?: { __typename?: 'Persona', avatar?: { __typename?: 'Image', url?: string | null } | null } | null };

export type EditPersonaAvatar_UpdatePersonaMutationVariables = Exact<{
  personaId: Scalars['UUID']['input'];
  imageId: Scalars['UUID']['input'];
}>;


export type EditPersonaAvatar_UpdatePersonaMutation = { __typename?: 'Mutation', updatePersona: { __typename?: 'PersonaUpdateResult', ok: boolean, errorMessage?: string | null } };

export type PersonaDetail_GetJourneyDetailQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type PersonaDetail_GetJourneyDetailQuery = { __typename?: 'Query', getJourney?: { __typename?: 'Journey', id: string, name: string, description?: string | null, color?: string | null, personas?: Array<(
      { __typename?: 'Persona', id: string }
      & { ' $fragmentRefs'?: { 'PersonaAvatar_PersonaFragment': PersonaAvatar_PersonaFragment } }
    )> | null, teams: Array<{ __typename?: 'Team', id: string, name: string }> } | null };

export type PersonaDetail_PersonaUsedInJourneyQueryVariables = Exact<{
  personaId: Scalars['UUID']['input'];
  journeyId: Scalars['UUID']['input'];
}>;


export type PersonaDetail_PersonaUsedInJourneyQuery = { __typename?: 'Query', getPersona?: { __typename?: 'Persona', activities: Array<{ __typename?: 'Activity', id: string, name: string }> } | null };

export type PersonaDetail_CreatePersonaBlockMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  color: Scalars['String']['input'];
  items?: InputMaybe<Array<PersonaBlockCreateItemsEntityRelationInput> | PersonaBlockCreateItemsEntityRelationInput>;
  personaId: Scalars['UUID']['input'];
  order: Scalars['Int']['input'];
}>;


export type PersonaDetail_CreatePersonaBlockMutation = { __typename?: 'Mutation', createPersonaBlock: { __typename?: 'PersonaBlockCreateResult', ok: boolean, errorMessage?: string | null } };

export type PersonaBlockItems_ItemFragmentFragment = { __typename?: 'PersonaBlockItem', id: string, name: string, value: number } & { ' $fragmentName'?: 'PersonaBlockItems_ItemFragmentFragment' };

export type PersonaDetailBlockItem_UpdatePersonaBlockItemMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data: Scalars['Int']['input'];
}>;


export type PersonaDetailBlockItem_UpdatePersonaBlockItemMutation = { __typename?: 'Mutation', updatePersonaBlockItem: { __typename?: 'PersonaBlockItemUpdateResult', ok: boolean, errorMessage?: string | null } };

export type PersonaBlockTile_BlockFragmentFragment = { __typename?: 'PersonaBlock', id: string, name: string, description?: string | null, color: string, items: Array<(
    { __typename?: 'PersonaBlockItem' }
    & { ' $fragmentRefs'?: { 'PersonaBlockItems_ItemFragmentFragment': PersonaBlockItems_ItemFragmentFragment } }
  )> } & { ' $fragmentName'?: 'PersonaBlockTile_BlockFragmentFragment' };

export type PersonaBlockTile_UpdateColorMutationVariables = Exact<{
  blockId: Scalars['UUID']['input'];
  color: Scalars['String']['input'];
}>;


export type PersonaBlockTile_UpdateColorMutation = { __typename?: 'Mutation', updatePersonaBlock: { __typename?: 'PersonaBlockUpdateResult', ok: boolean, errorMessage?: string | null } };

export type PersonaBlockUpdateModal_PersonaBlockQueryVariables = Exact<{
  blockId: Scalars['UUID']['input'];
}>;


export type PersonaBlockUpdateModal_PersonaBlockQuery = { __typename?: 'Query', getPersonaBlock?: { __typename?: 'PersonaBlock', id: string, name: string, description?: string | null, color: string, items: Array<{ __typename?: 'PersonaBlockItem', id: string, name: string, value: number }> } | null };

export type PersonaDetail_UpdatePersonaBlockMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  color: Scalars['String']['input'];
  items?: InputMaybe<Array<PersonaBlockUpdateItemsEntityRelationInput> | PersonaBlockUpdateItemsEntityRelationInput>;
  personaId: Scalars['UUID']['input'];
  blockId: Scalars['UUID']['input'];
}>;


export type PersonaDetail_UpdatePersonaBlockMutation = { __typename?: 'Mutation', updatePersonaBlock: { __typename?: 'PersonaBlockUpdateResult', ok: boolean, errorMessage?: string | null } };

export type PersonaDetailEditDrawer_GetPersonaQueryVariables = Exact<{
  personaId: Scalars['UUID']['input'];
}>;


export type PersonaDetailEditDrawer_GetPersonaQuery = { __typename?: 'Query', getPersona?: (
    { __typename?: 'Persona', age?: number | null, description?: string | null, gender?: PersonaGender | null, location?: string | null, id: string, job?: string | null, name: string, quote?: string | null, status?: PersonaStatus | null, color?: string | null }
    & { ' $fragmentRefs'?: { 'PersonaAvatar_PersonaFragment': PersonaAvatar_PersonaFragment } }
  ) | null };

export type UpdatePersonaDetailMutationMutationVariables = Exact<{
  updatePersonaBy2: PersonaUniqueWhere;
  data: PersonaUpdateInput;
}>;


export type UpdatePersonaDetailMutationMutation = { __typename?: 'Mutation', updatePersona: { __typename?: 'PersonaUpdateResult', ok: boolean, errorMessage?: string | null } };

export type PersonaDetail_GetPersonaQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type PersonaDetail_GetPersonaQuery = { __typename?: 'Query', getPersona?: (
    { __typename?: 'Persona', age?: number | null, description?: string | null, gender?: PersonaGender | null, location?: string | null, id: string, job?: string | null, name: string, quote?: string | null, status?: PersonaStatus | null, color?: string | null, journeys?: Array<{ __typename?: 'Journey', id: string }> | null, blocks: Array<(
      { __typename?: 'PersonaBlock', id: string }
      & { ' $fragmentRefs'?: { 'PersonaBlockTile_BlockFragmentFragment': PersonaBlockTile_BlockFragmentFragment } }
    )> }
    & { ' $fragmentRefs'?: { 'PersonaAvatar_PersonaFragment': PersonaAvatar_PersonaFragment;'PersonaPopover_PersonaFragmentFragment': PersonaPopover_PersonaFragmentFragment } }
  ) | null };

export type RemovePersonaAvatar_UpdatePersonaMutationVariables = Exact<{
  personaId: Scalars['UUID']['input'];
}>;


export type RemovePersonaAvatar_UpdatePersonaMutation = { __typename?: 'Mutation', updatePersona: { __typename?: 'PersonaUpdateResult', ok: boolean, errorMessage?: string | null } };

export type Organization_CreatePersonaMutationVariables = Exact<{
  name: Scalars['String']['input'];
  age: Scalars['Int']['input'];
  quote: Scalars['String']['input'];
  description: Scalars['String']['input'];
  status: PersonaStatus;
  gender: PersonaGender;
  job: Scalars['String']['input'];
  location: Scalars['String']['input'];
  blocks?: InputMaybe<Array<PersonaCreateBlocksEntityRelationInput> | PersonaCreateBlocksEntityRelationInput>;
}>;


export type Organization_CreatePersonaMutation = { __typename?: 'Mutation', createPersona: { __typename?: 'PersonaCreateResult', ok: boolean, errorMessage?: string | null } };

export type Organization_UpdatePersonaMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
}>;


export type Organization_UpdatePersonaMutation = { __typename?: 'Mutation', updatePersona: { __typename?: 'PersonaUpdateResult', ok: boolean, errorMessage?: string | null } };

export type PersonaDetail_PersonaFragmentFragment = (
  { __typename?: 'Persona', id: string, name: string, color?: string | null, quote?: string | null, age?: number | null, job?: string | null, journeys?: Array<{ __typename?: 'Journey', id: string, color?: string | null }> | null }
  & { ' $fragmentRefs'?: { 'PersonaAvatar_PersonaFragment': PersonaAvatar_PersonaFragment;'PersonaPopover_PersonaFragmentFragment': PersonaPopover_PersonaFragmentFragment } }
) & { ' $fragmentName'?: 'PersonaDetail_PersonaFragmentFragment' };

export type Auth_ResetPasswordMutationVariables = Exact<{
  token: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type Auth_ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'ResetPasswordResponse', error?: { __typename?: 'ResetPasswordError', code: ResetPasswordErrorCode } | null } | null };

export type Auth_ExpiredTokenResetPasswordRequestMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type Auth_ExpiredTokenResetPasswordRequestMutation = { __typename?: 'Mutation', createResetPasswordRequest?: { __typename?: 'CreatePasswordResetRequestResponse', error?: { __typename?: 'CreatePasswordResetRequestError', code: CreatePasswordResetRequestErrorCode } | null } | null };

export type Auth_CreateResetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type Auth_CreateResetPasswordMutation = { __typename?: 'Mutation', createResetPassword: { __typename?: 'CreatePasswordResetRequestResponse', error?: { __typename?: 'CreatePasswordResetRequestError', code: CreatePasswordResetRequestErrorCode } | null } };

export type Organization_InviteMemberMutationVariables = Exact<{
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type Organization_InviteMemberMutation = { __typename?: 'Mutation', inviteMember: { __typename?: 'MemberCreateResult', ok: boolean, errorMessage?: string | null } };

export type Organization_PaginateMembersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type Organization_PaginateMembersQuery = { __typename?: 'Query', paginateMember: { __typename?: 'MemberConnection', edges: Array<{ __typename?: 'MemberEdge', node: { __typename?: 'Member', id: string, name: string, isBlocked: boolean, avatar?: { __typename?: 'Image', url?: string | null } | null, team?: { __typename?: 'Team', id: string, name: string } | null, person?: { __typename?: 'MemberPerson', email: string, name?: string | null, roles: Array<string> } | null } }>, pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type Organization_DeactivateMemberMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type Organization_DeactivateMemberMutation = { __typename?: 'Mutation', deactivateMember?: { __typename?: 'MemberUpdateResult', ok: boolean, errorMessage?: string | null } | null };

export type Organization_ReactivateMemberMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type Organization_ReactivateMemberMutation = { __typename?: 'Mutation', reactivateMember?: { __typename?: 'MemberUpdateResult', ok: boolean, errorMessage?: string | null } | null };

export type Organization_Members_ListTeamsQueryVariables = Exact<{ [key: string]: never; }>;


export type Organization_Members_ListTeamsQuery = { __typename?: 'Query', listTeam: Array<{ __typename?: 'Team', id: string, name: string }> };

export type Organization_UpdateMemberMutationVariables = Exact<{
  memberId: Scalars['UUID']['input'];
  data: MemberUpdateInputFiltered;
}>;


export type Organization_UpdateMemberMutation = { __typename?: 'Mutation', updateMember: { __typename?: 'MemberUpdateResult', ok: boolean, errorMessage?: string | null } };

export type Organization_DeleteTeamMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
}>;


export type Organization_DeleteTeamMutation = { __typename?: 'Mutation', deleteTeam: { __typename?: 'TeamDeleteResult', ok: boolean, errorMessage?: string | null } };

export type Organization_GetTeamByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type Organization_GetTeamByIdQuery = { __typename?: 'Query', getTeam?: { __typename?: 'Team', members: Array<{ __typename?: 'Member', id: string }> } | null };

export type Organization_CreateTeamMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type Organization_CreateTeamMutation = { __typename?: 'Mutation', createTeam: { __typename?: 'TeamCreateResult', ok: boolean, errorMessage?: string | null } };

export type Organization_UpdateTeamMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
}>;


export type Organization_UpdateTeamMutation = { __typename?: 'Mutation', updateTeam: { __typename?: 'TeamUpdateResult', ok: boolean, errorMessage?: string | null } };

export type Organization_Teams_PaginateTeamsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type Organization_Teams_PaginateTeamsQuery = { __typename?: 'Query', paginateTeam: { __typename?: 'TeamConnection', edges: Array<{ __typename?: 'TeamEdge', node: { __typename?: 'Team', id: string, name: string, members: Array<{ __typename?: 'Member', id: string, avatar?: { __typename?: 'Image', url?: string | null } | null }> } }>, pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type PaginateTagQueryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PaginateTagQueryQuery = { __typename?: 'Query', paginateTag: { __typename?: 'TagConnection', edges: Array<{ __typename?: 'TagEdge', node: { __typename?: 'Tag', id: string, name: string, paginateActivities: { __typename?: 'ActivityConnection', pageInfo: { __typename?: 'PageInfo', totalCount: number } } } }>, pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type Tags_ListTagQueryVariables = Exact<{ [key: string]: never; }>;


export type Tags_ListTagQuery = { __typename?: 'Query', listTag: Array<{ __typename?: 'Tag', id: string }> };

export type DeleteTagMutationMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteTagMutationMutation = { __typename?: 'Mutation', deleteTag: { __typename?: 'TagDeleteResult', ok: boolean, errorMessage?: string | null } };

export type DeleteProfilePhoto_UpdateMemberMutationVariables = Exact<{
  memberId: Scalars['UUID']['input'];
}>;


export type DeleteProfilePhoto_UpdateMemberMutation = { __typename?: 'Mutation', updateMember: { __typename?: 'MemberUpdateResult', ok: boolean, errorMessage?: string | null } };

export type Settings_UpdateMyProfileMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
}>;


export type Settings_UpdateMyProfileMutation = { __typename?: 'Mutation', updateMyProfile: { __typename?: 'MemberUpdateResult', ok: boolean, errorMessage?: string | null } };

export type Settings_ChangeMyPasswordMutationVariables = Exact<{
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type Settings_ChangeMyPasswordMutation = { __typename?: 'Mutation', changeMyPassword?: { __typename?: 'ChangeMyPasswordResponse', ok: boolean, error?: { __typename?: 'ChangeMyPasswordError', code: ChangeMyPasswordErrorCode } | null } | null };

export type SettingsProfile_MeQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsProfile_MeQuery = { __typename?: 'Query', me: { __typename?: 'Member', avatar?: { __typename?: 'Image', url?: string | null } | null } };

export type SettingsProfile_UpdateMemberMutationVariables = Exact<{
  memberId: Scalars['UUID']['input'];
  imageId: Scalars['UUID']['input'];
}>;


export type SettingsProfile_UpdateMemberMutation = { __typename?: 'Mutation', updateMember: { __typename?: 'MemberUpdateResult', ok: boolean, errorMessage?: string | null } };

export type Upgrade_StripeLinkQueryQueryVariables = Exact<{
  plan: PaymentPlan;
}>;


export type Upgrade_StripeLinkQueryQuery = { __typename?: 'Query', paymentLink?: { __typename?: 'PaymentLink', costPerMember?: number | null, link?: string | null } | null };

export type CurrentOrganization_SubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentOrganization_SubscriptionQuery = { __typename?: 'Query', getOrganizationMeta?: { __typename?: 'OrganizationMeta', trialDaysLeft?: number | null, status: OrganizationStatus } | null };

export type CurrentOrganization_LicenseQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentOrganization_LicenseQuery = { __typename?: 'Query', getOrganizationMeta?: { __typename?: 'OrganizationMeta', license: OrganizationLicense, trialEndDate?: string | null, status: OrganizationStatus } | null };

export const CreatableMetricTemplateSelect_MetricTemplateFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreatableMetricTemplateSelect_MetricTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MetricTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}}]}}]} as unknown as DocumentNode<CreatableMetricTemplateSelect_MetricTemplateFragment, unknown>;
export const JourneyTemplateTile_JourneyFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"journeyTemplateTile_journeyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Journey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<JourneyTemplateTile_JourneyFragmentFragment, unknown>;
export const CustomAvatarGroup_MemberFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomAvatarGroup_Member"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url24"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}}]} as unknown as DocumentNode<CustomAvatarGroup_MemberFragment, unknown>;
export const ActivityCard_ActivityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"activityCard_activity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Activity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitSign"}},{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitSign"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"showOnActivityMap"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"occurence"}}]}},{"kind":"Field","name":{"kind":"Name","value":"controlCycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"at"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomAvatarGroup_Member"}}]}},{"kind":"Field","name":{"kind":"Name","value":"satisfaction"}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"150"}}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"warnings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomAvatarGroup_Member"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url24"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}}]} as unknown as DocumentNode<ActivityCard_ActivityFragment, unknown>;
export const JourneyFilters_PhasesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"journeyFilters_phases"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"touchpoints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"activity"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"satisfaction"}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"personas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<JourneyFilters_PhasesFragment, unknown>;
export const JourneyDetail_PhasesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"journeyDetail_phases"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitSign"}},{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitSign"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"touchpoints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"activity"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"activityCard_activity"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"journeyFilters_phases"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomAvatarGroup_Member"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url24"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"activityCard_activity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Activity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitSign"}},{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitSign"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"showOnActivityMap"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"occurence"}}]}},{"kind":"Field","name":{"kind":"Name","value":"controlCycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"at"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomAvatarGroup_Member"}}]}},{"kind":"Field","name":{"kind":"Name","value":"satisfaction"}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"150"}}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"warnings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"journeyFilters_phases"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"touchpoints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"activity"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"satisfaction"}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"personas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<JourneyDetail_PhasesFragment, unknown>;
export const PersonaAvatar_PersonaFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonaAvatar_persona"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Persona"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url90"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"90"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"90"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url48"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"48"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"48"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url40"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"40"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"40"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url24"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}}]} as unknown as DocumentNode<PersonaAvatar_PersonaFragment, unknown>;
export const OwnerCell_MemberFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerCell_Member"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"40"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"40"}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]} as unknown as DocumentNode<OwnerCell_MemberFragment, unknown>;
export const PictureGrid_GalleryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PictureGrid_Gallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Activity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"galleryImgSource"},"name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"450"}}]}]}}]}}]}}]} as unknown as DocumentNode<PictureGrid_GalleryFragment, unknown>;
export const JourneyDetail_WidgetsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"journeyDetail_widgets"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Activity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"links"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"goalsAndObjectives"}},{"kind":"Field","name":{"kind":"Name","value":"personas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonaAvatar_persona"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"occurence"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"showOnActivityMap"}}]}},{"kind":"Field","name":{"kind":"Name","value":"satisfaction"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"controlCycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"at"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerCell_Member"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitSign"}},{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitSign"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"150"}}]}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PictureGrid_Gallery"}},{"kind":"Field","name":{"kind":"Name","value":"opportunities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEq"},"value":{"kind":"EnumValue","value":"resolved"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEq"},"value":{"kind":"EnumValue","value":"resolved"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subTouchpoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"touchpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parentActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectedJourneys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonaAvatar_persona"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Persona"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url90"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"90"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"90"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url48"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"48"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"48"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url40"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"40"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"40"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url24"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerCell_Member"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"40"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"40"}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PictureGrid_Gallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Activity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"galleryImgSource"},"name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"450"}}]}]}}]}}]}}]} as unknown as DocumentNode<JourneyDetail_WidgetsFragment, unknown>;
export const Journey_SingleJourneyFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Journey_SingleJourneyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Journey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"personas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonaAvatar_persona"}}]}},{"kind":"Field","name":{"kind":"Name","value":"satisfaction"}},{"kind":"Field","name":{"kind":"Name","value":"activityWarnings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainMetric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitSign"}},{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitSign"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonaAvatar_persona"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Persona"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url90"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"90"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"90"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url48"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"48"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"48"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url40"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"40"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"40"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url24"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}}]} as unknown as DocumentNode<Journey_SingleJourneyFragmentFragment, unknown>;
export const Planning_ActivityUnresolvedActionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"planning_activityUnresolvedActions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Activity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"activityActionsUnresolved"},"name":{"kind":"Name","value":"actions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEq"},"value":{"kind":"EnumValue","value":"resolved"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Planning_ActivityUnresolvedActionsFragment, unknown>;
export const Planning_ActivityActionsLastWeekOrMonthFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"planning_activityActionsLastWeekOrMonth"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Activity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"activityActionsLastWeekOrMonth"},"name":{"kind":"Name","value":"actions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromLast"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toLast"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"solvedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromLast"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toLast"}}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEq"},"value":{"kind":"EnumValue","value":"resolved"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Planning_ActivityActionsLastWeekOrMonthFragment, unknown>;
export const Planning_ActivityActionsThisWeekOrMonthFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"planning_activityActionsThisWeekOrMonth"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Activity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"activityActionsThisWeekOrMonth"},"name":{"kind":"Name","value":"actions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromThis"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toThis"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"solvedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromThis"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toThis"}}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEq"},"value":{"kind":"EnumValue","value":"resolved"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Planning_ActivityActionsThisWeekOrMonthFragment, unknown>;
export const TimelineBody_PhasesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"timelineBody_phases"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"touchpoints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"activity"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"activityCard_activity"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subTouchpoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"journeyFilters_phases"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomAvatarGroup_Member"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url24"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"activityCard_activity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Activity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitSign"}},{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitSign"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"showOnActivityMap"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"occurence"}}]}},{"kind":"Field","name":{"kind":"Name","value":"controlCycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"at"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomAvatarGroup_Member"}}]}},{"kind":"Field","name":{"kind":"Name","value":"satisfaction"}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"150"}}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"warnings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"journeyFilters_phases"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"touchpoints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"activity"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"satisfaction"}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"personas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TimelineBody_PhasesFragment, unknown>;
export const PersonaBlockItems_ItemFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"personaBlockItems_itemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PersonaBlockItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode<PersonaBlockItems_ItemFragmentFragment, unknown>;
export const PersonaBlockTile_BlockFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"personaBlockTile_blockFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PersonaBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"personaBlockItems_itemFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"personaBlockItems_itemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PersonaBlockItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode<PersonaBlockTile_BlockFragmentFragment, unknown>;
export const PersonaPopover_PersonaFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"personaPopover_personaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Persona"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<PersonaPopover_PersonaFragmentFragment, unknown>;
export const PersonaDetail_PersonaFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"personaDetail_personaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Persona"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"quote"}},{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"job"}},{"kind":"Field","name":{"kind":"Name","value":"journeys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonaAvatar_persona"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"personaPopover_personaFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonaAvatar_persona"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Persona"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url90"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"90"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"90"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url48"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"48"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"48"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url40"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"40"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"40"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url24"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"personaPopover_personaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Persona"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<PersonaDetail_PersonaFragmentFragment, unknown>;
export const JourneyEditDrawer_GetJourneyUniqueMetricsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journeyEditDrawer_getJourneyUniqueMetrics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainMetric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<JourneyEditDrawer_GetJourneyUniqueMetricsQuery, JourneyEditDrawer_GetJourneyUniqueMetricsQueryVariables>;
export const JourneyEditDrawer_SetJourneyMainMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"journeyEditDrawer_setJourneyMainMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mainMetric"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mainMetric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mainMetric"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<JourneyEditDrawer_SetJourneyMainMetricMutation, JourneyEditDrawer_SetJourneyMainMetricMutationVariables>;
export const JourneyEditDrawer_DisconnectJourneyMainMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"journeyEditDrawer_disconnectJourneyMainMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mainMetric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"disconnect"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<JourneyEditDrawer_DisconnectJourneyMainMetricMutation, JourneyEditDrawer_DisconnectJourneyMainMetricMutationVariables>;
export const Journey_SelectTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journey_selectTeam"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listTeam"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Journey_SelectTeamQuery, Journey_SelectTeamQueryVariables>;
export const ActionAddOpportunityModal_ListOpportunitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"actionAddOpportunityModal_listOpportunities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEq"},"value":{"kind":"EnumValue","value":"resolved"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ActionAddOpportunityModal_ListOpportunitiesQuery, ActionAddOpportunityModal_ListOpportunitiesQueryVariables>;
export const ActionAddOpportunityModal_GetActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"actionAddOpportunityModal_getAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"opportunities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ActionAddOpportunityModal_GetActionQuery, ActionAddOpportunityModal_GetActionQueryVariables>;
export const ActionAddOpportunityModal_CreateOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"actionAddOpportunityModal_createOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"benefit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpportunityStatus"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"links"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Json"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activities"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpportunityCreateActivitiesEntityRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"benefit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"benefit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"links"},"value":{"kind":"Variable","name":{"kind":"Name","value":"links"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"activities"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activities"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ActionAddOpportunityModal_CreateOpportunityMutation, ActionAddOpportunityModal_CreateOpportunityMutationVariables>;
export const ActionAddOpportunityModal_UpdateActionOpportunitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"actionAddOpportunityModal_updateActionOpportunities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"opportunities"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<ActionAddOpportunityModal_UpdateActionOpportunitiesMutation, ActionAddOpportunityModal_UpdateActionOpportunitiesMutationVariables>;
export const ActionOpportunitiesList_GetActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"actionOpportunitiesList_getAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"opportunities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"benefit"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ActionOpportunitiesList_GetActionQuery, ActionOpportunitiesList_GetActionQueryVariables>;
export const ActionOpportunitiesList_RemoveActionOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"actionOpportunitiesList_removeActionOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"opportunities"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"disconnect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<ActionOpportunitiesList_RemoveActionOpportunityMutation, ActionOpportunitiesList_RemoveActionOpportunityMutationVariables>;
export const AssignActionModal_UpdateActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"assignActionModal_updateAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActionUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<AssignActionModal_UpdateActionMutation, AssignActionModal_UpdateActionMutationVariables>;
export const ActionDetailContent_UpdateActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"actionDetailContent_updateAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActionUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<ActionDetailContent_UpdateActionMutation, ActionDetailContent_UpdateActionMutationVariables>;
export const ActionDetailForm_UpdateActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"actionDetailForm_updateAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActionUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<ActionDetailForm_UpdateActionMutation, ActionDetailForm_UpdateActionMutationVariables>;
export const ActionDetailHeader_UpdateActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"actionDetailHeader_updateAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActionUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<ActionDetailHeader_UpdateActionMutation, ActionDetailHeader_UpdateActionMutationVariables>;
export const ActionDetailPage_GetActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"actionDetailPage_getAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"opportunities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"benefit"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"26"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"26"}}]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"links"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ActionDetailPage_GetActionQuery, ActionDetailPage_GetActionQueryVariables>;
export const ActionDeleteModal_GetActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"actionDeleteModal_getAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ActionDeleteModal_GetActionQuery, ActionDeleteModal_GetActionQueryVariables>;
export const ActionDeleteModal_DeleteActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"actionDeleteModal_deleteAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<ActionDeleteModal_DeleteActionMutation, ActionDeleteModal_DeleteActionMutationVariables>;
export const ActionHeader_ListActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"actionHeader_listActions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ActionHeader_ListActionsQuery, ActionHeader_ListActionsQueryVariables>;
export const ActionListHeader_CreateActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"actionListHeader_createAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priority"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActionPriority"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActionStatus"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"links"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Json"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"priority"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priority"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"links"},"value":{"kind":"Variable","name":{"kind":"Name","value":"links"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ActionListHeader_CreateActionMutation, ActionListHeader_CreateActionMutationVariables>;
export const ActionList_GetActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"actionList_getActions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"opportunities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"touchpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"journey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ActionList_GetActionsQuery, ActionList_GetActionsQueryVariables>;
export const Announcement_AnnouncementQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"announcement_announcementQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"announcements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<Announcement_AnnouncementQueryQuery, Announcement_AnnouncementQueryQueryVariables>;
export const GetMeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"168"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"168"}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"organizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"slugAlias"}},{"kind":"Field","name":{"kind":"Name","value":"slugPreferred"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"slugAlias"}},{"kind":"Field","name":{"kind":"Name","value":"slugPreferred"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"}}]}}]}}]}}]} as unknown as DocumentNode<GetMeQuery, GetMeQueryVariables>;
export const Auth_SignInDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"auth_signIn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signIn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"expiration"},"value":{"kind":"IntValue","value":"3600"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"memberPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roles"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<Auth_SignInMutation, Auth_SignInMutationVariables>;
export const Auth_SignOutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"auth_signOut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signOut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<Auth_SignOutMutation, Auth_SignOutMutationVariables>;
export const Connection_PaginateActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"connection_paginateActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paginateActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentMetrics"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"not"},"value":{"kind":"NullValue"}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"touchpoint"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phase"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"journey"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isTemplate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"touchpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"journey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<Connection_PaginateActivityQuery, Connection_PaginateActivityQueryVariables>;
export const DataPointTable_GetMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dataPointTable_getMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getContentMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dataLabels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DataPointTable_GetMetricQuery, DataPointTable_GetMetricQueryVariables>;
export const DataPointTable_ListMetricDataPointDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dataPointTable_listMetricDataPoint"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MetricDataPointWhere"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listContentMetricDataPoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metricDataPoint"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metricDataPoint"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metricDataPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<DataPointTable_ListMetricDataPointQuery, DataPointTable_ListMetricDataPointQueryVariables>;
export const Connections_DeleteMetricDataPointDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"connections_deleteMetricDataPoint"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentMetricDataPointId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteContentMetricDataPoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentMetricDataPointId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Connections_DeleteMetricDataPointMutation, Connections_DeleteMetricDataPointMutationVariables>;
export const EditDataPoint_GetMetricDataPointDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"editDataPoint_getMetricDataPoint"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentDataPointId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getContentMetricDataPoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentDataPointId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricDataPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<EditDataPoint_GetMetricDataPointQuery, EditDataPoint_GetMetricDataPointQueryVariables>;
export const EditDataPoint_GetMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"editDataPoint_getMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentMetricId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getContentMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentMetricId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EditDataPoint_GetMetricQuery, EditDataPoint_GetMetricQueryVariables>;
export const EditDataPoint_CreateMetricDataPointDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editDataPoint_createMetricDataPoint"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataSetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"creatorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createContentMetricDataPoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"creator"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"creatorId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"metricDataPoint"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataSet"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataSetId"}}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<EditDataPoint_CreateMetricDataPointMutation, EditDataPoint_CreateMetricDataPointMutationVariables>;
export const EditDataPoint_UpdateMetricDataPointDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editDataPoint_updateMetricDataPoint"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataPointId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateContentMetricDataPoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataPointId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metricDataPoint"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<EditDataPoint_UpdateMetricDataPointMutation, EditDataPoint_UpdateMetricDataPointMutationVariables>;
export const Connections_ListMetricTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"connections_listMetricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listMetricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}}]}}]}}]} as unknown as DocumentNode<Connections_ListMetricTemplateQuery, Connections_ListMetricTemplateQueryVariables>;
export const ListMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listMetric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listContentMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataSet"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEq"},"value":{"kind":"EnumValue","value":"google_sheets"}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListMetricQuery, ListMetricQueryVariables>;
export const SetMapSheetsToMetricTemplateMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setMapSheetsToMetricTemplateMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetGoogleSheetConfigurationMappingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setGoogleSheetsMetricTemplateMapping"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<SetMapSheetsToMetricTemplateMutationMutation, SetMapSheetsToMetricTemplateMutationMutationVariables>;
export const DataSourcesList_GoogleSheetsConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dataSourcesList_googleSheetsConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"googleSheetsConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spreadsheetId"}}]}}]}}]} as unknown as DocumentNode<DataSourcesList_GoogleSheetsConfigurationQuery, DataSourcesList_GoogleSheetsConfigurationQueryVariables>;
export const DataSourceList_GoogleSheetsAuthorizedByDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dataSourceList_googleSheetsAuthorizedBy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMetricGoogleSheetsSource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metricGoogleSheetsSpreadsheets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"externalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}}]}}]}}]} as unknown as DocumentNode<DataSourceList_GoogleSheetsAuthorizedByQuery, DataSourceList_GoogleSheetsAuthorizedByQueryVariables>;
export const GoogleSheetsModal_SetGoogleSheetsConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"googleSheetsModal_setGoogleSheetsConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spreadsheetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setGoogleSheetsConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"spreadsheetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spreadsheetId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"currentUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<GoogleSheetsModal_SetGoogleSheetsConfigurationMutation, GoogleSheetsModal_SetGoogleSheetsConfigurationMutationVariables>;
export const TriggerMetricsSyncDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"triggerMetricsSync"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"triggerMetricsSync"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<TriggerMetricsSyncMutation, TriggerMetricsSyncMutationVariables>;
export const GoogleSheetsModal_GoogleSheetsConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"googleSheetsModal_googleSheetsConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"googleSheetsConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spreadsheetId"}}]}}]}}]} as unknown as DocumentNode<GoogleSheetsModal_GoogleSheetsConfigurationQuery, GoogleSheetsModal_GoogleSheetsConfigurationQueryVariables>;
export const GoogleSheetsModal_TriggerMetricsSyncDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"googleSheetsModal_triggerMetricsSync"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"triggerMetricsSync"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<GoogleSheetsModal_TriggerMetricsSyncMutation, GoogleSheetsModal_TriggerMetricsSyncMutationVariables>;
export const DataSourcelastUpdates_KeboolaSyncEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dataSourcelastUpdates_keboolaSyncEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listKeboolaSyncEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<DataSourcelastUpdates_KeboolaSyncEventQuery, DataSourcelastUpdates_KeboolaSyncEventQueryVariables>;
export const GetUnmappedSpreadsheetSheetsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUnmappedSpreadsheetSheetsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spreadsheetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"googleSpreadsheetSheets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"spreadsheetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spreadsheetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sheets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sheetTitle"}},{"kind":"Field","name":{"kind":"Name","value":"templateId"}},{"kind":"Field","name":{"kind":"Name","value":"templateName"}}]}}]}}]}}]} as unknown as DocumentNode<GetUnmappedSpreadsheetSheetsQueryQuery, GetUnmappedSpreadsheetSheetsQueryQueryVariables>;
export const MetricsTable_GoogleSheetsMetricsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"metricsTable_GoogleSheetsMetricsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paginateContentMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataSet"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"google_sheets"}}]}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<MetricsTable_GoogleSheetsMetricsQueryQuery, MetricsTable_GoogleSheetsMetricsQueryQueryVariables>;
export const MetricsTable_GoogleSpreadsheetsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"metricsTable_GoogleSpreadsheetsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listMetricGoogleSheetsSpreadsheet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalId"}}]}}]}}]} as unknown as DocumentNode<MetricsTable_GoogleSpreadsheetsQueryQuery, MetricsTable_GoogleSpreadsheetsQueryQueryVariables>;
export const SourceMetricsTableRow_ListMetricDataPointDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"sourceMetricsTableRow_listMetricDataPoint"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MetricDataPointWhere"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listContentMetricDataPoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metricDataPoint"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SourceMetricsTableRow_ListMetricDataPointQuery, SourceMetricsTableRow_ListMetricDataPointQueryVariables>;
export const MapSingleSheetToExistingMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mapSingleSheetToExistingMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSingleExistingContentMetricDataSet"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateContentMetricDataSetToGoogleSheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<MapSingleSheetToExistingMetricMutation, MapSingleSheetToExistingMetricMutationVariables>;
export const MapSingleSheetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mapSingleSheet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SingleSheetMappingConfig"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setSingleSheetMapping"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<MapSingleSheetMutation, MapSingleSheetMutationVariables>;
export const UseGoogleAuthorization_SetGoogleSheetsConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"useGoogleAuthorization_setGoogleSheetsConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"authorizationCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setGoogleSheetsConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"authorizationCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"authorizationCode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"currentUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"accessToken"}}]}}]}}]} as unknown as DocumentNode<UseGoogleAuthorization_SetGoogleSheetsConfigurationMutation, UseGoogleAuthorization_SetGoogleSheetsConfigurationMutationVariables>;
export const GoogleSheetsModal_SetGoogleSheetsConfigurationPickerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"googleSheetsModal_setGoogleSheetsConfigurationPicker"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spreadsheetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setGoogleSheetsConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"spreadsheetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spreadsheetId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"currentUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"sheets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sheetTitle"}},{"kind":"Field","name":{"kind":"Name","value":"templateId"}},{"kind":"Field","name":{"kind":"Name","value":"templateName"}}]}}]}}]}}]} as unknown as DocumentNode<GoogleSheetsModal_SetGoogleSheetsConfigurationPickerMutation, GoogleSheetsModal_SetGoogleSheetsConfigurationPickerMutationVariables>;
export const Connections_PaginateMetricsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"connections_paginateMetrics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paginateContentMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"touchpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"journey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<Connections_PaginateMetricsQuery, Connections_PaginateMetricsQueryVariables>;
export const Connections_ListMetricDataSetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"connections_listMetricDataSet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listMetricDataSet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Connections_ListMetricDataSetQuery, Connections_ListMetricDataSetQueryVariables>;
export const Connections_CreateMetricDataSetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"connections_createMetricDataSet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMetricDataSet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Connections_CreateMetricDataSetMutation, Connections_CreateMetricDataSetMutationVariables>;
export const Connections_DeleteMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"connections_deleteMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentMetricId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteContentMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentMetricId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Connections_DeleteMetricMutation, Connections_DeleteMetricMutationVariables>;
export const Connections_GetMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"connections_getMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentMetricId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getContentMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentMetricId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Connections_GetMetricQuery, Connections_GetMetricQueryVariables>;
export const Connections_ListMetricDataSourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"connections_listMetricDataSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listMetricSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Connections_ListMetricDataSourceQuery, Connections_ListMetricDataSourceQueryVariables>;
export const Connections_GetMetricDataSetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"connections_getMetricDataSet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataSetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMetricDataSet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataSetId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Connections_GetMetricDataSetQuery, Connections_GetMetricDataSetQueryVariables>;
export const Connections_UpdateMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"connections_updateMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentMetricId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataSetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateContentMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentMetricId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataSet"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataSetId"}}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updateMetricDataSet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataSetId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metricTemplate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Connections_UpdateMetricMutation, Connections_UpdateMetricMutationVariables>;
export const MetricTemplateDescription_GetMetricTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"metricTemplateDescription_getMetricTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metricTemplateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMetricTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricTemplateId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<MetricTemplateDescription_GetMetricTemplateQuery, MetricTemplateDescription_GetMetricTemplateQueryVariables>;
export const CreateMetricStepLocation_GetActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"createMetricStepLocation_getActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"touchpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"journey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateMetricStepLocation_GetActivityQuery, CreateMetricStepLocation_GetActivityQueryVariables>;
export const AssignMetricModal_UpdateMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"assignMetricModal_updateMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentMetricUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateContentMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<AssignMetricModal_UpdateMetricMutation, AssignMetricModal_UpdateMetricMutationVariables>;
export const Settings_DeleteMetricTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"settings_deleteMetricTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteMetricTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Settings_DeleteMetricTemplateMutation, Settings_DeleteMetricTemplateMutationVariables>;
export const Settings_GetMetricTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"settings_getMetricTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMetricTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}},{"kind":"Field","name":{"kind":"Name","value":"behavior"}},{"kind":"Field","name":{"kind":"Name","value":"precision"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitSign"}},{"kind":"Field","name":{"kind":"Name","value":"expectations"}},{"kind":"Field","name":{"kind":"Name","value":"defaultTrendComparison"}}]}}]}}]} as unknown as DocumentNode<Settings_GetMetricTemplateQuery, Settings_GetMetricTemplateQueryVariables>;
export const Settings_CreateMetricTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"settings_createMetricTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MetricTemplateCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMetricTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Settings_CreateMetricTemplateMutation, Settings_CreateMetricTemplateMutationVariables>;
export const Settings_UpdateMetricTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"settings_updateMetricTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MetricTemplateUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMetricTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Settings_UpdateMetricTemplateMutation, Settings_UpdateMetricTemplateMutationVariables>;
export const Settings_PaginateMetricTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"settings_paginateMetricTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paginateMetricTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}},{"kind":"Field","name":{"kind":"Name","value":"behavior"}},{"kind":"Field","name":{"kind":"Name","value":"expectations"}},{"kind":"Field","name":{"kind":"Name","value":"precision"}},{"kind":"Field","name":{"kind":"Name","value":"defaultTrendComparison"}},{"kind":"Field","name":{"kind":"Name","value":"paginateDataSets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<Settings_PaginateMetricTemplateQuery, Settings_PaginateMetricTemplateQueryVariables>;
export const Connections_GetManualMetricSourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"connections_getManualMetricSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listMetricSource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"manual"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<Connections_GetManualMetricSourceQuery, Connections_GetManualMetricSourceQueryVariables>;
export const Connections_GetMetricTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"connections_getMetricTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMetricTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"behavior"}}]}}]}}]} as unknown as DocumentNode<Connections_GetMetricTemplateQuery, Connections_GetMetricTemplateQueryVariables>;
export const Connections_CreateMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"connections_createMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentMetricCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createContentMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Connections_CreateMetricMutation, Connections_CreateMetricMutationVariables>;
export const CreateMetricModal_UpdateMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createMetricModal_updateMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentMetricUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateContentMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<CreateMetricModal_UpdateMetricMutation, CreateMetricModal_UpdateMetricMutationVariables>;
export const CreateMetricStepBasics_ListMetricTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"createMetricStepBasics_listMetricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listMetricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreatableMetricTemplateSelect_MetricTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreatableMetricTemplateSelect_MetricTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MetricTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}}]}}]} as unknown as DocumentNode<CreateMetricStepBasics_ListMetricTemplateQuery, CreateMetricStepBasics_ListMetricTemplateQueryVariables>;
export const Dashboard_ListMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dashboard_listMetric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listContentMetric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<Dashboard_ListMetricQuery, Dashboard_ListMetricQueryVariables>;
export const Dashboard_AddedMetricsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dashboard_addedMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listDashboardMetric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentMetric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Dashboard_AddedMetricsQuery, Dashboard_AddedMetricsQueryVariables>;
export const CreateDashboardMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDashboardMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DashboardMetricCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDashboardMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<CreateDashboardMetricMutation, CreateDashboardMetricMutationVariables>;
export const Dashboard_MetricsCardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dashboard_metricsCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listDashboardMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentMetric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitSign"}},{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitSign"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"touchpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"journey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]} as unknown as DocumentNode<Dashboard_MetricsCardsQuery, Dashboard_MetricsCardsQueryVariables>;
export const Dashboard_GetJourneysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dashboard_getJourneys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isTemplate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"satisfaction"}},{"kind":"Field","name":{"kind":"Name","value":"personas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonaAvatar_persona"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainMetric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitSign"}},{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitSign"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonaAvatar_persona"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Persona"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url90"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"90"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"90"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url48"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"48"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"48"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url40"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"40"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"40"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url24"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}}]} as unknown as DocumentNode<Dashboard_GetJourneysQuery, Dashboard_GetJourneysQueryVariables>;
export const Dashboard_GetMetricValuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dashboard_getMetricValues"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"range"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTimeRangeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chartDataPoints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"range"},"value":{"kind":"Variable","name":{"kind":"Name","value":"range"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}}]}}]} as unknown as DocumentNode<Dashboard_GetMetricValuesQuery, Dashboard_GetMetricValuesQueryVariables>;
export const Dashboard_UpdateMetricsOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"dashboard_updateMetricsOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DashboardUpdateDashboardMetricsEntityRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDashboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dashboardMetrics"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Dashboard_UpdateMetricsOrderMutation, Dashboard_UpdateMetricsOrderMutationVariables>;
export const DeleteDashboardMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDashboardMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentMetricId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDashboardMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentMetric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentMetricId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<DeleteDashboardMetricMutation, DeleteDashboardMetricMutationVariables>;
export const Dashbord_SortedDashboardMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dashbord_sortedDashboardMetric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listDashboardMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentMetric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"touchpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"journey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<Dashbord_SortedDashboardMetricQuery, Dashbord_SortedDashboardMetricQueryVariables>;
export const Dashboard_ListDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dashboard_listDashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listDashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<Dashboard_ListDashboardQuery, Dashboard_ListDashboardQueryVariables>;
export const DashboardImprovementsActions_ListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dashboardImprovementsActions_list"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActionOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEq"},"value":{"kind":"EnumValue","value":"resolved"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}}]}}]}}]} as unknown as DocumentNode<DashboardImprovementsActions_ListQuery, DashboardImprovementsActions_ListQueryVariables>;
export const DashboardImprovementsOpportunities_ListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dashboardImprovementsOpportunities_list"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpportunityOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEq"},"value":{"kind":"EnumValue","value":"resolved"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"benefit"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<DashboardImprovementsOpportunities_ListQuery, DashboardImprovementsOpportunities_ListQueryVariables>;
export const ActivitiesSelect_ListActivitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"activitiesSelect_listActivities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"touchpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"journey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ActivitiesSelect_ListActivitiesQuery, ActivitiesSelect_ListActivitiesQueryVariables>;
export const FormJourneySelect_ListJourneyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"formJourneySelect_listJourney"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isTemplate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<FormJourneySelect_ListJourneyQuery, FormJourneySelect_ListJourneyQueryVariables>;
export const OpportunitiesMemberSelect_ListMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"opportunitiesMemberSelect_listMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"40"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"40"}}]}]}}]}}]}}]} as unknown as DocumentNode<OpportunitiesMemberSelect_ListMembersQuery, OpportunitiesMemberSelect_ListMembersQueryVariables>;
export const MembersSelect_ListMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"membersSelect_listMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"40"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"40"}}]}]}}]}}]}}]} as unknown as DocumentNode<MembersSelect_ListMemberQuery, MembersSelect_ListMemberQueryVariables>;
export const PersonasSelect_ListPersonaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"personasSelect_listPersona"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listPersona"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonaAvatar_persona"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonaAvatar_persona"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Persona"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url90"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"90"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"90"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url48"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"48"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"48"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url40"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"40"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"40"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url24"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}}]} as unknown as DocumentNode<PersonasSelect_ListPersonaQuery, PersonasSelect_ListPersonaQueryVariables>;
export const TagsSelect_ListTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"tagsSelect_listTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listTag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<TagsSelect_ListTagsQuery, TagsSelect_ListTagsQueryVariables>;
export const TagsSelect_CreateTagDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"tagsSelect_createTag"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<TagsSelect_CreateTagMutation, TagsSelect_CreateTagMutationVariables>;
export const UseImageUpload_RequestImageUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"useImageUpload_requestImageUpload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestImageUpload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uploadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"formDataFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UseImageUpload_RequestImageUploadMutation, UseImageUpload_RequestImageUploadMutationVariables>;
export const UseImageUpload_GetImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"useImageUpload_getImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<UseImageUpload_GetImageQuery, UseImageUpload_GetImageQueryVariables>;
export const ActivitySelect_ListTouchpointDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"activitySelect_listTouchpoint"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listTouchpoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phase"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"activity"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ActivitySelect_ListTouchpointQuery, ActivitySelect_ListTouchpointQueryVariables>;
export const Journey_ActivityDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"journey_activityDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTouchpoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Journey_ActivityDeleteMutation, Journey_ActivityDeleteMutationVariables>;
export const Journey_GetActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journey_getActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTouchpoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"opportunities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"controlCycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goalsAndObjectives"}},{"kind":"Field","name":{"kind":"Name","value":"links"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"personas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Journey_GetActivityQuery, Journey_GetActivityQueryVariables>;
export const Journey_DeleteJourneyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"journey_DeleteJourney"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Journey_DeleteJourneyMutation, Journey_DeleteJourneyMutationVariables>;
export const Journey_GetJourneyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journey_getJourney"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Journey_GetJourneyQuery, Journey_GetJourneyQueryVariables>;
export const Journey_DeletePhaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"journey_DeletePhase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePhase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Journey_DeletePhaseMutation, Journey_DeletePhaseMutationVariables>;
export const Journey_GetPhaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journey_getPhase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPhase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"touchpoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Journey_GetPhaseQuery, Journey_GetPhaseQueryVariables>;
export const Journey_ActivityDuplicateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"journey_activityDuplicate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createActivityDeepClone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"activityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Journey_ActivityDuplicateMutation, Journey_ActivityDuplicateMutationVariables>;
export const EditJourney_SingleJourneyQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"editJourney_SingleJourneyQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<EditJourney_SingleJourneyQueryQuery, EditJourney_SingleJourneyQueryQueryVariables>;
export const JourneyWarnings_GetJourneyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journeyWarnings_getJourney"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"satisfaction"}},{"kind":"Field","name":{"kind":"Name","value":"widgets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"personas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonaAvatar_persona"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activityWarnings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainMetric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitSign"}},{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitSign"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonaAvatar_persona"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Persona"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url90"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"90"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"90"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url48"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"48"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"48"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url40"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"40"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"40"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url24"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}}]} as unknown as DocumentNode<JourneyWarnings_GetJourneyQuery, JourneyWarnings_GetJourneyQueryVariables>;
export const GetActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"touchpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parentActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetActivityQuery, GetActivityQueryVariables>;
export const Journey_UpdateColorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"journey_updateColor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"color"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"color"},"value":{"kind":"Variable","name":{"kind":"Name","value":"color"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Journey_UpdateColorMutation, Journey_UpdateColorMutationVariables>;
export const JourneySelect_ListJourneyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journeySelect_listJourney"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isTemplate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<JourneySelect_ListJourneyQuery, JourneySelect_ListJourneyQueryVariables>;
export const PhaseSelect_ListPhaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"phaseSelect_listPhase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listPhase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"journey"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<PhaseSelect_ListPhaseQuery, PhaseSelect_ListPhaseQueryVariables>;
export const Journey_CreateJourneyFromTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"journey_createJourneyFromTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createJourneyDeepClone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"journeyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Journey_CreateJourneyFromTemplateMutation, Journey_CreateJourneyFromTemplateMutationVariables>;
export const Journey_CreateJourneyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"journey_createJourney"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Journey_CreateJourneyMutation, Journey_CreateJourneyMutationVariables>;
export const JourneyCreateModal_ListJourneyTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journeyCreateModal_listJourneyTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isTemplate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<JourneyCreateModal_ListJourneyTemplatesQuery, JourneyCreateModal_ListJourneyTemplatesQueryVariables>;
export const Journey_ListJourneyTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journey_listJourneyTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isTemplate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"journeyTemplateTile_journeyFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"journeyTemplateTile_journeyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Journey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<Journey_ListJourneyTemplatesQuery, Journey_ListJourneyTemplatesQueryVariables>;
export const JourneyDetail_ActivityCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journeyDetail_activityCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listTouchpoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phase"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]} as unknown as DocumentNode<JourneyDetail_ActivityCountQuery, JourneyDetail_ActivityCountQueryVariables>;
export const JourneyDetail_CreateActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"journeyDetail_createActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"StringValue","value":"","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"touchpoint"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"activity"}},{"kind":"ObjectField","name":{"kind":"Name","value":"phase"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"touchpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<JourneyDetail_CreateActivityMutation, JourneyDetail_CreateActivityMutationVariables>;
export const JourneyDetail_UpdatePhaseTouchpointsOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"journeyDetail_updatePhaseTouchpointsOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"touchpoints"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PhaseUpdateTouchpointsEntityRelationInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePhase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"touchpoints"},"value":{"kind":"Variable","name":{"kind":"Name","value":"touchpoints"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<JourneyDetail_UpdatePhaseTouchpointsOrderMutation, JourneyDetail_UpdatePhaseTouchpointsOrderMutationVariables>;
export const JourneyCreatePhaseModal_CreatePhaseAndReorderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"journeyCreatePhaseModal_createPhaseAndReorder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phaseName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phaseDesc"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phases"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JourneyUpdatePhasesEntityRelationInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPhase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phaseName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phaseDesc"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"journey"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updateJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phases"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phases"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<JourneyCreatePhaseModal_CreatePhaseAndReorderMutation, JourneyCreatePhaseModal_CreatePhaseAndReorderMutationVariables>;
export const JourneyCreatePhaseModal_GetJourneyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journeyCreatePhaseModal_getJourney"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<JourneyCreatePhaseModal_GetJourneyQuery, JourneyCreatePhaseModal_GetJourneyQueryVariables>;
export const JourneyDetail_GetJourneyDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journeyDetail_getJourneyDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"widgets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"touchpoints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"activity"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"warnings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"journeyDetail_widgets"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"journeyDetail_phases"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"journeyFilters_phases"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonaAvatar_persona"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Persona"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url90"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"90"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"90"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url48"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"48"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"48"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url40"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"40"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"40"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url24"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerCell_Member"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"40"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"40"}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PictureGrid_Gallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Activity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"galleryImgSource"},"name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"450"}}]}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomAvatarGroup_Member"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url24"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"activityCard_activity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Activity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitSign"}},{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitSign"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"showOnActivityMap"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"occurence"}}]}},{"kind":"Field","name":{"kind":"Name","value":"controlCycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"at"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomAvatarGroup_Member"}}]}},{"kind":"Field","name":{"kind":"Name","value":"satisfaction"}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"150"}}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"warnings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"journeyFilters_phases"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"touchpoints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"activity"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"satisfaction"}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"personas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"journeyDetail_widgets"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Activity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"links"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"goalsAndObjectives"}},{"kind":"Field","name":{"kind":"Name","value":"personas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonaAvatar_persona"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"occurence"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"showOnActivityMap"}}]}},{"kind":"Field","name":{"kind":"Name","value":"satisfaction"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"controlCycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"at"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerCell_Member"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitSign"}},{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitSign"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"150"}}]}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PictureGrid_Gallery"}},{"kind":"Field","name":{"kind":"Name","value":"opportunities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEq"},"value":{"kind":"EnumValue","value":"resolved"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEq"},"value":{"kind":"EnumValue","value":"resolved"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subTouchpoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"touchpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parentActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectedJourneys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"journeyDetail_phases"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitSign"}},{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitSign"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"touchpoints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"activity"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"activityCard_activity"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"journeyFilters_phases"}}]}}]} as unknown as DocumentNode<JourneyDetail_GetJourneyDetailQuery, JourneyDetail_GetJourneyDetailQueryVariables>;
export const JourneyEditDrawer_GetJourneyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journeyEditDrawer_getJourney"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<JourneyEditDrawer_GetJourneyQuery, JourneyEditDrawer_GetJourneyQueryVariables>;
export const EditJourney_UpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editJourney_update"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<EditJourney_UpdateMutation, EditJourney_UpdateMutationVariables>;
export const JourneyDetail_CreateWidgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"journeyDetail_createWidget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WidgetType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createWidget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"journey"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<JourneyDetail_CreateWidgetMutation, JourneyDetail_CreateWidgetMutationVariables>;
export const JourneyDetail_DeleteWidgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"journeyDetail_deleteWidget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteWidget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<JourneyDetail_DeleteWidgetMutation, JourneyDetail_DeleteWidgetMutationVariables>;
export const JourneyDetail_UpdateWidgetsOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"journeyDetail_updateWidgetsOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"widgets"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JourneyUpdateWidgetsEntityRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"widgets"},"value":{"kind":"Variable","name":{"kind":"Name","value":"widgets"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<JourneyDetail_UpdateWidgetsOrderMutation, JourneyDetail_UpdateWidgetsOrderMutationVariables>;
export const Detail_UpdateWidgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"detail_updateWidget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"widgetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateWidget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"widgetId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Detail_UpdateWidgetMutation, Detail_UpdateWidgetMutationVariables>;
export const Detail_GetWidgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"detail_getWidget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"widgetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getWidget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"widgetId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Detail_GetWidgetQuery, Detail_GetWidgetQueryVariables>;
export const Journey_DisplayMainMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journey_displayMainMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"compareStart"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"compareEnd"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetStart"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetEnd"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"expectations"}},{"kind":"Field","name":{"kind":"Name","value":"precision"}},{"kind":"Field","name":{"kind":"Name","value":"trendComparison"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"compareRange"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"compareStart"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"compareEnd"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"targetRange"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetStart"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetEnd"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetValue"}},{"kind":"Field","name":{"kind":"Name","value":"comparison"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateAt"}}]}}]}}]}}]} as unknown as DocumentNode<Journey_DisplayMainMetricQuery, Journey_DisplayMainMetricQueryVariables>;
export const Journey_DisplayPhaseMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journey_displayPhaseMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"compareStart"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"compareEnd"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetStart"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetEnd"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"expectations"}},{"kind":"Field","name":{"kind":"Name","value":"precision"}},{"kind":"Field","name":{"kind":"Name","value":"trendComparison"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"compareRange"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"compareStart"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"compareEnd"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"targetRange"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetStart"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetEnd"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetValue"}},{"kind":"Field","name":{"kind":"Name","value":"comparison"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateAt"}}]}}]}}]}}]} as unknown as DocumentNode<Journey_DisplayPhaseMetricQuery, Journey_DisplayPhaseMetricQueryVariables>;
export const Detail_ReorderPhasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"detail_reorderPhases"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phases"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JourneyUpdatePhasesEntityRelationInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phases"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phases"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Detail_ReorderPhasesMutation, Detail_ReorderPhasesMutationVariables>;
export const Timeline_UpdatePhasesTouchpointsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"timeline_updatePhasesTouchpoints"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"destinationPhase"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"touchpointId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTouchpoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"touchpointId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phase"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"destinationPhase"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Timeline_UpdatePhasesTouchpointsMutation, Timeline_UpdatePhasesTouchpointsMutationVariables>;
export const Timeline_UpdatePhaseTouchpointsOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"timeline_updatePhaseTouchpointsOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"touchpoints"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PhaseUpdateTouchpointsEntityRelationInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePhase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"touchpoints"},"value":{"kind":"Variable","name":{"kind":"Name","value":"touchpoints"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Timeline_UpdatePhaseTouchpointsOrderMutation, Timeline_UpdatePhaseTouchpointsOrderMutationVariables>;
export const SatisfactionCell_UpdateSatisfactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"satisfactionCell_updateSatisfaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"satisfactionValue"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"satisfaction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"satisfactionValue"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<SatisfactionCell_UpdateSatisfactionMutation, SatisfactionCell_UpdateSatisfactionMutationVariables>;
export const ActionDrawerForm_GetActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"actionDrawerForm_getAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"links"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<ActionDrawerForm_GetActionQuery, ActionDrawerForm_GetActionQueryVariables>;
export const ActionDrawerForm_UpdateActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"actionDrawerForm_updateAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActionUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<ActionDrawerForm_UpdateActionMutation, ActionDrawerForm_UpdateActionMutationVariables>;
export const ActionDrawerTabs_GetActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"actionDrawerTabs_getAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"opportunities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ActionDrawerTabs_GetActionQuery, ActionDrawerTabs_GetActionQueryVariables>;
export const ActionDrawerTabs_UpdateActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"actionDrawerTabs_updateAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActionUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<ActionDrawerTabs_UpdateActionMutation, ActionDrawerTabs_UpdateActionMutationVariables>;
export const ActionsWidget_AddActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"actionsWidget_addAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"actions"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<ActionsWidget_AddActionMutation, ActionsWidget_AddActionMutationVariables>;
export const ActionsWidget_RemoveActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"actionsWidget_removeAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"actions"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"disconnect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<ActionsWidget_RemoveActionMutation, ActionsWidget_RemoveActionMutationVariables>;
export const ActionSelect_ListActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"actionSelect_listActions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEq"},"value":{"kind":"EnumValue","value":"resolved"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ActionSelect_ListActionsQuery, ActionSelect_ListActionsQueryVariables>;
export const CreateActionAndAddToActivityModal_CreateActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createActionAndAddToActivityModal_createAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priority"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActionPriority"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActionStatus"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"links"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Json"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"priority"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priority"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"links"},"value":{"kind":"Variable","name":{"kind":"Name","value":"links"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateActionAndAddToActivityModal_CreateActionMutation, CreateActionAndAddToActivityModal_CreateActionMutationVariables>;
export const CreateActionAndAddToActivityModal_UpdateActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createActionAndAddToActivityModal_updateActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"actions"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<CreateActionAndAddToActivityModal_UpdateActivityMutation, CreateActionAndAddToActivityModal_UpdateActivityMutationVariables>;
export const ConnectJourneyToActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"connectJourneyToActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivityUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<ConnectJourneyToActivityMutation, ConnectJourneyToActivityMutationVariables>;
export const Widget_ListJourneyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"widget_listJourney"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isTemplate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Journey_SingleJourneyFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonaAvatar_persona"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Persona"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url90"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"90"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"90"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url48"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"48"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"48"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url40"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"40"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"40"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url24"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Journey_SingleJourneyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Journey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"personas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonaAvatar_persona"}}]}},{"kind":"Field","name":{"kind":"Name","value":"satisfaction"}},{"kind":"Field","name":{"kind":"Name","value":"activityWarnings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainMetric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitSign"}},{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitSign"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Widget_ListJourneyQuery, Widget_ListJourneyQueryVariables>;
export const JourneyDetail_GetActivityDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journeyDetail_getActivityDescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<JourneyDetail_GetActivityDescriptionQuery, JourneyDetail_GetActivityDescriptionQueryVariables>;
export const JourneyDetail_UpdateDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"journeyDetail_updateDescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<JourneyDetail_UpdateDescriptionMutation, JourneyDetail_UpdateDescriptionMutationVariables>;
export const DurationDrawer_GetActivityDurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"durationDrawer_getActivityDuration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"showOnActivityMap"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"occurence"}}]}}]}}]}}]} as unknown as DocumentNode<DurationDrawer_GetActivityDurationQuery, DurationDrawer_GetActivityDurationQueryVariables>;
export const DurationDrawer_UpdateActivityDurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"durationDrawer_updateActivityDuration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"duration"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivityUpdateDurationEntityRelationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"duration"},"value":{"kind":"Variable","name":{"kind":"Name","value":"duration"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<DurationDrawer_UpdateActivityDurationMutation, DurationDrawer_UpdateActivityDurationMutationVariables>;
export const DurationDrawer_UpdateActivityMapPresenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"durationDrawer_updateActivityMapPresence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showOnActivityMap"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"duration"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"showOnActivityMap"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showOnActivityMap"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<DurationDrawer_UpdateActivityMapPresenceMutation, DurationDrawer_UpdateActivityMapPresenceMutationVariables>;
export const JourneyDetail_GetActivityGoalsAndObjectivesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journeyDetail_getActivityGoalsAndObjectives"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"goalsAndObjectives"}}]}}]}}]} as unknown as DocumentNode<JourneyDetail_GetActivityGoalsAndObjectivesQuery, JourneyDetail_GetActivityGoalsAndObjectivesQueryVariables>;
export const JourneyDetail_UpdateGoalsAndObjectivesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"journeyDetail_updateGoalsAndObjectives"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"goalsAndObjectives"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"goalsAndObjectives"},"value":{"kind":"Variable","name":{"kind":"Name","value":"goalsAndObjectives"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<JourneyDetail_UpdateGoalsAndObjectivesMutation, JourneyDetail_UpdateGoalsAndObjectivesMutationVariables>;
export const JourneyDetail_ListActivityLinksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journeyDetail_listActivityLinks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"activityLinks"},"name":{"kind":"Name","value":"getActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"links"}}]}}]}}]} as unknown as DocumentNode<JourneyDetail_ListActivityLinksQuery, JourneyDetail_ListActivityLinksQueryVariables>;
export const Links_UpdateLinksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"links_updateLinks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"links"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Json"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"links"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"values"},"value":{"kind":"Variable","name":{"kind":"Name","value":"links"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Links_UpdateLinksMutation, Links_UpdateLinksMutationVariables>;
export const AddMetricSelect_ListMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"addMetricSelect_listMetric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listContentMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AddMetricSelect_ListMetricQuery, AddMetricSelect_ListMetricQueryVariables>;
export const AddMetricSelect_UpdateActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addMetricSelect_updateActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivityUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<AddMetricSelect_UpdateActivityMutation, AddMetricSelect_UpdateActivityMutationVariables>;
export const Metrics_GetMetricBoundsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"metrics_getMetricBounds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentMetricId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getContentMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentMetricId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lowerWarningBound"}},{"kind":"Field","name":{"kind":"Name","value":"upperWarningBound"}}]}}]}}]}}]} as unknown as DocumentNode<Metrics_GetMetricBoundsQuery, Metrics_GetMetricBoundsQueryVariables>;
export const Metrics_UpdateMetricBoundDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"metrics_updateMetricBound"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentMetricId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentMetricUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateContentMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentMetricId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Metrics_UpdateMetricBoundMutation, Metrics_UpdateMetricBoundMutationVariables>;
export const EditMetricWidgetDrawer_GetMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"editMetricWidgetDrawer_getMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentMetricId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getContentMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentMetricId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<EditMetricWidgetDrawer_GetMetricQuery, EditMetricWidgetDrawer_GetMetricQueryVariables>;
export const EditMetricWidgetDrawer_UpdateActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editMetricWidgetDrawer_updateActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivityUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<EditMetricWidgetDrawer_UpdateActivityMutation, EditMetricWidgetDrawer_UpdateActivityMutationVariables>;
export const GetDashboardMetricsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDashboardMetricsList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listDashboardMetric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentMetric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetDashboardMetricsListQuery, GetDashboardMetricsListQueryVariables>;
export const UpdateDashboardMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDashboardMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentMetricId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DashboardMetricUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDashboardMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentMetric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentMetricId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<UpdateDashboardMetricMutation, UpdateDashboardMetricMutationVariables>;
export const SourceDrawer_GetContentMetricQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"sourceDrawer_getContentMetricQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentMetricId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getContentMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentMetricId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hideFromPlanning"}}]}}]}}]} as unknown as DocumentNode<SourceDrawer_GetContentMetricQueryQuery, SourceDrawer_GetContentMetricQueryQueryVariables>;
export const SourceDrawer_UpdateContentMetricMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sourceDrawer_updateContentMetricMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentMetricId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateContentMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentMetricId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hideFromPlanning"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<SourceDrawer_UpdateContentMetricMutationMutation, SourceDrawer_UpdateContentMetricMutationMutationVariables>;
export const JourneyDetail_GetActivityNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journeyDetail_getActivityName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<JourneyDetail_GetActivityNameQuery, JourneyDetail_GetActivityNameQueryVariables>;
export const JourneyDetail_UpdateNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"journeyDetail_updateName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<JourneyDetail_UpdateNameMutation, JourneyDetail_UpdateNameMutationVariables>;
export const JourneyDetail_GetActivityNotesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journeyDetail_getActivityNotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]}}]} as unknown as DocumentNode<JourneyDetail_GetActivityNotesQuery, JourneyDetail_GetActivityNotesQueryVariables>;
export const JourneyDetail_UpdateNotesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"journeyDetail_updateNotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notes"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notes"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<JourneyDetail_UpdateNotesMutation, JourneyDetail_UpdateNotesMutationVariables>;
export const OpportunitySelect_ListOpportunitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"opportunitySelect_listOpportunities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEq"},"value":{"kind":"EnumValue","value":"resolved"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<OpportunitySelect_ListOpportunitiesQuery, OpportunitySelect_ListOpportunitiesQueryVariables>;
export const CreateOpportunityAndAddToActivityModal_CreateOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createOpportunityAndAddToActivityModal_createOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"benefit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpportunityStatus"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"links"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Json"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"benefit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"benefit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"links"},"value":{"kind":"Variable","name":{"kind":"Name","value":"links"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateOpportunityAndAddToActivityModal_CreateOpportunityMutation, CreateOpportunityAndAddToActivityModal_CreateOpportunityMutationVariables>;
export const CreateOpportunityAndAddToActivityModal_UpdateActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createOpportunityAndAddToActivityModal_updateActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"opportunities"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<CreateOpportunityAndAddToActivityModal_UpdateActivityMutation, CreateOpportunityAndAddToActivityModal_UpdateActivityMutationVariables>;
export const OpportunitiesWidget_AddOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"opportunitiesWidget_addOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"opportunities"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<OpportunitiesWidget_AddOpportunityMutation, OpportunitiesWidget_AddOpportunityMutationVariables>;
export const OpportunitiesWidget_RemoveOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"opportunitiesWidget_removeOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"opportunities"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"disconnect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<OpportunitiesWidget_RemoveOpportunityMutation, OpportunitiesWidget_RemoveOpportunityMutationVariables>;
export const OpportunityDrawerForm_GetOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"opportunityDrawerForm_getOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"links"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefit"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<OpportunityDrawerForm_GetOpportunityQuery, OpportunityDrawerForm_GetOpportunityQueryVariables>;
export const OpportunityDrawerForm_UpdateOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"opportunityDrawerForm_updateOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpportunityUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<OpportunityDrawerForm_UpdateOpportunityMutation, OpportunityDrawerForm_UpdateOpportunityMutationVariables>;
export const OpportunityDrawerTabs_GetOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"opportunityDrawerTabs_getOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<OpportunityDrawerTabs_GetOpportunityQuery, OpportunityDrawerTabs_GetOpportunityQueryVariables>;
export const OpportunityDrawerTabs_UpdateOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"opportunityDrawerTabs_updateOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpportunityUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<OpportunityDrawerTabs_UpdateOpportunityMutation, OpportunityDrawerTabs_UpdateOpportunityMutationVariables>;
export const JourneyDetail_GetControlCycleHistoryQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journeyDetail_getControlCycleHistoryQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"controlCycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"at"}},{"kind":"Field","name":{"kind":"Name","value":"who"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<JourneyDetail_GetControlCycleHistoryQueryQuery, JourneyDetail_GetControlCycleHistoryQueryQueryVariables>;
export const JourneyDetail_GetActivityOwnerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journeyDetail_getActivityOwner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"currentOwner"},"name":{"kind":"Name","value":"getActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"controlCycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"days"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"selectOptions"},"name":{"kind":"Name","value":"listMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<JourneyDetail_GetActivityOwnerQuery, JourneyDetail_GetActivityOwnerQueryVariables>;
export const JourneyDetail_UpdateOwnerMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"journeyDetail_updateOwnerMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ownerData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivityUpdateOwnerEntityRelationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ownerData"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<JourneyDetail_UpdateOwnerMutationMutation, JourneyDetail_UpdateOwnerMutationMutationVariables>;
export const JourneyDetail_UpdateControlCycleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"journeyDetail_updateControlCycle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"controlCycle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivityUpdateControlCycleEntityRelationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"controlCycle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"controlCycle"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<JourneyDetail_UpdateControlCycleMutation, JourneyDetail_UpdateControlCycleMutationVariables>;
export const JourneyDetail_CreateControlCycleCheckDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"journeyDetail_createControlCycleCheck"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"controlCycleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createControlCycleCheck"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cycle"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"controlCycleId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"who"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<JourneyDetail_CreateControlCycleCheckMutation, JourneyDetail_CreateControlCycleCheckMutationVariables>;
export const PersonasWidget_ConnectPersonaToWidgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"personasWidget_connectPersonaToWidget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"personas"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personaId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<PersonasWidget_ConnectPersonaToWidgetMutation, PersonasWidget_ConnectPersonaToWidgetMutationVariables>;
export const PersonasWidget_DisconnectPersonaFromWidgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"personasWidget_disconnectPersonaFromWidget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"personas"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"disconnect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personaId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<PersonasWidget_DisconnectPersonaFromWidgetMutation, PersonasWidget_DisconnectPersonaFromWidgetMutationVariables>;
export const JourneyDetail_ListActivityPersonasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journeyDetail_listActivityPersonas"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"activityPersonas"},"name":{"kind":"Name","value":"getActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"personas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonaAvatar_persona"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"listPersona"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonaAvatar_persona"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonaAvatar_persona"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Persona"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url90"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"90"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"90"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url48"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"48"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"48"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url40"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"40"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"40"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url24"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}}]} as unknown as DocumentNode<JourneyDetail_ListActivityPersonasQuery, JourneyDetail_ListActivityPersonasQueryVariables>;
export const JourneyDetail_GetActivityPicturesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journeyDetail_getActivityPictures"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"270"}}]}]}}]}}]}}]}}]} as unknown as DocumentNode<JourneyDetail_GetActivityPicturesQuery, JourneyDetail_GetActivityPicturesQueryVariables>;
export const PicturesDrawer_ConnectPicutreToActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"picturesDrawer_connectPicutreToActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPicture"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"activity"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"image"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<PicturesDrawer_ConnectPicutreToActivityMutation, PicturesDrawer_ConnectPicutreToActivityMutationVariables>;
export const PicturesDrawer_UpdatePictureOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"picturesDrawer_updatePictureOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pictures"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivityUpdatePicturesEntityRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pictures"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pictures"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<PicturesDrawer_UpdatePictureOrderMutation, PicturesDrawer_UpdatePictureOrderMutationVariables>;
export const PictureItem_DeleteFromActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"pictureItem_deleteFromActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pictureId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePicture"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pictureId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<PictureItem_DeleteFromActivityMutation, PictureItem_DeleteFromActivityMutationVariables>;
export const JourneyDetail_GetActivitySubtouchpointsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journeyDetail_getActivitySubtouchpoints"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subTouchpoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<JourneyDetail_GetActivitySubtouchpointsQuery, JourneyDetail_GetActivitySubtouchpointsQueryVariables>;
export const JourneyDetail_DeleteSubTouchpointDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"journeyDetail_deleteSubTouchpoint"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subTouchpointId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTouchpoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subTouchpointId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<JourneyDetail_DeleteSubTouchpointMutation, JourneyDetail_DeleteSubTouchpointMutationVariables>;
export const JourneyDetail_CreateSubactivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"journeyDetail_createSubactivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentActivityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"touchpoint"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"IntValue","value":"0"}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"subactivity"}},{"kind":"ObjectField","name":{"kind":"Name","value":"parentActivity"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentActivityId"}}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<JourneyDetail_CreateSubactivityMutation, JourneyDetail_CreateSubactivityMutationVariables>;
export const TagsCell_UpdateActivityMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"tagsCell_updateActivityMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivityUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<TagsCell_UpdateActivityMutationMutation, TagsCell_UpdateActivityMutationMutationVariables>;
export const CreateTagMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTagMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<CreateTagMutationMutation, CreateTagMutationMutationVariables>;
export const UpdateTagMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTagMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<UpdateTagMutationMutation, UpdateTagMutationMutationVariables>;
export const Tags_GetTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"tags_getTags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"availableTags"},"name":{"kind":"Name","value":"listTag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"assignedTags"},"name":{"kind":"Name","value":"listTag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"activities"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Tags_GetTagsQuery, Tags_GetTagsQueryVariables>;
export const UpdateActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivityUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<UpdateActivityMutation, UpdateActivityMutationVariables>;
export const Journey_JourneysQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journey_JourneysQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isTemplate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Journey_SingleJourneyFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonaAvatar_persona"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Persona"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url90"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"90"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"90"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url48"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"48"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"48"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url40"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"40"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"40"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url24"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Journey_SingleJourneyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Journey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"personas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonaAvatar_persona"}}]}},{"kind":"Field","name":{"kind":"Name","value":"satisfaction"}},{"kind":"Field","name":{"kind":"Name","value":"activityWarnings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainMetric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitSign"}},{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitSign"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Journey_JourneysQueryQuery, Journey_JourneysQueryQueryVariables>;
export const JourneyUpdateTeamMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"journeyUpdateTeamMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"journeyName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teams"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JourneyUpdateTeamsEntityRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"journeyName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"teams"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teams"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<JourneyUpdateTeamMutationMutation, JourneyUpdateTeamMutationMutationVariables>;
export const Planning_UpdateActionStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"planning_updateActionStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActionStatus"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Planning_UpdateActionStatusMutation, Planning_UpdateActionStatusMutationVariables>;
export const Planning_ActivityActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"planning_activityActions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromThis"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toThis"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromLast"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toLast"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"touchpoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEq"},"value":{"kind":"EnumValue","value":"resolved"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"planning_activityUnresolvedActions"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"planning_activityActionsThisWeekOrMonth"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"planning_activityActionsLastWeekOrMonth"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"planning_activityUnresolvedActions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Activity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"activityActionsUnresolved"},"name":{"kind":"Name","value":"actions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEq"},"value":{"kind":"EnumValue","value":"resolved"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"planning_activityActionsThisWeekOrMonth"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Activity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"activityActionsThisWeekOrMonth"},"name":{"kind":"Name","value":"actions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromThis"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toThis"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"solvedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromThis"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toThis"}}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEq"},"value":{"kind":"EnumValue","value":"resolved"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"planning_activityActionsLastWeekOrMonth"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Activity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"activityActionsLastWeekOrMonth"},"name":{"kind":"Name","value":"actions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromLast"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toLast"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"solvedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromLast"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toLast"}}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEq"},"value":{"kind":"EnumValue","value":"resolved"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Planning_ActivityActionsQuery, Planning_ActivityActionsQueryVariables>;
export const CreateActionModal_UpdateActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createActionModal_updateActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"actions"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<CreateActionModal_UpdateActivityMutation, CreateActionModal_UpdateActivityMutationVariables>;
export const Journey_PlanningMetricsOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journey_planningMetricsOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hideFromPlanning"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitSign"}},{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitSign"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Journey_PlanningMetricsOverviewQuery, Journey_PlanningMetricsOverviewQueryVariables>;
export const Planning_GetJourneyPlanningWeeklyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"planning_getJourneyPlanningWeekly"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionFromThisWeek"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionToThisWeek"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionFromLastWeek"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionToLastWeek"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityFromThisWeek"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityToThisWeek"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityFromLastWeek"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityToLastWeek"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"satisfaction"}},{"kind":"Field","alias":{"kind":"Name","value":"solvedActionsThisWeek"},"name":{"kind":"Name","value":"solvedActionsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionFromThisWeek"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionToThisWeek"}}}]},{"kind":"Field","alias":{"kind":"Name","value":"solvedActionsLastWeek"},"name":{"kind":"Name","value":"solvedActionsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionFromLastWeek"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionToLastWeek"}}}]},{"kind":"Field","alias":{"kind":"Name","value":"createdOpportunitiesThisWeek"},"name":{"kind":"Name","value":"createdOpportunitiesCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityFromThisWeek"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityToThisWeek"}}}]},{"kind":"Field","alias":{"kind":"Name","value":"createdOpportunitiesLastWeek"},"name":{"kind":"Name","value":"createdOpportunitiesCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityFromLastWeek"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityToLastWeek"}}}]}]}}]}}]} as unknown as DocumentNode<Planning_GetJourneyPlanningWeeklyQuery, Planning_GetJourneyPlanningWeeklyQueryVariables>;
export const Planning_GetJourneyPlanningMonthlyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"planning_getJourneyPlanningMonthly"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionFromThisMonth"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionToThisMonth"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionFromLastMonth"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionToLastMonth"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityFromThisMonth"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityToThisMonth"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityFromLastMonth"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityToLastMonth"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"satisfaction"}},{"kind":"Field","alias":{"kind":"Name","value":"solvedActionsThisMonth"},"name":{"kind":"Name","value":"solvedActionsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionFromThisMonth"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionToThisMonth"}}}]},{"kind":"Field","alias":{"kind":"Name","value":"solvedActionsLastMonth"},"name":{"kind":"Name","value":"solvedActionsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionFromLastMonth"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionToLastMonth"}}}]},{"kind":"Field","alias":{"kind":"Name","value":"createdOpportunitiesThisMonth"},"name":{"kind":"Name","value":"createdOpportunitiesCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityFromThisMonth"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityToThisMonth"}}}]},{"kind":"Field","alias":{"kind":"Name","value":"createdOpportunitiesLastMonth"},"name":{"kind":"Name","value":"createdOpportunitiesCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityFromLastMonth"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityToLastMonth"}}}]}]}}]}}]} as unknown as DocumentNode<Planning_GetJourneyPlanningMonthlyQuery, Planning_GetJourneyPlanningMonthlyQueryVariables>;
export const Planning_GeneralUnresolvedActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"planning_generalUnresolvedActions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEq"},"value":{"kind":"EnumValue","value":"resolved"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Planning_GeneralUnresolvedActionsQuery, Planning_GeneralUnresolvedActionsQueryVariables>;
export const Planning_GeneralActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"planning_generalActions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"solvedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEq"},"value":{"kind":"EnumValue","value":"resolved"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Planning_GeneralActionsQuery, Planning_GeneralActionsQueryVariables>;
export const PlanningTableRow_DisplayMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"planningTableRow_displayMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rangeStart"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rangeEnd"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breakdownInterval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BreakdownInterval"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"expectations"}},{"kind":"Field","name":{"kind":"Name","value":"precision"}},{"kind":"Field","name":{"kind":"Name","value":"trendComparison"}},{"kind":"Field","name":{"kind":"Name","value":"breakdown"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"range"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rangeStart"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rangeEnd"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"breakdownInterval"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breakdownInterval"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"range"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetValue"}},{"kind":"Field","name":{"kind":"Name","value":"comparedValue"}},{"kind":"Field","name":{"kind":"Name","value":"comparison"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chartDataPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PlanningTableRow_DisplayMetricQuery, PlanningTableRow_DisplayMetricQueryVariables>;
export const SubactivityDetail_GetActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"subactivityDetail_getActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"journeyDetail_widgets"}},{"kind":"Field","name":{"kind":"Name","value":"touchpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parentActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"touchpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"journey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"widgets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subTouchpoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subTouchpoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonaAvatar_persona"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Persona"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url90"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"90"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"90"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url48"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"48"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"48"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url40"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"40"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"40"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url24"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerCell_Member"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"40"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"40"}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PictureGrid_Gallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Activity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"galleryImgSource"},"name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"450"}}]}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"journeyDetail_widgets"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Activity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"links"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"goalsAndObjectives"}},{"kind":"Field","name":{"kind":"Name","value":"personas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonaAvatar_persona"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"occurence"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"showOnActivityMap"}}]}},{"kind":"Field","name":{"kind":"Name","value":"satisfaction"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"controlCycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"at"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerCell_Member"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitSign"}},{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitSign"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"150"}}]}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PictureGrid_Gallery"}},{"kind":"Field","name":{"kind":"Name","value":"opportunities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEq"},"value":{"kind":"EnumValue","value":"resolved"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEq"},"value":{"kind":"EnumValue","value":"resolved"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subTouchpoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"touchpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parentActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectedJourneys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]} as unknown as DocumentNode<SubactivityDetail_GetActivityQuery, SubactivityDetail_GetActivityQueryVariables>;
export const Journey_SummaryBannerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journey_summaryBanner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"satisfaction"}},{"kind":"Field","name":{"kind":"Name","value":"personas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonaAvatar_persona"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonaAvatar_persona"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Persona"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url90"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"90"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"90"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url48"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"48"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"48"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url40"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"40"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"40"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url24"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}}]} as unknown as DocumentNode<Journey_SummaryBannerQuery, Journey_SummaryBannerQueryVariables>;
export const Journey_SummaryDrawerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journey_summaryDrawer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"satisfaction"}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"touchpoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitSign"}},{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitSign"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"personas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonaAvatar_persona"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonaAvatar_persona"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Persona"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url90"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"90"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"90"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url48"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"48"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"48"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url40"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"40"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"40"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url24"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}}]} as unknown as DocumentNode<Journey_SummaryDrawerQuery, Journey_SummaryDrawerQueryVariables>;
export const ActivityMap_GetJourneyDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"activityMap_getJourneyDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"widgets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"journeyDetail_phases"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"timelineBody_phases"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomAvatarGroup_Member"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url24"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"activityCard_activity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Activity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitSign"}},{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitSign"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"showOnActivityMap"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"occurence"}}]}},{"kind":"Field","name":{"kind":"Name","value":"controlCycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"at"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomAvatarGroup_Member"}}]}},{"kind":"Field","name":{"kind":"Name","value":"satisfaction"}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"150"}}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"warnings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"journeyFilters_phases"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"touchpoints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"activity"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"satisfaction"}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"personas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"journeyDetail_phases"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitSign"}},{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitSign"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"touchpoints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"activity"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"activityCard_activity"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"journeyFilters_phases"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"timelineBody_phases"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"touchpoints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"activity"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"activityCard_activity"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subTouchpoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"journeyFilters_phases"}}]}}]} as unknown as DocumentNode<ActivityMap_GetJourneyDetailQuery, ActivityMap_GetJourneyDetailQueryVariables>;
export const ActivityMap_TouchpointSubactivitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"activityMap_touchpointSubactivities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subTouchpoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"activityCard_activity"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomAvatarGroup_Member"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url24"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"activityCard_activity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Activity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitSign"}},{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitSign"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"showOnActivityMap"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"occurence"}}]}},{"kind":"Field","name":{"kind":"Name","value":"controlCycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"at"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomAvatarGroup_Member"}}]}},{"kind":"Field","name":{"kind":"Name","value":"satisfaction"}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"150"}}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"warnings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ActivityMap_TouchpointSubactivitiesQuery, ActivityMap_TouchpointSubactivitiesQueryVariables>;
export const Journey_DisplayMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"journey_displayMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"compareStart"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"compareEnd"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetStart"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetEnd"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"expectations"}},{"kind":"Field","name":{"kind":"Name","value":"precision"}},{"kind":"Field","name":{"kind":"Name","value":"trendComparison"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"compareRange"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"compareStart"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"compareEnd"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"targetRange"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetStart"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetEnd"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetValue"}},{"kind":"Field","name":{"kind":"Name","value":"comparedValue"}},{"kind":"Field","name":{"kind":"Name","value":"comparison"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateAt"}}]}}]}}]}}]} as unknown as DocumentNode<Journey_DisplayMetricQuery, Journey_DisplayMetricQueryVariables>;
export const PhaseEditDrawer_GetPhaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"phaseEditDrawer_getPhase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPhase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"touchpoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PhaseEditDrawer_GetPhaseQuery, PhaseEditDrawer_GetPhaseQueryVariables>;
export const EditPhase_UpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editPhase_update"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentMetrics"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PhaseUpdateContentMetricsEntityRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePhase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contentMetrics"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentMetrics"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<EditPhase_UpdateMutation, EditPhase_UpdateMutationVariables>;
export const Warnings_ListPhasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"warnings_listPhases"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listPhase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"journey"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"touchpoints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"activity"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"activityCard_activity"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"journeyFilters_phases"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomAvatarGroup_Member"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url24"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"activityCard_activity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Activity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitSign"}},{"kind":"Field","name":{"kind":"Name","value":"dataSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitSign"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"showOnActivityMap"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"occurence"}}]}},{"kind":"Field","name":{"kind":"Name","value":"controlCycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"at"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomAvatarGroup_Member"}}]}},{"kind":"Field","name":{"kind":"Name","value":"satisfaction"}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"150"}}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"warnings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"journeyFilters_phases"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"touchpoints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"activity"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"satisfaction"}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"personas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Warnings_ListPhasesQuery, Warnings_ListPhasesQueryVariables>;
export const Warnings_ReorderPhasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"warnings_reorderPhases"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phases"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JourneyUpdatePhasesEntityRelationInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phases"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phases"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Warnings_ReorderPhasesMutation, Warnings_ReorderPhasesMutationVariables>;
export const Warnings_ConnectTpToColumnDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"warnings_connectTpToColumn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"touchpointId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetPhaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTouchpoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"touchpointId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phase"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetPhaseId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Warnings_ConnectTpToColumnMutation, Warnings_ConnectTpToColumnMutationVariables>;
export const Warnings_TouchpointsReorderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"warnings_touchpointsReorder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"touchpoints"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PhaseUpdateTouchpointsEntityRelationInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePhase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"touchpoints"},"value":{"kind":"Variable","name":{"kind":"Name","value":"touchpoints"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Warnings_TouchpointsReorderMutation, Warnings_TouchpointsReorderMutationVariables>;
export const Warnings_CreateActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"warnings_createActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"New activity","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"StringValue","value":"","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"touchpoint"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"activity"}},{"kind":"ObjectField","name":{"kind":"Name","value":"phase"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Warnings_CreateActivityMutation, Warnings_CreateActivityMutationVariables>;
export const OpportunityActionsList_GetOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"opportunityActionsList_getOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OpportunityActionsList_GetOpportunityQuery, OpportunityActionsList_GetOpportunityQueryVariables>;
export const OpportunityActionssList_RemoveOpportunityActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"opportunityActionssList_removeOpportunityAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"actions"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"disconnect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<OpportunityActionssList_RemoveOpportunityActionMutation, OpportunityActionssList_RemoveOpportunityActionMutationVariables>;
export const OpportunityAddActionModal_ListActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"opportunityAddActionModal_listActions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEq"},"value":{"kind":"EnumValue","value":"resolved"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<OpportunityAddActionModal_ListActionsQuery, OpportunityAddActionModal_ListActionsQueryVariables>;
export const OpportunityAddActionModal_GetOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"opportunityAddActionModal_getOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<OpportunityAddActionModal_GetOpportunityQuery, OpportunityAddActionModal_GetOpportunityQueryVariables>;
export const OpportunityAddActionModal_CreateActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"opportunityAddActionModal_createAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priority"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActionPriority"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActionStatus"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"links"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Json"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activities"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActionCreateActivitiesEntityRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"priority"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priority"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"links"},"value":{"kind":"Variable","name":{"kind":"Name","value":"links"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"activities"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activities"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<OpportunityAddActionModal_CreateActionMutation, OpportunityAddActionModal_CreateActionMutationVariables>;
export const OpportunityAddActionModal_UpdateOpportunityActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"opportunityAddActionModal_updateOpportunityActions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"actions"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<OpportunityAddActionModal_UpdateOpportunityActionsMutation, OpportunityAddActionModal_UpdateOpportunityActionsMutationVariables>;
export const OpportunityDeleteModal_GetOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"opportunityDeleteModal_getOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<OpportunityDeleteModal_GetOpportunityQuery, OpportunityDeleteModal_GetOpportunityQueryVariables>;
export const OpportunityDeleteModal_DeleteOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"opportunityDeleteModal_deleteOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<OpportunityDeleteModal_DeleteOpportunityMutation, OpportunityDeleteModal_DeleteOpportunityMutationVariables>;
export const AssignOpportunityModal_UpdateOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"assignOpportunityModal_updateOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpportunityUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<AssignOpportunityModal_UpdateOpportunityMutation, AssignOpportunityModal_UpdateOpportunityMutationVariables>;
export const OpportunityDetailContent_UpdateOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"opportunityDetailContent_updateOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpportunityUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<OpportunityDetailContent_UpdateOpportunityMutation, OpportunityDetailContent_UpdateOpportunityMutationVariables>;
export const OpportunityDetailForm_UpdateOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"opportunityDetailForm_updateOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpportunityUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<OpportunityDetailForm_UpdateOpportunityMutation, OpportunityDetailForm_UpdateOpportunityMutationVariables>;
export const OpportunityDetailHeader_UpdateOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"opportunityDetailHeader_updateOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpportunityUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<OpportunityDetailHeader_UpdateOpportunityMutation, OpportunityDetailHeader_UpdateOpportunityMutationVariables>;
export const OpportunityDetailPage_GetOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"opportunityDetailPage_getOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"links"}},{"kind":"Field","name":{"kind":"Name","value":"benefit"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<OpportunityDetailPage_GetOpportunityQuery, OpportunityDetailPage_GetOpportunityQueryVariables>;
export const OpportunityHeader_ListOpportunitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"opportunityHeader_listOpportunities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listOpportunity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<OpportunityHeader_ListOpportunitiesQuery, OpportunityHeader_ListOpportunitiesQueryVariables>;
export const OpportunityListHeader_CreateOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"opportunityListHeader_createOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"benefit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpportunityStatus"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"links"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Json"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"benefit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"benefit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"links"},"value":{"kind":"Variable","name":{"kind":"Name","value":"links"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<OpportunityListHeader_CreateOpportunityMutation, OpportunityListHeader_CreateOpportunityMutationVariables>;
export const OpportunityList_GetOpportunitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"opportunityList_getOpportunities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listOpportunity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefit"}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"journeys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"touchpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"journey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OpportunityList_GetOpportunitiesQuery, OpportunityList_GetOpportunitiesQueryVariables>;
export const Settings_GetMemberSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"settings_getMemberSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMemberSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"member"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"firstDayOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]}}]} as unknown as DocumentNode<Settings_GetMemberSettingsQuery, Settings_GetMemberSettingsQueryVariables>;
export const Settings_UpdateMemberSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"settings_updateMemberSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MemberSettingsUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"create"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MemberSettingsCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertMemberSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"member"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update"}}},{"kind":"Argument","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"create"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"firstDayOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]}}]}}]} as unknown as DocumentNode<Settings_UpdateMemberSettingsMutation, Settings_UpdateMemberSettingsMutationVariables>;
export const OrganizationSettings_UpdateOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"organizationSettings_updateOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"alias"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"config"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"alias"},"value":{"kind":"Variable","name":{"kind":"Name","value":"alias"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<OrganizationSettings_UpdateOrganizationMutation, OrganizationSettings_UpdateOrganizationMutationVariables>;
export const Persona_DeletePersonaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"persona_deletePersona"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePersona"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Persona_DeletePersonaMutation, Persona_DeletePersonaMutationVariables>;
export const Persona_GetPersonaByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"persona_getPersonaById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPersona"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Persona_GetPersonaByIdQuery, Persona_GetPersonaByIdQueryVariables>;
export const Persona_ListPersonasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"persona_listPersonas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listPersona"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"personaDetail_personaFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonaAvatar_persona"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Persona"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url90"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"90"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"90"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url48"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"48"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"48"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url40"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"40"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"40"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url24"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"personaPopover_personaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Persona"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"personaDetail_personaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Persona"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"quote"}},{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"job"}},{"kind":"Field","name":{"kind":"Name","value":"journeys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonaAvatar_persona"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"personaPopover_personaFragment"}}]}}]} as unknown as DocumentNode<Persona_ListPersonasQuery, Persona_ListPersonasQueryVariables>;
export const PersonaPopover_UpdatePersonaColorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"personaPopover_updatePersonaColor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"color"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePersona"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"color"},"value":{"kind":"Variable","name":{"kind":"Name","value":"color"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<PersonaPopover_UpdatePersonaColorMutation, PersonaPopover_UpdatePersonaColorMutationVariables>;
export const Persona_DeletePersonaBlockDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"persona_deletePersonaBlock"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePersonaBlock"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Persona_DeletePersonaBlockMutation, Persona_DeletePersonaBlockMutationVariables>;
export const EditPersonaAvatar_GetPersonaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"editPersonaAvatar_getPersona"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPersona"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"64"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"64"}}]}]}}]}}]}}]} as unknown as DocumentNode<EditPersonaAvatar_GetPersonaQuery, EditPersonaAvatar_GetPersonaQueryVariables>;
export const EditPersonaAvatar_UpdatePersonaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editPersonaAvatar_updatePersona"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePersona"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personaId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"avatar"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<EditPersonaAvatar_UpdatePersonaMutation, EditPersonaAvatar_UpdatePersonaMutationVariables>;
export const PersonaDetail_GetJourneyDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"personaDetail_getJourneyDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getJourney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"personas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonaAvatar_persona"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonaAvatar_persona"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Persona"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url90"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"90"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"90"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url48"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"48"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"48"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url40"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"40"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"40"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url24"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}}]} as unknown as DocumentNode<PersonaDetail_GetJourneyDetailQuery, PersonaDetail_GetJourneyDetailQueryVariables>;
export const PersonaDetail_PersonaUsedInJourneyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"personaDetail_personaUsedInJourney"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPersona"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personaId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"touchpoint"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phase"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"journey"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"journeyId"}}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<PersonaDetail_PersonaUsedInJourneyQuery, PersonaDetail_PersonaUsedInJourneyQueryVariables>;
export const PersonaDetail_CreatePersonaBlockDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"personaDetail_createPersonaBlock"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"color"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"items"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PersonaBlockCreateItemsEntityRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPersonaBlock"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"color"},"value":{"kind":"Variable","name":{"kind":"Name","value":"color"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"items"},"value":{"kind":"Variable","name":{"kind":"Name","value":"items"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"persona"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personaId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<PersonaDetail_CreatePersonaBlockMutation, PersonaDetail_CreatePersonaBlockMutationVariables>;
export const PersonaDetailBlockItem_UpdatePersonaBlockItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"personaDetailBlockItem_updatePersonaBlockItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePersonaBlockItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<PersonaDetailBlockItem_UpdatePersonaBlockItemMutation, PersonaDetailBlockItem_UpdatePersonaBlockItemMutationVariables>;
export const PersonaBlockTile_UpdateColorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"personaBlockTile_updateColor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"blockId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"color"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePersonaBlock"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"blockId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"color"},"value":{"kind":"Variable","name":{"kind":"Name","value":"color"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<PersonaBlockTile_UpdateColorMutation, PersonaBlockTile_UpdateColorMutationVariables>;
export const PersonaBlockUpdateModal_PersonaBlockDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"personaBlockUpdateModal_personaBlock"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"blockId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPersonaBlock"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"blockId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<PersonaBlockUpdateModal_PersonaBlockQuery, PersonaBlockUpdateModal_PersonaBlockQueryVariables>;
export const PersonaDetail_UpdatePersonaBlockDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"personaDetail_updatePersonaBlock"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"color"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"items"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PersonaBlockUpdateItemsEntityRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"blockId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePersonaBlock"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"blockId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"color"},"value":{"kind":"Variable","name":{"kind":"Name","value":"color"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"items"},"value":{"kind":"Variable","name":{"kind":"Name","value":"items"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"persona"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personaId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<PersonaDetail_UpdatePersonaBlockMutation, PersonaDetail_UpdatePersonaBlockMutationVariables>;
export const PersonaDetailEditDrawer_GetPersonaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"personaDetailEditDrawer_getPersona"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPersona"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personaId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quote"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonaAvatar_persona"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonaAvatar_persona"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Persona"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url90"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"90"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"90"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url48"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"48"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"48"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url40"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"40"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"40"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url24"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}}]} as unknown as DocumentNode<PersonaDetailEditDrawer_GetPersonaQuery, PersonaDetailEditDrawer_GetPersonaQueryVariables>;
export const UpdatePersonaDetailMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePersonaDetailMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updatePersonaBy2"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PersonaUniqueWhere"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PersonaUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePersona"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatePersonaBy2"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<UpdatePersonaDetailMutationMutation, UpdatePersonaDetailMutationMutationVariables>;
export const PersonaDetail_GetPersonaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"personaDetail_getPersona"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPersona"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quote"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"journeys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"personaBlockTile_blockFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonaAvatar_persona"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"personaPopover_personaFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"personaBlockItems_itemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PersonaBlockItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"personaBlockTile_blockFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PersonaBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"personaBlockItems_itemFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonaAvatar_persona"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Persona"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url90"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"90"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"90"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url48"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"48"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"48"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url40"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"40"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"40"}}]},{"kind":"Field","alias":{"kind":"Name","value":"url24"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"24"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"24"}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"personaPopover_personaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Persona"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<PersonaDetail_GetPersonaQuery, PersonaDetail_GetPersonaQueryVariables>;
export const RemovePersonaAvatar_UpdatePersonaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removePersonaAvatar_updatePersona"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePersona"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personaId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"avatar"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"disconnect"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<RemovePersonaAvatar_UpdatePersonaMutation, RemovePersonaAvatar_UpdatePersonaMutationVariables>;
export const Organization_CreatePersonaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"organization_createPersona"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"age"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quote"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PersonaStatus"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gender"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PersonaGender"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"job"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"blocks"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PersonaCreateBlocksEntityRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPersona"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"age"},"value":{"kind":"Variable","name":{"kind":"Name","value":"age"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"quote"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quote"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"gender"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gender"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"job"},"value":{"kind":"Variable","name":{"kind":"Name","value":"job"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"location"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"blocks"},"value":{"kind":"Variable","name":{"kind":"Name","value":"blocks"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Organization_CreatePersonaMutation, Organization_CreatePersonaMutationVariables>;
export const Organization_UpdatePersonaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"organization_updatePersona"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePersona"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Organization_UpdatePersonaMutation, Organization_UpdatePersonaMutationVariables>;
export const Auth_ResetPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"auth_resetPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<Auth_ResetPasswordMutation, Auth_ResetPasswordMutationVariables>;
export const Auth_ExpiredTokenResetPasswordRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"auth_expiredTokenResetPasswordRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createResetPasswordRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<Auth_ExpiredTokenResetPasswordRequestMutation, Auth_ExpiredTokenResetPasswordRequestMutationVariables>;
export const Auth_CreateResetPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"auth_createResetPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createResetPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<Auth_CreateResetPasswordMutation, Auth_CreateResetPasswordMutationVariables>;
export const Organization_InviteMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"organization_inviteMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inviteMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"teamId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Organization_InviteMemberMutation, Organization_InviteMemberMutationVariables>;
export const Organization_PaginateMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"organization_paginateMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paginateMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"containsCI"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"containsCI"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isBlocked"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"32"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"32"}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<Organization_PaginateMembersQuery, Organization_PaginateMembersQueryVariables>;
export const Organization_DeactivateMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"organization_deactivateMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deactivateMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Organization_DeactivateMemberMutation, Organization_DeactivateMemberMutationVariables>;
export const Organization_ReactivateMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"organization_reactivateMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reactivateMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Organization_ReactivateMemberMutation, Organization_ReactivateMemberMutationVariables>;
export const Organization_Members_ListTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"organization_members_listTeams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listTeam"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Organization_Members_ListTeamsQuery, Organization_Members_ListTeamsQueryVariables>;
export const Organization_UpdateMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"organization_updateMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MemberUpdateInputFiltered"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Organization_UpdateMemberMutation, Organization_UpdateMemberMutationVariables>;
export const Organization_DeleteTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"organization_deleteTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTeam"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Organization_DeleteTeamMutation, Organization_DeleteTeamMutationVariables>;
export const Organization_GetTeamByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"organization_getTeamById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTeam"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Organization_GetTeamByIdQuery, Organization_GetTeamByIdQueryVariables>;
export const Organization_CreateTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"organization_createTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTeam"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Organization_CreateTeamMutation, Organization_CreateTeamMutationVariables>;
export const Organization_UpdateTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"organization_updateTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTeam"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Organization_UpdateTeamMutation, Organization_UpdateTeamMutationVariables>;
export const Organization_Teams_PaginateTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"organization_teams_paginateTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paginateTeam"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"28"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"28"}}]}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<Organization_Teams_PaginateTeamsQuery, Organization_Teams_PaginateTeamsQueryVariables>;
export const PaginateTagQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"paginateTagQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paginateTag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"paginateActivities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"touchpoint"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phase"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"journey"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isTemplate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<PaginateTagQueryQuery, PaginateTagQueryQueryVariables>;
export const Tags_ListTagDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"tags_listTag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listTag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<Tags_ListTagQuery, Tags_ListTagQueryVariables>;
export const DeleteTagMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTagMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<DeleteTagMutationMutation, DeleteTagMutationMutationVariables>;
export const DeleteProfilePhoto_UpdateMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteProfilePhoto_updateMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"avatar"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"disconnect"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<DeleteProfilePhoto_UpdateMemberMutation, DeleteProfilePhoto_UpdateMemberMutationVariables>;
export const Settings_UpdateMyProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"settings_updateMyProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobTitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMyProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobTitle"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<Settings_UpdateMyProfileMutation, Settings_UpdateMyProfileMutationVariables>;
export const Settings_ChangeMyPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"settings_changeMyPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeMyPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"currentPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentPassword"}}},{"kind":"Argument","name":{"kind":"Name","value":"newPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newPassword"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<Settings_ChangeMyPasswordMutation, Settings_ChangeMyPasswordMutationVariables>;
export const SettingsProfile_MeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"settingsProfile_me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"168"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"168"}}]}]}}]}}]}}]} as unknown as DocumentNode<SettingsProfile_MeQuery, SettingsProfile_MeQueryVariables>;
export const SettingsProfile_UpdateMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"settingsProfile_updateMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"avatar"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<SettingsProfile_UpdateMemberMutation, SettingsProfile_UpdateMemberMutationVariables>;
export const Upgrade_StripeLinkQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"upgrade_stripeLinkQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plan"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentPlan"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"plan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plan"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"costPerMember"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]} as unknown as DocumentNode<Upgrade_StripeLinkQueryQuery, Upgrade_StripeLinkQueryQueryVariables>;
export const CurrentOrganization_SubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"currentOrganization_subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrganizationMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"singleton"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trialDaysLeft"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<CurrentOrganization_SubscriptionQuery, CurrentOrganization_SubscriptionQueryVariables>;
export const CurrentOrganization_LicenseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"currentOrganization_license"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrganizationMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"singleton"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"license"}},{"kind":"Field","name":{"kind":"Name","value":"trialEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<CurrentOrganization_LicenseQuery, CurrentOrganization_LicenseQueryVariables>;